const DoNotResearchCountries = ["russia", "china"];
const DoNotResearchEmails = ["163.", "Yandex.", "Qq."];
const GoodPersonalEmails = [
    "gmail",
    "yahoo",
    "hotmail",
    "outlook",
    "ahaks.com",
    "arinuse.com",
    "banasthali.in",
    "bcooq.com",
    "bitflirt.com",
    "bk.ru",
    "bmixr.com",
    "bumail.net",
    "codverts.com",
    "duck.com",
    "egvoo.com",
    "emaily.pro",
    "envoes.com",
    "fundapk.com",
    "gufum.com",
    "halbov.com",
    "hartaria.com",
    "htlm.com",
    "isimg.tn",
    "jarars.com",
    "jioso.com",
    "jomspar.com",
    "kuandika.com",
    "kurbieh.com",
    "kytstore.com",
    "lxheir.com",
    "mozmail.com",
    "msssg.com",
    "noomlocs.com",
    "numerobo.com",
    "owlny.com",
    "oziere.com",
    "payposs.com",
    "prorsd.com",
    "proton.me",
    "rmutsvmail.com",
    "sectorid.com",
    "shouxs.com",
    "suggets.com",
    "emaily.pro",
    "edny.net",
    "tutanota.com",
    "tuta.com"
];
const ShouldResearchCountries = [
    "australia",
    "austria",
    "bahrain",
    "belgium",
    "brazil",
    "brunei",
    "canada",
    "denmark",
    "finland",
    "france",
    "germany",
    "hong kong",
    "iceland",
    "ireland",
    "israel",
    "italy",
    "japan",
    "kuwait",
    "luxembourg",
    "macau",
    "netherlands",
    "new zealand",
    "norway",
    "portugal",
    "qatar",
    "san marino",
    "singapore",
    "south africa",
    "south korea",
    "spain",
    "sweden",
    "switzerland",
    "taiwan",
    "united arab emirates",
    "united kingdom",
    "united states"
];
const PersonEmailDomains = [
    ".edu",
    "yahoo.",
    "student",
    "outlook",
    "gmail.",
    "roboflow.",
    "qq.",
    "naver.",
    "hotmail.",
    "yahoo.",
    "163.",
    "mail.ru",
    "icloud.",
    "yandex.",
    "126.",
    "protomail.",
    "protonmail.",
    "live.com",
    "web.de",
    "gmx.de",
    "Kmitl.ac.th",
    "foxmail.com",
    "googlemail.com",
    "kkumail.com",
    "me.com",
    "hanmail.net",
    ".ac.kr",
    "pm.me",
    "proton.me",
    "urgent.be",
    "passmail.net",
    "vkr1.com",
    "139.com",
    "q.com",
    "proton.me",
    "mozmail.com",
    "live.cn",
    "o2.pl",
    "duck.com"
];
const LeadTableName = "crm";
const StudentEmailDomains = [
    ".edu",
    ".polyu.",
    "uva.nl",
    "student",
    "pm.szczecin.pl",
    "ba.estudante.senai.br",
    "campus.technion.ac.il",
    "conestogac.on.ca",
    "ctb.upm.es",
    ".ac.in",
    "estudiantes.unileon.es",
    "g.bracu.ac.bd",
    "g.ecc.u-tokyo.ac.jp",
    "g.kmou.ac.kr",
    "g.sut.ac.th",
    "hs-heilbronn.de",
    "imerir.com",
    "informatik.uni-kl.de",
    "interia.pl",
    "kdu.ac.lk",
    "kth.se",
    "ku.th",
    "kuleuven.be",
    "lhr.nu.edu.pk",
    "mail.kmutt.ac.th",
    "mail.mcgill.ca",
    "mail.pucv.cl",
    "mail.ugm.ac.id",
    "mca.christuniversity.in",
    "ms.dendai.ac.jp",
    "pcru.ac.th",
    "shinshu-u.ac.jp",
    "stud.h-da.de",
    "ualberta.ca",
    "ufms.br",
    "ufv.br",
    "umoncton.ca",
    "usal.es",
    "virtual.prc.ac.th",
    "vku.udn.vn",
    "ynl.t.u-tokyo.ac.jp",
    "york.ac.uk",
    ".ac.",
    "thu.de",
    "sansano.usm.cl",
    "cin.ufpe.br",
    ".hku",
    "inno.no",
    "uni-wuerzburg.de",
    "hst.aau.dk",
    "g.uporto.pt",
    "fe.up.pt",
    "campus.fct.unl.pt",
    "ipcbcampus.pt",
    "tecnico.ulisboa.pt",
    "alunos.",
    "academico",
    "estudante",
    "aluno.",
    "edu.",
    "studnet.",
    "universite.",
    "kmu.kr",
    "student.westherts.ac.uk",
    "westherts.ac.uk",
    "insa-toulouse.fr",
    "mbzuai.ac.ae",
    "uniceub.br",
    "student.karazin.ua",
    "karazin.ua",
    "usm.cl",
    "ieseg.fr",
    "rhul.ac.uk",
    "myport.ac.uk",
    "myport.port.ac.uk",
    "ac-paris.fr",
    "ac-aix-marseille.fr",
    "ac-creteil.fr",
    "upes.ac.in",
    "cstj.qc.ca",
    "davietjal.org",
    "lpu.in",
    "itt-tech.info",
    "student.42.us.org",
    "ddu.ac.in",
    "futureworks.ac.uk",
    "indianatech.net",
    "lambtoncollege.ca",
    "mylambton.ca",
    "usuhs.mil",
    "usafa.af.mil",
    "arts.ac.uk",
    "kumsa.net",
    "polytechnic-kabul.org",
    "upt.al",
    "epitech.al",
    "lagh-univ.dz",
    "umbb.dz",
    "ummto.dz",
    "univ-alger3.dz",
    "univ-alger.dz",
    "univ-annaba.dz",
    "univ-batna.dz",
    "univ-bejaia.dz",
    "univ-biskra.dz",
    "univ-blida.dz",
    "univ-chlef.dz",
    "univ-emir.dz",
    "univ-guelma.dz",
    "univ-jijel.dz",
    "univ-mosta.dz",
    "univ-msila.dz",
    "univ-oeb.dz",
    "univ-oran.dz",
    "univ-ouargla.dz",
    "univ-saida.dz",
    "univ-sba.dz",
    "univ-setif.dz",
    "univ-skikda.dz",
    "univ-tebessa.dz",
    "univ-tiaret.dz",
    "univ-tlemcen.dz",
    "univ-usto.dz",
    "usthb.dz",
    "uda.ad",
    "uan.ao",
    "ugs.ed.ao",
    "ulangola.net",
    "uma.co.ao",
    "unia.ao",
    "utanga.co.ao",
    "auamed.org",
    "uhsa.ag",
    "uba.ar",
    "ucasal.net",
    "armmed.am",
    "asau.am",
    "asue.am",
    "aua.am",
    "eiu.am",
    "eriicta.am",
    "haybusak.org",
    "rau.am",
    "seua.am",
    "ufar.am",
    "ysmu.am",
    "ysu.am",
    "adfa.oz.au",
    "nt.gov.au",
    "akbild.ac.at",
    "boku.ac.at",
    "donau-uni.ac.at",
    "fh-burgenland.at",
    "fh-hagenberg.at",
    "fh-joanneum.at",
    "fh-kaernten.ac.at",
    "fh-krems.ac.at",
    "fh-kufstein.ac.at",
    "fh-sbg.ac.at",
    "fh-steyr.at",
    "fh-stpoelten.ac.at",
    "fhv.at",
    "fh-vie.ac.at",
    "fhw.at",
    "fh-wels.at",
    "fhwn.ac.at",
    "imc-krems.ac.at",
    "i-med.ac.at",
    "ist.ac.at",
    "kfunigraz.ac.at",
    "khs-linz.ac.at",
    "kth-linz.ac.at",
    "kug.ac.at",
    "mdw.ac.at",
    "meduni-graz.at",
    "meduniwien.at",
    "moz.ac.at",
    "ns2.uni-ak.ac.at",
    "sbg.ac.at",
    "technikum-wien.at",
    "tugraz.at",
    "tuwien.ac.at",
    "uibk.ac.at",
    "umit.at",
    "uni-klu.ac.at",
    "unileoben.ac.at",
    "jku.at",
    "univie.ac.at",
    "vu-wien.ac.at",
    "webster.ac.at",
    "wu-wien.ac.at",
    "wu.ac.at",
    "ascca.gov.az",
    "az-npu.org",
    "bsu-edu.org",
    "conservatory.az",
    "khazar.org",
    "ahliauniversity.org",
    "aou.org.bh",
    "gulfuniversity.net",
    "asb.bh",
    "aub-bd.org",
    "bgctrustbd.org",
    "bracuniversity.net",
    "brur.ac.bd",
    "buet.ac.bd",
    "cou.ac.bd",
    "cu.ac.bd",
    "cuet.ac.bd",
    "diu.ac.bd",
    "diu.net.bd",
    "du.ac.bd",
    "duet.ac.bd",
    "hstu.ac.bd",
    "icu-edu.org",
    "iiuc.ac.bd",
    "iu.ac.bd",
    "jnu.ac.bd",
    "ku.ac.bd",
    "kuet.ac.bd",
    "lus.ac.bd",
    "manarat.ac.bd",
    "mbstu.ac.bd",
    "mist.ac.bd",
    "nub.ac.bd",
    "pstu.ac.bd",
    "pub.ac.bd",
    "puc.ac.bd",
    "pust.ac.bd",
    "ru.ac.bd",
    "ruet.ac.bd",
    "sau.ac.bd",
    "sec.ac.bd",
    "seu.ac.bd",
    "uiu.ac.bd",
    "ustc.ac.bd",
    "academy.mia.by",
    "baa.by",
    "belsut.gomel.by",
    "bntu.by",
    "brsu.brest.by",
    "bru.mogilev.by",
    "bseu.by",
    "bsmu.by",
    "bspu.unibel.by",
    "bstu.by",
    "bstu.unibel.by",
    "bsu.by",
    "bsuir.by",
    "buk.by",
    "grsmu.by",
    "grsu.by",
    "gstu.gomel.by",
    "gsu.unibel.by",
    "iseu.by",
    "kii.gov.by",
    "meduniver.gomel.by",
    "mgpu.gomel.by",
    "miu.by",
    "mslu.by",
    "msu.mogilev.by",
    "pac.by",
    "psu.by",
    "uni-agro.grodno.by",
    "vgmu.vitebsk.by",
    "vstu.vitebsk.by",
    "vsu.by",
    "brexgata.eu",
    "carolus-magnus-university.eu",
    "coleurope.eu",
    "ecam.be",
    "ehb.be",
    "ehsal.be",
    "europeaniu.org",
    "fpms.ac.be",
    "fsagx.ac.be",
    "fucam.ac.be",
    "ful.ac.be",
    "fundp.ac.be",
    "fusl.ac.be",
    "ha.be",
    "howest.be",
    "hzs.be",
    "ichec.be",
    "kdg.be",
    "khk.be",
    "khleuven.be",
    "khlim.be",
    "kubrussel.ac.be",
    "kulak.kuleuven.be",
    "kuleuven.be",
    "rma.ac.be",
    "ugent.be",
    "rug.ac.be",
    "thierryschool.org",
    "ua.ac.be",
    "uantwerpen.be",
    "uams.be",
    "ucl.ac.be",
    "ufsia.ac.be",
    "uhasselt.be",
    "ulb.be",
    "ulb.ac.be",
    "umh.ac.be",
    "vlekho.be",
    "vlerick.be",
    "vub.ac.be",
    "vub.be",
    "wenk.be",
    "odisee.be",
    "hogent.be",
    "thomasmore.be",
    "giuedu.bz",
    "westcoastuniversity.bz",
    "espam-formationuc.org",
    "hnaubenin.org",
    "uac.bj",
    "bercol.bm",
    "usfx.info",
    "aubih.ba",
    "sfa.ba",
    "spu.ba",
    "sve-mo.ba",
    "unbi.ba",
    "unibl.org",
    "unmo.ba",
    "unsa.ba",
    "unssa.rs.ba",
    "untz.ba",
    "unze.ba",
    "abm.ac.bw",
    "bac.ac.bw",
    "bca.bw",
    "biust.ac.bw",
    "bothocollege.ac.bw",
    "guc.co.bw",
    "neweracollege.ac.bw",
    "ub.bw",
    "baraodemaua.br",
    "brazcubas.br",
    "candidomendes.br",
    "castelobranco.br",
    "creupi.br",
    "emescam.br",
    "epm.br",
    "estacio.br",
    "faap.br",
    "faculdadescuritiba.br",
    "fic.br",
    "fua.br",
    "furb.rct-sc.br",
    "furg.br",
    "impa.br",
    "ime.eb.mil.br",
    "ita.br",
    "italo.br",
    "mackenzie.br",
    "maua.br",
    "newtonpaiva.br",
    "pop-to.rnp.br",
    "puccamp.br",
    "pucminas.br",
    "pucpr.br",
    "puc-rio.br",
    "pucrs.br",
    "pucsp.br",
    "saojudas.br",
    "smarcos.br",
    "sp.senac.br",
    "stcecilia.br",
    "toledo.br",
    "ucb.br",
    "ucg.br",
    "ucp.br",
    "ucpel.tche.br",
    "ucsal.br",
    "ucs.tche.br",
    "udesc.br",
    "uece.br",
    "uefs.br",
    "uel.br",
    "uema.br",
    "uem.br",
    "uenf.br",
    "uepg.br",
    "uerj.br",
    "uern.br",
    "uesb.br",
    "uesc.br",
    "uespi.br",
    "ufac.br",
    "ufal.br",
    "ufba.br",
    "ufc.br",
    "ufes.br",
    "uff.br",
    "ufg.br",
    "ufjf.br",
    "ufla.br",
    "ufma.br",
    "ufmg.br",
    "dcc.ufmg.br",
    "ufms.br",
    "ufmt.br",
    "ufop.br",
    "ufpa.br",
    "ufpb.br",
    "ufpe.br",
    "ufpel.tche.br",
    "ufpi.br",
    "ufpr.br",
    "ufrgs.br",
    "ufrj.br",
    "ufrn.br",
    "ufrpe.br",
    "ufrrj.br",
    "ufs.br",
    "ufscar.br",
    "ufsc.br",
    "ufsm.br",
    "ufu.br",
    "ufv.br",
    "ugf.br",
    "ulbra.br",
    "umc.br",
    "unaerp.br",
    "unama.br",
    "unb.br",
    "uneb.br",
    "unesc.rct-sc.br",
    "unesp.br",
    "ung.br",
    "uniban.br",
    "unib.br",
    "unibosco.br",
    "unicamp.br",
    "unicap.br",
    "unicastelo.br",
    "unicid.br",
    "unicruz.tche.br",
    "unicsul.br",
    "unidavi.rct-sc.br",
    "unifacs.br",
    "unifap.br",
    "unifenas.br",
    "unifor.br",
    "unifran.br",
    "unig.br",
    "unigranrio.br",
    "unijui.tche.br",
    "unimar.br",
    "unimep.br",
    "unimonte.br",
    "unimontes.br",
    "unioeste.br",
    "unipe.br",
    "unip-objetivo.br",
    "unir.br",
    "unirio.br",
    "unisa.br",
    "unisc.br",
    "unisinos.br",
    "unisul.br",
    "unitau.br",
    "unit.br",
    "uniube.br",
    "univale.br",
    "univali.rct-sc.br",
    "univap.br",
    "universo.br",
    "unoeste.br",
    "unp.br",
    "upe.br",
    "upf.tche.br",
    "upis.br",
    "urca.br",
    "urcamp.tche.br",
    "uri.br",
    "usc.br",
    "usf.br",
    "usp.br",
    "usu.br",
    "uva.br",
    "uvanet.br",
    "amti.hit.bg",
    "aubg.bg",
    "au-plovdiv.bg",
    "bfu.bg",
    "btu.bg",
    "cityu.bg",
    "ltu.bg",
    "meduniversity-plovdiv.bg",
    "mgu.bg",
    "mu-pleven.bg",
    "mu-sofia.bg",
    "mu-varna.bg",
    "natfiz.bg",
    "nbu.bg",
    "nha-bg.org",
    "nma.bg",
    "nsa.bg",
    "pv-ma.bg",
    "ru.acad.bg",
    "shu-bg.net",
    "swu.bg",
    "tugab.bg",
    "tu-sofia.bg",
    "tu-varna.acad.bg",
    "uacg.bg",
    "ue-varna.bg",
    "uft-plovdiv.bg",
    "uni-plovdiv.bg",
    "uni-sofia.bg",
    "uni-svishtov.bg",
    "uni-sz.bg",
    "uni-vt.bg",
    "unwe.acad.bg",
    "vfu.bg",
    "vumk.eu",
    "univ-ouaga.bf",
    "itbmu.org.mm",
    "most.gov.mm",
    "hopeafricauniversity.org",
    "ulbu.bi",
    "fomicgroup.cm",
    "ubuea.cm",
    "udesmontagnes.org",
    "unibda.net",
    "univ-dschang.org",
    "universite-yde2.org",
    "univ-ndere.cm",
    "uy1.uninet.cm",
    "acadiau.ca",
    "assumptionu.ca",
    "athabascau.ca",
    "augustana.ab.ca",
    "bcit.ca",
    "bcou.ca",
    "boothcollege.ca",
    "borealc.on.ca",
    "bowvalleycollege.ca",
    "brandonu.ca",
    "brocku.ca",
    "cal.devry.ca",
    "camosun.bc.ca",
    "capcollege.bc.ca",
    "cariboo.bc.ca",
    "carleton.ca",
    "ccbc.ca",
    "centennialcollege.ca",
    "cmu.ca",
    "cnc.bc.ca",
    "columbiacollege.ca",
    "concordia.ab.ca",
    "concordia.ca",
    "conestogac.on.ca",
    "cotr.bc.ca",
    "cus.ca",
    "cuslm.ca",
    "dal.ca",
    "douglas.bc.ca",
    "dcmail.ca",
    "eciad.bc.ca",
    "enap.uquebec.ca",
    "etsmtl.ca",
    "firstnationsuniversity.ca",
    "gbrownc.on.ca",
    "hec.ca",
    "humber.ca",
    "humbermail.ca",
    "huronuc.on.ca",
    "iaf.inrs.ca",
    "inrs.uquebec.ca",
    "kingsu.ab.ca",
    "kwantlen.bc.ca",
    "lakeheadu.ca",
    "langara.bc.ca",
    "langara.ca",
    "laurentian.ca",
    "macewan.ca",
    "mala.bc.ca",
    "mcgill.ca",
    "mcmaster.ca",
    "msvu.ca",
    "mta.ca",
    "mtroyal.ca",
    "nait.ca",
    "nic.bc.ca",
    "nipissingu.ca",
    "nlc.bc.ca",
    "nsac.ns.ca",
    "nscad.ns.ca",
    "nvit.bc.ca",
    "ocad.ca",
    "okanagan.bc.ca",
    "op.org",
    "picollege.ca",
    "polymtl.ca",
    "queensu.ca",
    "questu.ca",
    "redeemer.ca",
    "rmc.ca",
    "royalroads.ca",
    "ryerson.ca",
    "sait.ca",
    "sauder.ubc.ca",
    "scar.utoronto.ca",
    "selkirk.bc.ca",
    "senecacollege.ca",
    "myseneca.ca",
    "sfu.ca",
    "sheridancollege.ca",
    "stclairc.on.ca",
    "stclairconnect.ca",
    "myscc.ca",
    "stfx.ca",
    "stmarys.ca",
    "smu.ca",
    "stthomasu.ca",
    "teluq.uquebec.ca",
    "trentu.ca",
    "trinity.utoronto.ca",
    "tru.ca",
    "twu.ca",
    "ualberta.ca",
    "ubc.ca",
    "ubishops.ca",
    "ucalgary.ca",
    "uccb.ns.ca",
    "ufv.ca",
    "ucs.mun.ca",
    "ukings.ns.ca",
    "ulaval.ca",
    "uleth.ca",
    "umanitoba.ca",
    "umoncton.ca",
    "umontreal.ca",
    "unb.ca",
    "unbc.ca",
    "unbsj.ca",
    "universitycanadawest.ca",
    "uoguelph.ca",
    "uoit.ca",
    "uottawa.ca",
    "upei.ca",
    "uqac.ca",
    "uqam.ca",
    "uqar.uquebec.ca",
    "uqat.uquebec.ca",
    "uqo.ca",
    "uqtr.uquebec.ca",
    "uquebec.ca",
    "uregina.ca",
    "usask.ca",
    "usherb.ca",
    "usjc.uwaterloo.ca",
    "ustanne.ednet.ns.ca",
    "ustboniface.mb.ca",
    "ustpaul.ca",
    "utm.utoronto.ca",
    "utoronto.ca",
    "uvic.ca",
    "uwaterloo.ca",
    "uwindsor.ca",
    "uwinnipeg.ca",
    "uwo.ca",
    "vcc.ca",
    "vicu.utoronto.ca",
    "wlu.ca",
    "mylaurier.ca",
    "yorku.ca",
    "yukoncollege.yk.ca",
    "cv.unipiaget.org",
    "univ-bangui.net",
    "univ-ndjamena.org",
    "academia.cl",
    "arquitecturaucv.cl",
    "uc.cl",
    "uach.cl",
    "uaconcagua.cl",
    "uahurtado.cl",
    "uai.cl",
    "uamericas.cl",
    "uandes.cl",
    "uantof.cl",
    "uas.cl",
    "ubiobio.cl",
    "ubohiggins.cl",
    "ubolivariana.cl",
    "ubritanica.cl",
    "ucentral.cl",
    "ucervantes.cl",
    "uchile.cl",
    "ucinf.cl",
    "ucm.cl",
    "ucn.cl",
    "ucsc.cl",
    "ucsh.cl",
    "uctem.cl",
    "ucv.cl",
    "uda.cl",
    "udec.cl",
    "udelmar.cl",
    "udesarrollo.cl",
    "udp.cl",
    "ufinis.cl",
    "ufro.cl",
    "ufromail.cl",
    "ugm.cl",
    "uisek.cl",
    "ujso.cl",
    "ulagos.cl",
    "ulare.cl",
    "umag.cl",
    "umaritima.cl",
    "umayor.cl",
    "umce.cl",
    "ume.cl",
    "unab.cl",
    "unachile.cl",
    "unap.cl",
    "unfa.cl",
    "uniacc.cl",
    "unicit.cl",
    "universidadarcis.cl",
    "upacifico.cl",
    "upa.cl",
    "usach.cl",
    "usanandres.cl",
    "userena.cl",
    "uss.cl",
    "ust.cl",
    "uta.cl",
    "utalca.cl",
    "utem.cl",
    "utfsm.cl",
    "uv.cl",
    "uvipro.cl",
    "uvm.cl",
    "cqec.net.cn",
    "cqust.cn",
    "cqwu.net",
    "ecjtu.jx.cn",
    "hnfjxy.cn",
    "hqgc.net",
    "hunau.net",
    "njuts.cn",
    "shouhua.net.cn",
    "swsm.cn",
    "wzmu.net",
    "xza.cn",
    "yznu.cn",
    "zgfxy.cn",
    "znuel.net",
    "ucbc.org",
    "ucbukavu.ac.cd",
    "um-rdc.org",
    "uniband.org",
    "unikin.cd",
    "unikis.ac.cd",
    "unilu.ac.cd",
    "unishabunia.org",
    "universitekongo.org",
    "upc-rdc.cd",
    "univ-mngb.net",
    "fundepos.ac.cr",
    "itcr.ac.cr",
    "uaca.ac.cr",
    "uca.ac.cr",
    "ucatolica.ac.cr",
    "uci.ac.cr",
    "ucr.ac.cr",
    "ufidelitas.ac.cr",
    "uhispanoamericana.ac.cr",
    "uia.ac.cr",
    "ulacit.ac.cr",
    "ulasalle.ac.cr",
    "ulatina.ac.cr",
    "ulicori.ac.cr",
    "umca.net",
    "una.ac.cr",
    "unadeca.ac.cr",
    "unam.ac.cr",
    "uned.ac.cr",
    "unibe.ac.cr",
    "upeace.org",
    "usam.ac.cr",
    "utur.ac.cr",
    "uveritas.ac.cr",
    "uabobo.ci",
    "ubouake.ci",
    "univ-cocody.ci",
    "tabari.ac.ir",
    "unidu.hr",
    "unios.hr",
    "unipu.hr",
    "uniri.hr",
    "unist.hr",
    "unizd.hr",
    "unizg.hr",
    "zsem.hr",
    "vern.hr",
    "tvz.hr",
    "algebra.hr",
    "unin.hr",
    "ispcmw.rimed.cu",
    "udg.co.cu",
    "uh.cu",
    "umcc.cu",
    "unica.cu",
    "ac.ac.cy",
    "ciim.ac.cy",
    "ctleuro.ac.cy",
    "cut.ac.cy",
    "cycollege.ac.cy",
    "euc.ac.cy",
    "frederick.ac.cy",
    "intercollege.ac.cy",
    "ouc.ac.cy",
    "ucy.ac.cy",
    "unic.ac.cy",
    "cuni.cz",
    "cvut.cz",
    "fa.cvut.cz",
    "fit.cvut.cz",
    "czu.cz",
    "famu.cz",
    "jcu.cz",
    "mendelu.cz",
    "mpu-prague.cz",
    "muni.cz",
    "osu.cz",
    "praguecollege.cz",
    "slu.cz",
    "tiffinprague.cz",
    "ujep.cz",
    "unva.cz",
    "unyp.cz",
    "upce.cz",
    "upol.cz",
    "utb.cz",
    "vfu.cz",
    "vsb.cz",
    "vscht.cz",
    "vsci.cz",
    "vse.cz",
    "vslib.cz",
    "vsp.cz",
    "vutbr.cz",
    "vut.cz",
    "zcu.cz",
    "a-aarhus.dk",
    "ah.dk",
    "ats.dk",
    "auc.dk",
    "aau.dk",
    "student.aau.dk",
    "au.dk",
    "cbs.dk",
    "db.dk",
    "ddea.dk",
    "dfh.dk",
    "dkdm.dk",
    "dlh.dk",
    "dpu.dk",
    "dtu.dk",
    "hha.dk",
    "hhs.dk",
    "ibss.eu",
    "iha.dk",
    "ihk.dk",
    "ipc.dk",
    "itu.dk",
    "karch.dk",
    "ku.dk",
    "kunstakademiet.dk",
    "kvl.dk",
    "musik-kons.dk",
    "ou.dk",
    "ruc.dk",
    "sdu.dk",
    "teologi.dk",
    "tietgen.dk",
    "en.via.dk",
    "dsc.dm",
    "newworld.ac",
    "ueb.isfun.net",
    "uisrael.ec",
    "msa.eun.eg",
    "usenghor-francophonie.org",
    "unge.gq",
    "artun.ee",
    "ebs.ee",
    "emu.ee",
    "nooruse.ee",
    "sisekaitse.ee",
    "tktk.ee",
    "tlu.ee",
    "ttu.ee",
    "ut.ee",
    "aastu.org",
    "setur.fo",
    "fnu.ac.fj",
    "fsm.ac.fj",
    "unifiji.ac.fj",
    "usp.ac.fj",
    "abo.fi",
    "cou.fi",
    "diak.fi",
    "evtek.fi",
    "helsinki.fi",
    "hkkk.fi",
    "hut.fi",
    "joensuu.fi",
    "jyu.fi",
    "kuva.fi",
    "lamk.fi",
    "student.lamk.fi",
    "laurea.fi",
    "student.laurea.fi",
    "lut.fi",
    "student.lut.fi",
    "oamk.fi",
    "oulu.fi",
    "puv.fi",
    "ramk.fi",
    "samk.fi",
    "scp.fi",
    "shh.fi",
    "siba.fi",
    "teak.fi",
    "tpu.fi",
    "tukkk.fi",
    "tut.fi",
    "uiah.fi",
    "uku.fi",
    "ulapland.fi",
    "uta.fi",
    "utu.fi",
    "uwasa.fi",
    "aalto.fi",
    "metropolia.fi",
    "student.42.fr",
    "aea.asso.fr",
    "agroparistech.fr",
    "agro.roazhon.inra.fr",
    "agrosupdijon.fr",
    "aup.fr",
    "bip.lon.ac.uk",
    "cesi.fr",
    "cnam.fr",
    "cnearc.fr",
    "cpe.fr",
    "cribx1.u-bordeaux.fr",
    "cust.univ-bpclermont.fr",
    "dauphine.fr",
    "devinci.fr",
    "e3i.univ-tours.fr",
    "eap.fr",
    "ecam.fr",
    "ece.fr",
    "imt-atlantique.net",
    "ec-lille.fr",
    "ec-lyon.fr",
    "ec-nantes.fr",
    "centrale-marseille.fr",
    "eerie.fr",
    "efpg.inpg.fr",
    "efrei.fr",
    "eivp-paris.fr",
    "emse.fr",
    "enac.fr",
    "ena.fr",
    "enic.fr",
    "enim.fr",
    "enise.fr",
    "enitab.fr",
    "enitac.fr",
    "enit.fr",
    "enitiaa-nantes.fr",
    "enm.meteo.fr",
    "enpc.fr",
    "ens2m.fr",
    "ensae.fr",
    "ensaia.u-nancy.fr",
    "ensai.fr",
    "ensait.fr",
    "ensam.inra.fr",
    "ensat.fr",
    "ens-cachan.fr",
    "ensccf.univ-bpclermont.fr",
    "ensc-lille.fr",
    "enscm.fr",
    "enscmu.univ-mulhouse.fr",
    "enscpb.u-bordeaux.fr",
    "enscp.jussieu.fr",
    "ensc-rennes.fr",
    "ensea.fr",
    "enseeiht.fr",
    "ensem.u-nancy.fr",
    "enserb.u-bordeaux.fr",
    "ens-fcl.fr",
    "ens.fr",
    "ensg.ign.fr",
    "ensg.u-nancy.fr",
    "ensica.fr",
    "ensic.u-nancy.fr",
    "ensieta.fr",
    "ensitm.fr",
    "ens-lyon.fr",
    "ensma.fr",
    "ensm-ales.fr",
    "mines-ales.fr",
    "mines-ales.org",
    "ensm-douai.fr",
    "ensmp.fr",
    "enspm.u-3mrs.fr",
    "ensta.fr",
    "enst-bretagne.fr",
    "enst.fr",
    "entpe.fr",
    "envt.fr",
    "epf.fr",
    "esa-purpan.fr",
    "esc-bordeaux.fr",
    "esc-brest.fr",
    "esc-clermont.fr",
    "escem.fr",
    "esc-lille.fr",
    "esc-marseille.fr",
    "escna.fr",
    "esc-normandie.fr",
    "escom.fr",
    "esc-pau.fr",
    "escp.fr",
    "escp.eu",
    "edu.escp.eu",
    "esc-rouen.fr",
    "esc-toulouse.fr",
    "eseo.fr",
    "esiae.fr",
    "esiea.fr",
    "esiee.fr",
    "esigelec.fr",
    "esim.imt-mrs.fr",
    "esitpa.org",
    "esme.fr",
    "espci.fr",
    "essca.asso.fr",
    "essec.fr",
    "esstin.u-nancy.fr",
    "estp.fr",
    "eudil.fr",
    "fupl.asso.fr",
    "esc-grenoble.fr",
    "hec.fr",
    "hei.fr",
    "icam.fr",
    "icp.fr",
    "ict-toulouse.asso.fr",
    "iep.u-bordeaux.fr",
    "ifp.fr",
    "inp-fc.fr",
    "inpl-nancy.fr",
    "insa-lyon.fr",
    "insa-rennes.fr",
    "insa-rouen.fr",
    "insa-tlse.fr",
    "inseec.fr",
    "int-evry.fr",
    "iota.u-psud.fr",
    "ircam.fr",
    "ireste.fr",
    "isab.fr",
    "isa.fupl.asso.fr",
    "isara.fr",
    "isen.fr",
    "isep.fr",
    "isim.univ-montp2.fr",
    "ismcm-cesti.fr",
    "ismra.fr",
    "itech.fr",
    "jussieu.fr",
    "etu.upmc.fr",
    "upmc.fr",
    "etu.sorbonne-universite.fr",
    "sorbonne-universite.fr",
    "mines.u-nancy.fr",
    "montaigne.u-bordeaux.fr",
    "montesquieu.u-bordeaux.fr",
    "nancy.archi.fr",
    "paris4.sorbonne.fr",
    "paris.ensam.fr",
    "polytech-lille.fr",
    "polytech-marseille.fr",
    "polytechnique.fr",
    "sciences-po.fr",
    "sciencespo.fr",
    "sigu7.jussieu.fr",
    "sorbon.fr",
    "supaero.fr",
    "supco-amiens.fr",
    "supco-montpellier.fr",
    "supelec.fr",
    "u-3mrs.fr",
    "u-bordeaux2.fr",
    "ubfc.fr",
    "u-cergy.fr",
    "u-clermont1.fr",
    "uco.fr",
    "u-grenoble3.fr",
    "univ-grenoble-alpes.fr",
    "ujf-grenoble.fr",
    "uhb.fr",
    "uhp-nancy.fr",
    "unicaen.fr",
    "unice.fr",
    "unilim.fr",
    "univ-angers.fr",
    "univ-artois.fr",
    "univ-avignon.fr",
    "univ-bpclermont.fr",
    "univ-brest.fr",
    "univ-catholyon.fr",
    "univ-corse.fr",
    "univ-evry.fr",
    "univ-inpt.fr",
    "univ-lehavre.fr",
    "univ-lemans.fr",
    "univ-lille1.fr",
    "univ-lille2.fr",
    "univ-lille3.fr",
    "univ-littoral.fr",
    "univ-lorraine.fr",
    "univ-lr.fr",
    "univ-lyon1.fr",
    "univ-lyon2.fr",
    "univ-lyon3.fr",
    "univmed.fr",
    "univ-metz.fr",
    "univ-mlv.fr",
    "u-pem.fr",
    "etud.u-pem.fr",
    "univ-montp1.fr",
    "univ-montp2.fr",
    "univ-montp3.fr",
    "univ-mulhouse.fr",
    "uha.fr",
    "univ-nancy2.fr",
    "univ-nantes.fr",
    "univ-orleans.fr",
    "univ-paris12.fr",
    "univ-paris13.fr",
    "univ-paris1.fr",
    "univ-paris3.fr",
    "univ-paris5.fr",
    "univ-paris8.fr",
    "univ-pau.fr",
    "univ-perp.fr",
    "univ-poitiers.fr",
    "univ-reims.fr",
    "univ-rennes1.fr",
    "univ-rouen.fr",
    "univ-savoie.fr",
    "univ-st-etienne.fr",
    "univ-tln.fr",
    "univ-tlse1.fr",
    "univ-tlse2.fr",
    "univ-toulouse.fr",
    "univ-tours.fr",
    "univ-ubs.fr",
    "univ-valenciennes.fr",
    "u-paris10.fr",
    "u-paris2.fr",
    "u-picardie.fr",
    "ups-tlse.fr",
    "u-psud.fr",
    "univ-amu.fr",
    "up.univ-mrs.fr",
    "ushs.u-strasbg.fr",
    "utbm.fr",
    "utc.fr",
    "utt.fr",
    "uvsq.fr",
    "vet-alfort.fr",
    "vet-lyon.fr",
    "vet-nantes.fr",
    "www-ecpm.u-strasbg.fr",
    "www-engees.u-strasbg.fr",
    "www-ensais.u-strasbg.fr",
    "grenoble-inp.fr",
    "inpg.fr",
    "www-ensps.u-strasbg.fr",
    "www-ulp.u-strasbg.fr",
    "www-urs.u-strasbg.fr",
    "unistra.fr",
    "etu.unistra.fr",
    "epitech.eu",
    "epitech.net",
    "epita.fr",
    "ipsa.fr",
    "etna.io",
    "supbiotech.fr",
    "univ-ag.fr",
    "upf.pf",
    "uob.ga",
    "euclid.int",
    "esm-tbilisi.ge",
    "sangu.ge",
    "akad.de",
    "asfh-berlin.de",
    "augustana.de",
    "bethel.de",
    "bits-iserlohn.de",
    "cbs.de",
    "code.berlin",
    "dhv-speyer.de",
    "diploma.de",
    "dshs-koeln.de",
    "eap.net",
    "eba-muenchen.de",
    "ebs.de",
    "ecla.de",
    "efh-bochum.de",
    "eh-darmstadt.de",
    "efh-freiburg.de",
    "efh-hannover.de",
    "efhlu.de",
    "efh-reutlingen-ludwigsburg.de",
    "ehs-dresden.de",
    "ems-mainz.de",
    "eufh.de",
    "euv-frankfurt-o.de",
    "evfh-berlin.de",
    "evfh-nuernberg.de",
    "fern-fh.de",
    "fernuni-hagen.de",
    "fh-aachen.de",
    "fh-aschaffenburg.de",
    "fh-augsburg.de",
    "fh-bad-honnef.de",
    "fh-biberach.de",
    "fh-bielefeld.de",
    "fh-bingen.de",
    "fh-bochum.de",
    "hochschule-bonn-rhein-sieg.de",
    "h-brs.de",
    "fh-brandenburg.de",
    "th-brandenburg.de",
    "th-deg.de",
    "fh-dortmund.de",
    "hs-duesseldorf.de",
    "fhdw.bib.de",
    "fhdw.de",
    "fh-eberswalde.de",
    "fh-erfurt.de",
    "fh-flensburg.de",
    "fh-frankfurt.de",
    "fh-fresenius.de",
    "fh-furtwangen.de",
    "fh-gelsenkirchen.de",
    "fh-giessen.de",
    "fh-hamburg.de",
    "haw-hamburg.de",
    "fh-hannover.de",
    "fh-heidelberg.de",
    "fh-heilbronn.de",
    "fh-hildesheim.de",
    "fh-hof.de",
    "thi.de",
    "fh-isny.de",
    "fh-jena.de",
    "fh-karlsruhe.de",
    "fh-kempten.de",
    "fh-kiel.de",
    "fh-kl.de",
    "fh-koblenz.de",
    "th-koeln.de",
    "fh-koeln.de",
    "fh-konstanz.de",
    "fhkt.de",
    "fh-landshut.de",
    "fh-lausitz.de",
    "fh-lippe.de",
    "fh-ludwigshafen.de",
    "fh-luebeck.de",
    "fh-mainz.de",
    "fh-mannheim.de",
    "fh-merseburg.de",
    "fhm-mittelstand.de",
    "fh-muenchen.de",
    "fh-muenster.de",
    "fh-nb.de",
    "hs-neu-ulm.de",
    "fh-niederrhein.de",
    "fhnon.de",
    "fh-nordhausen.de",
    "fh-nuernberg.de",
    "fh-nuertingen.de",
    "fhoebb.de",
    "fh-offenburg.de",
    "fh-oow.de",
    "fh-osnabrueck.de",
    "fh-ottersberg.de",
    "fh-pforzheim.de",
    "fh-potsdam.de",
    "fh-regensburg.de",
    "fh-reutlingen.de",
    "fh-riedlingen.de",
    "fh-rosenheim.de",
    "fh-rottenburg.de",
    "fh-schmalkalden.de",
    "fh-schwaebischhall.de",
    "fhs-mannheim.de",
    "fhs-moritzburg.de",
    "fh-stralsund.de",
    "fh-telekom-leipzig.de",
    "fh-trier.de",
    "fht-stuttgart.de",
    "fhtw-berlin.de",
    "htw-berlin.de",
    "hs-ulm.de",
    "fhvr.berlin.de",
    "fhw-berlin.de",
    "fh-wedel.de",
    "fh-weihenstephan.de",
    "fh-weingarten.de",
    "fh-westkueste.de",
    "fh-wiesbaden.de",
    "ostfalia.de",
    "fh-wolfenbuettel.de",
    "fh-worms.de",
    "fhwt.de",
    "fh-wuerzburg.de",
    "fh-zwickau.de",
    "fom.de",
    "fu-berlin.de",
    "hanseuni.de",
    "hcu-hamburg.de",
    "hdm-stuttgart.de",
    "hertie-school.org",
    "hfb.de",
    "hfg-gmuend.de",
    "hfph.mwn.de",
    "hfp.mhn.de",
    "hhl.de",
    "himh.de",
    "hjs.uni-heidelberg.de",
    "hs-albsig.de",
    "hs-anhalt.de",
    "student.hs-anhalt.de",
    "hs-bremen.de",
    "hs-bremerhaven.de",
    "hs-coburg.de",
    "h-da.de",
    "hs-esslingen.de",
    "hs-fulda.de",
    "hs-harz.de",
    "hs-magdeburg.de",
    "hs-wismar.de",
    "hs-zigr.de",
    "htw-dresden.de",
    "htwk-leipzig.de",
    "htwm.de",
    "hs-mittweida.de",
    "campus-m-university.de",
    "campusm21.de",
    "htw-saarland.de",
    "hu-berlin.de",
    "hwp-hamburg.de",
    "ihi-zittau.de",
    "international.fh-aalen.de",
    "ism-dortmund.de",
    "isnm.de",
    "i-u.de",
    "jacobs-university.de",
    "karlshochschule.de",
    "kath-fh-nord.de",
    "kfb-berlin.de",
    "kfh-freiburg.de",
    "kfh-mainz.de",
    "kfhnw.de",
    "kh-berlin.de",
    "khsa.de",
    "ksfh.de",
    "ku-eichstaett.de",
    "kunstakademie-duesseldorf.de",
    "merkur-fh.org",
    "merz-akademie.de",
    "mfh-iserlohn.de",
    "mh-hannover.de",
    "mh-trossingen.de",
    "mu-luebeck.de",
    "muthesius.de",
    "nordakademie.de",
    "paderborn.de",
    "pfh-goettingen.de",
    "ph-erfurt.de",
    "ph-freiburg.de",
    "ph-gmuend.de",
    "ph-heidelberg.de",
    "philtheol-augustin.de",
    "ph-karlsruhe.de",
    "ph-ludwigsburg.de",
    "ph-weingarten.de",
    "popakademie.de",
    "privatfh-da.de",
    "pth-bb.de",
    "pth-muenster.de",
    "pthv.de",
    "rauheshaus.de",
    "rfh-koeln.de",
    "ruhr-uni-bochum.de",
    "rwth-aachen.de",
    "selk.de",
    "siewerth-akademie.de",
    "siu-heidelberg.de",
    "srh-berlin.de",
    "st-georgen.uni-frankfurt.de",
    "stw.de",
    "tfh-berlin.de",
    "tfh-bochum.de",
    "tfh-wildau.de",
    "thh-friedensau.de",
    "tiho-hannover.de",
    "tu-berlin.de",
    "tu-braunschweig.de",
    "tu-bs.de",
    "tu-chemnitz.de",
    "tu-clausthal.de",
    "tu-cottbus.de",
    "tu-darmstadt.de",
    "tu-dresden.de",
    "tu-freiberg.de",
    "tuhh.de",
    "tu-ilmenau.de",
    "tum.de",
    "mytum.de",
    "uni-augsburg.de",
    "uni-bamberg.de",
    "uni-bayreuth.de",
    "uni-bielefeld.de",
    "uni-bonn.de",
    "uni-bremen.de",
    "unibw-hamburg.de",
    "unibw-muenchen.de",
    "tu-dortmund.de",
    "uni-duesseldorf.de",
    "uni-duisburg-essen.de",
    "uni-erfurt.de",
    "fau.de",
    "uni-erlangen.de",
    "uni-flensburg.de",
    "uni-frankfurt.de",
    "uni-freiburg.de",
    "uni-giessen.de",
    "uni-goettingen.de",
    "uni-greifswald.de",
    "uni-halle.de",
    "uni-hamburg.de",
    "uni-hannover.de",
    "uni-heidelberg.de",
    "uni-hildesheim.de",
    "uni-hohenheim.de",
    "uni-jena.de",
    "uni-kassel.de",
    "uni-kiel.de",
    "uni-kl.de",
    "uni-koblenz-landau.de",
    "uni-koeln.de",
    "uni-konstanz.de",
    "uni-leipzig.de",
    "uni-lueneburg.de",
    "uni-magdeburg.de",
    "uni-mainz.de",
    "uni-mannheim.de",
    "uni-marburg.de",
    "lmu.de",
    "uni-muenchen.de",
    "uni-muenster.de",
    "wwu.de",
    "uol.de",
    "uni-oldenburg.de",
    "uni-osnabrueck.de",
    "uni-paderborn.de",
    "uni-passau.de",
    "uni-potsdam.de",
    "uni-polsdam.de",
    "uni-regensburg.de",
    "uni-rostock.de",
    "uni-saarland.de",
    "uni-siegen.de",
    "uni-stuttgart.de",
    "uni-trier.de",
    "uni-tuebingen.de",
    "uni-ulm.de",
    "uni-vechta.de",
    "uni-weimar.de",
    "uni-wh.de",
    "uni-wuerzburg.de",
    "uni-wuppertal.de",
    "whu-koblenz.de",
    "acighana.org",
    "ghanacu.org",
    "regentghana.net",
    "zucghana.org",
    "acg.gr",
    "aegean.gr",
    "aspete.gr",
    "agsm.gr",
    "asfa.gr",
    "aua.gr",
    "aueb.gr",
    "auth.gr",
    "cityu.gr",
    "duth.gr",
    "eap.gr",
    "hua.gr",
    "ihu.gr",
    "ntua.gr",
    "panteion.gr",
    "sse.army.gr",
    "sse.gr",
    "uniwa.gr",
    "hmu.gr",
    "tuc.gr",
    "ionio.gr",
    "unipi.gr",
    "uoa.gr",
    "uoc.gr",
    "uoi.gr",
    "uom.gr",
    "uop.gr",
    "uowm.gr",
    "upatras.gr",
    "uth.gr",
    "ilisimatusarfik.gl",
    "univ-antilles.fr",
    "uganc.org",
    "ujnk.org",
    "univ-kag.org",
    "utad-petel-edu.org",
    "greenheartmed.org",
    "tauedu.org",
    "auchaiti.org",
    "ucnh.org",
    "undh.org",
    "uneph.org",
    "pust.urbe.it",
    "unigre.urbe.it",
    "upra.org",
    "ups.urbe.it",
    "uth.hn",
    "hku.hk",
    "ln.hk",
    "connect.polyu.hk",
    "ust.hk",
    "connect.ust.hk",
    "eduhk.hk",
    "agr.unideb.hu",
    "andrassyuni.hu",
    "arts7.hu",
    "avicenna.hu",
    "bdtf.hu",
    "bke.hu",
    "bme.hu",
    "ceu.hu",
    "dote.hu",
    "drk.hu",
    "duf.hu",
    "efe.hu",
    "ehf.hu",
    "elte.hu",
    "filmacademy.hu",
    "hiete.hu",
    "hupe.hu",
    "jpte.hu",
    "kee.hu",
    "kgre.hu",
    "kodolanyi.hu",
    "lfze.hu",
    "lib.klte.hu",
    "mif.hu",
    "nyme.hu",
    "pote.hu",
    "ppke.hu",
    "pte.hu",
    "sote.hu",
    "sze.hu",
    "szie.hu",
    "tkbf.hu",
    "unideb.hu",
    "uni-miskolc.hu",
    "uni-pannon.hu",
    "univet.hu",
    "u-szeged.hu",
    "bifrost.is",
    "hi.is",
    "holar.is",
    "hsvest.is",
    "hvanneyri.is",
    "iti.is",
    "khi.is",
    "lhi.is",
    "ru.is",
    "unak.is",
    "ntruhs.ap.nic.in",
    "aaidu.org",
    "aau.ac.in",
    "aiims.ac.in",
    "aisectuniversity.ac.in",
    "alagappauniversity.ac.in",
    "alldunivpio.org",
    "altmedworld.net",
    "amu.ac.in",
    "andhrauniversity.info",
    "angrau.net",
    "annamalaiuniversity.ac.in",
    "apsurewa.nic.in",
    "assamuniversity.nic.in",
    "bamu.net",
    "bamu.nic.in",
    "banasthali.org",
    "bau.nic.in",
    "bbauindia.org",
    "bdu.ernet.in",
    "becs.ac.in",
    "bharathi.ernet.in",
    "bhu.ac.in",
    "bhub.ori.nic.in",
    "bitmesraranchi.org",
    "bits-pilani.ac.in",
    "bnmu.in",
    "bput.org",
    "brabu.net",
    "braou.ac.in",
    "nitj.ac.in",
    "bsauniv.ac.in",
    "bubhopal.nic.in",
    "vitbhopal.ac.in",
    "bundelkhanduniversity.org",
    "burdwanuniversity.ac.in",
    "caluniv.ac.in",
    "cau.org.in",
    "ccsuniversity.ac.in",
    "ccsuniversity.org",
    "cesbm.ac.in",
    "christuniversity.in",
    "ciefl.org",
    "cihts.ac.in",
    "csauk.ac.in",
    "cusat.ac.in",
    "cvru.ac.in",
    "da-iict.org",
    "davuniversity.org",
    "davv.ac.in",
    "dbatechuni.org",
    "dbskkv.org",
    "dbs.tn.nic.in",
    "dceonline.net",
    "deccancollegepune.ac.in",
    "coeptech.ac.in",
    "dei.ac.in",
    "dibru.ernet.in",
    "dravidianuniversity.ac.in",
    "du.ac.in",
    "dypatiluniversity.org",
    "eiilmuniversity.ac.in",
    "fatimacollege.net",
    "fri.icfre.gov.in",
    "gbpuat.ac.in",
    "ggu.ac.in",
    "gipe.ernet.in",
    "gju.ernet.in",
    "gkvharidwar.org",
    "gnduonline.org",
    "government.ind.in",
    "gtu.ac.in",
    "gujaratuniversity.org.in",
    "gulbargauniversity.kar.nic.in",
    "gu.nic.in",
    "gurukuluniversity.org",
    "hau.ernet.in",
    "hillagric.ernet.in",
    "hnbgu.ac.in",
    "hpuniv.nic.in",
    "iari.ernet.in",
    "iaseduniv.org",
    "icfai.org",
    "ifheindia.org",
    "igidr.ac.in",
    "igims.org",
    "ignou.ac.in",
    "iiitmk.ac.in",
    "iiitd.ac.in",
    "iiit-bh.ac.in",
    "iiitb.ac.in",
    "iimtrichy.ac.in",
    "iiitg.ac.in",
    "iiitvadodara.ac.in",
    "iiitkota.ac.in",
    "iipsindia.org",
    "iisc.ernet.in",
    "iisc.ac.in",
    "iitb.ac.in",
    "iitd.ernet.in",
    "iitd.ac.in",
    "iitgn.ac.in",
    "iitg.ernet.in",
    "iitg.ac.in",
    "iith.ac.in",
    "iitk.ac.in",
    "iitkgp.ernet.in",
    "iitm.ac.in",
    "iitr.ac.in",
    "iitp.ac.in",
    "iiti.ac.in",
    "iitj.ac.in",
    "ilidelhi.org",
    "indusuni.ac.in",
    "integraluniversity.ac.in",
    "ipu.ac.in",
    "isbm.org.in",
    "isical.ac.in",
    "ismdhanbad.ac.in",
    "iur.ac.in",
    "ivri.nic.in",
    "jainuniversity.org",
    "jammuvarsity.org",
    "jiit.ac.in",
    "jmi.nic.in",
    "jncasr.ac.in",
    "jnkvv.nic.in",
    "jntu.ac.in",
    "jnu.ac.in",
    "jnujaipur.ac.in",
    "jpv.bih.nic.in",
    "jrnrvu.org",
    "jvbi.ac.in",
    "kanchiuniv.ac.in",
    "kannadauniversity.org",
    "kannuruniversity.ac.in",
    "kanpuruniversity.org",
    "kanpuruniversity.org",
    "karnatakastateopenuniversity.in",
    "kashmiruniversity.net",
    "keralauniversity.ac.in",
    "kimi.kohinoor.ac.in",
    "klyuniv.ac.in",
    "krishnauniversity.ac.in",
    "kslu.ac.in",
    "kud.ac.in",
    "kufos.ac.in",
    "kct.ac.in",
    "kumaununiversity.org",
    "kuvempu.ac.in",
    "ldceahd.org",
    "lnmu.bih.nic.in",
    "lucknowuniv.org",
    "macfast.org",
    "magadhuniversity.org",
    "mangaloreuniversity.ac.in",
    "manipur.nic.in",
    "manuu.ac.in",
    "mcu.ac.in",
    "mdsuajmer.ac.in",
    "mgkvp.ac.in",
    "mgsubikaner.ac.in",
    "mgu.ac.in",
    "mjpru.ac.in",
    "mkv2.mah.nic.in",
    "mlsu.ac.in",
    "mnnit.ac.in",
    "mpbou.org",
    "mpkv.mah.nic.in",
    "msubaroda.ac.in",
    "mu.ac.in",
    "nagarjunauniversity.ac.in",
    "nagauniv.org.in",
    "nalandaopenuniversity.info",
    "nationalmuseumindia.org",
    "nbu.ac.in",
    "ndri.nic.in",
    "nduat.nic.in",
    "nehu.ac.in",
    "ngu.ac.in",
    "nimhans.kar.nic.in",
    "nims.ap.nic.in",
    "nims.net.in",
    "nirmauni.ac.in",
    "nita.ac.in",
    "nitandhra.ac.in",
    "nitap.in",
    "nitc.ac.in",
    "nitdelhi.ac.in",
    "nitdgp.ac.in",
    "nitgoa.ac.in",
    "nith.ac.in",
    "nitjsr.ac.in",
    "nitkkr.net",
    "nitmanipur.ac.in",
    "nitm.ac.in",
    "nitmz.ac.in",
    "nitnagaland.ac.in",
    "nitp.ac.in",
    "nitpy.ac.in",
    "nitrr.ac.in",
    "nitrkl.ac.in",
    "nitsikkim.ac.in",
    "nits.ac.in",
    "nitsri.net",
    "nitk.ac.in",
    "nituk.ac.in",
    "nitw.ernet.in",
    "nls.ac.in",
    "nmu.ac.in",
    "nsit.ac.in",
    "osmania.ac.in",
    "padmavatiwomen-univ.org",
    "pdpu.ac.in",
    "pdkv.ac.in",
    "paruluniversity.ac.in",
    "pec.ac.in",
    "pgimer.nic.in",
    "pondiuni.org",
    "ptetjnvu.org",
    "ptu.ac.in",
    "puchd.ac.in",
    "punjabiuniversity.ac.in",
    "puonline.bih.nic.in",
    "pusavarsity.org.in",
    "rabindrabharatiuniversity.net",
    "ranchiuniversity.org.in",
    "raubikaner.org",
    "rdunijbpin.org",
    "rgtu.net",
    "rgu.ac.in",
    "riths.ac.in",
    "rmlau.ac.in",
    "rtu.ac.in",
    "ruraluniversity-chitrakoot.org",
    "sagaruniversity.nic.in",
    "sambalpuruniversitypgc.in",
    "sanskrit.nic.in",
    "sastra.ac.in",
    "sathyabamauniv.ac.in",
    "sctimst.ker.nic.in",
    "sgpgi.ac.in",
    "sgu.ernet.in",
    "shobhituniversity.ac.in",
    "shridharuniversity.ac.in",
    "simhapuriuniv.ac.in",
    "sjsv.nic.in",
    "skuastkashmir.ac.in",
    "skuniv.ap.nic.in",
    "slbsrsv.ac.in",
    "smkfomra.net",
    "soauniversity.ac.in",
    "southasianuniversity.org",
    "spa.ac.in",
    "spuniv.org",
    "srisathyasai.org.in",
    "srkdc.org",
    "srmuniv.ac.in",
    "srtmun.org",
    "ssgmce.org",
    "ssus.ac.in",
    "ssvv.up.nic.in",
    "su.digitaluniversity.ac",
    "svbpuctm.org",
    "svnit.ac.in",
    "svimstpt.ap.nic.in",
    "svuni.ap.nic.in",
    "tamiluniversity.ac.in",
    "teluguuniversity.ac.in",
    "tezu.ernet.in",
    "tiet.ac.in",
    "tmbu.org",
    "tndalu.org",
    "tnmmu.ac.in",
    "tnuniv.ac.in",
    "manit.ac.in",
    "mnit.ac.in",
    "tripurauniv.in",
    "tshmc.org",
    "tumkuruniversity.ac.in",
    "tvuni.in",
    "uasbng.kar.nic.in",
    "uasd.net",
    "uktech.ac.in",
    "uma.ac.in",
    "unical.ac.in",
    "unigoa.ac.in",
    "uni-mysore.ac.in",
    "unipune.ernet.in",
    "uniraj.org",
    "unishivaji.ac.in",
    "unom.ac.in",
    "uohyd.ernet.in",
    "uok.ac.in",
    "uor.org",
    "uou.ac.in",
    "uptu.ac.in",
    "utkaluniv.org",
    "vbspu.ac.in",
    "vbu.co.in",
    "vidyasagar.ac.in",
    "vignanuniversity.org",
    "vikramuniversity.org",
    "visva-bharati.ac.in",
    "vit.ac.in",
    "vksu-ara.org",
    "vmou.ac.in",
    "vnitnagpur.ac.in",
    "vssut.ac.in",
    "vtu.ac.in",
    "wbuafs.nic.in",
    "wbut.net",
    "ysparmaruniversity.org",
    "akfarmitseda.ac.id",
    "akprind.ac.id",
    "amikom.ac.id",
    "stikesrsanwarmedika.ac.id",
    "atmajaya.ac.id",
    "bakrie.ac.id",
    "binus.ac.id",
    "stikes-ppni.ac.id",
    "bunghatta.ac.id",
    "dinus.ac.id",
    "gunadarma.ac.id",
    "ibnuchaldun.ac.id",
    "indonusa.ac.id",
    "ipb.ac.id",
    "ista.ac.id",
    "itats.ac.id",
    "itb.ac.id",
    "its.ac.id",
    "janabadra.ac.id",
    "jayabaya.ac.id",
    "machung.ac.id",
    "umaha.ac.id",
    "mahendradatta.org",
    "um.ac.id",
    "mercubuana.ac.id",
    "moestopo.ac.id",
    "narotama.ac.id",
    "nommensen.org",
    "pancabudi.ac.id",
    "paramadina.ac.id",
    "pasim.ac.id",
    "perbanas.ac.id",
    "perbanas.id",
    "petra.ac.id",
    "pmbs.ac.id",
    "pnj.ac.id",
    "pnl.ac.id",
    "polban.ac.id",
    "polines.ac.id",
    "polinpdg.ac.id",
    "polnep.ac.id",
    "poltek-malang.ac.id",
    "poltekpos.ac.id",
    "poltesa.ac.id",
    "puterabatam.ac.id",
    "sarjanawiyata.ac.id",
    "sgu.ac.id",
    "sinus.ac.id",
    "stan.ac.id",
    "stptrisakti.ac.id",
    "telkomuniversity.ac.id",
    "unklab.ac.id",
    "trisakti.ac.id",
    "uad.ac.id",
    "uajy.ac.id",
    "ub.ac.id",
    "ubaya.ac.id",
    "ubhara.ac.id",
    "ubharajaya.ac.id",
    "ubm.ac.id",
    "uda.ac.id",
    "ugm.ac.id",
    "ui.ac.id",
    "uii.ac.id",
    "uika-bogor.ac.id",
    "uinjkt.ac.id",
    "uir.ac.id",
    "uisu.ac.id",
    "ukdw.ac.id",
    "uki.ac.id",
    "ukit-tomohon.org",
    "ukrida.ac.id",
    "umi.ac.id",
    "umj.ac.id",
    "umk.ac.id",
    "umm.ac.id",
    "ummgl.ac.id",
    "umsida.ac.id",
    "ums.ac.id",
    "umsu.ac.id",
    "umy.ac.id",
    "unair.ac.id",
    "unand.ac.id",
    "unas.ac.id",
    "uncen.ac.id",
    "undana.ac.id",
    "undip.ac.id",
    "unej.ac.id",
    "unesa.ac.id",
    "ung.ac.id",
    "unhalu.ac.id",
    "unhamzah.ac.id",
    "unhas.ac.id",
    "unib.ac.id",
    "unigoro.ac.id",
    "unika.ac.id",
    "unikal.ac.id",
    "unik-kediri.ac.id",
    "unikom.ac.id",
    "unila.ac.id",
    "unilak.ac.id",
    "unima.ac.id",
    "unimed.ac.id",
    "uninus.ac.id",
    "unipdu.ac.id",
    "unira.ac.id",
    "unisba.ac.id",
    "unisma.ac.id",
    "unismuh.ac.id",
    "unisri.ac.id",
    "unissula.ac.id",
    "unistangerang.ac.id",
    "unitomo.ac.id",
    "universitas-trilogi.ac.id",
    "trunojoyo.ac.id",
    "univpancasila.ac.id",
    "unipasby.ac.id",
    "unja.ac.id",
    "unj.ac.id",
    "unjani.ac.id",
    "unkhair.ac.id",
    "unkris.ac.id",
    "unlam.ac.id",
    "unm.ac.id",
    "unmas.org",
    "unmer.ac.id",
    "unmer-madiun.ac.id",
    "unmuhjember.ac.id",
    "unmul.ac.id",
    "wicida.ac.id",
    "unnes.ac.id",
    "unp.ac.id",
    "unpad.ac.id",
    "unpak.ac.id",
    "unpar.ac.id",
    "unpas.ac.id",
    "unpatti.ac.id",
    "unr.ac.id",
    "unram.ac.id",
    "unri.ac.id",
    "uns.ac.id",
    "unsada.ac.id",
    "unsil.ac.id",
    "unsoed.ac.id",
    "unsrat.ac.id",
    "unsri.ac.id",
    "unswagati-crb.ac.id",
    "unsyiah.ac.id",
    "untad.ac.id",
    "untag.ac.id",
    "untag-banyuwangi.ac.id",
    "untagcirebon.info",
    "untag-jkt.org",
    "untag-smd.ac.id",
    "untagsmg.ac.id",
    "untan.ac.id",
    "untar.ac.id",
    "untirta.ac.id",
    "unud.ac.id",
    "unwiku.ac.id",
    "uny.ac.id",
    "up45.ac.id",
    "upnvj.ac.id",
    "upnjatim.ac.id",
    "upnyk.ac.id",
    "upr.ac.id",
    "upstegal.ac.id",
    "usd.ac.id",
    "usi.ac.id",
    "usm.ac.id",
    "usu.ac.id",
    "ut.ac.id",
    "untidar.ac.id",
    "utp.ac.id",
    "widyagama.ac.id",
    "widyakarya.ac.id",
    "widyatama.ac.id",
    "wijayakusumasby.ac.id",
    "wima.ac.id",
    "wisnuwardhana.ac.id",
    "yai.ac.id",
    "yarsi.ac.id",
    "acmt.ac.ir",
    "adiban.ac.ir",
    "ajums.ac.ir",
    "aliabadiau.ac.ir",
    "miu.ac.ir",
    "arakmu.ac.ir",
    "araku.ac.ir",
    "arakut.ac.ir",
    "kut.ac.ir",
    "art.ac.ir",
    "arums.ac.ir",
    "atu.ac.ir",
    "aums.ac.ir",
    "aut.ac.ir",
    "azad.ac.ir",
    "alzahra.ac.ir",
    "basu.ac.ir",
    "bihe.org",
    "birjand.ac.ir",
    "bmsu.ac.ir",
    "bojnourdiau.ac.ir",
    "bpums.ac.ir",
    "bums.ac.ir",
    "scu.ac.ir",
    "dehaghan.ac.ir",
    "delijanpnu.ac.ir",
    "deylaman.ac.ir",
    "du.ac.ir",
    "falavarjan.ac.ir",
    "fsriau.ac.ir",
    "fums.ac.ir",
    "gau.ac.ir",
    "gmu.ac.ir",
    "gorganiau.ir",
    "goums.ac.ir",
    "guilan.ac.ir",
    "gums.ac.ir",
    "hormozgan.ac.ir",
    "hums.ac.ir",
    "hyrcania.ac.ir",
    "iasbs.ac.ir",
    "iau-ahar.ac.ir",
    "iau-arak.ac.ir",
    "iauardabil.ac.ir",
    "iauba.ac.ir",
    "iaubos.ac.ir",
    "iau-boukan.ac.ir",
    "iauctb.ac.ir",
    "iau-garmsar.ac.ir",
    "iauh.ac.ir",
    "iauk.ac.ir",
    "iaukb.ir",
    "iau-lahijan.ac.ir",
    "iaumajlesi.ac.ir",
    "iaun.ac.ir",
    "iauq.ac.ir",
    "iauro.ac.ir",
    "iau-saveh.ac.ir",
    "iausdj.ac.ir",
    "iaushab.ac.ir",
    "iau-shahrood.ac.ir",
    "iaushiraz.ac.ir",
    "iau-shirvan.ac.ir",
    "iausr.ac.ir",
    "iaut.ac.ir",
    "iautb.ac.ir",
    "iautmu.ac.ir",
    "iau-tnb.ac.ir",
    "iauvaramin.ac.ir",
    "iauyazd.ac.ir",
    "ikiu.ac.ir",
    "ilam.ac.ir",
    "imamreza.ac.ir",
    "isu.ac.ir",
    "iums.ac.ir",
    "iust.ac.ir",
    "iut.ac.ir",
    "jami.ac.ir",
    "janahiau.ac.ir",
    "jums.ac.ir",
    "kamalolmolk.ac.ir",
    "kashanu.ac.ir",
    "kau.ac.ir",
    "kaums.ac.ir",
    "kgut.ac.ir",
    "khuisf.ac.ir",
    "kish.ac.ir",
    "km.isfpnu.ac.ir",
    "kmu.ac.ir",
    "kntu.ac.ir",
    "kums.ac.ir",
    "teh-lavasan.pnu.ac.ir",
    "lu.ac.ir",
    "lums.ac.ir",
    "mahshahriau.ac.ir",
    "malayeru.ac.ir",
    "malekanpnu.ac.ir",
    "mamasaniiau.ac.ir",
    "mau.ac.ir",
    "maybod.ac.ir",
    "mazums.ac.ir",
    "medilam.hbi.ir",
    "medsab.ac.ir",
    "modares.ac.ir",
    "mofidu.ac.ir",
    "mshdiau.ac.ir",
    "mubabol.ac.ir",
    "mui.ac.ir",
    "muk.ac.ir",
    "mums.ac.ir",
    "muq.ac.ir",
    "najafabad-uast.ac.ir",
    "nit.ac.ir",
    "pgu.ac.ir",
    "piau.ac.ir",
    "pnu.ac.ir",
    "pnum.ac.ir",
    "pnut.ac.ir",
    "put.ac.ir",
    "pwit.ac.ir",
    "qiau.ac.ir",
    "qom.ac.ir",
    "qom-iau.ac.ir",
    "qums.ac.ir",
    "qut.ac.ir",
    "raghebisf.ac.ir",
    "razi.ac.ir",
    "riau.ac.ir",
    "rums.ac.ir",
    "sadjad.ac.ir",
    "sadra.ac.ir",
    "sbmu.ac.ir",
    "sbu.ac.ir",
    "sdi.ac.ir",
    "semnan.ac.ir",
    "semnaniau.ac.ir",
    "sem-ums.ac.ir",
    "ses.ac.ir",
    "shahed.ac.ir",
    "shahroodut.ac.ir",
    "shahryariau.ac.ir",
    "sharif.ac.ir",
    "shbu.ac.ir",
    "shirazu.ac.ir",
    "shmu.ac.ir",
    "shomal.ac.ir",
    "sku.ac.ir",
    "skums.ac.ir",
    "sowmesaraiau.ac.ir",
    "spnu.ac.ir",
    "srbiau.ac.ir",
    "ssu.ac.ir",
    "sttu.ac.ir",
    "sums.ac.ir",
    "sut.ac.ir",
    "sutech.ac.ir",
    "tabriziau.ac.ir",
    "tabrizu.ac.ir",
    "tbzmed.ac.ir",
    "tct.ac.ir",
    "thums.ac.ir",
    "tiau.ac.ir",
    "tmu.ac.ir",
    "tums.ac.ir",
    "uast.ac.ir",
    "ucna.info",
    "ui.ac.ir",
    "uk.ac.ir",
    "uma.ac.ir",
    "um.ac.ir",
    "umsha.ac.ir",
    "umsu.ac.ir",
    "umz.ac.ir",
    "uok.ac.ir",
    "uoz.ac.ir",
    "urmia.ac.ir",
    "usb.ac.ir",
    "usc.ac.ir",
    "ustmb.ac.ir",
    "uswr.ac.ir",
    "ut.ac.ir",
    "uut.ac.ir",
    "vru.ac.ir",
    "yazduni.ac.ir",
    "yu.ac.ir",
    "yums.ac.ir",
    "zdmu.ac.ir",
    "znu.ac.ir",
    "zums.ac.ir",
    "almamonuc.org",
    "alsadrain.org",
    "auc-edu.org",
    "broyalu.net",
    "hawlermu.org",
    "iraquniversity.net",
    "koyauniversity.org",
    "thiqaruni.org",
    "ukh.ac",
    "univsul.org",
    "uod.ac",
    "ait.ie",
    "cit.ie",
    "dcu.ie",
    "dias.ie",
    "dit.ie",
    "gcd.ie",
    "gmit.ie",
    "iiuedu.ie",
    "itcarlow.ie",
    "ittralee.ie",
    "lsb.ie",
    "may.ie",
    "ncirl.ie",
    "nui.ie",
    "rcpi.ie",
    "rcsi.ie",
    "tcd.ie",
    "ucc.ie",
    "ucd.ie",
    "nuigalway.ie",
    "ucg.ie",
    "ul.ie",
    "wit.ie",
    "afeka.ac.il",
    "jct.ac.il",
    "ariel.ac.il",
    "ash-college.ac.il",
    "bezalel.ac.il",
    "bgu.ac.il",
    "biu.ac.il",
    "clb.ac.il",
    "colman.ac.il",
    "galilcol.ac.il",
    "haifa.ac.il",
    "huji.ac.il",
    "idc.ac.il",
    "openu.ac.il",
    "rbni.technion.ac.il",
    "sce.ac.il",
    "shenkar.ac.il",
    "tau.ac.il",
    "technion.ac.il",
    "weizmann.ac.il",
    "wgalil.ac.il",
    "yvc.ac.il",
    "angelicum.org",
    "antonianum.ofm.org",
    "casa.unimo.it",
    "ictp.trieste.it",
    "imtlucca.it",
    "iuav.unive.it",
    "iue.it",
    "iulm.it",
    "iuoart.org",
    "iuo.it",
    "iusspavia.it",
    "jhubc.it",
    "liuc.it",
    "lumsa.it",
    "naba.it",
    "nyuniversity.net",
    "pio.urbe.it",
    "poliba.it",
    "polimi.it",
    "mail.polimi.it",
    "polito.it",
    "pul.it",
    "pusc.it",
    "sacrocuore.org",
    "sissa.it",
    "sns.it",
    "sssup.it",
    "unian.it",
    "uniba.it",
    "unibas.it",
    "unibg.it",
    "unibocconi.it",
    "unibo.it",
    "unibs.it",
    "unibz.it",
    "unica.it",
    "unical.it",
    "unicam.it",
    "unicampus.it",
    "unicas.it",
    "unicatt.it",
    "unich.it",
    "unict.it",
    "uniecampus.it",
    "uniese.it",
    "unife.it",
    "unifg.it",
    "unifi.it",
    "unige.it",
    "unigre.it",
    "unile.it",
    "unilink.it",
    "unimc.it",
    "unime.it",
    "unimib.it",
    "unimi.it",
    "unimol.it",
    "unina2.it",
    "unina.it",
    "uninav.it",
    "uninsubria.it",
    "unipa.it",
    "unipd.it",
    "unipg.it",
    "unipi.it",
    "unipr.it",
    "unipv.it",
    "unirc.it",
    "uniroma1.it",
    "uniroma2.eu",
    "uniroma3.it",
    "unisa.it",
    "unisal.it",
    "unisannio.it",
    "unisg.it",
    "unisi.it",
    "unisob.na.it",
    "uniss.it",
    "unistrapg.it",
    "unistrasi.it",
    "unite.it",
    "unitn.it",
    "unito.it",
    "unitus.it",
    "uniud.it",
    "uniurb.it",
    "univaq.it",
    "unive.it",
    "univr.it",
    "units.it",
    "ihteamlingue.it",
    "aasa.ac.jp",
    "abu.ac.jp",
    "aichi-edu.ac.jp",
    "aichi-fam-u.ac.jp",
    "aichi-gakuin.ac.jp",
    "aichi-med-u.ac.jp",
    "aichi-pu.ac.jp",
    "aichi-u.ac.jp",
    "aikoku-u.ac.jp",
    "aitech.ac.jp",
    "akeihou-u.ac.jp",
    "akita-u.ac.jp",
    "andrew.ac.jp",
    "aomoricgu.ac.jp",
    "aomori-u.ac.jp",
    "aoyama.ac.jp",
    "apu.ac.jp",
    "asahikawa-med.ac.jp",
    "asahikawa-u.ac.jp",
    "asahi-u.ac.jp",
    "ashitech.ac.jp",
    "ashiya-u.ac.jp",
    "asia-u.ac.jp",
    "asu.ac.jp",
    "atomi.ac.jp",
    "aue-okinawa.ac.jp",
    "auhw.ac.jp",
    "azabu-u.ac.jp",
    "baika.ac.jp",
    "baiko.ac.jp",
    "beppu-u.ac.jp",
    "budo-u.ac.jp",
    "bukkyo-u.ac.jp",
    "bunka-wu.ac.jp",
    "bunkyo.ac.jp",
    "bunri-u.ac.jp",
    "cgu.ac.jp",
    "chiba-u.ac.jp",
    "chikushi.ac.jp",
    "chubu.ac.jp",
    "chubu-gu.ac.jp",
    "chujo-u.ac.jp",
    "chukyogakuin-u.ac.jp",
    "chukyo-u.ac.jp",
    "chuo-u.ac.jp",
    "cku.ac.jp",
    "cuc.ac.jp",
    "daido-it.ac.jp",
    "daiichi-cps.ac.jp",
    "daiichi-koudai.ac.jp",
    "daiichi-ue.ac.jp",
    "daion.ac.jp",
    "daishodai.ac.jp",
    "daito.ac.jp",
    "dendai.ac.jp",
    "doho.ac.jp",
    "dohto.ac.jp",
    "do-johodai.ac.jp",
    "dokkyo.ac.jp",
    "dokkyomed.ac.jp",
    "doshisha.ac.jp",
    "dwc.doshisha.ac.jp",
    "edogawa-u.ac.jp",
    "ehime-u.ac.jp",
    "eichi-u.ac.jp",
    "eiyo.ac.jp",
    "eum.ac.jp",
    "fdcnet.ac.jp",
    "ferris.ac.jp",
    "fish-u.ac.jp",
    "fit.ac.jp",
    "fmu.ac.jp",
    "fpu.ac.jp",
    "fujijoshi.ac.jp",
    "fujita-hu.ac.jp",
    "fukui-med.ac.jp",
    "fukui-u.ac.jp",
    "fukui-ut.ac.jp",
    "fukuoka-edu.ac.jp",
    "fukuoka-int-u.ac.jp",
    "fukuoka-pu.ac.jp",
    "fukuoka-u.ac.jp",
    "fukushima-u.ac.jp",
    "fukuyama-u.ac.jp",
    "fwu.ac.jp",
    "gakusen.ac.jp",
    "gakushuin.ac.jp",
    "geidai.ac.jp",
    "gifu-keizai.ac.jp",
    "gifu-kyoiku.ac.jp",
    "gifu-pu.ac.jp",
    "gifu-u.ac.jp",
    "gijodai.ac.jp",
    "gpwu.ac.jp",
    "gunma-u.ac.jp",
    "hachinohe-u.ac.jp",
    "hakodate-u.ac.jp",
    "hakuoh.ac.jp",
    "hamamatsu-u.ac.jp",
    "hama-med.ac.jp",
    "hanazono.ac.jp",
    "hannan-u.ac.jp",
    "h-bunkyo.ac.jp",
    "heisei-u.ac.jp",
    "hijiyama-u.ac.jp",
    "himeji-du.ac.jp",
    "himeji-tech.ac.jp",
    "hirogaku-u.ac.jp",
    "hirojo-u.ac.jp",
    "hirokoku-u.ac.jp",
    "hirosaki-u.ac.jp",
    "hiroshima-cu.ac.jp",
    "hiroshima-pu.ac.jp",
    "hiroshima-u.ac.jp",
    "hit.ac.jp",
    "hi-tech.ac.jp",
    "hit-u.ac.jp",
    "hiu.ac.jp",
    "hju.ac.jp",
    "hkg.ac.jp",
    "hokkai-k-u.ac.jp",
    "hokkai-s-u.ac.jp",
    "hokkyodai.ac.jp",
    "hokudai.ac.jp",
    "hoku-iryo-u.ac.jp",
    "hokuriku-u.ac.jp",
    "hokusei.ac.jp",
    "hokuyakudai.ac.jp",
    "hosei.ac.jp",
    "hoshi.ac.jp",
    "hue.ac.jp",
    "hyogo-dai.ac.jp",
    "hyogo-u.ac.jp",
    "hyo-med.ac.jp",
    "ibaraki.ac.jp",
    "icc.ac.jp",
    "icu.ac.jp",
    "ip.kyusan-u.ac.jp",
    "ipu.ac.jp",
    "isenshu-u.ac.jp",
    "it-chiba.ac.jp",
    "it-hiroshima.ac.jp",
    "iuhw.ac.jp",
    "iuj.ac.jp",
    "iuk.ac.jp",
    "iwakimu.ac.jp",
    "iwate-med.ac.jp",
    "iwate-pu.ac.jp",
    "iwate-u.ac.jp",
    "jaist.ac.jp",
    "jichi.ac.jp",
    "jikei.ac.jp",
    "jissen.ac.jp",
    "jiu.ac.jp",
    "jobu.ac.jp",
    "josai.ac.jp",
    "joshibi.ac.jp",
    "juen.ac.jp",
    "juntan.k-junshin.ac.jp",
    "juntendo.ac.jp",
    "jwu.ac.jp",
    "kagawa-u.ac.jp",
    "kagoshima-u.ac.jp",
    "kamakura-u.ac.jp",
    "kanagawa-it.ac.jp",
    "kanagawa-u.ac.jp",
    "kanazawa-bidai.ac.jp",
    "kanazawa-eco.ac.jp",
    "kanazawa-gu.ac.jp",
    "kanazawa-it.ac.jp",
    "kanazawa-med.ac.jp",
    "kanazawa-u.ac.jp",
    "kankyo-u.ac.jp",
    "kansai-gaidai-u.ac.jp",
    "kansai-u.ac.jp",
    "kanto-gakuen.ac.jp",
    "kanto-gakuin.ac.jp",
    "kawasaki-m.ac.jp",
    "kbu.ac.jp",
    "kcua.ac.jp",
    "kdcnet.ac.jp",
    "keiho-u.ac.jp",
    "keio.ac.jp",
    "keisen.ac.jp",
    "keiwa-c.ac.jp",
    "kgwu.ac.jp",
    "kindai.ac.jp",
    "kinjo-u.ac.jp",
    "kit.ac.jp",
    "kitakyu-u.ac.jp",
    "kitami-it.ac.jp",
    "kitasato-u.ac.jp",
    "kiu.ac.jp",
    "kiui.ac.jp",
    "kms.ac.jp",
    "kmu.ac.jp",
    "knct.ac.jp",
    "kobe-c.ac.jp",
    "kobe-cufs.ac.jp",
    "kobe-du.ac.jp",
    "kobegakuin.ac.jp",
    "kobe-kiu.ac.jp",
    "kobepharma-u.ac.jp",
    "kobe-shinwa.ac.jp",
    "kobe-u.ac.jp",
    "kochi-ms.ac.jp",
    "kochi-tech.ac.jp",
    "kochi-u.ac.jp",
    "kochi-wu.ac.jp",
    "kogakkan-u.ac.jp",
    "kogakuin.ac.jp",
    "koka.ac.jp",
    "kokugakuin.ac.jp",
    "kokushikan.ac.jp",
    "komazawa-u.ac.jp",
    "konan-u.ac.jp",
    "konan-wu.ac.jp",
    "korea-u.ac.jp",
    "koriyama-kgc.ac.jp",
    "koshien.ac.jp",
    "koyasan-u.ac.jp",
    "kpu.ac.jp",
    "kpu-m.ac.jp",
    "kshosen.ac.jp",
    "ksu.ac.jp",
    "ktokai-u.ac.jp",
    "kufs.ac.jp",
    "kuins.ac.jp",
    "kuis.ac.jp",
    "kumagaku.ac.jp",
    "kumamoto-u.ac.jp",
    "kunitachi.ac.jp",
    "kure-u.ac.jp",
    "kurume-it.ac.jp",
    "kurume-u.ac.jp",
    "kusa.ac.jp",
    "kushiro-pu.ac.jp",
    "kusw.ac.jp",
    "kwansei.ac.jp",
    "kwassui.ac.jp",
    "kwc-u.ac.jp",
    "kwuc.ac.jp",
    "kyokyo-u.ac.jp",
    "kyorin-u.ac.jp",
    "kyoritsu-ph.ac.jp",
    "kyoritsu-wu.ac.jp",
    "kyoto-art.ac.jp",
    "kyotogakuen-u.ac.jp",
    "kyoto-phu.ac.jp",
    "kyoto-seika.ac.jp",
    "kyoto-su.ac.jp",
    "kyoto-u.ac.jp",
    "kyoto-wu.ac.jp",
    "kyu-dent.ac.jp",
    "kyukyo-u.ac.jp",
    "kyushu-id.ac.jp",
    "kyushu-ns.ac.jp",
    "kyushu-u.ac.jp",
    "kyutech.ac.jp",
    "marianna-u.ac.jp",
    "matsuyama-u.ac.jp",
    "mdu.ac.jp",
    "meiji.ac.jp",
    "meijigakuin.ac.jp",
    "meiji-u.ac.jp",
    "meijo-u.ac.jp",
    "meikai.ac.jp",
    "meio-u.ac.jp",
    "meisei-u.ac.jp",
    "mejiro.ac.jp",
    "metro-hs.ac.jp",
    "metro-u.ac.jp",
    "mgu.ac.jp",
    "mie-chukyo-u.ac.jp",
    "mie-u.ac.jp",
    "mimasaka.ac.jp",
    "miyakyo-u.ac.jp",
    "miyasankei-u.ac.jp",
    "miyazaki-med.ac.jp",
    "miyazaki-mu.ac.jp",
    "miyazaki-u.ac.jp",
    "morioka-u.ac.jp",
    "mpu.ac.jp",
    "mukogawa-u.ac.jp",
    "muroran-it.ac.jp",
    "musabi.ac.jp",
    "musashi.ac.jp",
    "musashino-music.ac.jp",
    "musashino-wu.ac.jp",
    "musashi-tech.ac.jp",
    "my-pharm.ac.jp",
    "myu.ac.jp",
    "nagano.ac.jp",
    "nagaokaut.ac.jp",
    "nagasakipu.ac.jp",
    "nagasaki-u.ac.jp",
    "nagoya-cu.ac.jp",
    "nagoya-ku.ac.jp",
    "nagoya-u.ac.jp",
    "nagoya-wu.ac.jp",
    "nakamura-u.ac.jp",
    "nankyudai.ac.jp",
    "nanzan-u.ac.jp",
    "nara-edu.ac.jp",
    "naramed-u.ac.jp",
    "nara-su.ac.jp",
    "nara-u.ac.jp",
    "narauc.ac.jp",
    "nara-wu.ac.jp",
    "naruto-u.ac.jp",
    "nbu.ac.jp",
    "ndmc.ac.jp",
    "ndsu.ac.jp",
    "ndu.ac.jp",
    "nebuta.ac.jp",
    "n-fukushi.ac.jp",
    "ngu.ac.jp",
    "nias.ac.jp",
    "nifs-k.ac.jp",
    "nihon-u.ac.jp",
    "niigata-pharm.ac.jp",
    "niigata-u.ac.jp",
    "niigataum.ac.jp",
    "nishitech.ac.jp",
    "nishogakusha-u.ac.jp",
    "nisikyu-u.ac.jp",
    "nit.ac.jp",
    "nitech.ac.jp",
    "nittai.ac.jp",
    "nms.ac.jp",
    "nodai.ac.jp",
    "notredame.ac.jp",
    "nsu.ac.jp",
    "ntu.ac.jp",
    "nua.ac.jp",
    "nucba.ac.jp",
    "nufs.nakanishi.ac.jp",
    "nuis.ac.jp",
    "nvau.ac.jp",
    "obihiro.ac.jp",
    "obirin.ac.jp",
    "ocha.ac.jp",
    "ohkagakuen-u.ac.jp",
    "ohtani-w.ac.jp",
    "ohu-u.ac.jp",
    "oit.ac.jp",
    "oita-med.ac.jp",
    "oita-nhs.ac.jp",
    "oita-u.ac.jp",
    "oiu.oiu.ac.jp",
    "oiuw.oiu.ac.jp",
    "oka-pu.ac.jp",
    "okayama-u.ac.jp",
    "okigei.ac.jp",
    "okinawa-u.ac.jp",
    "okiu.ac.jp",
    "osakac.ac.jp",
    "oecu.jp",
    "osaka-cu.ac.jp",
    "osaka-dent.ac.jp",
    "osakafu-u.ac.jp",
    "osaka-gaidai.ac.jp",
    "osaka-geidai.ac.jp",
    "osaka-gu.ac.jp",
    "osaka-kyoiku.ac.jp",
    "osaka-med.ac.jp",
    "osaka-sandai.ac.jp",
    "osaka-shoin.ac.jp",
    "osaka-u.ac.jp",
    "osaka-ue.ac.jp",
    "osaka-wu.ac.jp",
    "osu.ac.jp",
    "otani.ac.jp",
    "otaru-uc.ac.jp",
    "otemae.ac.jp",
    "otemon.ac.jp",
    "otsuma.ac.jp",
    "ouhs.ac.jp",
    "oups.ac.jp",
    "ous.ac.jp",
    "poole.ac.jp",
    "pu-kumamoto.ac.jp",
    "pu-toyama.ac.jp",
    "rakuno.ac.jp",
    "redcross.ac.jp",
    "reitaku-u.ac.jp",
    "rikkyo.ac.jp",
    "ris.ac.jp",
    "ritsumei.ac.jp",
    "rku.ac.jp",
    "ryukoku.ac.jp",
    "saga-med.ac.jp",
    "sagami-wu.ac.jp",
    "saga-u.ac.jp",
    "saitama-med.ac.jp",
    "saitama-u.ac.jp",
    "sakushin-u.ac.jp",
    "sanno.ac.jp",
    "sapmed.ac.jp",
    "sapporo-u.ac.jp",
    "seian.ac.jp",
    "seigakuin-univ.ac.jp",
    "seijo.ac.jp",
    "seikei.ac.jp",
    "seinan-gu.ac.jp",
    "seisen-u.ac.jp",
    "seiwa-u.ac.jp",
    "sendaidaigaku.jp",
    "senshu-u.ac.jp",
    "senzoku.ac.jp",
    "setsunan.ac.jp",
    "sgu.ac.jp",
    "sg-u.ac.jp",
    "sguc.ac.jp",
    "shakaijigyo.ac.jp",
    "shibaura-it.ac.jp",
    "shiga-med.ac.jp",
    "shiga-u.ac.jp",
    "shikoku-u.ac.jp",
    "shimane-med.ac.jp",
    "shimane-u.ac.jp",
    "shimonoseki-cu.ac.jp",
    "shinshu-u.ac.jp",
    "shirayuri.ac.jp",
    "shitennoji.ac.jp",
    "shizuoka.ac.jp",
    "shodai.ac.jp",
    "shoin.ac.jp",
    "shokei-gakuen.ac.jp",
    "shonan-it.ac.jp",
    "shotoku.ac.jp",
    "showa-u.ac.jp",
    "shoyaku.ac.jp",
    "shuchiin.ac.jp",
    "shudo-u.ac.jp",
    "shujitsu.ac.jp",
    "shukutoku.ac.jp",
    "shumei-u.ac.jp",
    "sit.ac.jp",
    "siu.ac.jp",
    "slcn.ac.jp",
    "soai.ac.jp",
    "soka.ac.jp",
    "soken.ac.jp",
    "sonoda-u.ac.jp",
    "sophia.ac.jp",
    "spu.ac.jp",
    "ssu.ac.jp",
    "sugino.ac.jp",
    "sugiyama-u.ac.jp",
    "suma.kobe-wu.ac.jp",
    "sun.ac.jp",
    "surugadai.ac.jp",
    "sut.ac.jp",
    "suzuka-iu.ac.jp",
    "suzuka-u.ac.jp",
    "swu.ac.jp",
    "tachibana-u.ac.jp",
    "tais.ac.jp",
    "takachiho.ac.jp",
    "takamatsu-u.ac.jp",
    "takara-univ.ac.jp",
    "takushoku-u.ac.jp",
    "tamabi.ac.jp",
    "tamagawa.ac.jp",
    "tbgu.ac.jp",
    "tcue.ac.jp",
    "tdc.ac.jp",
    "teikyo-u.ac.jp",
    "tenri-u.ac.jp",
    "termnet.co.jp",
    "teu.ac.jp",
    "tezuka-gu.ac.jp",
    "tezukayama-u.ac.jp",
    "tfu.ac.jp",
    "timis.ac.jp",
    "titech.ac.jp",
    "tiu.ac.jp",
    "t-komazawa.ac.jp",
    "t-kougei.ac.jp",
    "tku.ac.jp",
    "tmd.ac.jp",
    "tmit.ac.jp",
    "tohoku.ac.jp",
    "tohoku-gakuin.ac.jp",
    "tohoku-pharm.ac.jp",
    "toho-music.ac.jp",
    "tohomusic.ac.jp",
    "toho-u.ac.jp",
    "tohtech.ac.jp",
    "tohwa-u.ac.jp",
    "toin.ac.jp",
    "tojo.ac.jp",
    "tokai.ac.jp",
    "tokaigakuen-u.ac.jp",
    "tokaijoshi-u.ac.jp",
    "tokiwa.ac.jp",
    "tokoha-u.ac.jp",
    "tokushima-u.ac.jp",
    "tokuyama-u.ac.jp",
    "tokyo-kasei.ac.jp",
    "tokyo-med.ac.jp",
    "tokyo-ondai.ac.jp",
    "tokyo-u-fish.ac.jp",
    "tonichi-kokusai-u.ac.jp",
    "tosho-u.ac.jp",
    "tottori-u.ac.jp",
    "toua-u.ac.jp",
    "toyaku.ac.jp",
    "toyama-mpu.ac.jp",
    "toyama-u.ac.jp",
    "toyo.ac.jp",
    "toyoeiwa.ac.jp",
    "toyogakuen-u.ac.jp",
    "toyota-ti.ac.jp",
    "tsuda.ac.jp",
    "tsukuba.ac.jp",
    "tsuru.ac.jp",
    "tsurumi-u.ac.jp",
    "tuad.ac.jp",
    "tuat.ac.jp",
    "tufs.ac.jp",
    "tuins.ac.jp",
    "tuis.ac.jp",
    "tuj.ac.jp",
    "tut.ac.jp",
    "twcpe.ac.jp",
    "twcu.ac.jp",
    "twmu.ac.jp",
    "u-air.ac.jp",
    "u-aizu.ac.jp",
    "u-bunkyo.ac.jp",
    "uec.ac.jp",
    "uenogakuen.ac.jp",
    "u-gakugei.ac.jp",
    "uitec.ac.jp",
    "u-keiai.ac.jp",
    "umds.ac.jp",
    "uoeh-u.ac.jp",
    "u-ryukyu.ac.jp",
    "u-sacred-heart.ac.jp",
    "u-shizuoka-ken.ac.jp",
    "usp.ac.jp",
    "pref.shiga.lg.jp",
    "u-tokai.ac.jp",
    "u-tokyo.ac.jp",
    "utsunomiya-u.ac.jp",
    "wakayama-med.ac.jp",
    "wakayama-u.ac.jp",
    "wakhok.ac.jp",
    "wako.ac.jp",
    "waseda.ac.jp",
    "wayo.ac.jp",
    "yamagata-u.ac.jp",
    "yamaguchi-pu.ac.jp",
    "yamaguchi-u.ac.jp",
    "yamanashi.ac.jp",
    "yamanashi-med.ac.jp",
    "yama.sut.ac.jp",
    "yasuda-u.ac.jp",
    "ygu.ac.jp",
    "ynu.ac.jp",
    "yokkaichi-u.ac.jp",
    "yokohama-cu.ac.jp",
    "zokei.ac.jp",
    "ablaikhan.kz",
    "agriun.almaty.kz",
    "aktsu.kz",
    "atgu.kz",
    "ektu.kz",
    "enu.kz",
    "eurazir.kz",
    "kau.kz",
    "kazeu.kz",
    "kaznpu.kz",
    "kazntu.kz",
    "kaznu.kz",
    "kbtu.kz",
    "kimep.kz",
    "kstu.kz",
    "ksu.kst.kz",
    "ksu.kz",
    "nkzu.kz",
    "psu.kz",
    "semgu.kz",
    "sgma.kz",
    "turkistan.kz",
    "uib.kz",
    "vkgu.kz",
    "wkau.kz",
    "zhezu.kz",
    "zhgu.kz",
    "aiu.ac.ke",
    "anu.ac.ke",
    "aua.ac.ke",
    "chuka.ac.ke",
    "daystar.ac.ke",
    "dkut.ac.ke",
    "egerton.ac.ke",
    "gluk.ac.ke",
    "gretsauniversity.ac.ke",
    "iu.ac.ke",
    "jkuat.ac.ke",
    "jooust.ac.ke",
    "kabarak.ac.ke",
    "kabianga.ac.ke",
    "karatinauniversity.ac.ke",
    "kca.ac.ke",
    "kemu.ac.ke",
    "kisiiuniversity.ac.ke",
    "kmtc.ac.ke",
    "ku.ac.ke",
    "kwust.ac.ke",
    "laikipia.ac.ke",
    "maseno.ac.ke",
    "mku.ac.ke",
    "mmarau.ac.ke",
    "mmu.ac.ke",
    "mmust.ac.ke",
    "mu.ac.ke",
    "must.ac.ke",
    "nibs.ac.ke",
    "ntti.ac.ke",
    "pacuniversity.ac.ke",
    "piu.ac.ke",
    "pu.ac.ke",
    "puea.ac.ke",
    "riarauniversity.ac.ke",
    "scott.ac.ke",
    "seku.ac.ke",
    "spu.ac.ke",
    "tukenya.ac.ke",
    "tum.ac.ke",
    "ueab.ac.ke",
    "uoeld.ac.ke",
    "uonbi.ac.ke",
    "usiu.ac.ke",
    "uzimauniversity.ac.ke",
    "pust.net",
    "ajou.ac.kr",
    "andong.ac.kr",
    "acts.ac.kr",
    "bu.ac.kr",
    "bnue.ac.kr",
    "bpu.ac.kr",
    "bufs.ac.kr",
    "cataegu.ac.kr",
    "cau.ac.kr",
    "changwon.ac.kr",
    "charusat.ac.in",
    "cheju.ac.kr",
    "cheju-e.ac.kr",
    "chinju.ac.kr",
    "chinju-e.ac.kr",
    "cue.ac.kr",
    "chodang.ac.kr",
    "cdu.ac.kr",
    "chonbuk.ac.kr",
    "chongju.ac.kr",
    "chongju-e.ac.kr",
    "chonju-e.ac.kr",
    "chonnam.ac.kr",
    "jnu.ac.kr",
    "chosun.ac.kr",
    "chungbuk.ac.kr",
    "cbnu.ac.kr",
    "chungju.ac.kr",
    "chungnam.ac.kr",
    "cnu.ac.kr",
    "cnue-e.ac.kr",
    "cuk.ac.kr",
    "cup.ac.kr",
    "cha.ac.kr",
    "cju.ac.kr",
    "cku.ac.kr",
    "cs.ac.kr",
    "cje.ac.kr",
    "chongshin.ac.kr",
    "chugye.ac.kr",
    "cnue.ac.kr",
    "chungwoon.ac.kr",
    "daebul.ac.kr",
    "dankook.ac.kr",
    "donga.ac.kr",
    "dongduk.ac.kr",
    "dongeui.ac.kr",
    "dongguk.ac.kr",
    "dongseo.ac.kr",
    "dongshinu.ac.kr",
    "dsu.ac.kr",
    "duksung.ac.kr",
    "dytc.ac.kr",
    "tau.ac.kr",
    "dgist.ac.kr",
    "dhu.ac.kr",
    "dnue.ac.kr",
    "daegu.ac.kr",
    "dufs.ac.kr",
    "dcatholic.ac.kr",
    "daejeon.ac.kr",
    "dju.ac.kr",
    "daejin.ac.kr",
    "daeshin.ac.kr",
    "deu.ac.kr",
    "dyu.ac.kr",
    "ewha.ac.kr",
    "eulji.ac.kr",
    "kdu.ac.kr",
    "gachon.ac.kr",
    "gwnu.ac.kr",
    "ggu.ac.kr",
    "gimcheon.ac.kr",
    "gjue.ac.kr",
    "gjcatholic.ac.kr",
    "gist.ac.kr",
    "gnue.ac.kr",
    "ginue.ac.kr",
    "gntech.ac.kr",
    "gsnu.ac.kr",
    "gnu.ac.kr",
    "hallym.ac.kr",
    "hangkong.ac.kr",
    "hannam.ac.kr",
    "hansei.ac.kr",
    "hanseo.ac.kr",
    "hanshin.ac.kr",
    "hs.ac.kr",
    "hansung.ac.kr",
    "hanyang.ac.kr",
    "hknu.ac.kr",
    "honam.ac.kr",
    "hongik.ac.kr",
    "hoseo.ac.kr",
    "howon.ac.kr",
    "hufs.ac.kr",
    "hyupsung.ac.kr",
    "uhs.ac.kr",
    "halla.ac.kr",
    "hanbat.ac.kr",
    "hanil.ac.kr",
    "hanlyo.ac.kr",
    "hanzhong.ac.kr",
    "htus.ac.kr",
    "iccu.ac.kr",
    "iuk.ac.kr",
    "icu.ac.kr",
    "inchon.ac.kr",
    "inchon-e.ac.kr",
    "inha.ac.kr",
    "inje.ac.kr",
    "jeonju.ac.kr",
    "jj.ac.kr",
    "jeju.ac.kr",
    "jejunu.ac.kr",
    "jnue.ac.kr",
    "jesus.ac.kr",
    "sangha.ac.kr",
    "joongbu.ac.kr",
    "jwu.ac.kr",
    "kaist.ac.kr",
    "kangnam.ac.kr",
    "kangnung.ac.kr",
    "kangwon.ac.kr",
    "kaya.ac.kr",
    "kdischool.ac.kr",
    "keimyung.ac.kr",
    "kmu.ac.kr",
    "kmaritime.ac.kr",
    "knou.ac.kr",
    "knua.ac.kr",
    "karts.ac.kr",
    "knue.ac.kr",
    "knupe.ac.kr",
    "kongju-e.ac.kr",
    "konkuk.ac.kr",
    "konyang.ac.kr",
    "kookmin.ac.kr",
    "korea.ac.kr",
    "kosin.ac.kr",
    "kumoh.ac.kr",
    "kunsan.ac.kr",
    "kwandong.ac.kr",
    "kwangju.ac.kr",
    "gwangju.ac.kr",
    "kwangju-e.ac.kr",
    "kwangwoon.ac.kr",
    "kw.ac.kr",
    "kyonggi.ac.kr",
    "kyongju.ac.kr",
    "kongju.ac.kr",
    "kyunghee.ac.kr",
    "kyungil.ac.kr",
    "kiu.ac.kr",
    "kyungnam.ac.kr",
    "kyungpook.ac.kr",
    "kyungsung.ac.kr",
    "ks.ac.kr",
    "kyungwon.ac.kr",
    "kcu.ac.kr",
    "kkot.ac.kr",
    "kau.ac.kr",
    "kafna.ac.kr",
    "kbtus.ac.kr",
    "kmou.ac.kr",
    "kma.ac.kr",
    "knsu.ac.kr",
    "nuch.ac.kr",
    "kornu.ac.kr",
    "kpu.ac.kr",
    "koreatech.ac.kr",
    "bible.ac.kr",
    "police.ac.kr",
    "kwu.ac.kr",
    "kwangshin.ac.kr",
    "khu.ac.kr",
    "kduniv.ac.kr",
    "ikw.ac.kr",
    "miryang.ac.kr",
    "mmu.ac.kr",
    "mokpo.ac.kr",
    "mokwon.ac.kr",
    "myongji.ac.kr",
    "mju.ac.kr",
    "mtu.ac.kr",
    "mcu.ac.kr",
    "nambu.ac.kr",
    "nsu.ac.kr",
    "pcu.ac.kr",
    "puts.ac.kr",
    "ptu.ac.kr",
    "paichai.ac.kr",
    "pknu.ac.kr",
    "postech.ac.kr",
    "ptuniv.ac.kr",
    "pufs.ac.kr",
    "pusan.ac.kr",
    "pusan-e.ac.kr",
    "pwc.ac.kr",
    "afa.ac.kr",
    "navy.ac.kr",
    "samchok.ac.kr",
    "sangji.ac.kr",
    "sangmyung.ac.kr",
    "sch.ac.kr",
    "sejong.ac.kr",
    "semyung.ac.kr",
    "seonam.ac.kr",
    "seoul-e.ac.kr",
    "snue.ac.kr",
    "seowon.ac.kr",
    "silla.ac.kr",
    "skku.ac.kr",
    "skuniv.ac.kr",
    "seokyeong.ac.kr",
    "snu.ac.kr",
    "snut.ac.kr",
    "sogang.ac.kr",
    "sookmyung.ac.kr",
    "soongsil.ac.kr",
    "ssu.ac.kr",
    "stu.ac.kr",
    "sunchon.ac.kr",
    "scnu.ac.kr",
    "sungkyul.ac.kr",
    "sungshin.ac.kr",
    "sunmoon.ac.kr",
    "suwon.ac.kr",
    "suwoncatholic.ac.kr",
    "swu.ac.kr",
    "syu.ac.kr",
    "smu.ac.kr",
    "sehan.ac.kr",
    "scu.ac.kr",
    "hytu.ac.kr",
    "sjs.ac.kr",
    "seoultech.ac.kr",
    "sgu.ac.kr",
    "shinhan.ac.kr",
    "songwon.ac.kr",
    "skhu.ac.kr",
    "taegu.ac.kr",
    "taegu-e.ac.kr",
    "taejon.ac.kr",
    "taeshin.ac.kr",
    "tit.ac.kr",
    "tnut.ac.kr",
    "ulsan.ac.kr",
    "uos.ac.kr",
    "ust.ac.kr",
    "u1.ac.kr",
    "uu.ac.kr",
    "unist.ac.kr",
    "wsu.ac.kr",
    "wonkwang.ac.kr",
    "wku.ac.kr",
    "woosuk.ac.kr",
    "yeungnam.ac.kr",
    "yonsei.ac.kr",
    "yosu.ac.kr",
    "www.yewon.ac.kr",
    "www.yongin.ac.kr",
    "www.ysu.ac.kr",
    "www.youngsan.ac.kr",
    "aukonline.org",
    "uiliria.org",
    "universum-ks.org",
    "auca.kg",
    "bhu.kg",
    "iuk.kg",
    "knau.kg",
    "kstu.kg",
    "ksucta.kg",
    "manas.kg",
    "university.kg",
    "aml.lv",
    "ba.lv",
    "cs.lpu.lv",
    "dau.lv",
    "lama.lv",
    "llu.lv",
    "lbtu.lv",
    "lma.lv",
    "lmuza.lv",
    "lspa.lanet.lv",
    "lu.lv",
    "mil.lv",
    "psy.lv",
    "rau.lv",
    "rpiva.lv",
    "rtu.lv",
    "ru.lv",
    "tsi.lv",
    "va.lv",
    "islahonline.org",
    "wakf.org",
    "nul.ls",
    "universityliberia.org",
    "libopenuniv-edu.org",
    "iap.li",
    "uni.li",
    "info.kma.lt",
    "ism.lt",
    "ktu.lt",
    "ku.lt",
    "lcc.lt",
    "lka.lt",
    "lkka.lt",
    "lmta.lt",
    "lva.lt",
    "lzua.lt",
    "mch.mii.lt",
    "mruni.eu",
    "su.lt",
    "vdu.lt",
    "vgtu.lt",
    "vpu.lt",
    "vu.lt",
    "iuil.lu",
    "uni.lu",
    "ukim.mk",
    "finki.ukim.mk",
    "students.finki.ukim.mk",
    "univ-antananarivo.mg",
    "univ-antsiranana.mg",
    "univ-fianar.mg",
    "univ-mahajanga.mg",
    "univ-toamasina.mg",
    "univ-toliara.mg",
    "cunima.net",
    "mzuni.ac.mw",
    "unima.ac.mw",
    "mubas.ac.mw",
    "must.ac.mw",
    "luanar.ac.mw",
    "unima.mw",
    "kudqi.net.my",
    "numed.ncl.ac.uk",
    "ukm.my",
    "unimas.my",
    "usm.my",
    "utm.my",
    "ml.refer.org",
    "univ-nkc.mr",
    "uom.ac.mu",
    "utm.ac.mu",
    "anahuac.mx",
    "buap.mx",
    "campusleon.ugto.mx",
    "ceti.mx",
    "cetys.mx",
    "ceux.mx",
    "chapingo.mx",
    "colmex.mx",
    "cueyatl.uam.mx",
    "dgit.gob.mx",
    "ebc.mx",
    "enes.unam.mx",
    "itam.mx",
    "ita.mx",
    "itc.mx",
    "itesm.mx",
    "iteso.mx",
    "itson.mx",
    "iztapalapa.uam.mx",
    "lef.upn.mx",
    "leon.uia.mx",
    "reduaeh.mx",
    "reduaz.mx",
    "secupv.org",
    "tecbc.mx",
    "uaaan.mx",
    "uaa.mx",
    "uabc.mx",
    "uabcs.mx",
    "uabjo.mx",
    "uacam.mx",
    "uach.mx",
    "uacj.mx",
    "uadec.mx",
    "uady.mx",
    "uaemex.mx",
    "uaem.mx",
    "uaf.mx",
    "uag.mx",
    "uagro.mx",
    "ual.mx",
    "uam.mx",
    "uanl.mx",
    "uan.mx",
    "uaq.mx",
    "uaslp.mx",
    "uas.mx",
    "uasnet.mx",
    "uat.mx",
    "uatx.mx",
    "ucol.mx",
    "udg.mx",
    "udla.mx",
    "udlap.mx",
    "udo.mx",
    "ugto.mx",
    "uia.mx",
    "ujat.mx",
    "ujed.mx",
    "ujsierra.mx",
    "umar.mx",
    "umich.mx",
    "unacar.mx",
    "unach.mx",
    "unam.mx",
    "unikino.mx",
    "unitec.mx",
    "univa.mx",
    "univillarica.mx",
    "un.mx",
    "uno.mx",
    "upaep.mx",
    "upiig.ipn.mx",
    "up.mx",
    "upn.mx",
    "uqroo.mx",
    "ur.mx",
    "uson.mx",
    "utm.mx",
    "uvg1.net",
    "uv.mx",
    "ver.ucc.mx",
    "azc.uam.mx",
    "ase.md",
    "kdu.md",
    "uasm.md",
    "uccm.md",
    "ulim.md",
    "upm.moldnet.md",
    "usam.md",
    "usb.md",
    "usmf.md",
    "usm.md",
    "ust.md",
    "utm.md",
    "riviera.fr",
    "hsu-hh.de",
    "hsum-ac.mn",
    "humanities.mn",
    "ucg.cg.ac.yu",
    "usat.ms",
    "archi.ac.ma",
    "aui.ma",
    "edhec.ac.ma",
    "emi.ac.ma",
    "enameknes.ac.ma",
    "esca.ac.ma",
    "esta.ac.ma",
    "groupeiscae.ma",
    "hec.ac.ma",
    "hem.ac.ma",
    "iihem.ac.ma",
    "imbt.ma",
    "inpt.ac.ma",
    "isfort.ac.ma",
    "matci.ac.ma",
    "rectorat-uh2c.ac.ma",
    "rumi.ac.ma",
    "suptelecom.net.ma",
    "uae.ac.ma",
    "ucam.ac.ma",
    "ucd.ac.ma",
    "uh1.ac.ma",
    "uh2m.ac.ma",
    "um5a.ac.ma",
    "um5s.ac.ma",
    "univ-ibntofail.ac.ma",
    "univ-oujda.ac.ma",
    "usmba.ac.ma",
    "ump.ac.ma",
    "isctem.ac.mz",
    "ispu.ac.mz",
    "isri.ac.mz",
    "ucm.ac.mz",
    "uem.mz",
    "up.ac.mz",
    "unizambeze.ac.mz",
    "unilurio.ac.mz",
    "unam.na",
    "internationaluniversity-schoolofmedicine.org",
    "sjsm.org",
    "una.an",
    "ddu.nl",
    "dehaagsehogeschool.nl",
    "eur.nl",
    "rsm.nl",
    "hanze.nl",
    "hku.nl",
    "hotelschool.nl",
    "hro.nl",
    "hr.nl",
    "hsleiden.nl",
    "hu.nl",
    "hva.nl",
    "inholland.nl",
    "islamicuniversity.nl",
    "iss.nl",
    "itc.nl",
    "universiteitleiden.nl",
    "nhtv.nl",
    "nyenrode.nl",
    "ou.nl",
    "roac.nl",
    "rug.nl",
    "ru.nl",
    "tilburguniversity.nl",
    "tudelft.nl",
    "student.tudelft.nl",
    "tue.nl",
    "unesco-ihe.org",
    "unimaas.nl",
    "student.maastrichtuniversity.nl",
    "utwente.nl",
    "uu.nl",
    "uva.nl",
    "uvh.nl",
    "vu.nl",
    "wageningenuniversity.nl",
    "windesheim.nl",
    "wittenborg.eu",
    "zuyd.nl",
    "ufp.nc",
    "auckland.ac.nz",
    "aucklanduni.ac.nz",
    "aut.ac.nz",
    "canterbury.ac.nz",
    "uclive.ac.nz",
    "cpit.ac.nz",
    "lincoln.ac.nz",
    "massey.ac.nz",
    "openpolytechnic.ac.nz",
    "otago.ac.nz",
    "vuw.ac.nz",
    "waikato.ac.nz",
    "nmit.ac.nz",
    "uam.refer.ne",
    "aust-abuja.org",
    "bellsuniversity.org",
    "bowenuniversity-edu.org",
    "ebsu-edu.net",
    "fcetakoka-edu.net",
    "kasuportal.net",
    "laspotech.net",
    "lasunigeria.org",
    "mylcp.net",
    "obonguniversity.net",
    "polyunwana.net",
    "aho.no",
    "bi.no",
    "hia.no",
    "hib.no",
    "hibo.no",
    "hifm.no",
    "hil.no",
    "himolde.no",
    "khio.no",
    "nhh.no",
    "nih.no",
    "nith.no",
    "nla.no",
    "nlh.no",
    "nmh.no",
    "ntnu.no",
    "ska.khio.no",
    "uib.no",
    "uio.no",
    "uis.no",
    "uit.no",
    "umb.no",
    "veths.no",
    "niab.org.pk",
    "institutoteima.ac.pa",
    "oteima.ac.pa",
    "ucapanama.org",
    "udelas.ac.pa",
    "ulacit.ac.pa",
    "ulat.ac.pa",
    "unachi.ac.pa",
    "unadp.ac.pa",
    "up.ac.pa",
    "usma.ac.pa",
    "utp.ac.pa",
    "dwu.ac.pg",
    "pau.ac.pg",
    "unitech.ac.pg",
    "uog.ac.pg",
    "upng.ac.pg",
    "una.py",
    "iacademy.ph",
    "iubs.co.uk",
    "lnu.evis.net.ph",
    "mu.fapenet.org",
    "ndu.fapenet.org",
    "pma.ph",
    "upou.org",
    "usp.ph",
    "asp.krakow.pl",
    "ae.katowice.pl",
    "ae.krakow.pl",
    "ae.poznan.pl",
    "ae.wroc.pl",
    "amb.bydgoszcz.pl",
    "amg.gda.pl",
    "am.katowice.pl",
    "am.lodz.pl",
    "am.lublin.pl",
    "amuz.bydgoszcz.pl",
    "amuz.gda.pl",
    "amuz.krakow.pl",
    "amuz.lodz.pl",
    "amuz.poznan.pl",
    "amuz.wroc.pl",
    "am.wroc.pl",
    "ap.siedlce.pl",
    "ar.krakow.pl",
    "ar.lublin.pl",
    "ar.szczecin.pl",
    "art.olsztyn.pl",
    "ar.wroc.pl",
    "asp.gda.pl",
    "asp.lodz.pl",
    "asp.poznan.pl",
    "asp.waw.pl",
    "asp.wroc.pl",
    "au.poznan.pl",
    "awf.gda.pl",
    "awf.katowice.pl",
    "awf.krakow.pl",
    "awf.poznan.pl",
    "awf.wroc.pl",
    "dswe.wroc.pl",
    "filmowka.lodz.pl",
    "gallus.pl",
    "gwsh.pl",
    "kul.lublin.pl",
    "lazarski.pl",
    "man.radom.pl",
    "nkrriwf.pl",
    "pam.szczecin.pl",
    "pb.bialystok.pl",
    "pcz.czest.pl",
    "pg.gda.pl",
    "p.lodz.pl",
    "pol.lublin.pl",
    "polsl.gliwice.pl",
    "polsl.pl",
    "po.opole.pl",
    "prz.rzeszow.pl",
    "pu.kielce.pl",
    "put.poznan.pl",
    "pwr.wroc.pl",
    "pwst.krakow.pl",
    "pwsz.eu",
    "pwsz.pila.pl",
    "pz.zgora.pl",
    "qdnet.pl",
    "sggw.waw.pl",
    "sgh.waw.pl",
    "slam.katowice.pl",
    "tu.kielce.pl",
    "tu.koszalin.pl",
    "tuniv.szczecin.pl",
    "umcs.lublin.pl",
    "wsei.lublin.pl",
    "uni.lodz.pl",
    "uni.opole.pl",
    "uni.torun.pl",
    "univ.gda.pl",
    "univ.rzeszow.pl",
    "univ.szczecin.pl",
    "uni.wroc.pl",
    "usoms.poznan.pl",
    "wlodkowic.pl",
    "wsb.poznan.pl",
    "wsb.toi.tarnow.pl",
    "wsiz.rzeszow.pl",
    "wsm.gdynia.pl",
    "wsm.szczecin.pl",
    "wsp.bydgoszcz.pl",
    "wsp.czest.pl",
    "wsp.krakow.pl",
    "wsp.slupsk.pl",
    "wsps.waw.pl",
    "wsp.zgora.pl",
    "wsub.waw.pl",
    "wszib.krakow.pl",
    "wsz.pl",
    "zpsb.szczecin.pl",
    "cocite.pt",
    "enautica.pt",
    "esad.pt",
    "eshte.pt",
    "europeanuniversity.pt",
    "iade.pt",
    "inp.pt",
    "inuaf-studia.pt",
    "ipbeja.pt",
    "ipb.pt",
    "ipca.pt",
    "ipcb.pt",
    "ipc.pt",
    "ipg.pt",
    "ipiaget.org",
    "ipleiria.pt",
    "my.ipleiria.pt",
    "ipl.pt",
    "ipportalegre.pt",
    "ipp.pt",
    "ipsantarem.pt",
    "ips.pt",
    "ipt.pt",
    "ipvc.pt",
    "isai.pt",
    "isbb.pt",
    "iscet.pt",
    "iscte.pt",
    "iscte-iul.pt",
    "isg.pt",
    "isla.pt",
    "ispab.pt",
    "ispa.pt",
    "ispgaya.pt",
    "istec.pt",
    "istp.pt",
    "oml.pt",
    "pedago.pt",
    "uac.pt",
    "ualg.pt",
    "ua.pt",
    "uatla.pt",
    "ubi.pt",
    "ucp.pt",
    "uc.pt",
    "uevora.pt",
    "ufp.pt",
    "uinternacional.pt",
    "ul.pt",
    "campus.ul.pt",
    "ulusiada.pt",
    "ulusofona.pt",
    "uma.pt",
    "uminho.pt",
    "umoderna.pt",
    "uni.pt",
    "univ-ab.pt",
    "universidade-autonoma.pt",
    "unl.pt",
    "uportu.pt",
    "up.pt",
    "utad.pt",
    "utl.pt",
    "novasbe.unl.pt",
    "ceaprc.org",
    "ut.pr",
    "oryxschool.qa",
    "univ-reunion.fr",
    "aistedaab.ro",
    "amgd.eu",
    "anefs-edu.ro",
    "arteiasi.ro",
    "ase.ro",
    "central.ucv.ro",
    "emanuel.ro",
    "iaim.ro",
    "mta.ro",
    "oradeauniversity.co",
    "ovidunivconstanta-edu.org",
    "pub.ro",
    "rau.ro",
    "sibiu.ro",
    "snspa.ro",
    "spiruharet.ro",
    "tuiasi.ro",
    "uab.ro",
    "uaic.ro",
    "uartdcluj.ro",
    "uat.ro",
    "uav.ro",
    "ubbcluj.ro",
    "ubm.ro",
    "ub.ro",
    "uem.ro",
    "ugal.ro",
    "ulbsibiu.ro",
    "umfcluj.ro",
    "umfiasi.ro",
    "umftgm.ro",
    "umft.ro",
    "unarte.ro",
    "unatc.ro",
    "unibuc.ro",
    "unitbv.ro",
    "univagro-iasi.ro",
    "univcb.ro",
    "univermed-cdgm.ro",
    "universitateamaritima.ro",
    "univ-ovidius.ro",
    "unmb.ro",
    "uoradea.ro",
    "upa.ro",
    "upet.ro",
    "upg-ploiesti.ro",
    "upit.ro",
    "upm.ro",
    "usab.ro",
    "usab-tm.ro",
    "usamvcluj.ro",
    "usv.ro",
    "utcb.ro",
    "utcluj.ro",
    "utgjiu.ro",
    "utm.ro",
    "utt.ro",
    "uvt.ro",
    "uvvg.ro",
    "valahia.ro",
    "academiaga.ru",
    "adygnet.ru",
    "ael.ru",
    "agma.astranet.ru",
    "agtu.ru",
    "ame.ru",
    "amursu.ru",
    "aqua.sci-nnov.ru",
    "artacademy.spb.ru",
    "asmu.ru",
    "aspu.ru",
    "astu.org",
    "astu.secna.ru",
    "asu.ru",
    "avtlg.ru",
    "bashedu.ru",
    "bigpi.biysk.ru",
    "bmstu.ru",
    "brstu.ru",
    "bsaa.ru",
    "bspu.ru",
    "bstu.ru",
    "bsu.burnet.ru",
    "mosgu.ru",
    "chuvsu.ru",
    "conservatoire.ru",
    "conservatory.ru",
    "cspi.urc.ac.ru",
    "csu.ac.ru",
    "dgu.ru",
    "dongau.ru",
    "dvgups.ru",
    "dvgu.ru",
    "education.ivanovo.ru",
    "elsu.ru",
    "eltech.ru",
    "engec.ru",
    "esstu.ru",
    "eu.spb.ru",
    "fa.ru",
    "festu.ru",
    "filine.centro.ru",
    "ftacademy.ru",
    "gasu.ru",
    "gitis.net",
    "gma.ru",
    "gnesin-academy.ru",
    "gorny-ins.ru",
    "gpma.ru",
    "gti.spb.ru",
    "gturp.spb.ru",
    "gubkin.ru",
    "gukit.ru",
    "guu.ru",
    "herzen.spb.ru",
    "hse.ru",
    "iate.obninsk.ru",
    "ibch.ru",
    "ibi.spb.ru",
    "ibp-moscow.ru",
    "ieeu.udm.ru",
    "iet.ru",
    "ifmo.ru",
    "itmo.ru",
    "niuitmo.ru",
    "ime.ru",
    "intstudy.mai.ru",
    "isea.irk.ru",
    "isea.ru",
    "isma.indi.ru",
    "ispu.ru",
    "istu.irk.ru",
    "istu.ru",
    "isuct.ru",
    "isu.ru",
    "iubnt.yar.ru",
    "ivanovo.ac.ru",
    "jum.ru",
    "mpgu.su",
    "kai.ru",
    "kalmsu.ru",
    "kamgu.ru",
    "kantiana.ru",
    "karelia.ru",
    "kazanconservatory.ru",
    "kbsu.ru",
    "kemsu.ru",
    "kgmu.kcn.ru",
    "kgpu.ru",
    "kgtu.runnet.ru",
    "khspu.ru",
    "khstu.ru",
    "kiu.ru",
    "klgtu.ru",
    "knastu.ru",
    "ksaba.ru",
    "ksfei.ru",
    "ksmu.kursknet.ru",
    "kspu.kaluga.ru",
    "kspu.ptz.ru",
    "kstu.kursk.ru",
    "ksu.ru",
    "kubagro.ru",
    "kubstu.ru",
    "kubsu.ru",
    "kursk-uni.ru",
    "kuzstu.ac.ru",
    "lunn.sci-nnov.ru",
    "madi.ru",
    "margu.mari.ru",
    "marstu.mari.ru",
    "masu.ru",
    "mechnik.spb.ru",
    "medin.nsc.ru",
    "med.sgu.ru",
    "mesi.ru",
    "mgavm.ru",
    "mgimo.ru",
    "mgri-rggru.ru",
    "mgsu.norna.ru",
    "mgul.ac.ru",
    "miet.ru",
    "miigaik.ru",
    "miit.ru",
    "miom.org",
    "mipt.ru",
    "mirbis.ru",
    "mirea.ru",
    "misis.ru",
    "miu.ru",
    "mma.ru",
    "mosconsv.ru",
    "mpei.ac.ru",
    "mrsu.ru",
    "msaab.ru",
    "msiu.ru",
    "msta.ac.ru",
    "mstuca.ru",
    "msuee.ru",
    "msuie.ru",
    "msu.ru",
    "mtuci.ru",
    "muh.ru",
    "ncstu.ru",
    "neic.nsk.su",
    "nes.ru",
    "ngasu.sci-nnov.ru",
    "nilc.spb.ru",
    "nntu.sci-nnov.ru",
    "nosu.ru",
    "novsu.ac.ru",
    "nsmu.ru",
    "nstu.ru",
    "nsu.ru",
    "g.nsu.ru",
    "nwpi.ru",
    "omgau.ru",
    "omgtu.ru",
    "omgups.ru",
    "omsk-osma.ru",
    "orun.ru",
    "osu.ru",
    "pglu.ru",
    "pnzgu.ru",
    "pomorsu.ru",
    "psfa.ru",
    "psma.ru",
    "pspu.ac.ru",
    "pstu.ac.ru",
    "psu.ru",
    "rah.ru",
    "rea.ru",
    "rgata.yaroslavl.ru",
    "rshu.ru",
    "rsmu.da.ru",
    "rsmu.ru",
    "rsuh.ru",
    "rsu.ru",
    "rsute.ru",
    "rusoil.net",
    "sakhgu.sakhalin.ru",
    "samiit.ru",
    "samsmu.ru",
    "sapanet.ru",
    "sgap.ru",
    "sgau.ru",
    "sgma.info",
    "sgu.ru",
    "shu.smolensk.su",
    "sibsiu.kemerovo.su",
    "smolny-un.spb.ru",
    "smtu.ru",
    "spbau.ru",
    "spbgasu.ru",
    "spbgau.spb.ru",
    "spbguki.ru",
    "spbiir.ru",
    "spbstu.ru",
    "spbtei.ru",
    "spbu.ru",
    "spbuwc.ru",
    "spcpa.ru",
    "ssaa.ru",
    "ssaba.smr.ru",
    "ssau.ru",
    "ssea.runnet.ru",
    "sseu.ru",
    "ssmu.ru",
    "ssttu.samara.ru",
    "sstu-edu.ru",
    "sstu.samara.ru",
    "ssu.samara.ru",
    "stankin.ru",
    "stavsu.ru",
    "stu.lipetsk.ru",
    "stu.ru",
    "suai.ru",
    "surgu.wsnet.ru",
    "sutd.ru",
    "sut.ru",
    "tart.spb.ru",
    "tgpi.ttn.ru",
    "tgsha.ru",
    "theatrins-yar.ru",
    "timacad.ru",
    "tltsu.ru",
    "touro.ru",
    "tpu.ru",
    "tsma.ru",
    "tsogu.ru",
    "tstu.ru",
    "tstu.tver.ru",
    "tsuab.ru",
    "tsure.ru",
    "tsu.ru",
    "utmn.ru",
    "tsu.tula.ru",
    "ttc.ryazan.ru",
    "tu-bryansk.ru",
    "tu-chel.ac.ru",
    "tusur.ru",
    "tuvsu.ru",
    "uapa.ru",
    "uef.ru",
    "ugatu.ac.ru",
    "ugrasu.ru",
    "ugsha.ru",
    "uii.sever.ru",
    "ulspu.ru",
    "ulstu.ru",
    "ulsu.ru",
    "uni-dubna.ru",
    "unilib.neva.ru",
    "uni.udm.ru",
    "univer.omsk.su",
    "university.tversu.ru",
    "uni-vologda.ac.ru",
    "uniyar.ac.ru",
    "unn.ac.ru",
    "urc.ac.ru",
    "usaaa.ru",
    "usart.ru",
    "uscon.ru",
    "usfea.ru",
    "usla.ru",
    "usmga.ru",
    "urfu.ru",
    "usue.ru",
    "usu.ru",
    "uvauga.ru",
    "vfrta.ru",
    "vgafk.ru",
    "vgasa.ru",
    "vgta.vrn.ru",
    "vieup.ru",
    "vlsu.ru",
    "voenmeh.ru",
    "volsu.ru",
    "vorstu.ac.ru",
    "vsau.ru",
    "vsgaki.burnet.ru",
    "vsgtu.eastsib.ru",
    "vsma.info",
    "vspu.ac.ru",
    "vspu.kirov.ru",
    "vspu.ru",
    "vstu.ru",
    "vsu.ru",
    "vvsu.ru",
    "yma.ac.ru",
    "yspu.yar.ru",
    "ystu.yar.ru",
    "ysu.ru",
    "synergy.ru",
    "synergy.university",
    "auca.ac.rw",
    "inatek.ac.rw",
    "isae.ac.rw",
    "khi.ac.rw",
    "kie.ac.rw",
    "kist.ac.rw",
    "nur.ac.rw",
    "sfb.ac.rw",
    "uck.ac.rw",
    "ulk.ac.rw",
    "umutarapolytech.ac.rw",
    "stmu.org",
    "unisilvaner.info",
    "spartanmed.org",
    "tusom.org",
    "unirsm.sm",
    "ngha.med.sa",
    "tnmeyah.net",
    "afi-ue.sn",
    "bambey.univ.sn",
    "uahb.sn",
    "ucad.sn",
    "udb.sn",
    "ugb.sn",
    "unis.sn",
    "univ-thies.sn",
    "univ-zig.sn",
    "arts.bg.ac.rs",
    "bg.ac.rs",
    "eu.ac.rs",
    "kg.ac.rs",
    "megatrend-edu.net",
    "ni.ac.rs",
    "np.ac.rs",
    "pr.ac.rs",
    "uns.ac.rs",
    "unisey.ac.sc",
    "liccsalsl.org",
    "tusol.org",
    "taoistcollege.org.sg",
    "akademiapz.sk",
    "aku.sk",
    "aos.sk",
    "bisla.sk",
    "dti.sk",
    "euba.sk",
    "ismpo.sk",
    "ku.sk",
    "szu.sk",
    "selyeuni.sk",
    "sevs.sk",
    "stuba.sk",
    "tnuni.sk",
    "truni.sk",
    "tuke.sk",
    "tuzvo.sk",
    "ucm.sk",
    "ukf.sk",
    "umb.sk",
    "uniag.sk",
    "uniba.sk",
    "uninova.sk",
    "unipo.sk",
    "uniza.sk",
    "upjs.sk",
    "uvm.sk",
    "vsm.sk",
    "vsmu.sk",
    "vssladkovicovo.sk",
    "vssvalzbety.sk",
    "vsvu.sk",
    "ung.si",
    "uni-lj.si",
    "um.si",
    "upr.si",
    "amouduniversity.org",
    "benadiruniversity.net",
    "eastafricauniversity.net",
    "eelouniversity.org",
    "hargeisauniversity.net",
    "hiiraanuniversity.info",
    "maakhiruniversity.net",
    "somtech.org",
    "universityofsomalia.net",
    "cput.ac.za",
    "cut.ac.za",
    "dut.ac.za",
    "mandela.ac.za",
    "nmmu.ac.za",
    "ru.ac.za",
    "sun.ac.za",
    "tut.ac.za",
    "uct.ac.za",
    "myuct.ac.za",
    "ufh.ac.za",
    "uj.ac.za",
    "ukzn.ac.za",
    "ul.ac.za",
    "unisa.ac.za",
    "univen.ac.za",
    "nwu.ac.za",
    "uniwest.ac.za",
    "uovs.ac.za",
    "ufs.ac.za",
    "up.ac.za",
    "uwc.ac.za",
    "unizulu.ac.za",
    "vut.ac.za",
    "wits.ac.za",
    "wsu.ac.za",
    "msa.ac.za",
    "ump.ac.za",
    "mut.ac.za",
    "smu.ac.za",
    "spu.ac.za",
    "aisct.org",
    "barcelonagse.eu",
    "ceu.es",
    "deusto.es",
    "ehu.es",
    "ehu.eus",
    "esic.es",
    "global-business-school.org",
    "lasalleuniversities.net",
    "muni.es",
    "uab.es",
    "ua.es",
    "uah.es",
    "ualm.es",
    "uam.es",
    "uax.es",
    "ub.es",
    "ubu.es",
    "uc3m.es",
    "uca.es",
    "ucavila.es",
    "uchceu.es",
    "uclm.es",
    "ucm.es",
    "uco.es",
    "ucv.es",
    "udc.es",
    "udg.es",
    "udl.es",
    "uem.es",
    "ufv.es",
    "ugr.es",
    "uhu.es",
    "uia.es",
    "uib.es",
    "uic.es",
    "uimp.es",
    "ujaen.es",
    "uji.es",
    "ull.es",
    "ulpgc.es",
    "uma.es",
    "um.es",
    "umh.es",
    "unavarra.es",
    "unav.es",
    "uned.es",
    "unex.es",
    "uniaam.uia.es",
    "uloyola.es",
    "uniara.uia.es",
    "unican.es",
    "unileon.es",
    "uniovi.es",
    "unirioja.es",
    "universidadatlantico.org",
    "unizar.es",
    "unnet.es",
    "uoc.es",
    "upco.es",
    "upct.es",
    "upf.es",
    "upm.es",
    "upo.es",
    "upsa.es",
    "upv.es",
    "urjc.es",
    "gsyc.es",
    "url.es",
    "urv.es",
    "usal.es",
    "usc.es",
    "us.es",
    "uva.es",
    "uv.es",
    "uvic.es",
    "uvigo.es",
    "accimt.ac.lk",
    "bbu.ac.lk",
    "bpu.ac.lk",
    "cmb.ac.lk",
    "esn.ac.lk",
    "jfn.ac.lk",
    "kdu.ac.lk",
    "kln.ac.lk",
    "mrt.ac.lk",
    "ou.ac.lk",
    "pdn.ac.lk",
    "pgia.ac.lk",
    "rjt.ac.lk",
    "ruh.ac.lk",
    "sab.ac.lk",
    "seu.ac.lk",
    "sjp.ac.lk",
    "sliate.net",
    "sliit.lk",
    "uwu.ac.lk",
    "vpa.ac.lk",
    "wyb.ac.lk",
    "nsbm.lk",
    "nibm.lk",
    "iit.ac.lk",
    "elrazicollege.net",
    "sas-sd.net",
    "ush.sd",
    "uniswa.sz",
    "bth.se",
    "chalmers.se",
    "du.se",
    "gu.se",
    "hb.se",
    "hdk.gu.se",
    "hgo.se",
    "hh.se",
    "hhs.se",
    "hig.se",
    "hik.se",
    "his.se",
    "hj.se",
    "hkr.se",
    "htu.se",
    "kau.se",
    "ki.se",
    "konstfack.se",
    "kth.se",
    "lhs.se",
    "liu.se",
    "lu.se",
    "luth.se",
    "mah.se",
    "mdh.se",
    "miun.se",
    "nhv.se",
    "oru.se",
    "sh.se",
    "slu.se",
    "su.se",
    "umu.se",
    "uu.se",
    "vxu.se",
    "wmu.se",
    "bhms.ch",
    "bsl-lausanne.ch",
    "dct.ch",
    "ehl.ch",
    "fh-aargau.ch",
    "fhbb.ch",
    "fh-htachur.ch",
    "fhso.ch",
    "gbs-ge.ch",
    "gsba.ch",
    "hgkz.ch",
    "iun.ch",
    "lrguas.ch",
    "phw.info",
    "swissmc.ch",
    "swissu.org",
    "uniludes.ch",
    "victoria-uni.ch",
    "webster.ch",
    "zhwin.ch",
    "epfl.ch",
    "ethz.ch",
    "usi.ch",
    "unibas.ch",
    "unifr.ch",
    "unige.ch",
    "uzh.ch",
    "unizh.ch",
    "unibe.ch",
    "unilu.ch",
    "unisg.ch",
    "student.unisg.ch",
    "unil.ch",
    "unine.ch",
    "bfh.ch",
    "ffhs.ch",
    "fhnw.ch",
    "fhsg.ch",
    "hepl.ch",
    "hep-bejune.ch",
    "edufr.ch",
    "hepvs.ch",
    "hes-so.ch",
    "hfh.ch",
    "hslu.ch",
    "hsr.ch",
    "fh-htwchur.ch",
    "fh-hwz.ch",
    "ntb.ch",
    "phzg.ch",
    "phzh.ch",
    "phbern.ch",
    "ph-gr.ch",
    "phlu.ch",
    "phsg.ch",
    "phsz.ch",
    "phtg.ch",
    "supsi.ch",
    "zhaw.ch",
    "zhdk.ch",
    "chuv.ch",
    "hcuge.ch",
    "insel.ch",
    "unispital.ch",
    "rosey.ch",
    "svuonline.org",
    "tajagroun.tj",
    "tgnu.tarena.tj",
    "tiu.tj",
    "avu.org",
    "dit.ac.tz",
    "hkmu.ac.tz",
    "iaa.ac.tz",
    "ifm.ac.tz",
    "kcmc.ac.tz",
    "mmu.ac.tz",
    "mnma.ac.tz",
    "muccobs.ac.tz",
    "muchs.ac.tz",
    "mzumbe.ac.tz",
    "out.ac.tz",
    "saut.ac.tz",
    "sekuco.org",
    "suanet.ac.tz",
    "tumaini.ac.tz",
    "udom.ac.tz",
    "udsm.ac.tz",
    "ait.ac.th",
    "aru.ac.th",
    "asianust.ac.th",
    "bu.ac.th",
    "buu.ac.th",
    "chiangmai.ac.th",
    "chiangraicampus.rmutl.ac.th",
    "chula.ac.th",
    "cmru.ac.th",
    "cmvc.ac.th",
    "cpu.ac.th",
    "dpu.ac.th",
    "dusit.ac.th",
    "eau.ac.th",
    "efau.org",
    "hcu.ac.th",
    "hu.ac.th",
    "ibc.ac.th",
    "kbu.ac.th",
    "kku.ac.th",
    "kmitl.ac.th",
    "kmutnb.ac.th",
    "kmutt.ac.th",
    "krirk.ac.th",
    "ku.ac.th",
    "lampangvc.ac.th",
    "lcat.ac.th",
    "lcct.ac.th",
    "lpru.ac.th",
    "mahidol.ac.th",
    "mbu.ac.th",
    "mcu.ac.th",
    "mfu.ac.th",
    "mju.ac.th",
    "msu.ac.th",
    "muic.mahidol.ac.th",
    "mut.ac.th",
    "nan.rmutl.ac.th",
    "nida.ac.th",
    "nuv.ac.in",
    "nivadhana.ac.th",
    "nu.ac.th",
    "payap.ac.th",
    "psu.ac.th",
    "ptu.ac.th",
    "rmutp.ac.th",
    "rsu.ac.th",
    "ru.ac.th",
    "sau.ac.th",
    "shinawatra.ac.th",
    "spu.ac.th",
    "stjohn.ac.th",
    "stou.ac.th",
    "su.ac.th",
    "sut.ac.th",
    "swu.ac.th",
    "tsu.ac.th",
    "tu.ac.th",
    "ubu.ac.th",
    "utcc.ac.th",
    "vu.ac.th",
    "webster.ac.th",
    "wu.ac.th",
    "nation.ac.th",
    "univ-lome.tg",
    "uwi.tt",
    "disfm.rnu.tn",
    "isetr.rnu.tn",
    "isg.rnu.tn",
    "u7nc.uvt.rnu.tn",
    "uc.rnu.tn",
    "ugaf.rnu.tn",
    "uj.rnu.tn",
    "ult.ens.tn",
    "uma.rnu.tn",
    "um.rnu.tn",
    "unat.ens.tn",
    "univgb.rnu.tn",
    "univ-k.rnu.tn",
    "uss.rnu.tn",
    "utm.rnu.tn",
    "utunis.rnu.tn",
    "uvt.rnu.tn",
    "uz.rnu.tn",
    "charismauniversity.org",
    "bugemauniv.ac.ug",
    "busitema.ac.ug",
    "busogauniversity.ac.ug",
    "gu.ac.ug",
    "iuiu.ac.ug",
    "kiu.ac.ug",
    "ku.ac.ug",
    "kyu.ac.ug",
    "mak.ac.ug",
    "mmu.ac.ug",
    "mru.ac.ug",
    "must.ac.ug",
    "ndejjeuniversity.ac.ug",
    "nkumbauniversity.ac.ug",
    "saiu.ac.ug",
    "ucu.ac.ug",
    "umu.ac.ug",
    "academy.sumy.ua",
    "arosmu.org",
    "btsau.kiev.ua",
    "chnu.cv.ua",
    "dnu.dp.ua",
    "dstu.dp.ua",
    "forest.lviv.ua",
    "franko.lviv.ua",
    "ifdtung.if.ua",
    "khadi.kharkov.ua",
    "kma.mk.ua",
    "kneu.kiev.ua",
    "kpi.kharkov.ua",
    "kpi.ua",
    "kse.org.ua",
    "ksmu.kharkov.ua",
    "kstuca.kharkov.ua",
    "nure.ua",
    "lgpu.lg.ua",
    "ma.odessa.ua",
    "meduniv.lviv.ua",
    "nauu.kiev.ua",
    "nmu.org.ua",
    "ntu.kar.net",
    "ogasa.odessa.ua",
    "opu.odessa.ua",
    "osaft.odessa.ua",
    "osmu.odessa.ua",
    "pu.if.ua",
    "sau.sumy.ua",
    "tnu.crimea.ua",
    "tup.km.ua",
    "uamsa.net",
    "ukma.kiev.ua",
    "ukrfa.kharkov.ua",
    "univer.kharkov.ua",
    "university.kherson.ua",
    "univ.kiev.ua",
    "knu.ua",
    "univ.uzhgorod.ua",
    "uosa.uar.net",
    "usuft.kiev.ua",
    "vnmu.vn.ua",
    "vstu.vinnica.ua",
    "acd.ac.ae",
    "adu.ac.ae",
    "agu.ae",
    "ajman.ac.ae",
    "alainuniversity.ac.ae",
    "alhosnu.ae",
    "aue.ae",
    "buid.ac.ae",
    "ece.ac.ae",
    "gmu.ac.ae",
    "hbmeu.ac.ae",
    "hct.ac.ae",
    "ittihad.ac.ae",
    "ju.ac.ae",
    "ku.ac.ae",
    "kustar.ac.ae",
    "masdar.ac.ae",
    "pi.ac.ae",
    "sharjah.ac.ae",
    "sorbonne.ae",
    "uaeu.ac.ae",
    "ud.ac.ae",
    "uowdubai.ac.ae",
    "zu.ac.ae",
    "sia.ae",
    "abdn.ac.uk",
    "aberdeen.ac.uk",
    "aber.ac.uk",
    "abertay.ac.uk",
    "anglia.ac.uk",
    "aston.ac.uk",
    "bangor.ac.uk",
    "bath.ac.uk",
    "bathspa.ac.uk",
    "bbk.ac.uk",
    "bcom.ac.uk",
    "bcu.ac.uk",
    "beds.ac.uk",
    "bham.ac.uk",
    "bolton.ac.uk",
    "bournemouth.ac.uk",
    "brad.ac.uk",
    "brijnet.org",
    "bristol.ac.uk",
    "bris.ac.uk",
    "brookes.ac.uk",
    "brunel.ac.uk",
    "bton.ac.uk",
    "buck.ac.uk",
    "bucks.ac.uk",
    "cam.ac.uk",
    "camb.linst.ac.uk",
    "canterbury.ac.uk",
    "cardiff.ac.uk",
    "cf.ac.uk",
    "chelsea.linst.ac.uk",
    "chester.ac.uk",
    "city.ac.uk",
    "courtauld.ac.uk",
    "coventry.ac.uk",
    "cranfield.ac.uk",
    "csm.linst.ac.uk",
    "derby.ac.uk",
    "dmu.ac.uk",
    "dundee.ac.uk",
    "dur.ac.uk",
    "edgehill.ac.uk",
    "ed.ac.uk",
    "eselondon.ac.uk",
    "essex.ac.uk",
    "sx.ac.uk",
    "ex.ac.uk",
    "falmouth.ac.uk",
    "gcal.ac.uk",
    "gcu.ac.uk",
    "gla.ac.uk",
    "glam.ac.uk",
    "glos.ac.uk",
    "gold.ac.uk",
    "gre.ac.uk",
    "gsa.ac.uk",
    "student.gsa.ac.uk",
    "halifaxuni.ac",
    "herts.ac.uk",
    "heythrop.ac.uk",
    "hope.ac.uk",
    "hud.ac.uk",
    "hull.ac.uk",
    "huron.ac.uk",
    "hw.ac.uk",
    "imperial.ac.uk",
    "ic.ac.uk",
    "ifslearning.ac.uk",
    "ihr.sas.ac.uk",
    "ioe.ac.uk",
    "kcl.ac.uk",
    "keele.ac.uk",
    "kingston.ac.uk",
    "lamp.ac.uk",
    "lancs.ac.uk",
    "lboro.ac.uk",
    "student.lboro.ac.uk",
    "lbs.lon.ac.uk",
    "lcst.ac",
    "le.ac.uk",
    "leeds.ac.uk",
    "lgu.ac.uk",
    "limt.co.uk",
    "lincoln.ac.uk",
    "liv.ac.uk",
    "ljmu.ac.uk",
    "leedsbeckett.ac.uk",
    "lon.ac.uk",
    "londonmet.ac.uk",
    "lsbf.org.uk",
    "lse.ac.uk",
    "lshtm.ac.uk",
    "manchester.ac.uk",
    "mbs.ac.uk",
    "man.ac.uk",
    "mdx.ac.uk",
    "med.ic.ac.uk",
    "mmu.ac.uk",
    "napier.ac.uk",
    "ncl.ac.uk",
    "newport.ac.uk",
    "niu.org.uk",
    "northampton.ac.uk",
    "nottingham.ac.uk",
    "ntu.ac.uk",
    "open.ac.uk",
    "ou.ac.uk",
    "oxford.ac.uk",
    "ox.ac.uk",
    "paisley.ac.uk",
    "plymouth.ac.uk",
    "port.ac.uk",
    "qmw.ac.uk",
    "qmul.ac.uk",
    "qub.ac.uk",
    "ram.ac.uk",
    "rca.ac.uk",
    "network.rca.ac.uk",
    "rcm.ac.uk",
    "rdg.ac.uk",
    "rfhsm.ac.uk",
    "rgu.ac.uk",
    "royalholloway.ac.uk",
    "rhbnc.ac.uk",
    "rh.ac.uk",
    "richmond.ac.uk",
    "roehampton.ac.uk",
    "salford.ac.uk",
    "sas.ac.uk",
    "sbu.ac.uk",
    "schillerlondon.ac.uk",
    "sclondon.ac",
    "sghms.ac.uk",
    "shef.ac.uk",
    "sheffield.ac.uk",
    "shu.ac.uk",
    "smu.ac.uk",
    "soas.ac.uk",
    "solent.ac.uk",
    "soton.ac.uk",
    "ssees.ac.uk",
    "staffs.ac.uk",
    "st-andrews.ac.uk",
    "st-and.ac.uk",
    "stir.ac.uk",
    "st-patricks.ac.uk",
    "strath.ac.uk",
    "sunderland.ac.uk",
    "surrey.ac.uk",
    "sussex.ac.uk",
    "swan.ac.uk",
    "tcm.ac.uk",
    "tees.ac.uk",
    "trinity-cm.ac.uk",
    "tvu.ac.uk",
    "ucl.ac.uk",
    "uclan.ac.uk",
    "ucs.ac.uk",
    "uea.ac.uk",
    "uel.ac.uk",
    "ukc.ac.uk",
    "ulsop.ac.uk",
    "ulst.ac.uk",
    "umds.ac.uk",
    "unl.ac.uk",
    "northumbria.ac.uk",
    "uwcm.ac.uk",
    "uwe.ac.uk",
    "uwic.ac.uk",
    "wales.ac.uk",
    "warwick.ac.uk",
    "westminster.ac.uk",
    "williamgilbert.co.uk",
    "wimbledon.ac.uk",
    "wlv.ac.uk",
    "worc.ac.uk",
    "york.ac.uk",
    "middlesbro.ac.uk",
    "mbro.ac.uk",
    "stmarys.ac.uk",
    "leedstrinity.ac.uk",
    "eastcoast.ac.uk",
    "swansea.ac.uk",
    "yorksj.ac.uk",
    "cavc.ac.uk",
    "agrar.uz",
    "ferpi.dem.ru",
    "ibs.uz",
    "mdis.uz",
    "ndpi.uz",
    "nuu.uz",
    "pharmi.uz",
    "polito.uz",
    "qdpi.uz",
    "samdu.uz",
    "tashgiv.uz",
    "tayi.uz",
    "tdiu.uz",
    "tdtu.uz",
    "tfi.uz",
    "tiim.uz",
    "tiu.uz",
    "tma.uz",
    "tuit.uz",
    "uwed.uz",
    "uzswlu.uz",
    "wiut.uz",
    "luz.ve",
    "ucv.ve",
    "ula.ve",
    "usb.ve",
    "dct.udn.vn",
    "huflit.vnn.vn",
    "arwauniversity.org",
    "hoduniv.net.ye",
    "sabauni.net",
    "taizun.net",
    "thuniv.net",
    "yuniv.net",
    "cavendishza.org",
    "mu.ac.zm",
    "unilus.ac.zm",
    "unza.zm",
    "zaou.ac.zm",
    "buse.ac.zw",
    "cut.ac.zw",
    "cuz.ac.zw",
    "gzu.ac.zw",
    "hit.ac.zw",
    "lsu.ac.zw",
    "msu.ac.zw",
    "nust.ac.zw",
    "rcu.ac.zw",
    "solusi.ac.zw",
    "uz.ac.zw",
    "wua.ac.zw",
    "zegu.ac.zw",
    "zou.ac.zw",
    "ladhs.org",
    "gmc.cc.ga.us",
    "cwidaho.cc",
    "lakeland.cc.il.us",
    "glenoaks.cc.mi.us",
    "kbocc.org",
    "acs350.org",
    "cgcc.cc.or.us",
    "tbcc.cc.or.us",
    "tvcc.cc",
    "swc.tc",
    "swtjc.net",
    "ui1.es",
    "alumnos.ui1.es",
    "enae.es",
    "viu.es",
    "dhbw.de",
    "heidenheim.dhbw.de",
    "cas.dhbw.de",
    "dhbw-loerrach.de",
    "dhbw-mosbach.de",
    "mosbach.dhbw.de",
    "ravensburg.dhbw.de",
    "dhbw-stuttgart.de",
    "dhbw-vs.de",
    "heilbronn.dhbw.de",
    "dhbw-karlsruhe.de",
    "karlsruhe.dhbw.de",
    "dhbw-mannheim.de",
    "mannheim.dhbw.de",
    "hs-hannover.de",
    "stud.hs-hannover.de",
    "ba-bautzen.de",
    "csmrouen.net",
    "btu.ge",
    "mohawkcollege.ca",
    "bdeb.qc.ca",
    "fanshawec.ca",
    "fanshaweonline.ca",
    "vaniercollege.qc.ca",
    "ontariotechu.ca",
    "ontariotechu.net",
    "torontomu.ca",
    "collegeuniversel.ca",
    "htl-villach.at",
    "edu.htl-villach.at",
    "htl-wels.at",
    "udb.ac.id",
    "jedlik.eu",
    "students.jedlik.eu",
    "thm.de",
    "hwg-lu.de",
    "iiitm.ac.in",
    "leuphana.de",
    "oth-aw.de",
    "hamk.fi",
    "uni-corvinus.hu",
    "uni-obuda.hu",
    "uni-bge.hu",
    "iitbbs.ac.in",
    "sciencespo-rennes.fr",
    "bmhs.org",
    "ojaiusd.org",
    "wakefield.ac.uk",
    "student.uliege.be",
    "helpnet.uliege.be",
    "ddi.uliege.be",
    "uliege.be",
    "student.spsmb.cz",
    "spsmb.cz",
    "uninove.br",
    "upe.poli.br",
    "ecomp.poli.br",
    "poli.br",
    "mh-luebeck.de",
    "musikhochschule-muenchen.de",
    "hmtm.de",
    "udk-berlin.de",
    "hfmt-koeln.de",
    "hfmdd.de",
    "hmdk-stuttgart.de",
    "hfk-bremen.de",
    "hfk2020.de",
    "hmt-leipzig.de",
    "hmtm-hannover.de",
    "hfm-detmold.de",
    "ac-orleans-tours.fr",
    "uni-speyer.de",
    "europa-uni.de",
    "ac-besancon.fr",
    "lis.ac.uk",
    "uca.fr",
    "uclouvain.be",
    "luiss.it",
    "smithseminary.org",
    "student.upt.ro",
    "upt.ro",
    "msruas.ac.in",
    "fs.de",
    "fs-students.de",
    "clsbe.lisboa.ucp.pt",
    "imd.org",
    "hff-muenchen.de",
    "ac-mayotte.fr",
    "umit-tirol.at",
    "uumail.in",
    "universitycollege.ac.in",
    "uni-nke.hu",
    "gsfcuniversity.ac.in",
    "student.g.nwu.ac.za",
    "tudublin.ie",
    "a2.keio.jp",
    "akfaryarsiptk.ac.id",
    "ulster.ac.uk",
    "bs.naist.jp",
    "campus.fct.unl.pt",
    "chiba-u.jp",
    "college-de-france.fr",
    "panimalar.ac.in",
    "panimalarengineeringcollegechennai.ac.in",
    "rajalakshmi.org",
    "stjosephs.ac.in",
    "stjosephstechnology.ac.in",
    "saveetha.ac.in",
    "svce.ac.in",
    "srmeaswari.ac.in",
    "jeppiaarcollege.org",
    "ritchennai.org",
    "kcgcollege.ac.in",
    "hindustanuniv.ac.in",
    "licet.ac.in",
    "rmkec.ac.in",
    "rmkcet.ac.in",
    "rmd.ac.in",
    "saec.ac.in",
    "howest.be",
    "u-bourgogne.fr",
    "miva.university",
    "esmad.ipp.pt",
    "www.esmad.ipp.pt",
    "univesp.br",
    "ac-bordeaux.fr",
    "if-pan.krakow.pl",
    "lamar.org.mx",
    "ehtp.ac.ma",
    "universite-paris-saclay.fr",
    "mtu.ie",
    "uaysen.cl",
    "snuniv.ac.in",
    "asmildkloster.dk",
    "dkit.ie",
    "videndjurs.dk",
    "floridauniversitaria.es",
    "univ-jfc.fr",
    "ifmparis.fr",
    "amsterdam.tech",
    "tecmilenio.mx",
    "gordon.ac.il",
    "eigsi.fr",
    "ist-hochschule.de",
    "vvsaz.org",
    "cambriancollege.ca",
    "ncl-coll.ac.uk",
    "btc.ac.uk",
    "runshaw.ac.uk",
    "wsc.ac.uk",
    "uf3ceu.es",
    "usj.es",
    "uneatlantico.es",
    "univ-rennes2.fr",
    "univ-fcomte.fr",
    "paris-sorbonne.fr",
    "univ-paris-diderot.fr",
    "parisnanterre.fr",
    "u-pec.fr",
    "unimes.fr",
    "univ-jfc.fr",
    "upmf-grenoble.fr",
    "spjain.org",
    "techvalleyhigh.org",
    "usfx.bo",
    "netocentre.fr",
    "esprit.tn",
    "bmt.hs.kr",
    "tec.mx",
    "gitam.in",
    "pccoepune.org",
    "esi.dz",
    "lapinamk.fi",
    "iesguillemcifre.cat",
    "wur.nl"
];

const StudentAndThrowawayDomains = {
    ".hku": 1,
    "uva.nl": 1,
    ".polyu.": 1,
    "inno.no": 1,
    "sansano.usm.cl": 1,
    "cin.ufpe.br": 1,
    "mail.kmutt.ac.th": 1,
    "nedoz.com": 1,
    "kkumail.com": 1,
    "grr.la": 1,
    "gamil.com": 1,
    "yopmail.com": 1,
    "iit.ac.lk": 1,
    "windowslive.com": 1,
    "wqcefp.com": 1,
    "twzhhq.com": 1,
    "mhzayt.online": 1,
    "gmai.com": 1,
    "1033edge.com": 1,
    "11mail.com": 1,
    "123.com": 1,
    "123box.net": 1,
    "123india.com": 1,
    "123mail.cl": 1,
    "123qwe.co.uk": 1,
    "126.com": 1,
    "150ml.com": 1,
    "15meg4free.com": 1,
    "163.com": 1,
    "1coolplace.com": 1,
    "1freeemail.com": 1,
    "1funplace.com": 1,
    "1internetdrive.com": 1,
    "1mail.net": 1,
    "1me.net": 1,
    "1mum.com": 1,
    "1musicrow.com": 1,
    "1netdrive.com": 1,
    "1nsyncfan.com": 1,
    "1under.com": 1,
    "1webave.com": 1,
    "1webhighway.com": 1,
    "212.com": 1,
    "24horas.com": 1,
    "2911.net": 1,
    "2bmail.co.uk": 1,
    "2d2i.com": 1,
    "2die4.com": 1,
    "3000.it": 1,
    "321media.com": 1,
    "37.com": 1,
    "3ammagazine.com": 1,
    "3dmail.com": 1,
    "3email.com": 1,
    "3xl.net": 1,
    "444.net": 1,
    "4email.com": 1,
    "4email.net": 1,
    "4mg.com": 1,
    "4newyork.com": 1,
    "4x4man.com": 1,
    "5iron.com": 1,
    "5star.com": 1,
    "88.am": 1,
    "8848.net": 1,
    "888.nu": 1,
    "97rock.com": 1,
    "aaamail.zzn.com": 1,
    "aamail.net": 1,
    "aaronkwok.net": 1,
    "abbeyroadlondon.co.uk": 1,
    "abcflash.net": 1,
    "abdulnour.com": 1,
    "aberystwyth.com": 1,
    "abolition-now.com": 1,
    "about.com": 1,
    "academycougars.com": 1,
    "acceso.or.cr": 1,
    "access4less.net": 1,
    "accessgcc.com": 1,
    "ace-of-base.com": 1,
    "acmecity.com": 1,
    "acmemail.net": 1,
    "acninc.net": 1,
    "adelphia.net": 1,
    "adexec.com": 1,
    "adfarrow.com": 1,
    "adios.net": 1,
    "ados.fr": 1,
    "advalvas.be": 1,
    "aeiou.pt": 1,
    "aemail4u.com": 1,
    "aeneasmail.com": 1,
    "afreeinternet.com": 1,
    "africamail.com": 1,
    "agoodmail.com": 1,
    "ahaa.dk": 1,
    "aichi.com": 1,
    "aim.com": 1,
    "airforce.net": 1,
    "airforceemail.com": 1,
    "airmail.net": 1,
    "airpost.net": 1,
    "ajacied.com": 1,
    "ak47.hu": 1,
    "aknet.kg": 1,
    "albawaba.com": 1,
    "alex4all.com": 1,
    "alexandria.cc": 1,
    "algeria.com": 1,
    "alhilal.net": 1,
    "alibaba.com": 1,
    "alice.it": 1,
    "aliceadsl.fr": 1,
    "alive.cz": 1,
    "aliyun.com": 1,
    "allmail.net": 1,
    "alloymail.com": 1,
    "allracing.com": 1,
    "allsaintsfan.com": 1,
    "alltel.net": 1,
    "alskens.dk": 1,
    "altavista.com": 1,
    "altavista.net": 1,
    "altavista.se": 1,
    "alternativagratis.com": 1,
    "alumnidirector.com": 1,
    "alvilag.hu": 1,
    "amele.com": 1,
    "america.hm": 1,
    "ameritech.net": 1,
    "amnetsal.com": 1,
    "amrer.net": 1,
    "amuro.net": 1,
    "amuromail.com": 1,
    "ananzi.co.za": 1,
    "ancestry.com": 1,
    "andylau.net": 1,
    "anfmail.com": 1,
    "angelfan.com": 1,
    "angelfire.com": 1,
    "animal.net": 1,
    "animalhouse.com": 1,
    "animalwoman.net": 1,
    "anjungcafe.com": 1,
    "anote.com": 1,
    "another.com": 1,
    "anotherwin95.com": 1,
    "anti-social.com": 1,
    "antisocial.com": 1,
    "antongijsen.com": 1,
    "antwerpen.com": 1,
    "anymoment.com": 1,
    "anytimenow.com": 1,
    "aol.com": 1,
    "aol.it": 1,
    "apexmail.com": 1,
    "apmail.com": 1,
    "apollo.lv": 1,
    "approvers.net": 1,
    "arabia.com": 1,
    "arabtop.net": 1,
    "arcademaster.com": 1,
    "archaeologist.com": 1,
    "arcor.de": 1,
    "arcotronics.bg": 1,
    "argentina.com": 1,
    "aristotle.org": 1,
    "army.net": 1,
    "arnet.com.ar": 1,
    "artlover.com": 1,
    "artlover.com.au": 1,
    "as-if.com": 1,
    "asean-mail.com": 1,
    "asheville.com": 1,
    "asia-links.com": 1,
    "asia.com": 1,
    "asiafind.com": 1,
    "asianavenue.com": 1,
    "asiancityweb.com": 1,
    "asiansonly.net": 1,
    "asianwired.net": 1,
    "asiapoint.net": 1,
    "assala.com": 1,
    "assamesemail.com": 1,
    "astroboymail.com": 1,
    "astrolover.com": 1,
    "astrosfan.com": 1,
    "astrosfan.net": 1,
    "asurfer.com": 1,
    "athenachu.net": 1,
    "atina.cl": 1,
    "atl.lv": 1,
    "atlanticbb.net ": 1,
    "atlaswebmail.com": 1,
    "atlink.com": 1,
    "ato.check.com": 1,
    "atozasia.com": 1,
    "att.net": 1,
    "attbi.com": 1,
    "attglobal.net": 1,
    "attymail.com": 1,
    "au.ru": 1,
    "ausi.com": 1,
    "austin.rr.com": 1,
    "australia.edu": 1,
    "australiamail.com": 1,
    "austrosearch.net": 1,
    "autoescuelanerja.com": 1,
    "automotiveauthority.com": 1,
    "avh.hu": 1,
    "awsom.net": 1,
    "axoskate.com": 1,
    "ayna.com": 1,
    "azimiweb.com": 1,
    "bachelorboy.com": 1,
    "bachelorgal.com": 1,
    "backpackers.com": 1,
    "backstreet-boys.com": 1,
    "backstreetboysclub.com": 1,
    "bagherpour.com": 1,
    "bangkok.com": 1,
    "bangkok2000.com": 1,
    "bannertown.net": 1,
    "baptistmail.com": 1,
    "baptized.com": 1,
    "barcelona.com": 1,
    "baseballmail.com": 1,
    "basketballmail.com": 1,
    "batuta.net": 1,
    "baudoinconsulting.com": 1,
    "bboy.zzn.com": 1,
    "bcpl.net": 1,
    "bcvibes.com": 1,
    "beeebank.com": 1,
    "beenhad.com": 1,
    "beep.ru": 1,
    "beer.com": 1,
    "beethoven.com": 1,
    "belice.com": 1,
    "belizehome.com": 1,
    "bellatlantic.net": 1,
    "bellnet.ca": 1,
    "bellsouth.net": 1,
    "berkscounty.com": 1,
    "berlin.com": 1,
    "berlin.de": 1,
    "berlinexpo.de": 1,
    "bestmail.us": 1,
    "bestweb.net": 1,
    "bettergolf.net": 1,
    "bev.net": 1,
    "bharatmail.com": 1,
    "bigassweb.com": 1,
    "bigblue.net.au": 1,
    "bigboab.com": 1,
    "bigfoot.com": 1,
    "bigfoot.de": 1,
    "bigger.com": 1,
    "bigmailbox.com": 1,
    "bigpond.com": 1,
    "bigpond.com.au": 1,
    "bigpond.net.au": 1,
    "bigramp.com": 1,
    "bikemechanics.com": 1,
    "bikeracer.com": 1,
    "bikeracers.net": 1,
    "bikerider.com": 1,
    "billsfan.com": 1,
    "billsfan.net": 1,
    "bimamail.com": 1,
    "bimla.net": 1,
    "birdowner.net": 1,
    "bisons.com": 1,
    "bitmail.com": 1,
    "bitpage.net": 1,
    "bizhosting.com": 1,
    "bla-bla.com": 1,
    "blackburnmail.com": 1,
    "blackplanet.com": 1,
    "blacksburg.net": 1,
    "blazemail.com": 1,
    "blazenet.net": 1,
    "bluehyppo.com": 1,
    "bluemail.ch": 1,
    "bluemail.dk": 1,
    "bluesfan.com": 1,
    "bluewin.ch": 1,
    "blueyonder.co.uk": 1,
    "blushmail.com": 1,
    "bmlsports.net": 1,
    "boardermail.com": 1,
    "boatracers.com": 1,
    "bol.com.br": 1,
    "bolando.com": 1,
    "bollywoodz.com": 1,
    "bolt.com": 1,
    "boltonfans.com": 1,
    "bombdiggity.com": 1,
    "bonbon.net": 1,
    "boom.com": 1,
    "bootmail.com": 1,
    "bornnaked.com": 1,
    "bossofthemoss.com": 1,
    "bostonoffice.com": 1,
    "bounce.net": 1,
    "box.az": 1,
    "boxbg.com": 1,
    "boxemail.com": 1,
    "boxfrog.com": 1,
    "boyzoneclub.com": 1,
    "bradfordfans.com": 1,
    "brasilia.net": 1,
    "brazilmail.com.br": 1,
    "breathe.com": 1,
    "bresnan.net": 1,
    "brfree.com.br": 1,
    "bright.net": 1,
    "britneyclub.com": 1,
    "brittonsign.com": 1,
    "broadcast.net": 1,
    "bt.com": 1,
    "btinternet.com": 1,
    "btopenworld.co.uk": 1,
    "buffymail.com": 1,
    "bullsfan.com": 1,
    "bullsgame.com": 1,
    "bumerang.ro": 1,
    "bunko.com": 1,
    "buryfans.com": 1,
    "business-man.com": 1,
    "businessman.net": 1,
    "businessweekmail.com": 1,
    "busta-rhymes.com": 1,
    "busymail.com": 1,
    "buyersusa.com": 1,
    "bvimailbox.com": 1,
    "byteme.com": 1,
    "c2i.net": 1,
    "c3.hu": 1,
    "c4.com": 1,
    "cabacabana.com": 1,
    "cableone.net": 1,
    "caere.it": 1,
    "cairomail.com": 1,
    "cais.net": 1,
    "callnetuk.com": 1,
    "callsign.net": 1,
    "caltanet.it": 1,
    "camidge.com": 1,
    "canada-11.com": 1,
    "canada.com": 1,
    "canadianmail.com": 1,
    "canoemail.com": 1,
    "canwetalk.com": 1,
    "capu.net": 1,
    "caramail.com": 1,
    "care2.com": 1,
    "careerbuildermail.com": 1,
    "carioca.net": 1,
    "cartestraina.ro": 1,
    "casablancaresort.com": 1,
    "casino.com": 1,
    "catcha.com": 1,
    "catholic.org": 1,
    "catlover.com": 1,
    "catsrule.garfield.com": 1,
    "ccnmail.com": 1,
    "cd2.com": 1,
    "celineclub.com": 1,
    "celtic.com": 1,
    "centoper.it": 1,
    "centralpets.com": 1,
    "centrum.cz": 1,
    "centrum.sk": 1,
    "centurytel.net": 1,
    "cfl.rr.com": 1,
    "cgac.es": 1,
    "chaiyomail.com": 1,
    "chance2mail.com": 1,
    "chandrasekar.net": 1,
    "charm.net": 1,
    "charmedmail.com": 1,
    "charter.net": 1,
    "chat.ru": 1,
    "chattown.com": 1,
    "chauhanweb.com": 1,
    "check.com": 1,
    "check1check.com": 1,
    "cheerful.com": 1,
    "chek.com": 1,
    "chello.nl": 1,
    "chemist.com": 1,
    "chequemail.com": 1,
    "cheyenneweb.com": 1,
    "chez.com": 1,
    "chickmail.com": 1,
    "china.net.vg": 1,
    "chinalook.com": 1,
    "chirk.com": 1,
    "chocaholic.com.au": 1,
    "christianmail.net": 1,
    "churchusa.com": 1,
    "cia-agent.com": 1,
    "cia.hu": 1,
    "ciaoweb.it": 1,
    "cicciociccio.com": 1,
    "cincinow.net": 1,
    "citeweb.net": 1,
    "citlink.net": 1,
    "city-of-bath.org": 1,
    "city-of-birmingham.com": 1,
    "city-of-brighton.org": 1,
    "city-of-cambridge.com": 1,
    "city-of-coventry.com": 1,
    "city-of-edinburgh.com": 1,
    "city-of-lichfield.com": 1,
    "city-of-lincoln.com": 1,
    "city-of-liverpool.com": 1,
    "city-of-manchester.com": 1,
    "city-of-nottingham.com": 1,
    "city-of-oxford.com": 1,
    "city-of-swansea.com": 1,
    "city-of-westminster.com": 1,
    "city-of-westminster.net": 1,
    "city-of-york.net": 1,
    "city2city.com": 1,
    "cityofcardiff.net": 1,
    "cityoflondon.org": 1,
    "claramail.com": 1,
    "classicalfan.com": 1,
    "classicmail.co.za": 1,
    "clerk.com": 1,
    "cliffhanger.com": 1,
    "close2you.net": 1,
    "club-internet.fr": 1,
    "club4x4.net": 1,
    "clubalfa.com": 1,
    "clubbers.net": 1,
    "clubducati.com": 1,
    "clubhonda.net": 1,
    "clubvdo.net": 1,
    "cluemail.com": 1,
    "cmpmail.com": 1,
    "cnnsimail.com": 1,
    "codec.ro": 1,
    "coder.hu": 1,
    "coid.biz": 1,
    "coldmail.com": 1,
    "collectiblesuperstore.com": 1,
    "collegebeat.com": 1,
    "collegeclub.com": 1,
    "collegemail.com": 1,
    "colleges.com": 1,
    "columbus.rr.com": 1,
    "columbusrr.com": 1,
    "columnist.com": 1,
    "comcast.net": 1,
    "comic.com": 1,
    "communityconnect.com": 1,
    "comprendemail.com": 1,
    "compuserve.com": 1,
    "computer-freak.com": 1,
    "computermail.net": 1,
    "concentric.net": 1,
    "conexcol.com": 1,
    "conk.com": 1,
    "connect4free.net": 1,
    "connectbox.com": 1,
    "conok.com": 1,
    "consultant.com": 1,
    "cookiemonster.com": 1,
    "cool.br": 1,
    "coolgoose.ca": 1,
    "coolgoose.com": 1,
    "coolkiwi.com": 1,
    "coollist.com": 1,
    "coolmail.com": 1,
    "coolmail.net": 1,
    "coolsend.com": 1,
    "cooooool.com": 1,
    "cooperation.net": 1,
    "cooperationtogo.net": 1,
    "copacabana.com": 1,
    "cornells.com": 1,
    "cornerpub.com": 1,
    "corporatedirtbag.com": 1,
    "correo.terra.com.gt": 1,
    "cortinet.com": 1,
    "cotas.net": 1,
    "counsellor.com": 1,
    "countrylover.com": 1,
    "covad.net": 1,
    "cox.net": 1,
    "coxinet.net": 1,
    "coxmail.com": 1,
    "cpaonline.net": 1,
    "cracker.hu": 1,
    "crazedanddazed.com": 1,
    "crazysexycool.com": 1,
    "cristianemail.com": 1,
    "critterpost.com": 1,
    "croeso.com": 1,
    "crosshairs.com": 1,
    "crosslink.net": 1,
    "crosswinds.net": 1,
    "crwmail.com": 1,
    "cry4helponline.com": 1,
    "cs.com": 1,
    "csi.com": 1,
    "csinibaba.hu": 1,
    "cuemail.com": 1,
    "curio-city.com": 1,
    "cute-girl.com": 1,
    "cuteandcuddly.com": 1,
    "cutey.com": 1,
    "cww.de": 1,
    "cyber-africa.net": 1,
    "cyber4all.com": 1,
    "cyberbabies.com": 1,
    "cybercafemaui.com": 1,
    "cyberdude.com": 1,
    "cyberforeplay.net": 1,
    "cybergal.com": 1,
    "cybergrrl.com": 1,
    "cyberinbox.com": 1,
    "cyberleports.com": 1,
    "cybermail.net": 1,
    "cybernet.it": 1,
    "cyberspace-asia.com": 1,
    "cybertrains.org": 1,
    "cyclefanz.com": 1,
    "cynetcity.com": 1,
    "dabsol.net": 1,
    "dadacasa.com": 1,
    "daha.com": 1,
    "dailypioneer.com": 1,
    "dallas.theboys.com": 1,
    "dangerous-minds.com": 1,
    "dansegulvet.com": 1,
    "data54.com": 1,
    "daum.net": 1,
    "davegracey.com": 1,
    "dawnsonmail.com": 1,
    "dawsonmail.com": 1,
    "dazedandconfused.com": 1,
    "dbzmail.com": 1,
    "dca.net": 1,
    "dcemail.com": 1,
    "deadlymob.org": 1,
    "deal-maker.com": 1,
    "dearriba.com": 1,
    "death-star.com": 1,
    "dejanews.com": 1,
    "deliveryman.com": 1,
    "deltanet.com": 1,
    "deneg.net": 1,
    "depechemode.com": 1,
    "deseretmail.com": 1,
    "desertmail.com": 1,
    "desilota.com": 1,
    "deskmail.com": 1,
    "deskpilot.com": 1,
    "destin.com": 1,
    "detik.com": 1,
    "deutschland-net.com": 1,
    "devotedcouples.com": 1,
    "dfwatson.com": 1,
    "di-ve.com": 1,
    "digibel.be": 1,
    "diplomats.com": 1,
    "direcway.com": 1,
    "dirtracer.com": 1,
    "discofan.com": 1,
    "discovery.com": 1,
    "discoverymail.com": 1,
    "disinfo.net": 1,
    "dmailman.com": 1,
    "dmv.com": 1,
    "dnsmadeeasy.com": 1,
    "doctor.com": 1,
    "dog.com": 1,
    "doglover.com": 1,
    "dogmail.co.uk": 1,
    "dogsnob.net": 1,
    "doityourself.com": 1,
    "doneasy.com": 1,
    "donjuan.com": 1,
    "dontgotmail.com": 1,
    "dontmesswithtexas.com": 1,
    "doramail.com": 1,
    "dostmail.com": 1,
    "dotcom.fr": 1,
    "dott.it": 1,
    "dplanet.ch": 1,
    "dr.com": 1,
    "dragoncon.net": 1,
    "dragracer.com": 1,
    "dropzone.com": 1,
    "drotposta.hu": 1,
    "dslextreme.com": 1,
    "dubaimail.com": 1,
    "dublin.com": 1,
    "dublin.ie": 1,
    "dunlopdriver.com": 1,
    "dunloprider.com": 1,
    "duno.com": 1,
    "dwp.net": 1,
    "dygo.com": 1,
    "dynamitemail.com": 1,
    "e-apollo.lv": 1,
    "e-mail.dk": 1,
    "e-mail.ru": 1,
    "e-mailanywhere.com": 1,
    "e-mails.ru": 1,
    "e-tapaal.com": 1,
    "earthalliance.com": 1,
    "earthcam.net": 1,
    "earthdome.com": 1,
    "earthling.net": 1,
    "earthlink.net": 1,
    "earthonline.net": 1,
    "eastcoast.co.za": 1,
    "eastmail.com": 1,
    "easy.to": 1,
    "easypost.com": 1,
    "eatmydirt.com": 1,
    "ecardmail.com": 1,
    "ecbsolutions.net": 1,
    "echina.com": 1,
    "ecompare.com": 1,
    "edge.net": 1,
    "edmail.com": 1,
    "ednatx.com": 1,
    "edtnmail.com": 1,
    "educacao.te.pt": 1,
    "educastmail.com": 1,
    "ehmail.com": 1,
    "eircom.net": 1,
    "elsitio.com": 1,
    "elvis.com": 1,
    "email-london.co.uk": 1,
    "email.com": 1,
    "email.cz": 1,
    "email.ee": 1,
    "email.it": 1,
    "email.nu": 1,
    "email.ro": 1,
    "email.ru": 1,
    "email.si": 1,
    "email.women.com": 1,
    "email2me.net": 1,
    "emailacc.com": 1,
    "emailaccount.com": 1,
    "emailchoice.com": 1,
    "emailcorner.net": 1,
    "emailem.com": 1,
    "emailengine.net": 1,
    "emailforyou.net": 1,
    "emailgroups.net": 1,
    "emailpinoy.com": 1,
    "emailplanet.com": 1,
    "emails.ru": 1,
    "emailuser.net": 1,
    "emailx.net": 1,
    "ematic.com": 1,
    "embarqmail.com": 1,
    "emumail.com": 1,
    "end-war.com": 1,
    "enel.net": 1,
    "engineer.com": 1,
    "england.com": 1,
    "england.edu": 1,
    "enter.net": 1,
    "epatra.com": 1,
    "epix.net": 1,
    "epost.de": 1,
    "eposta.hu": 1,
    "eqqu.com": 1,
    "eramail.co.za": 1,
    "eresmas.com": 1,
    "eriga.lv": 1,
    "erols.com": 1,
    "estranet.it": 1,
    "ethos.st": 1,
    "etoast.com": 1,
    "etrademail.com": 1,
    "eudoramail.com": 1,
    "europe.com": 1,
    "euroseek.com": 1,
    "every1.net": 1,
    "everyday.com.kh": 1,
    "everyone.net": 1,
    "examnotes.net": 1,
    "excite.co.jp": 1,
    "excite.com": 1,
    "excite.it": 1,
    "execs.com": 1,
    "expressasia.com": 1,
    "extenda.net": 1,
    "extended.com": 1,
    "eyou.com": 1,
    "ezcybersearch.com": 1,
    "ezmail.egine.com": 1,
    "ezmail.ru": 1,
    "ezrs.com": 1,
    "ezy.net": 1,
    "f1fans.net": 1,
    "facebook.com": 1,
    "fan.com": 1,
    "fan.theboys.com": 1,
    "fansonlymail.com": 1,
    "fantasticmail.com": 1,
    "farang.net": 1,
    "faroweb.com": 1,
    "fastem.com": 1,
    "fastemail.us": 1,
    "fastemailer.com": 1,
    "fastermail.com": 1,
    "fastimap.com": 1,
    "fastmail.fm": 1,
    "fastmailbox.net": 1,
    "fastmessaging.com": 1,
    "fatcock.net": 1,
    "fathersrightsne.org": 1,
    "fbi-agent.com": 1,
    "fbi.hu": 1,
    "fcc.net": 1,
    "federalcontractors.com": 1,
    "felicity.com": 1,
    "felicitymail.com": 1,
    "femenino.com": 1,
    "fetchmail.co.uk": 1,
    "fetchmail.com": 1,
    "feyenoorder.com": 1,
    "ffanet.com": 1,
    "fiberia.com": 1,
    "fibertel.com.ar": 1,
    "filipinolinks.com": 1,
    "financemail.net": 1,
    "financier.com": 1,
    "findmail.com": 1,
    "finebody.com": 1,
    "finfin.com": 1,
    "fire-brigade.com": 1,
    "fishburne.org": 1,
    "flashcom.net": 1,
    "flashemail.com": 1,
    "flashmail.com": 1,
    "flashmail.net": 1,
    "flipcode.com": 1,
    "fmail.co.uk": 1,
    "fmailbox.com": 1,
    "fmgirl.com": 1,
    "fmguy.com": 1,
    "fnbmail.co.za": 1,
    "fnmail.com": 1,
    "folkfan.com": 1,
    "foodmail.com": 1,
    "football.theboys.com": 1,
    "footballmail.com": 1,
    "for-president.com": 1,
    "forfree.at": 1,
    "forpresident.com": 1,
    "forthnet.gr": 1,
    "fortuncity.com": 1,
    "fortunecity.com": 1,
    "forum.dk": 1,
    "foxmail.com": 1,
    "free-org.com": 1,
    "free.com.pe": 1,
    "free.fr": 1,
    "freeaccess.nl": 1,
    "freeaccount.com": 1,
    "freeandsingle.com": 1,
    "freedom.usa.com": 1,
    "freedomlover.com": 1,
    "freegates.be": 1,
    "freeghana.com": 1,
    "freeler.nl": 1,
    "freemail.c3.hu": 1,
    "freemail.com.au": 1,
    "freemail.com.pk": 1,
    "freemail.de": 1,
    "freemail.et": 1,
    "freemail.gr": 1,
    "freemail.hu": 1,
    "freemail.it": 1,
    "freemail.lt": 1,
    "freemail.nl": 1,
    "freemail.org.mk": 1,
    "freenet.de": 1,
    "freenet.kg": 1,
    "freeola.com": 1,
    "freeola.net": 1,
    "freeserve.co.uk": 1,
    "freestamp.com": 1,
    "freestart.hu": 1,
    "freesurf.fr": 1,
    "freesurf.nl": 1,
    "freeuk.com": 1,
    "freeuk.net": 1,
    "freeukisp.co.uk": 1,
    "freeweb.org": 1,
    "freewebemail.com": 1,
    "freeyellow.com": 1,
    "freezone.co.uk": 1,
    "fresnomail.com": 1,
    "friends-cafe.com": 1,
    "friendsfan.com": 1,
    "from-africa.com": 1,
    "from-america.com": 1,
    "from-argentina.com": 1,
    "from-asia.com": 1,
    "from-australia.com": 1,
    "from-belgium.com": 1,
    "from-brazil.com": 1,
    "from-canada.com": 1,
    "from-china.net": 1,
    "from-england.com": 1,
    "from-europe.com": 1,
    "from-france.net": 1,
    "from-germany.net": 1,
    "from-holland.com": 1,
    "from-israel.com": 1,
    "from-italy.net": 1,
    "from-japan.net": 1,
    "from-korea.com": 1,
    "from-mexico.com": 1,
    "from-outerspace.com": 1,
    "from-russia.com": 1,
    "from-spain.net": 1,
    "fromalabama.com": 1,
    "fromalaska.com": 1,
    "fromarizona.com": 1,
    "fromarkansas.com": 1,
    "fromcalifornia.com": 1,
    "fromcolorado.com": 1,
    "fromconnecticut.com": 1,
    "fromdelaware.com": 1,
    "fromflorida.net": 1,
    "fromgeorgia.com": 1,
    "fromhawaii.net": 1,
    "fromidaho.com": 1,
    "fromillinois.com": 1,
    "fromindiana.com": 1,
    "fromiowa.com": 1,
    "fromjupiter.com": 1,
    "fromkansas.com": 1,
    "fromkentucky.com": 1,
    "fromlouisiana.com": 1,
    "frommaine.net": 1,
    "frommaryland.com": 1,
    "frommassachusetts.com": 1,
    "frommiami.com": 1,
    "frommichigan.com": 1,
    "fromminnesota.com": 1,
    "frommississippi.com": 1,
    "frommissouri.com": 1,
    "frommontana.com": 1,
    "fromnebraska.com": 1,
    "fromnevada.com": 1,
    "fromnewhampshire.com": 1,
    "fromnewjersey.com": 1,
    "fromnewmexico.com": 1,
    "fromnewyork.net": 1,
    "fromnorthcarolina.com": 1,
    "fromnorthdakota.com": 1,
    "fromohio.com": 1,
    "fromoklahoma.com": 1,
    "fromoregon.net": 1,
    "frompennsylvania.com": 1,
    "fromrhodeisland.com": 1,
    "fromru.com": 1,
    "fromsouthcarolina.com": 1,
    "fromsouthdakota.com": 1,
    "fromtennessee.com": 1,
    "fromtexas.com": 1,
    "fromthestates.com": 1,
    "fromutah.com": 1,
    "fromvermont.com": 1,
    "fromvirginia.com": 1,
    "fromwashington.com": 1,
    "fromwashingtondc.com": 1,
    "fromwestvirginia.com": 1,
    "fromwisconsin.com": 1,
    "fromwyoming.com": 1,
    "front.ru": 1,
    "frontier.com": 1,
    "frontiernet.net": 1,
    "frostbyte.uk.net": 1,
    "fsmail.net": 1,
    "ftml.net": 1,
    "fullchannel.net": 1,
    "fullmail.com": 1,
    "funkfan.com": 1,
    "fuorissimo.com": 1,
    "furnitureprovider.com": 1,
    "fuse.net": 1,
    "fut.es": 1,
    "fwnb.com": 1,
    "fxsmails.com": 1,
    "galamb.net": 1,
    "galaxy5.com": 1,
    "gamebox.net": 1,
    "gamegeek.com": 1,
    "games.com": 1,
    "gamespotmail.com": 1,
    "garbage.com": 1,
    "gardener.com": 1,
    "gateway.net": 1,
    "gawab.com": 1,
    "gaybrighton.co.uk": 1,
    "gaza.net": 1,
    "gazeta.pl": 1,
    "gazibooks.com": 1,
    "gci.net": 1,
    "gee-wiz.com": 1,
    "geecities.com": 1,
    "geek.com": 1,
    "geek.hu": 1,
    "geeklife.com": 1,
    "general-hospital.com": 1,
    "geocities.com": 1,
    "geologist.com": 1,
    "geopia.com": 1,
    "gh2000.com": 1,
    "ghanamail.com": 1,
    "ghostmail.com": 1,
    "giantsfan.com": 1,
    "giga4u.de": 1,
    "gigileung.org": 1,
    "givepeaceachance.com": 1,
    "glay.org": 1,
    "glendale.net": 1,
    "globalfree.it": 1,
    "globalpagan.com": 1,
    "globalsite.com.br": 1,
    "globo.com": 1,
    "globomail.com": 1,
    "gmail.com": 1,
    "gmx.at": 1,
    "gmx.com": 1,
    "gmx.de": 1,
    "gmx.fr": 1,
    "gmx.li": 1,
    "gmx.net": 1,
    "gnwmail.com": 1,
    "go.com": 1,
    "go.ro": 1,
    "go.ru": 1,
    "go2.com.py": 1,
    "go2net.com": 1,
    "gocollege.com": 1,
    "gocubs.com": 1,
    "gofree.co.uk": 1,
    "goldenmail.ru": 1,
    "goldmail.ru": 1,
    "golfemail.com": 1,
    "golfmail.be": 1,
    "gonavy.net": 1,
    "goodstick.com": 1,
    "google.com": 1,
    "googlemail.com": 1,
    "goplay.com": 1,
    "gorontalo.net": 1,
    "gospelfan.com": 1,
    "gothere.uk.com": 1,
    "gotmail.com": 1,
    "gotomy.com": 1,
    "govolsfan.com": 1,
    "gportal.hu": 1,
    "grabmail.com": 1,
    "graffiti.net": 1,
    "gramszu.net": 1,
    "grapplers.com": 1,
    "gratisweb.com": 1,
    "grungecafe.com": 1,
    "gtemail.net": 1,
    "gti.net": 1,
    "gtmc.net": 1,
    "gua.net": 1,
    "guessmail.com": 1,
    "guju.net": 1,
    "gurlmail.com": 1,
    "guy.com": 1,
    "guy2.com": 1,
    "guyanafriends.com": 1,
    "gyorsposta.com": 1,
    "gyorsposta.hu": 1,
    "hackermail.net": 1,
    "hailmail.net": 1,
    "hairdresser.net": 1,
    "hamptonroads.com": 1,
    "handbag.com": 1,
    "handleit.com": 1,
    "hang-ten.com": 1,
    "hanmail.net": 1,
    "happemail.com": 1,
    "happycounsel.com": 1,
    "happypuppy.com": 1,
    "hardcorefreak.com": 1,
    "hawaii.rr.com": 1,
    "hawaiiantel.net": 1,
    "headbone.com": 1,
    "heartthrob.com": 1,
    "heerschap.com": 1,
    "heesun.net": 1,
    "hehe.com": 1,
    "hello.hu": 1,
    "hello.net.au": 1,
    "hello.to": 1,
    "helter-skelter.com": 1,
    "hempseed.com": 1,
    "herediano.com": 1,
    "heremail.com": 1,
    "herono1.com": 1,
    "hetnet.nl": 1,
    "hey.to": 1,
    "hhdevel.com": 1,
    "highmilton.com": 1,
    "highquality.com": 1,
    "highveldmail.co.za": 1,
    "hiphopfan.com": 1,
    "hispavista.com": 1,
    "hitthe.net": 1,
    "hkg.net": 1,
    "hkstarphoto.com": 1,
    "hockeymail.com": 1,
    "hollywoodkids.com": 1,
    "home-email.com": 1,
    "home.nl": 1,
    "home.no.net": 1,
    "home.ro": 1,
    "home.se": 1,
    "homeart.com": 1,
    "homelocator.com": 1,
    "homemail.com": 1,
    "homestead.com": 1,
    "homeworkcentral.com": 1,
    "hongkong.com": 1,
    "hookup.net": 1,
    "hoopsmail.com": 1,
    "horrormail.com": 1,
    "host-it.com.sg": 1,
    "hot-shot.com": 1,
    "hot.ee": 1,
    "hotbot.com": 1,
    "hotbrev.com": 1,
    "hotepmail.com": 1,
    "hotfire.net": 1,
    "hotletter.com": 1,
    "hotmail.be": 1,
    "hotmail.co.il": 1,
    "hotmail.co.uk": 1,
    "hotmail.com": 1,
    "hotmail.com.ar": 1,
    "hotmail.com.br": 1,
    "hotmail.com.mx": 1,
    "hotmail.de": 1,
    "hotmail.es": 1,
    "hotmail.fr": 1,
    "hotmail.it": 1,
    "hotmail.kg": 1,
    "hotmail.kz": 1,
    "hotmail.ru": 1,
    "hotpop.com": 1,
    "hotpop3.com": 1,
    "hotvoice.com": 1,
    "housefancom": 1,
    "housemail.com": 1,
    "hsuchi.net": 1,
    "html.tou.com": 1,
    "hughes.net": 1,
    "hunsa.com": 1,
    "hush.com": 1,
    "hushmail.com": 1,
    "hypernautica.com": 1,
    "i-connect.com": 1,
    "i-france.com": 1,
    "i-mail.com.au": 1,
    "i-p.com": 1,
    "i-plus.net": 1,
    "i.am": 1,
    "i12.com": 1,
    "iamawoman.com": 1,
    "iamwaiting.com": 1,
    "iamwasted.com": 1,
    "iamyours.com": 1,
    "ibm.net": 1,
    "icestorm.com": 1,
    "icloud.com": 1,
    "icmsconsultants.com": 1,
    "icq.com": 1,
    "icqmail.com": 1,
    "icrazy.com": 1,
    "id-base.com": 1,
    "ididitmyway.com": 1,
    "idirect.com": 1,
    "iespana.es": 1,
    "ifoward.com": 1,
    "ig.com.br": 1,
    "ignazio.it": 1,
    "ignmail.com": 1,
    "ihateclowns.com": 1,
    "ihwy.com": 1,
    "iinet.net.au": 1,
    "ijustdontcare.com": 1,
    "ilovechocolate.com": 1,
    "ilovejesus.com": 1,
    "ilovethemovies.com": 1,
    "ilovetocollect.net": 1,
    "ilse.nl": 1,
    "imaginemail.com": 1,
    "imail.org": 1,
    "imail.ru": 1,
    "imailbox.com": 1,
    "imel.org": 1,
    "imneverwrong.com": 1,
    "imposter.co.uk": 1,
    "imstressed.com": 1,
    "imtoosexy.com": 1,
    "in-box.net": 1,
    "iname.com": 1,
    "inbox.com": 1,
    "inbox.net": 1,
    "inbox.ru": 1,
    "incamail.com": 1,
    "incredimail.com": 1,
    "indexa.fr": 1,
    "india.com": 1,
    "indiatimes.com": 1,
    "indo-mail.com": 1,
    "indocities.com": 1,
    "indomail.com": 1,
    "indyracers.com": 1,
    "info-media.de": 1,
    "info66.com": 1,
    "infohq.com": 1,
    "infomail.es": 1,
    "infomart.or.jp": 1,
    "infospacemail.com": 1,
    "infovia.com.ar": 1,
    "inicia.es": 1,
    "inmail.sk": 1,
    "innocent.com": 1,
    "inorbit.com": 1,
    "insidebaltimore.net": 1,
    "insight.rr.com": 1,
    "insurer.com": 1,
    "integra.net": 1,
    "interaccess.com": 1,
    "interburp.com": 1,
    "interfree.it": 1,
    "interia.pl": 1,
    "interlap.com.ar": 1,
    "intermail.co.il": 1,
    "internet-club.com": 1,
    "internet-police.com": 1,
    "internetbiz.com": 1,
    "internetdrive.com": 1,
    "internetegypt.com": 1,
    "internetemails.net": 1,
    "internetmailing.net": 1,
    "internetmci.com": 1,
    "investormail.com": 1,
    "inwind.it": 1,
    "iobox.com": 1,
    "iobox.fi": 1,
    "iol.it": 1,
    "ionet.net": 1,
    "iowaemail.com": 1,
    "ip3.com": 1,
    "iprimus.com.au": 1,
    "iqemail.com": 1,
    "irangate.net": 1,
    "iraqmail.com": 1,
    "ireland.com": 1,
    "irj.hu": 1,
    "isellcars.com": 1,
    "islamonline.net": 1,
    "isleuthmail.com": 1,
    "ismart.net": 1,
    "isonfire.com": 1,
    "isp9.net": 1,
    "itelefonica.com.br": 1,
    "itloox.com": 1,
    "itmom.com": 1,
    "itol.com": 1,
    "ivebeenframed.com": 1,
    "ivillage.com": 1,
    "iwan-fals.com": 1,
    "iwmail.com": 1,
    "iwon.com": 1,
    "izadpanah.com": 1,
    "jahoopa.com": 1,
    "jakuza.hu": 1,
    "japan.com": 1,
    "jaydemail.com": 1,
    "jazzandjava.com": 1,
    "jazzfan.com": 1,
    "jazzgame.com": 1,
    "jerusalemmail.com": 1,
    "jetemail.net": 1,
    "jewishmail.com": 1,
    "jippii.fi": 1,
    "jmail.co.za": 1,
    "joinme.com": 1,
    "jokes.com": 1,
    "jordanmail.com": 1,
    "journalist.com": 1,
    "jovem.te.pt": 1,
    "joymail.com": 1,
    "jpopmail.com": 1,
    "jubiimail.dk": 1,
    "jump.com": 1,
    "jumpy.it": 1,
    "juniormail.com": 1,
    "juno.com": 1,
    "justemail.net": 1,
    "justicemail.com": 1,
    "kaazoo.com": 1,
    "kaixo.com": 1,
    "kalpoint.com": 1,
    "kansascity.com": 1,
    "kapoorweb.com": 1,
    "karachian.com": 1,
    "karachioye.com": 1,
    "karbasi.com": 1,
    "katamail.com": 1,
    "kayafmmail.co.za": 1,
    "kbjrmail.com": 1,
    "kcks.com": 1,
    "keg-party.com": 1,
    "keko.com.ar": 1,
    "kellychen.com": 1,
    "keromail.com": 1,
    "keyemail.com": 1,
    "kgb.hu": 1,
    "khosropour.com": 1,
    "kickassmail.com": 1,
    "killermail.com": 1,
    "kimo.com": 1,
    "kinki-kids.com": 1,
    "kittymail.com": 1,
    "kitznet.at": 1,
    "kiwibox.com": 1,
    "kiwitown.com": 1,
    "kmail.com.au": 1,
    "konx.com": 1,
    "korea.com": 1,
    "kozmail.com": 1,
    "krongthip.com": 1,
    "krunis.com": 1,
    "ksanmail.com": 1,
    "ksee24mail.com": 1,
    "kube93mail.com": 1,
    "kukamail.com": 1,
    "kumarweb.com": 1,
    "kuwait-mail.com": 1,
    "la.com": 1,
    "ladymail.cz": 1,
    "lagerlouts.com": 1,
    "lahoreoye.com": 1,
    "lakmail.com": 1,
    "lamer.hu": 1,
    "land.ru": 1,
    "lankamail.com": 1,
    "laposte.net": 1,
    "latemodels.com": 1,
    "latinmail.com": 1,
    "latino.com": 1,
    "lavabit.com": 1,
    "law.com": 1,
    "lawyer.com": 1,
    "leehom.net": 1,
    "legalactions.com": 1,
    "legislator.com": 1,
    "leonlai.net": 1,
    "letsgomets.net": 1,
    "letterbox.com": 1,
    "levele.com": 1,
    "levele.hu": 1,
    "lex.bg": 1,
    "lexis-nexis-mail.com": 1,
    "libero.it": 1,
    "liberomail.com": 1,
    "lick101.com": 1,
    "linkmaster.com": 1,
    "linktrader.com": 1,
    "linuxfreemail.com": 1,
    "linuxmail.org": 1,
    "lionsfan.com.au": 1,
    "liontrucks.com": 1,
    "liquidinformation.net": 1,
    "list.ru": 1,
    "littleblueroom.com": 1,
    "live.be": 1,
    "live.ca": 1,
    "live.co.uk": 1,
    "live.com": 1,
    "live.com.ar": 1,
    "live.com.au": 1,
    "live.com.mx": 1,
    "live.de": 1,
    "live.fr": 1,
    "live.it": 1,
    "live.nl": 1,
    "liverpoolfans.com": 1,
    "llandudno.com": 1,
    "llangollen.com": 1,
    "lmxmail.sk": 1,
    "lobbyist.com": 1,
    "localbar.com": 1,
    "london.com": 1,
    "loobie.com": 1,
    "looksmart.co.uk": 1,
    "looksmart.com": 1,
    "looksmart.com.au": 1,
    "lopezclub.com": 1,
    "louiskoo.com": 1,
    "love.com": 1,
    "love.cz": 1,
    "loveable.com": 1,
    "lovelygirl.net": 1,
    "lovemail.com": 1,
    "lover-boy.com": 1,
    "lovergirl.com": 1,
    "lovingjesus.com": 1,
    "lowandslow.com": 1,
    "luso.pt": 1,
    "luukku.com": 1,
    "lycos.co.uk": 1,
    "lycos.com": 1,
    "lycos.es": 1,
    "lycos.it": 1,
    "lycos.ne.jp": 1,
    "lycosemail.com": 1,
    "lycosmail.com": 1,
    "m-a-i-l.com": 1,
    "m-hmail.com": 1,
    "m4.org": 1,
    "mac.com": 1,
    "macbox.com": 1,
    "macfreak.com": 1,
    "machinecandy.com": 1,
    "macmail.com": 1,
    "madcreations.com": 1,
    "madrid.com": 1,
    "maffia.hu": 1,
    "magicmail.co.za": 1,
    "mahmoodweb.com": 1,
    "mail-awu.de": 1,
    "mail-box.cz": 1,
    "mail-center.com": 1,
    "mail-central.com": 1,
    "mail-page.com": 1,
    "mail.austria.com": 1,
    "mail.az": 1,
    "mail.be": 1,
    "mail.bulgaria.com": 1,
    "mail.byte.it": 1,
    "mail.co.za": 1,
    "mail.com": 1,
    "mail.ee": 1,
    "mail.entrepeneurmag.com": 1,
    "mail.freetown.com": 1,
    "mail.gr": 1,
    "mail.hitthebeach.com": 1,
    "mail.kmsp.com": 1,
    "mail.md": 1,
    "mail.nu": 1,
    "mail.org.uk": 1,
    "mail.pf": 1,
    "mail.pharmacy.com": 1,
    "mail.pt": 1,
    "mail.r-o-o-t.com": 1,
    "mail.ru": 1,
    "mail.salu.net": 1,
    "mail.sisna.com": 1,
    "mail.spaceports.com": 1,
    "mail.theboys.com": 1,
    "mail.usa.com": 1,
    "mail.vasarhely.hu": 1,
    "mail15.com": 1,
    "mail1st.com": 1,
    "mail2007.com": 1,
    "mail2aaron.com": 1,
    "mail2abby.com": 1,
    "mail2abc.com": 1,
    "mail2actor.com": 1,
    "mail2admiral.com": 1,
    "mail2adorable.com": 1,
    "mail2adoration.com": 1,
    "mail2adore.com": 1,
    "mail2adventure.com": 1,
    "mail2aeolus.com": 1,
    "mail2aether.com": 1,
    "mail2affection.com": 1,
    "mail2afghanistan.com": 1,
    "mail2africa.com": 1,
    "mail2agent.com": 1,
    "mail2aha.com": 1,
    "mail2ahoy.com": 1,
    "mail2aim.com": 1,
    "mail2air.com": 1,
    "mail2airbag.com": 1,
    "mail2airforce.com": 1,
    "mail2airport.com": 1,
    "mail2alabama.com": 1,
    "mail2alan.com": 1,
    "mail2alaska.com": 1,
    "mail2albania.com": 1,
    "mail2alcoholic.com": 1,
    "mail2alec.com": 1,
    "mail2alexa.com": 1,
    "mail2algeria.com": 1,
    "mail2alicia.com": 1,
    "mail2alien.com": 1,
    "mail2allan.com": 1,
    "mail2allen.com": 1,
    "mail2allison.com": 1,
    "mail2alpha.com": 1,
    "mail2alyssa.com": 1,
    "mail2amanda.com": 1,
    "mail2amazing.com": 1,
    "mail2amber.com": 1,
    "mail2america.com": 1,
    "mail2american.com": 1,
    "mail2andorra.com": 1,
    "mail2andrea.com": 1,
    "mail2andy.com": 1,
    "mail2anesthesiologist.com": 1,
    "mail2angela.com": 1,
    "mail2angola.com": 1,
    "mail2ann.com": 1,
    "mail2anna.com": 1,
    "mail2anne.com": 1,
    "mail2anthony.com": 1,
    "mail2anything.com": 1,
    "mail2aphrodite.com": 1,
    "mail2apollo.com": 1,
    "mail2april.com": 1,
    "mail2aquarius.com": 1,
    "mail2arabia.com": 1,
    "mail2arabic.com": 1,
    "mail2architect.com": 1,
    "mail2ares.com": 1,
    "mail2argentina.com": 1,
    "mail2aries.com": 1,
    "mail2arizona.com": 1,
    "mail2arkansas.com": 1,
    "mail2armenia.com": 1,
    "mail2army.com": 1,
    "mail2arnold.com": 1,
    "mail2art.com": 1,
    "mail2artemus.com": 1,
    "mail2arthur.com": 1,
    "mail2artist.com": 1,
    "mail2ashley.com": 1,
    "mail2ask.com": 1,
    "mail2astronomer.com": 1,
    "mail2athena.com": 1,
    "mail2athlete.com": 1,
    "mail2atlas.com": 1,
    "mail2atom.com": 1,
    "mail2attitude.com": 1,
    "mail2auction.com": 1,
    "mail2aunt.com": 1,
    "mail2australia.com": 1,
    "mail2austria.com": 1,
    "mail2azerbaijan.com": 1,
    "mail2baby.com": 1,
    "mail2bahamas.com": 1,
    "mail2bahrain.com": 1,
    "mail2ballerina.com": 1,
    "mail2ballplayer.com": 1,
    "mail2band.com": 1,
    "mail2bangladesh.com": 1,
    "mail2bank.com": 1,
    "mail2banker.com": 1,
    "mail2bankrupt.com": 1,
    "mail2baptist.com": 1,
    "mail2bar.com": 1,
    "mail2barbados.com": 1,
    "mail2barbara.com": 1,
    "mail2barter.com": 1,
    "mail2basketball.com": 1,
    "mail2batter.com": 1,
    "mail2beach.com": 1,
    "mail2beast.com": 1,
    "mail2beatles.com": 1,
    "mail2beauty.com": 1,
    "mail2becky.com": 1,
    "mail2beijing.com": 1,
    "mail2belgium.com": 1,
    "mail2belize.com": 1,
    "mail2ben.com": 1,
    "mail2bernard.com": 1,
    "mail2beth.com": 1,
    "mail2betty.com": 1,
    "mail2beverly.com": 1,
    "mail2beyond.com": 1,
    "mail2biker.com": 1,
    "mail2bill.com": 1,
    "mail2billionaire.com": 1,
    "mail2billy.com": 1,
    "mail2bio.com": 1,
    "mail2biologist.com": 1,
    "mail2black.com": 1,
    "mail2blackbelt.com": 1,
    "mail2blake.com": 1,
    "mail2blind.com": 1,
    "mail2blonde.com": 1,
    "mail2blues.com": 1,
    "mail2bob.com": 1,
    "mail2bobby.com": 1,
    "mail2bolivia.com": 1,
    "mail2bombay.com": 1,
    "mail2bonn.com": 1,
    "mail2bookmark.com": 1,
    "mail2boreas.com": 1,
    "mail2bosnia.com": 1,
    "mail2boston.com": 1,
    "mail2botswana.com": 1,
    "mail2bradley.com": 1,
    "mail2brazil.com": 1,
    "mail2breakfast.com": 1,
    "mail2brian.com": 1,
    "mail2bride.com": 1,
    "mail2brittany.com": 1,
    "mail2broker.com": 1,
    "mail2brook.com": 1,
    "mail2bruce.com": 1,
    "mail2brunei.com": 1,
    "mail2brunette.com": 1,
    "mail2brussels.com": 1,
    "mail2bryan.com": 1,
    "mail2bug.com": 1,
    "mail2bulgaria.com": 1,
    "mail2business.com": 1,
    "mail2buy.com": 1,
    "mail2ca.com": 1,
    "mail2california.com": 1,
    "mail2calvin.com": 1,
    "mail2cambodia.com": 1,
    "mail2cameroon.com": 1,
    "mail2canada.com": 1,
    "mail2cancer.com": 1,
    "mail2capeverde.com": 1,
    "mail2capricorn.com": 1,
    "mail2cardinal.com": 1,
    "mail2cardiologist.com": 1,
    "mail2care.com": 1,
    "mail2caroline.com": 1,
    "mail2carolyn.com": 1,
    "mail2casey.com": 1,
    "mail2cat.com": 1,
    "mail2caterer.com": 1,
    "mail2cathy.com": 1,
    "mail2catlover.com": 1,
    "mail2catwalk.com": 1,
    "mail2cell.com": 1,
    "mail2chad.com": 1,
    "mail2champaign.com": 1,
    "mail2charles.com": 1,
    "mail2chef.com": 1,
    "mail2chemist.com": 1,
    "mail2cherry.com": 1,
    "mail2chicago.com": 1,
    "mail2chile.com": 1,
    "mail2china.com": 1,
    "mail2chinese.com": 1,
    "mail2chocolate.com": 1,
    "mail2christian.com": 1,
    "mail2christie.com": 1,
    "mail2christmas.com": 1,
    "mail2christy.com": 1,
    "mail2chuck.com": 1,
    "mail2cindy.com": 1,
    "mail2clark.com": 1,
    "mail2classifieds.com": 1,
    "mail2claude.com": 1,
    "mail2cliff.com": 1,
    "mail2clinic.com": 1,
    "mail2clint.com": 1,
    "mail2close.com": 1,
    "mail2club.com": 1,
    "mail2coach.com": 1,
    "mail2coastguard.com": 1,
    "mail2colin.com": 1,
    "mail2college.com": 1,
    "mail2colombia.com": 1,
    "mail2color.com": 1,
    "mail2colorado.com": 1,
    "mail2columbia.com": 1,
    "mail2comedian.com": 1,
    "mail2composer.com": 1,
    "mail2computer.com": 1,
    "mail2computers.com": 1,
    "mail2concert.com": 1,
    "mail2congo.com": 1,
    "mail2connect.com": 1,
    "mail2connecticut.com": 1,
    "mail2consultant.com": 1,
    "mail2convict.com": 1,
    "mail2cook.com": 1,
    "mail2cool.com": 1,
    "mail2cory.com": 1,
    "mail2costarica.com": 1,
    "mail2country.com": 1,
    "mail2courtney.com": 1,
    "mail2cowboy.com": 1,
    "mail2cowgirl.com": 1,
    "mail2craig.com": 1,
    "mail2crave.com": 1,
    "mail2crazy.com": 1,
    "mail2create.com": 1,
    "mail2croatia.com": 1,
    "mail2cry.com": 1,
    "mail2crystal.com": 1,
    "mail2cuba.com": 1,
    "mail2culture.com": 1,
    "mail2curt.com": 1,
    "mail2customs.com": 1,
    "mail2cute.com": 1,
    "mail2cutey.com": 1,
    "mail2cynthia.com": 1,
    "mail2cyprus.com": 1,
    "mail2czechrepublic.com": 1,
    "mail2dad.com": 1,
    "mail2dale.com": 1,
    "mail2dallas.com": 1,
    "mail2dan.com": 1,
    "mail2dana.com": 1,
    "mail2dance.com": 1,
    "mail2dancer.com": 1,
    "mail2danielle.com": 1,
    "mail2danny.com": 1,
    "mail2darlene.com": 1,
    "mail2darling.com": 1,
    "mail2darren.com": 1,
    "mail2daughter.com": 1,
    "mail2dave.com": 1,
    "mail2dawn.com": 1,
    "mail2dc.com": 1,
    "mail2dealer.com": 1,
    "mail2deanna.com": 1,
    "mail2dearest.com": 1,
    "mail2debbie.com": 1,
    "mail2debby.com": 1,
    "mail2deer.com": 1,
    "mail2delaware.com": 1,
    "mail2delicious.com": 1,
    "mail2demeter.com": 1,
    "mail2democrat.com": 1,
    "mail2denise.com": 1,
    "mail2denmark.com": 1,
    "mail2dennis.com": 1,
    "mail2dentist.com": 1,
    "mail2derek.com": 1,
    "mail2desert.com": 1,
    "mail2devoted.com": 1,
    "mail2devotion.com": 1,
    "mail2diamond.com": 1,
    "mail2diana.com": 1,
    "mail2diane.com": 1,
    "mail2diehard.com": 1,
    "mail2dilemma.com": 1,
    "mail2dillon.com": 1,
    "mail2dinner.com": 1,
    "mail2dinosaur.com": 1,
    "mail2dionysos.com": 1,
    "mail2diplomat.com": 1,
    "mail2director.com": 1,
    "mail2dirk.com": 1,
    "mail2disco.com": 1,
    "mail2dive.com": 1,
    "mail2diver.com": 1,
    "mail2divorced.com": 1,
    "mail2djibouti.com": 1,
    "mail2doctor.com": 1,
    "mail2doglover.com": 1,
    "mail2dominic.com": 1,
    "mail2dominica.com": 1,
    "mail2dominicanrepublic.com": 1,
    "mail2don.com": 1,
    "mail2donald.com": 1,
    "mail2donna.com": 1,
    "mail2doris.com": 1,
    "mail2dorothy.com": 1,
    "mail2doug.com": 1,
    "mail2dough.com": 1,
    "mail2douglas.com": 1,
    "mail2dow.com": 1,
    "mail2downtown.com": 1,
    "mail2dream.com": 1,
    "mail2dreamer.com": 1,
    "mail2dude.com": 1,
    "mail2dustin.com": 1,
    "mail2dyke.com": 1,
    "mail2dylan.com": 1,
    "mail2earl.com": 1,
    "mail2earth.com": 1,
    "mail2eastend.com": 1,
    "mail2eat.com": 1,
    "mail2economist.com": 1,
    "mail2ecuador.com": 1,
    "mail2eddie.com": 1,
    "mail2edgar.com": 1,
    "mail2edwin.com": 1,
    "mail2egypt.com": 1,
    "mail2electron.com": 1,
    "mail2eli.com": 1,
    "mail2elizabeth.com": 1,
    "mail2ellen.com": 1,
    "mail2elliot.com": 1,
    "mail2elsalvador.com": 1,
    "mail2elvis.com": 1,
    "mail2emergency.com": 1,
    "mail2emily.com": 1,
    "mail2engineer.com": 1,
    "mail2english.com": 1,
    "mail2environmentalist.com": 1,
    "mail2eos.com": 1,
    "mail2eric.com": 1,
    "mail2erica.com": 1,
    "mail2erin.com": 1,
    "mail2erinyes.com": 1,
    "mail2eris.com": 1,
    "mail2eritrea.com": 1,
    "mail2ernie.com": 1,
    "mail2eros.com": 1,
    "mail2estonia.com": 1,
    "mail2ethan.com": 1,
    "mail2ethiopia.com": 1,
    "mail2eu.com": 1,
    "mail2europe.com": 1,
    "mail2eurus.com": 1,
    "mail2eva.com": 1,
    "mail2evan.com": 1,
    "mail2evelyn.com": 1,
    "mail2everything.com": 1,
    "mail2exciting.com": 1,
    "mail2expert.com": 1,
    "mail2fairy.com": 1,
    "mail2faith.com": 1,
    "mail2fanatic.com": 1,
    "mail2fancy.com": 1,
    "mail2fantasy.com": 1,
    "mail2farm.com": 1,
    "mail2farmer.com": 1,
    "mail2fashion.com": 1,
    "mail2fat.com": 1,
    "mail2feeling.com": 1,
    "mail2female.com": 1,
    "mail2fever.com": 1,
    "mail2fighter.com": 1,
    "mail2fiji.com": 1,
    "mail2filmfestival.com": 1,
    "mail2films.com": 1,
    "mail2finance.com": 1,
    "mail2finland.com": 1,
    "mail2fireman.com": 1,
    "mail2firm.com": 1,
    "mail2fisherman.com": 1,
    "mail2flexible.com": 1,
    "mail2florence.com": 1,
    "mail2florida.com": 1,
    "mail2floyd.com": 1,
    "mail2fly.com": 1,
    "mail2fond.com": 1,
    "mail2fondness.com": 1,
    "mail2football.com": 1,
    "mail2footballfan.com": 1,
    "mail2found.com": 1,
    "mail2france.com": 1,
    "mail2frank.com": 1,
    "mail2frankfurt.com": 1,
    "mail2franklin.com": 1,
    "mail2fred.com": 1,
    "mail2freddie.com": 1,
    "mail2free.com": 1,
    "mail2freedom.com": 1,
    "mail2french.com": 1,
    "mail2freudian.com": 1,
    "mail2friendship.com": 1,
    "mail2from.com": 1,
    "mail2fun.com": 1,
    "mail2gabon.com": 1,
    "mail2gabriel.com": 1,
    "mail2gail.com": 1,
    "mail2galaxy.com": 1,
    "mail2gambia.com": 1,
    "mail2games.com": 1,
    "mail2gary.com": 1,
    "mail2gavin.com": 1,
    "mail2gemini.com": 1,
    "mail2gene.com": 1,
    "mail2genes.com": 1,
    "mail2geneva.com": 1,
    "mail2george.com": 1,
    "mail2georgia.com": 1,
    "mail2gerald.com": 1,
    "mail2german.com": 1,
    "mail2germany.com": 1,
    "mail2ghana.com": 1,
    "mail2gilbert.com": 1,
    "mail2gina.com": 1,
    "mail2girl.com": 1,
    "mail2glen.com": 1,
    "mail2gloria.com": 1,
    "mail2goddess.com": 1,
    "mail2gold.com": 1,
    "mail2golfclub.com": 1,
    "mail2golfer.com": 1,
    "mail2gordon.com": 1,
    "mail2government.com": 1,
    "mail2grab.com": 1,
    "mail2grace.com": 1,
    "mail2graham.com": 1,
    "mail2grandma.com": 1,
    "mail2grandpa.com": 1,
    "mail2grant.com": 1,
    "mail2greece.com": 1,
    "mail2green.com": 1,
    "mail2greg.com": 1,
    "mail2grenada.com": 1,
    "mail2gsm.com": 1,
    "mail2guard.com": 1,
    "mail2guatemala.com": 1,
    "mail2guy.com": 1,
    "mail2hades.com": 1,
    "mail2haiti.com": 1,
    "mail2hal.com": 1,
    "mail2handhelds.com": 1,
    "mail2hank.com": 1,
    "mail2hannah.com": 1,
    "mail2harold.com": 1,
    "mail2harry.com": 1,
    "mail2hawaii.com": 1,
    "mail2headhunter.com": 1,
    "mail2heal.com": 1,
    "mail2heather.com": 1,
    "mail2heaven.com": 1,
    "mail2hebe.com": 1,
    "mail2hecate.com": 1,
    "mail2heidi.com": 1,
    "mail2helen.com": 1,
    "mail2hell.com": 1,
    "mail2help.com": 1,
    "mail2helpdesk.com": 1,
    "mail2henry.com": 1,
    "mail2hephaestus.com": 1,
    "mail2hera.com": 1,
    "mail2hercules.com": 1,
    "mail2herman.com": 1,
    "mail2hermes.com": 1,
    "mail2hespera.com": 1,
    "mail2hestia.com": 1,
    "mail2highschool.com": 1,
    "mail2hindu.com": 1,
    "mail2hip.com": 1,
    "mail2hiphop.com": 1,
    "mail2holland.com": 1,
    "mail2holly.com": 1,
    "mail2hollywood.com": 1,
    "mail2homer.com": 1,
    "mail2honduras.com": 1,
    "mail2honey.com": 1,
    "mail2hongkong.com": 1,
    "mail2hope.com": 1,
    "mail2horse.com": 1,
    "mail2hot.com": 1,
    "mail2hotel.com": 1,
    "mail2houston.com": 1,
    "mail2howard.com": 1,
    "mail2hugh.com": 1,
    "mail2human.com": 1,
    "mail2hungary.com": 1,
    "mail2hungry.com": 1,
    "mail2hygeia.com": 1,
    "mail2hyperspace.com": 1,
    "mail2hypnos.com": 1,
    "mail2ian.com": 1,
    "mail2ice-cream.com": 1,
    "mail2iceland.com": 1,
    "mail2idaho.com": 1,
    "mail2idontknow.com": 1,
    "mail2illinois.com": 1,
    "mail2imam.com": 1,
    "mail2in.com": 1,
    "mail2india.com": 1,
    "mail2indian.com": 1,
    "mail2indiana.com": 1,
    "mail2indonesia.com": 1,
    "mail2infinity.com": 1,
    "mail2intense.com": 1,
    "mail2iowa.com": 1,
    "mail2iran.com": 1,
    "mail2iraq.com": 1,
    "mail2ireland.com": 1,
    "mail2irene.com": 1,
    "mail2iris.com": 1,
    "mail2irresistible.com": 1,
    "mail2irving.com": 1,
    "mail2irwin.com": 1,
    "mail2isaac.com": 1,
    "mail2israel.com": 1,
    "mail2italian.com": 1,
    "mail2italy.com": 1,
    "mail2jackie.com": 1,
    "mail2jacob.com": 1,
    "mail2jail.com": 1,
    "mail2jaime.com": 1,
    "mail2jake.com": 1,
    "mail2jamaica.com": 1,
    "mail2james.com": 1,
    "mail2jamie.com": 1,
    "mail2jan.com": 1,
    "mail2jane.com": 1,
    "mail2janet.com": 1,
    "mail2janice.com": 1,
    "mail2japan.com": 1,
    "mail2japanese.com": 1,
    "mail2jasmine.com": 1,
    "mail2jason.com": 1,
    "mail2java.com": 1,
    "mail2jay.com": 1,
    "mail2jazz.com": 1,
    "mail2jed.com": 1,
    "mail2jeffrey.com": 1,
    "mail2jennifer.com": 1,
    "mail2jenny.com": 1,
    "mail2jeremy.com": 1,
    "mail2jerry.com": 1,
    "mail2jessica.com": 1,
    "mail2jessie.com": 1,
    "mail2jesus.com": 1,
    "mail2jew.com": 1,
    "mail2jeweler.com": 1,
    "mail2jim.com": 1,
    "mail2jimmy.com": 1,
    "mail2joan.com": 1,
    "mail2joann.com": 1,
    "mail2joanna.com": 1,
    "mail2jody.com": 1,
    "mail2joe.com": 1,
    "mail2joel.com": 1,
    "mail2joey.com": 1,
    "mail2john.com": 1,
    "mail2join.com": 1,
    "mail2jon.com": 1,
    "mail2jonathan.com": 1,
    "mail2jones.com": 1,
    "mail2jordan.com": 1,
    "mail2joseph.com": 1,
    "mail2josh.com": 1,
    "mail2joy.com": 1,
    "mail2juan.com": 1,
    "mail2judge.com": 1,
    "mail2judy.com": 1,
    "mail2juggler.com": 1,
    "mail2julian.com": 1,
    "mail2julie.com": 1,
    "mail2jumbo.com": 1,
    "mail2junk.com": 1,
    "mail2justin.com": 1,
    "mail2justme.com": 1,
    "mail2kansas.com": 1,
    "mail2karate.com": 1,
    "mail2karen.com": 1,
    "mail2karl.com": 1,
    "mail2karma.com": 1,
    "mail2kathleen.com": 1,
    "mail2kathy.com": 1,
    "mail2katie.com": 1,
    "mail2kay.com": 1,
    "mail2kazakhstan.com": 1,
    "mail2keen.com": 1,
    "mail2keith.com": 1,
    "mail2kelly.com": 1,
    "mail2kelsey.com": 1,
    "mail2ken.com": 1,
    "mail2kendall.com": 1,
    "mail2kennedy.com": 1,
    "mail2kenneth.com": 1,
    "mail2kenny.com": 1,
    "mail2kentucky.com": 1,
    "mail2kenya.com": 1,
    "mail2kerry.com": 1,
    "mail2kevin.com": 1,
    "mail2kim.com": 1,
    "mail2kimberly.com": 1,
    "mail2king.com": 1,
    "mail2kirk.com": 1,
    "mail2kiss.com": 1,
    "mail2kosher.com": 1,
    "mail2kristin.com": 1,
    "mail2kurt.com": 1,
    "mail2kuwait.com": 1,
    "mail2kyle.com": 1,
    "mail2kyrgyzstan.com": 1,
    "mail2la.com": 1,
    "mail2lacrosse.com": 1,
    "mail2lance.com": 1,
    "mail2lao.com": 1,
    "mail2larry.com": 1,
    "mail2latvia.com": 1,
    "mail2laugh.com": 1,
    "mail2laura.com": 1,
    "mail2lauren.com": 1,
    "mail2laurie.com": 1,
    "mail2lawrence.com": 1,
    "mail2lawyer.com": 1,
    "mail2lebanon.com": 1,
    "mail2lee.com": 1,
    "mail2leo.com": 1,
    "mail2leon.com": 1,
    "mail2leonard.com": 1,
    "mail2leone.com": 1,
    "mail2leslie.com": 1,
    "mail2letter.com": 1,
    "mail2liberia.com": 1,
    "mail2libertarian.com": 1,
    "mail2libra.com": 1,
    "mail2libya.com": 1,
    "mail2liechtenstein.com": 1,
    "mail2life.com": 1,
    "mail2linda.com": 1,
    "mail2linux.com": 1,
    "mail2lionel.com": 1,
    "mail2lipstick.com": 1,
    "mail2liquid.com": 1,
    "mail2lisa.com": 1,
    "mail2lithuania.com": 1,
    "mail2litigator.com": 1,
    "mail2liz.com": 1,
    "mail2lloyd.com": 1,
    "mail2lois.com": 1,
    "mail2lola.com": 1,
    "mail2london.com": 1,
    "mail2looking.com": 1,
    "mail2lori.com": 1,
    "mail2lost.com": 1,
    "mail2lou.com": 1,
    "mail2louis.com": 1,
    "mail2louisiana.com": 1,
    "mail2lovable.com": 1,
    "mail2love.com": 1,
    "mail2lucky.com": 1,
    "mail2lucy.com": 1,
    "mail2lunch.com": 1,
    "mail2lust.com": 1,
    "mail2luxembourg.com": 1,
    "mail2luxury.com": 1,
    "mail2lyle.com": 1,
    "mail2lynn.com": 1,
    "mail2madagascar.com": 1,
    "mail2madison.com": 1,
    "mail2madrid.com": 1,
    "mail2maggie.com": 1,
    "mail2mail4.com": 1,
    "mail2maine.com": 1,
    "mail2malawi.com": 1,
    "mail2malaysia.com": 1,
    "mail2maldives.com": 1,
    "mail2mali.com": 1,
    "mail2malta.com": 1,
    "mail2mambo.com": 1,
    "mail2man.com": 1,
    "mail2mandy.com": 1,
    "mail2manhunter.com": 1,
    "mail2mankind.com": 1,
    "mail2many.com": 1,
    "mail2marc.com": 1,
    "mail2marcia.com": 1,
    "mail2margaret.com": 1,
    "mail2margie.com": 1,
    "mail2marhaba.com": 1,
    "mail2maria.com": 1,
    "mail2marilyn.com": 1,
    "mail2marines.com": 1,
    "mail2mark.com": 1,
    "mail2marriage.com": 1,
    "mail2married.com": 1,
    "mail2marries.com": 1,
    "mail2mars.com": 1,
    "mail2marsha.com": 1,
    "mail2marshallislands.com": 1,
    "mail2martha.com": 1,
    "mail2martin.com": 1,
    "mail2marty.com": 1,
    "mail2marvin.com": 1,
    "mail2mary.com": 1,
    "mail2maryland.com": 1,
    "mail2mason.com": 1,
    "mail2massachusetts.com": 1,
    "mail2matt.com": 1,
    "mail2matthew.com": 1,
    "mail2maurice.com": 1,
    "mail2mauritania.com": 1,
    "mail2mauritius.com": 1,
    "mail2max.com": 1,
    "mail2maxwell.com": 1,
    "mail2maybe.com": 1,
    "mail2mba.com": 1,
    "mail2me4u.com": 1,
    "mail2mechanic.com": 1,
    "mail2medieval.com": 1,
    "mail2megan.com": 1,
    "mail2mel.com": 1,
    "mail2melanie.com": 1,
    "mail2melissa.com": 1,
    "mail2melody.com": 1,
    "mail2member.com": 1,
    "mail2memphis.com": 1,
    "mail2methodist.com": 1,
    "mail2mexican.com": 1,
    "mail2mexico.com": 1,
    "mail2mgz.com": 1,
    "mail2miami.com": 1,
    "mail2michael.com": 1,
    "mail2michelle.com": 1,
    "mail2michigan.com": 1,
    "mail2mike.com": 1,
    "mail2milan.com": 1,
    "mail2milano.com": 1,
    "mail2mildred.com": 1,
    "mail2milkyway.com": 1,
    "mail2millennium.com": 1,
    "mail2millionaire.com": 1,
    "mail2milton.com": 1,
    "mail2mime.com": 1,
    "mail2mindreader.com": 1,
    "mail2mini.com": 1,
    "mail2minister.com": 1,
    "mail2minneapolis.com": 1,
    "mail2minnesota.com": 1,
    "mail2miracle.com": 1,
    "mail2missionary.com": 1,
    "mail2mississippi.com": 1,
    "mail2missouri.com": 1,
    "mail2mitch.com": 1,
    "mail2model.com": 1,
    "mail2moldova.commail2molly.com": 1,
    "mail2mom.com": 1,
    "mail2monaco.com": 1,
    "mail2money.com": 1,
    "mail2mongolia.com": 1,
    "mail2monica.com": 1,
    "mail2montana.com": 1,
    "mail2monty.com": 1,
    "mail2moon.com": 1,
    "mail2morocco.com": 1,
    "mail2morpheus.com": 1,
    "mail2mors.com": 1,
    "mail2moscow.com": 1,
    "mail2moslem.com": 1,
    "mail2mouseketeer.com": 1,
    "mail2movies.com": 1,
    "mail2mozambique.com": 1,
    "mail2mp3.com": 1,
    "mail2mrright.com": 1,
    "mail2msright.com": 1,
    "mail2museum.com": 1,
    "mail2music.com": 1,
    "mail2musician.com": 1,
    "mail2muslim.com": 1,
    "mail2my.com": 1,
    "mail2myboat.com": 1,
    "mail2mycar.com": 1,
    "mail2mycell.com": 1,
    "mail2mygsm.com": 1,
    "mail2mylaptop.com": 1,
    "mail2mymac.com": 1,
    "mail2mypager.com": 1,
    "mail2mypalm.com": 1,
    "mail2mypc.com": 1,
    "mail2myphone.com": 1,
    "mail2myplane.com": 1,
    "mail2namibia.com": 1,
    "mail2nancy.com": 1,
    "mail2nasdaq.com": 1,
    "mail2nathan.com": 1,
    "mail2nauru.com": 1,
    "mail2navy.com": 1,
    "mail2neal.com": 1,
    "mail2nebraska.com": 1,
    "mail2ned.com": 1,
    "mail2neil.com": 1,
    "mail2nelson.com": 1,
    "mail2nemesis.com": 1,
    "mail2nepal.com": 1,
    "mail2netherlands.com": 1,
    "mail2network.com": 1,
    "mail2nevada.com": 1,
    "mail2newhampshire.com": 1,
    "mail2newjersey.com": 1,
    "mail2newmexico.com": 1,
    "mail2newyork.com": 1,
    "mail2newzealand.com": 1,
    "mail2nicaragua.com": 1,
    "mail2nick.com": 1,
    "mail2nicole.com": 1,
    "mail2niger.com": 1,
    "mail2nigeria.com": 1,
    "mail2nike.com": 1,
    "mail2no.com": 1,
    "mail2noah.com": 1,
    "mail2noel.com": 1,
    "mail2noelle.com": 1,
    "mail2normal.com": 1,
    "mail2norman.com": 1,
    "mail2northamerica.com": 1,
    "mail2northcarolina.com": 1,
    "mail2northdakota.com": 1,
    "mail2northpole.com": 1,
    "mail2norway.com": 1,
    "mail2notus.com": 1,
    "mail2noway.com": 1,
    "mail2nowhere.com": 1,
    "mail2nuclear.com": 1,
    "mail2nun.com": 1,
    "mail2ny.com": 1,
    "mail2oasis.com": 1,
    "mail2oceanographer.com": 1,
    "mail2ohio.com": 1,
    "mail2ok.com": 1,
    "mail2oklahoma.com": 1,
    "mail2oliver.com": 1,
    "mail2oman.com": 1,
    "mail2one.com": 1,
    "mail2onfire.com": 1,
    "mail2online.com": 1,
    "mail2oops.com": 1,
    "mail2open.com": 1,
    "mail2ophthalmologist.com": 1,
    "mail2optometrist.com": 1,
    "mail2oregon.com": 1,
    "mail2oscars.com": 1,
    "mail2oslo.com": 1,
    "mail2painter.com": 1,
    "mail2pakistan.com": 1,
    "mail2palau.com": 1,
    "mail2pan.com": 1,
    "mail2panama.com": 1,
    "mail2paraguay.com": 1,
    "mail2paralegal.com": 1,
    "mail2paris.com": 1,
    "mail2park.com": 1,
    "mail2parker.com": 1,
    "mail2party.com": 1,
    "mail2passion.com": 1,
    "mail2pat.com": 1,
    "mail2patricia.com": 1,
    "mail2patrick.com": 1,
    "mail2patty.com": 1,
    "mail2paul.com": 1,
    "mail2paula.com": 1,
    "mail2pay.com": 1,
    "mail2peace.com": 1,
    "mail2pediatrician.com": 1,
    "mail2peggy.com": 1,
    "mail2pennsylvania.com": 1,
    "mail2perry.com": 1,
    "mail2persephone.com": 1,
    "mail2persian.com": 1,
    "mail2peru.com": 1,
    "mail2pete.com": 1,
    "mail2peter.com": 1,
    "mail2pharmacist.com": 1,
    "mail2phil.com": 1,
    "mail2philippines.com": 1,
    "mail2phoenix.com": 1,
    "mail2phonecall.com": 1,
    "mail2phyllis.com": 1,
    "mail2pickup.com": 1,
    "mail2pilot.com": 1,
    "mail2pisces.com": 1,
    "mail2planet.com": 1,
    "mail2platinum.com": 1,
    "mail2plato.com": 1,
    "mail2pluto.com": 1,
    "mail2pm.com": 1,
    "mail2podiatrist.com": 1,
    "mail2poet.com": 1,
    "mail2poland.com": 1,
    "mail2policeman.com": 1,
    "mail2policewoman.com": 1,
    "mail2politician.com": 1,
    "mail2pop.com": 1,
    "mail2pope.com": 1,
    "mail2popular.com": 1,
    "mail2portugal.com": 1,
    "mail2poseidon.com": 1,
    "mail2potatohead.com": 1,
    "mail2power.com": 1,
    "mail2presbyterian.com": 1,
    "mail2president.com": 1,
    "mail2priest.com": 1,
    "mail2prince.com": 1,
    "mail2princess.com": 1,
    "mail2producer.com": 1,
    "mail2professor.com": 1,
    "mail2protect.com": 1,
    "mail2psychiatrist.com": 1,
    "mail2psycho.com": 1,
    "mail2psychologist.com": 1,
    "mail2qatar.com": 1,
    "mail2queen.com": 1,
    "mail2rabbi.com": 1,
    "mail2race.com": 1,
    "mail2racer.com": 1,
    "mail2rachel.com": 1,
    "mail2rage.com": 1,
    "mail2rainmaker.com": 1,
    "mail2ralph.com": 1,
    "mail2randy.com": 1,
    "mail2rap.com": 1,
    "mail2rare.com": 1,
    "mail2rave.com": 1,
    "mail2ray.com": 1,
    "mail2raymond.com": 1,
    "mail2realtor.com": 1,
    "mail2rebecca.com": 1,
    "mail2recruiter.com": 1,
    "mail2recycle.com": 1,
    "mail2redhead.com": 1,
    "mail2reed.com": 1,
    "mail2reggie.com": 1,
    "mail2register.com": 1,
    "mail2rent.com": 1,
    "mail2republican.com": 1,
    "mail2resort.com": 1,
    "mail2rex.com": 1,
    "mail2rhodeisland.com": 1,
    "mail2rich.com": 1,
    "mail2richard.com": 1,
    "mail2ricky.com": 1,
    "mail2ride.com": 1,
    "mail2riley.com": 1,
    "mail2rita.com": 1,
    "mail2rob.com": 1,
    "mail2robert.com": 1,
    "mail2roberta.com": 1,
    "mail2robin.com": 1,
    "mail2rock.com": 1,
    "mail2rocker.com": 1,
    "mail2rod.com": 1,
    "mail2rodney.com": 1,
    "mail2romania.com": 1,
    "mail2rome.com": 1,
    "mail2ron.com": 1,
    "mail2ronald.com": 1,
    "mail2ronnie.com": 1,
    "mail2rose.com": 1,
    "mail2rosie.com": 1,
    "mail2roy.com": 1,
    "mail2rudy.com": 1,
    "mail2rugby.com": 1,
    "mail2runner.com": 1,
    "mail2russell.com": 1,
    "mail2russia.com": 1,
    "mail2russian.com": 1,
    "mail2rusty.com": 1,
    "mail2ruth.com": 1,
    "mail2rwanda.com": 1,
    "mail2ryan.com": 1,
    "mail2sa.com": 1,
    "mail2sabrina.com": 1,
    "mail2safe.com": 1,
    "mail2sagittarius.com": 1,
    "mail2sail.com": 1,
    "mail2sailor.com": 1,
    "mail2sal.com": 1,
    "mail2salaam.com": 1,
    "mail2sam.com": 1,
    "mail2samantha.com": 1,
    "mail2samoa.com": 1,
    "mail2samurai.com": 1,
    "mail2sandra.com": 1,
    "mail2sandy.com": 1,
    "mail2sanfrancisco.com": 1,
    "mail2sanmarino.com": 1,
    "mail2santa.com": 1,
    "mail2sara.com": 1,
    "mail2sarah.com": 1,
    "mail2sat.com": 1,
    "mail2saturn.com": 1,
    "mail2saudi.com": 1,
    "mail2saudiarabia.com": 1,
    "mail2save.com": 1,
    "mail2savings.com": 1,
    "mail2school.com": 1,
    "mail2scientist.com": 1,
    "mail2scorpio.com": 1,
    "mail2scott.com": 1,
    "mail2sean.com": 1,
    "mail2search.com": 1,
    "mail2seattle.com": 1,
    "mail2secretagent.com": 1,
    "mail2senate.com": 1,
    "mail2senegal.com": 1,
    "mail2sensual.com": 1,
    "mail2seth.com": 1,
    "mail2sevenseas.com": 1,
    "mail2sexy.com": 1,
    "mail2seychelles.com": 1,
    "mail2shane.com": 1,
    "mail2sharon.com": 1,
    "mail2shawn.com": 1,
    "mail2ship.com": 1,
    "mail2shirley.com": 1,
    "mail2shoot.com": 1,
    "mail2shuttle.com": 1,
    "mail2sierraleone.com": 1,
    "mail2simon.com": 1,
    "mail2singapore.com": 1,
    "mail2single.com": 1,
    "mail2site.com": 1,
    "mail2skater.com": 1,
    "mail2skier.com": 1,
    "mail2sky.com": 1,
    "mail2sleek.com": 1,
    "mail2slim.com": 1,
    "mail2slovakia.com": 1,
    "mail2slovenia.com": 1,
    "mail2smile.com": 1,
    "mail2smith.com": 1,
    "mail2smooth.com": 1,
    "mail2soccer.com": 1,
    "mail2soccerfan.com": 1,
    "mail2socialist.com": 1,
    "mail2soldier.com": 1,
    "mail2somalia.com": 1,
    "mail2son.com": 1,
    "mail2song.com": 1,
    "mail2sos.com": 1,
    "mail2sound.com": 1,
    "mail2southafrica.com": 1,
    "mail2southamerica.com": 1,
    "mail2southcarolina.com": 1,
    "mail2southdakota.com": 1,
    "mail2southkorea.com": 1,
    "mail2southpole.com": 1,
    "mail2spain.com": 1,
    "mail2spanish.com": 1,
    "mail2spare.com": 1,
    "mail2spectrum.com": 1,
    "mail2splash.com": 1,
    "mail2sponsor.com": 1,
    "mail2sports.com": 1,
    "mail2srilanka.com": 1,
    "mail2stacy.com": 1,
    "mail2stan.com": 1,
    "mail2stanley.com": 1,
    "mail2star.com": 1,
    "mail2state.com": 1,
    "mail2stephanie.com": 1,
    "mail2steve.com": 1,
    "mail2steven.com": 1,
    "mail2stewart.com": 1,
    "mail2stlouis.com": 1,
    "mail2stock.com": 1,
    "mail2stockholm.com": 1,
    "mail2stockmarket.com": 1,
    "mail2storage.com": 1,
    "mail2store.com": 1,
    "mail2strong.com": 1,
    "mail2student.com": 1,
    "mail2studio.com": 1,
    "mail2studio54.com": 1,
    "mail2stuntman.com": 1,
    "mail2subscribe.com": 1,
    "mail2sudan.com": 1,
    "mail2superstar.com": 1,
    "mail2surfer.com": 1,
    "mail2suriname.com": 1,
    "mail2susan.com": 1,
    "mail2suzie.com": 1,
    "mail2swaziland.com": 1,
    "mail2sweden.com": 1,
    "mail2sweetheart.com": 1,
    "mail2swim.com": 1,
    "mail2swimmer.com": 1,
    "mail2swiss.com": 1,
    "mail2switzerland.com": 1,
    "mail2sydney.com": 1,
    "mail2sylvia.com": 1,
    "mail2syria.com": 1,
    "mail2taboo.com": 1,
    "mail2taiwan.com": 1,
    "mail2tajikistan.com": 1,
    "mail2tammy.com": 1,
    "mail2tango.com": 1,
    "mail2tanya.com": 1,
    "mail2tanzania.com": 1,
    "mail2tara.com": 1,
    "mail2taurus.com": 1,
    "mail2taxi.com": 1,
    "mail2taxidermist.com": 1,
    "mail2taylor.com": 1,
    "mail2taz.com": 1,
    "mail2teacher.com": 1,
    "mail2technician.com": 1,
    "mail2ted.com": 1,
    "mail2telephone.com": 1,
    "mail2teletubbie.com": 1,
    "mail2tenderness.com": 1,
    "mail2tennessee.com": 1,
    "mail2tennis.com": 1,
    "mail2tennisfan.com": 1,
    "mail2terri.com": 1,
    "mail2terry.com": 1,
    "mail2test.com": 1,
    "mail2texas.com": 1,
    "mail2thailand.com": 1,
    "mail2therapy.com": 1,
    "mail2think.com": 1,
    "mail2tickets.com": 1,
    "mail2tiffany.com": 1,
    "mail2tim.com": 1,
    "mail2time.com": 1,
    "mail2timothy.com": 1,
    "mail2tina.com": 1,
    "mail2titanic.com": 1,
    "mail2toby.com": 1,
    "mail2todd.com": 1,
    "mail2togo.com": 1,
    "mail2tom.com": 1,
    "mail2tommy.com": 1,
    "mail2tonga.com": 1,
    "mail2tony.com": 1,
    "mail2touch.com": 1,
    "mail2tourist.com": 1,
    "mail2tracey.com": 1,
    "mail2tracy.com": 1,
    "mail2tramp.com": 1,
    "mail2travel.com": 1,
    "mail2traveler.com": 1,
    "mail2travis.com": 1,
    "mail2trekkie.com": 1,
    "mail2trex.com": 1,
    "mail2triallawyer.com": 1,
    "mail2trick.com": 1,
    "mail2trillionaire.com": 1,
    "mail2troy.com": 1,
    "mail2truck.com": 1,
    "mail2trump.com": 1,
    "mail2try.com": 1,
    "mail2tunisia.com": 1,
    "mail2turbo.com": 1,
    "mail2turkey.com": 1,
    "mail2turkmenistan.com": 1,
    "mail2tv.com": 1,
    "mail2tycoon.com": 1,
    "mail2tyler.com": 1,
    "mail2u4me.com": 1,
    "mail2uae.com": 1,
    "mail2uganda.com": 1,
    "mail2uk.com": 1,
    "mail2ukraine.com": 1,
    "mail2uncle.com": 1,
    "mail2unsubscribe.com": 1,
    "mail2uptown.com": 1,
    "mail2uruguay.com": 1,
    "mail2usa.com": 1,
    "mail2utah.com": 1,
    "mail2uzbekistan.com": 1,
    "mail2v.com": 1,
    "mail2vacation.com": 1,
    "mail2valentines.com": 1,
    "mail2valerie.com": 1,
    "mail2valley.com": 1,
    "mail2vamoose.com": 1,
    "mail2vanessa.com": 1,
    "mail2vanuatu.com": 1,
    "mail2venezuela.com": 1,
    "mail2venous.com": 1,
    "mail2venus.com": 1,
    "mail2vermont.com": 1,
    "mail2vickie.com": 1,
    "mail2victor.com": 1,
    "mail2victoria.com": 1,
    "mail2vienna.com": 1,
    "mail2vietnam.com": 1,
    "mail2vince.com": 1,
    "mail2virginia.com": 1,
    "mail2virgo.com": 1,
    "mail2visionary.com": 1,
    "mail2vodka.com": 1,
    "mail2volleyball.com": 1,
    "mail2waiter.com": 1,
    "mail2wallstreet.com": 1,
    "mail2wally.com": 1,
    "mail2walter.com": 1,
    "mail2warren.com": 1,
    "mail2washington.com": 1,
    "mail2wave.com": 1,
    "mail2way.com": 1,
    "mail2waycool.com": 1,
    "mail2wayne.com": 1,
    "mail2webmaster.com": 1,
    "mail2webtop.com": 1,
    "mail2webtv.com": 1,
    "mail2weird.com": 1,
    "mail2wendell.com": 1,
    "mail2wendy.com": 1,
    "mail2westend.com": 1,
    "mail2westvirginia.com": 1,
    "mail2whether.com": 1,
    "mail2whip.com": 1,
    "mail2white.com": 1,
    "mail2whitehouse.com": 1,
    "mail2whitney.com": 1,
    "mail2why.com": 1,
    "mail2wilbur.com": 1,
    "mail2wild.com": 1,
    "mail2willard.com": 1,
    "mail2willie.com": 1,
    "mail2wine.com": 1,
    "mail2winner.com": 1,
    "mail2wired.com": 1,
    "mail2wisconsin.com": 1,
    "mail2woman.com": 1,
    "mail2wonder.com": 1,
    "mail2world.com": 1,
    "mail2worship.com": 1,
    "mail2wow.com": 1,
    "mail2www.com": 1,
    "mail2wyoming.com": 1,
    "mail2xfiles.com": 1,
    "mail2xox.com": 1,
    "mail2yachtclub.com": 1,
    "mail2yahalla.com": 1,
    "mail2yemen.com": 1,
    "mail2yes.com": 1,
    "mail2yugoslavia.com": 1,
    "mail2zack.com": 1,
    "mail2zambia.com": 1,
    "mail2zenith.com": 1,
    "mail2zephir.com": 1,
    "mail2zeus.com": 1,
    "mail2zipper.com": 1,
    "mail2zoo.com": 1,
    "mail2zoologist.com": 1,
    "mail2zurich.com": 1,
    "mail3000.com": 1,
    "mail333.com": 1,
    "mailandftp.com": 1,
    "mailandnews.com": 1,
    "mailas.com": 1,
    "mailasia.com": 1,
    "mailbolt.com": 1,
    "mailbomb.net": 1,
    "mailboom.com": 1,
    "mailbox.as": 1,
    "mailbox.co.za": 1,
    "mailbox.gr": 1,
    "mailbox.hu": 1,
    "mailbr.com.br": 1,
    "mailc.net": 1,
    "mailcan.com": 1,
    "mailcc.com": 1,
    "mailchoose.co": 1,
    "mailcity.com": 1,
    "mailclub.fr": 1,
    "mailclub.net": 1,
    "mailexcite.com": 1,
    "mailforce.net": 1,
    "mailftp.com": 1,
    "mailgate.gr": 1,
    "mailgenie.net": 1,
    "mailhaven.com": 1,
    "mailhood.com": 1,
    "mailingweb.com": 1,
    "mailisent.com": 1,
    "mailite.com": 1,
    "mailme.dk": 1,
    "mailmight.com": 1,
    "mailmij.nl": 1,
    "mailnew.com": 1,
    "mailops.com": 1,
    "mailoye.com": 1,
    "mailpanda.com": 1,
    "mailpost.zzn.com": 1,
    "mailpride.com": 1,
    "mailpuppy.com": 1,
    "mailroom.com": 1,
    "mailru.com": 1,
    "mailsent.net": 1,
    "mailshuttle.com": 1,
    "mailstart.com": 1,
    "mailstartplus.com": 1,
    "mailsurf.com": 1,
    "mailtag.com": 1,
    "mailto.de": 1,
    "mailup.net": 1,
    "mailwire.com": 1,
    "maktoob.com": 1,
    "malayalamtelevision.net": 1,
    "manager.de": 1,
    "mantrafreenet.com": 1,
    "mantramail.com": 1,
    "mantraonline.com": 1,
    "marchmail.com": 1,
    "mariah-carey.ml.org": 1,
    "mariahc.com": 1,
    "marijuana.nl": 1,
    "marketing.lu": 1,
    "married-not.com": 1,
    "marsattack.com": 1,
    "martindalemail.com": 1,
    "masrawy.com": 1,
    "matmail.com": 1,
    "mauimail.com": 1,
    "mauritius.com": 1,
    "maxleft.com": 1,
    "maxmail.co.uk": 1,
    "mbox.com.au": 1,
    "mchsi.com": 1,
    "mciworldcom.net": 1,
    "me-mail.hu": 1,
    "me.com": 1,
    "medical.net.au": 1,
    "medione.net": 1,
    "medmail.com": 1,
    "medscape.com": 1,
    "meetingmall.com": 1,
    "megago.com": 1,
    "megamail.pt": 1,
    "megapathdsl.net": 1,
    "megapoint.com": 1,
    "mehrani.com": 1,
    "mehtaweb.com": 1,
    "mekhong.com": 1,
    "melodymail.com": 1,
    "meloo.com": 1,
    "members.student.com": 1,
    "message.hu": 1,
    "messages.to": 1,
    "metacrawler.com": 1,
    "metalfan.com": 1,
    "metta.lk": 1,
    "miatadriver.com": 1,
    "miesto.sk": 1,
    "mighty.co.za": 1,
    "miho-nakayama.com": 1,
    "mikrotamanet.com": 1,
    "millionaireintraining.com": 1,
    "milmail.com": 1,
    "mindless.com": 1,
    "mindspring.com": 1,
    "mini-mail.com": 1,
    "misery.net": 1,
    "mittalweb.com": 1,
    "mixmail.com": 1,
    "mjfrogmail.com": 1,
    "ml1.net": 1,
    "mobilbatam.com": 1,
    "mochamail.com": 1,
    "mohammed.com": 1,
    "moldova.cc": 1,
    "moldova.com": 1,
    "moldovacc.com": 1,
    "money.net": 1,
    "montevideo.com.uy": 1,
    "moonman.com": 1,
    "moose-mail.com": 1,
    "mortaza.com": 1,
    "mosaicfx.com": 1,
    "most-wanted.com": 1,
    "mostlysunny.com": 1,
    "motormania.com": 1,
    "movemail.com": 1,
    "movieluver.com": 1,
    "mp4.it": 1,
    "mr-potatohead.com": 1,
    "mrpost.com": 1,
    "mscold.com": 1,
    "msgbox.com": 1,
    "msn.com": 1,
    "mttestdriver.com": 1,
    "mundomail.net": 1,
    "munich.com": 1,
    "music.com": 1,
    "musician.org": 1,
    "musicscene.org": 1,
    "mybox.it": 1,
    "mycabin.com": 1,
    "mycampus.com": 1,
    "mycity.com": 1,
    "mycool.com": 1,
    "mydomain.com": 1,
    "mydotcomaddress.com": 1,
    "myfamily.com": 1,
    "mygo.com": 1,
    "myiris.com": 1,
    "mynamedot.com": 1,
    "mynetaddress.com": 1,
    "myownemail.com": 1,
    "myownfriends.com": 1,
    "mypad.com": 1,
    "mypersonalemail.com": 1,
    "myplace.com": 1,
    "myrealbox.com": 1,
    "myremarq.com": 1,
    "myself.com": 1,
    "mystupidjob.com": 1,
    "mythirdage.com": 1,
    "myway.com": 1,
    "myworldmail.com": 1,
    "n2.com": 1,
    "n2business.com": 1,
    "n2mail.com": 1,
    "n2software.com": 1,
    "nabc.biz": 1,
    "nafe.com": 1,
    "nagpal.net": 1,
    "nakedgreens.com": 1,
    "name.com": 1,
    "nameplanet.com": 1,
    "nandomail.com": 1,
    "naplesnews.net": 1,
    "naseej.com": 1,
    "nate.com": 1,
    "nativestar.net": 1,
    "nativeweb.net": 1,
    "naui.net": 1,
    "nauticom.net": 1,
    "naver.com": 1,
    "navigator.lv": 1,
    "navy.org": 1,
    "naz.com": 1,
    "nchoicemail.com": 1,
    "neeva.net": 1,
    "nemra1.com": 1,
    "nenter.com": 1,
    "neo.rr.com": 1,
    "nervhq.org": 1,
    "net-pager.net": 1,
    "net4b.pt": 1,
    "net4you.at": 1,
    "netbounce.com": 1,
    "netbroadcaster.com": 1,
    "netby.dk": 1,
    "netcenter-vn.net": 1,
    "netcom.ca": 1,
    "netcom.com": 1,
    "netcourrier.com": 1,
    "netexecutive.com": 1,
    "netexpressway.com": 1,
    "netgenie.com": 1,
    "netian.com": 1,
    "netizen.com.ar": 1,
    "netlane.com": 1,
    "netlimit.com": 1,
    "netmanor.com": 1,
    "netmongol.com": 1,
    "netnet.com.sg": 1,
    "netpiper.com": 1,
    "netposta.net": 1,
    "netradiomail.com": 1,
    "netralink.com": 1,
    "netscape.com": 1,
    "netscape.net": 1,
    "netscapeonline.co.uk": 1,
    "netsero.net": 1,
    "netspeedway.com": 1,
    "netsquare.com": 1,
    "netster.com": 1,
    "nettaxi.com": 1,
    "netzero.com": 1,
    "netzero.net": 1,
    "neuf.fr": 1,
    "newmail.com": 1,
    "newmail.net": 1,
    "newmail.ru": 1,
    "newyork.com": 1,
    "nexxmail.com": 1,
    "nfmail.com": 1,
    "nhmail.com": 1,
    "nicebush.com": 1,
    "nicegal.com": 1,
    "nicholastse.net": 1,
    "nicolastse.com": 1,
    "nightmail.com": 1,
    "nikopage.com": 1,
    "nimail.com": 1,
    "nirvanafan.com": 1,
    "noavar.com": 1,
    "norika-fujiwara.com": 1,
    "norikomail.com": 1,
    "northgates.net": 1,
    "nospammail.net": 1,
    "ntlworld.com": 1,
    "ntscan.com": 1,
    "ny.com": 1,
    "nyc.com": 1,
    "nycmail.com": 1,
    "nzoomail.com": 1,
    "o-tay.com": 1,
    "o2.co.uk": 1,
    "oaklandas-fan.com": 1,
    "oceanfree.net": 1,
    "oddpost.com": 1,
    "odmail.com": 1,
    "office-email.com": 1,
    "officedomain.com": 1,
    "offroadwarrior.com": 1,
    "oi.com.br": 1,
    "oicexchange.com": 1,
    "okbank.com": 1,
    "okhuman.com": 1,
    "okmad.com": 1,
    "okmagic.com": 1,
    "okname.net": 1,
    "okuk.com": 1,
    "oldies1041.com": 1,
    "oldies104mail.com": 1,
    "ole.com": 1,
    "olemail.com": 1,
    "olg.com": 1,
    "olympist.net": 1,
    "omaninfo.com": 1,
    "onebox.com": 1,
    "onenet.com.ar": 1,
    "onet.pl": 1,
    "oninet.pt": 1,
    "online.de": 1,
    "online.ie": 1,
    "onlinewiz.com": 1,
    "onmilwaukee.com": 1,
    "onobox.com": 1,
    "onvillage.com": 1,
    "operafan.com": 1,
    "operamail.com": 1,
    "optician.com": 1,
    "optonline.net": 1,
    "optusnet.com.au": 1,
    "orange.fr": 1,
    "orange.net": 1,
    "orbitel.bg": 1,
    "orgmail.net": 1,
    "osite.com.br": 1,
    "oso.com": 1,
    "otakumail.com": 1,
    "our-computer.com": 1,
    "our-office.com": 1,
    "our.st": 1,
    "ourbrisbane.com": 1,
    "ournet.md": 1,
    "outel.com": 1,
    "outgun.com": 1,
    "outlook.com": 1,
    "outlook.com.br": 1,
    "over-the-rainbow.com": 1,
    "ownmail.net": 1,
    "ozbytes.net.au": 1,
    "ozemail.com.au": 1,
    "pacbell.net": 1,
    "pacific-re.com": 1,
    "packersfan.com": 1,
    "pagina.de": 1,
    "pagons.org": 1,
    "pakistanoye.com": 1,
    "palestinemail.com": 1,
    "parkjiyoon.com": 1,
    "parrot.com": 1,
    "parsmail.com": 1,
    "partlycloudy.com": 1,
    "partynight.at": 1,
    "parvazi.com": 1,
    "passwordmail.com": 1,
    "pathfindermail.com": 1,
    "patmedia.net": 1,
    "pconnections.net": 1,
    "pcpostal.com": 1,
    "pcsrock.com": 1,
    "peachworld.com": 1,
    "pediatrician.com": 1,
    "pemail.net": 1,
    "penpen.com": 1,
    "peoplepc.com": 1,
    "peopleweb.com": 1,
    "perfectmail.com": 1,
    "personal.ro": 1,
    "personales.com": 1,
    "petml.com": 1,
    "pettypool.com": 1,
    "pezeshkpour.com": 1,
    "phayze.com": 1,
    "phreaker.net": 1,
    "pickupman.com": 1,
    "picusnet.com": 1,
    "pigpig.net": 1,
    "pinoymail.com": 1,
    "pipeline.com": 1,
    "piracha.net": 1,
    "pisem.net": 1,
    "planet-mail.com": 1,
    "planet.nl": 1,
    "planetaccess.com": 1,
    "planetall.com": 1,
    "planetarymotion.net": 1,
    "planetdirect.com": 1,
    "planetearthinter.net": 1,
    "planetout.com": 1,
    "plasa.com": 1,
    "playersodds.com": 1,
    "playful.com": 1,
    "plusmail.com.br": 1,
    "pmail.net": 1,
    "pobox.com": 1,
    "pobox.hu": 1,
    "pobox.sk": 1,
    "pochta.ru": 1,
    "poczta.fm": 1,
    "poetic.com": 1,
    "polbox.com": 1,
    "policeoffice.com": 1,
    "pool-sharks.com": 1,
    "poond.com": 1,
    "popaccount.com": 1,
    "popmail.com": 1,
    "popsmail.com": 1,
    "popstar.com": 1,
    "populus.net": 1,
    "portableoffice.com": 1,
    "portugalmail.com": 1,
    "portugalmail.pt": 1,
    "portugalnet.com": 1,
    "positive-thinking.com": 1,
    "post.com": 1,
    "post.cz": 1,
    "post.sk": 1,
    "posta.net": 1,
    "posta.ro": 1,
    "postaccesslite.com": 1,
    "postafree.com": 1,
    "postaweb.com": 1,
    "poste.it": 1,
    "postinbox.com": 1,
    "postino.ch": 1,
    "postmark.net": 1,
    "postmaster.co.uk": 1,
    "postpro.net": 1,
    "pousa.com": 1,
    "powerfan.com": 1,
    "praize.com": 1,
    "premiumservice.com": 1,
    "presidency.com": 1,
    "press.co.jp": 1,
    "priest.com": 1,
    "primposta.com": 1,
    "primposta.hu": 1,
    "pro.hu": 1,
    "probemail.com": 1,
    "prodigy.net": 1,
    "prodigy.net.mx": 1,
    "progetplus.it": 1,
    "programmer.net": 1,
    "programozo.hu": 1,
    "proinbox.com": 1,
    "project2k.com": 1,
    "prolaunch.com": 1,
    "promessage.com": 1,
    "prontomail.com": 1,
    "protonmail.com": 1,
    "psi.net": 1,
    "psv-supporter.com": 1,
    "ptd.net": 1,
    "public.usa.com": 1,
    "publicist.com": 1,
    "pulp-fiction.com": 1,
    "punkass.com": 1,
    "qatarmail.com": 1,
    "qis.net": 1,
    "qprfans.com": 1,
    "qq.com": 1,
    "qrio.com": 1,
    "quackquack.com": 1,
    "quakemail.com": 1,
    "qudsmail.com": 1,
    "quepasa.com": 1,
    "quickwebmail.com": 1,
    "quiklinks.com": 1,
    "quikmail.com": 1,
    "qwest.net": 1,
    "qwestoffice.net": 1,
    "r-o-o-t.com": 1,
    "r7.com": 1,
    "raakim.com": 1,
    "racedriver.com": 1,
    "racefanz.com": 1,
    "racingfan.com.au": 1,
    "racingmail.com": 1,
    "radicalz.com": 1,
    "ragingbull.com": 1,
    "rambler.ru": 1,
    "ranmamail.com": 1,
    "rastogi.net": 1,
    "ratt-n-roll.com": 1,
    "rattle-snake.com": 1,
    "ravearena.com": 1,
    "ravemail.com": 1,
    "razormail.com": 1,
    "rccgmail.org": 1,
    "rcn.com": 1,
    "realemail.net": 1,
    "reallyfast.biz": 1,
    "realradiomail.com": 1,
    "recycler.com": 1,
    "rediffmail.com": 1,
    "rediffmailpro.com": 1,
    "rednecks.com": 1,
    "redseven.de": 1,
    "redsfans.com": 1,
    "reggafan.com": 1,
    "registerednurses.com": 1,
    "repairman.com": 1,
    "reply.hu": 1,
    "representative.com": 1,
    "rescueteam.com": 1,
    "resumemail.com": 1,
    "rezai.com": 1,
    "richmondhill.com": 1,
    "rickymail.com": 1,
    "rin.ru": 1,
    "riopreto.com.br": 1,
    "rn.com": 1,
    "roadrunner.com": 1,
    "roanokemail.com": 1,
    "rock.com": 1,
    "rocketmail.com": 1,
    "rockfan.com": 1,
    "rodrun.com": 1,
    "rome.com": 1,
    "roosh.com": 1,
    "rotfl.com": 1,
    "roughnet.com": 1,
    "rr.com": 1,
    "rrohio.com": 1,
    "rsub.com": 1,
    "rubyridge.com": 1,
    "runbox.com": 1,
    "rushpost.com": 1,
    "ruttolibero.com": 1,
    "rvshop.com": 1,
    "s-mail.com": 1,
    "sabreshockey.com": 1,
    "sacbeemail.com": 1,
    "safarimail.com": 1,
    "safe-mail.net": 1,
    "sagra.lu": 1,
    "sailormoon.com": 1,
    "saintly.com": 1,
    "saintmail.net": 1,
    "sale-sale-sale.com": 1,
    "salehi.net": 1,
    "samerica.com": 1,
    "samilan.net": 1,
    "sammimail.com": 1,
    "sanfranmail.com": 1,
    "sanook.com": 1,
    "sapo.pt": 1,
    "sativa.ro.org": 1,
    "saudia.com": 1,
    "sayhi.net": 1,
    "sbcglobal.net": 1,
    "scandalmail.com": 1,
    "schizo.com": 1,
    "schoolemail.com": 1,
    "schoolmail.com": 1,
    "schoolsucks.com": 1,
    "schweiz.org": 1,
    "sci.fi": 1,
    "science.com.au": 1,
    "scientist.com": 1,
    "scifianime.com": 1,
    "scottishmail.co.uk": 1,
    "scubadiving.com": 1,
    "seanet.com": 1,
    "searchwales.com": 1,
    "sebil.com": 1,
    "secret-police.com": 1,
    "secretservices.net": 1,
    "seductive.com": 1,
    "seekstoyboy.com": 1,
    "seguros.com.br": 1,
    "send.hu": 1,
    "sendme.cz": 1,
    "sent.com": 1,
    "sentrismail.com": 1,
    "serga.com.ar": 1,
    "servemymail.com": 1,
    "sesmail.com": 1,
    "sexmagnet.com": 1,
    "seznam.cz": 1,
    "sfr.fr": 1,
    "shahweb.net": 1,
    "shaniastuff.com": 1,
    "sharewaredevelopers.com": 1,
    "sharmaweb.com": 1,
    "shaw.ca": 1,
    "she.com": 1,
    "shootmail.com": 1,
    "shotgun.hu": 1,
    "shuf.com": 1,
    "sialkotcity.com": 1,
    "sialkotian.com": 1,
    "sialkotoye.com": 1,
    "sify.com": 1,
    "silkroad.net": 1,
    "sina.cn": 1,
    "sina.com": 1,
    "sinamail.com": 1,
    "singapore.com": 1,
    "singmail.com": 1,
    "singnet.com.sg": 1,
    "singpost.com": 1,
    "skafan.com": 1,
    "skim.com": 1,
    "skizo.hu": 1,
    "sky.com": 1,
    "skynet.be": 1,
    "slamdunkfan.com": 1,
    "slingshot.com": 1,
    "slo.net": 1,
    "slotter.com": 1,
    "smapxsmap.net": 1,
    "smileyface.comsmithemail.net": 1,
    "smoothmail.com": 1,
    "snail-mail.net": 1,
    "snail-mail.ney": 1,
    "snakemail.com": 1,
    "sndt.net": 1,
    "sneakemail.com": 1,
    "snet.net": 1,
    "snip.net": 1,
    "sniper.hu": 1,
    "snoopymail.com": 1,
    "snowboarding.com": 1,
    "snowdonia.net": 1,
    "socamail.com": 1,
    "socceramerica.net": 1,
    "soccermail.com": 1,
    "soccermomz.com": 1,
    "sociologist.com": 1,
    "softhome.net": 1,
    "sol.dk": 1,
    "soldier.hu": 1,
    "soon.com": 1,
    "soulfoodcookbook.com": 1,
    "sp.nl": 1,
    "space-bank.com": 1,
    "space-man.com": 1,
    "space-ship.com": 1,
    "space-travel.com": 1,
    "space.com": 1,
    "spaceart.com": 1,
    "spacebank.com": 1,
    "spacemart.com": 1,
    "spacetowns.com": 1,
    "spacewar.com": 1,
    "spamex.com": 1,
    "spartapiet.com": 1,
    "spazmail.com": 1,
    "speedemail.net": 1,
    "speedpost.net": 1,
    "speedrules.com": 1,
    "speedrulz.com": 1,
    "speedy.com.ar": 1,
    "spils.com": 1,
    "spinfinder.com": 1,
    "sportemail.com": 1,
    "sportsmail.com": 1,
    "sporttruckdriver.com": 1,
    "spray.no": 1,
    "spray.se": 1,
    "sprintmail.com": 1,
    "sprynet.com": 1,
    "spymac.com": 1,
    "srilankan.net": 1,
    "st-davids.net": 1,
    "stade.fr": 1,
    "stalag13.com": 1,
    "stargateradio.com": 1,
    "starmail.com": 1,
    "starmail.org": 1,
    "starmedia.com": 1,
    "starplace.com": 1,
    "starpower.net": 1,
    "starspath.com": 1,
    "start.com.au": 1,
    "starting-point.com": 1,
    "startrekmail.com": 1,
    "stealthmail.com": 1,
    "stockracer.com": 1,
    "stones.com": 1,
    "stopdropandroll.com": 1,
    "storksite.com": 1,
    "stribmail.com": 1,
    "strompost.com": 1,
    "strongguy.com": 1,
    "studentcenter.org": 1,
    "subnetwork.com": 1,
    "subram.com": 1,
    "sudanmail.net": 1,
    "suhabi.com": 1,
    "suisse.org": 1,
    "sukhumvit.net": 1,
    "sunpoint.net": 1,
    "sunrise-sunset.com": 1,
    "sunsgame.com": 1,
    "sunumail.sn": 1,
    "superdada.com": 1,
    "supereva.it": 1,
    "supermail.ru": 1,
    "surat.com": 1,
    "surf3.net": 1,
    "surfree.com": 1,
    "surfy.net": 1,
    "surimail.com": 1,
    "survivormail.com": 1,
    "swbell.net": 1,
    "sweb.cz": 1,
    "swiftdesk.com": 1,
    "swingeasyhithard.com": 1,
    "swingfan.com": 1,
    "swipermail.zzn.com": 1,
    "swirve.com": 1,
    "swissinfo.org": 1,
    "swissmail.net": 1,
    "switchboardmail.com": 1,
    "switzerland.org": 1,
    "swva.net": 1,
    "sx172.com": 1,
    "sympatico.ca": 1,
    "syom.com": 1,
    "syriamail.com": 1,
    "t-online.de": 1,
    "t2mail.com": 1,
    "takuyakimura.com": 1,
    "talk21.com": 1,
    "talkcity.com": 1,
    "talktalk.co.uk": 1,
    "tamil.com": 1,
    "tampabay.rr.com": 1,
    "tatanova.com": 1,
    "tbwt.com": 1,
    "tds.net": 1,
    "teamdiscovery.com": 1,
    "teamtulsa.net": 1,
    "tech4peace.org": 1,
    "techemail.com": 1,
    "techie.com": 1,
    "technisamail.co.za": 1,
    "technologist.com": 1,
    "techpointer.com": 1,
    "techscout.com": 1,
    "techseek.com": 1,
    "techspot.com": 1,
    "teenagedirtbag.com": 1,
    "telebot.com": 1,
    "telebot.net": 1,
    "teleline.es": 1,
    "telenet.be": 1,
    "telerymd.com": 1,
    "teleserve.dynip.com": 1,
    "teletu.it": 1,
    "telinco.net": 1,
    "telkom.net": 1,
    "telpage.net": 1,
    "telus.net": 1,
    "temtulsa.net": 1,
    "tenchiclub.com": 1,
    "tenderkiss.com": 1,
    "tennismail.com": 1,
    "terra.cl": 1,
    "terra.com": 1,
    "terra.com.ar": 1,
    "terra.com.br": 1,
    "terra.es": 1,
    "tfanus.com.er": 1,
    "tfz.net": 1,
    "thai.com": 1,
    "thaimail.com": 1,
    "thaimail.net": 1,
    "the-african.com": 1,
    "the-airforce.com": 1,
    "the-aliens.com": 1,
    "the-american.com": 1,
    "the-animal.com": 1,
    "the-army.com": 1,
    "the-astronaut.com": 1,
    "the-beauty.com": 1,
    "the-big-apple.com": 1,
    "the-biker.com": 1,
    "the-boss.com": 1,
    "the-brazilian.com": 1,
    "the-canadian.com": 1,
    "the-canuck.com": 1,
    "the-captain.com": 1,
    "the-chinese.com": 1,
    "the-country.com": 1,
    "the-cowboy.com": 1,
    "the-davis-home.com": 1,
    "the-dutchman.com": 1,
    "the-eagles.com": 1,
    "the-englishman.com": 1,
    "the-fastest.net": 1,
    "the-fool.com": 1,
    "the-frenchman.com": 1,
    "the-galaxy.net": 1,
    "the-genius.com": 1,
    "the-gentleman.com": 1,
    "the-german.com": 1,
    "the-gremlin.com": 1,
    "the-hooligan.com": 1,
    "the-italian.com": 1,
    "the-japanese.com": 1,
    "the-lair.com": 1,
    "the-madman.com": 1,
    "the-mailinglist.com": 1,
    "the-marine.com": 1,
    "the-master.com": 1,
    "the-mexican.com": 1,
    "the-ministry.com": 1,
    "the-monkey.com": 1,
    "the-newsletter.net": 1,
    "the-pentagon.com": 1,
    "the-police.com": 1,
    "the-prayer.com": 1,
    "the-professional.com": 1,
    "the-quickest.com": 1,
    "the-russian.com": 1,
    "the-snake.com": 1,
    "the-spaceman.com": 1,
    "the-stock-market.com": 1,
    "the-student.net": 1,
    "the-whitehouse.net": 1,
    "the-wild-west.com": 1,
    "the18th.com": 1,
    "thecoolguy.com": 1,
    "thecriminals.com": 1,
    "thedoghousemail.com": 1,
    "thedorm.com": 1,
    "theend.hu": 1,
    "theglobe.com": 1,
    "thegolfcourse.com": 1,
    "thegooner.com": 1,
    "theheadoffice.com": 1,
    "thelanddownunder.com": 1,
    "themillionare.net": 1,
    "theoffice.net": 1,
    "thepokerface.com": 1,
    "thepostmaster.net": 1,
    "theraces.com": 1,
    "theracetrack.com": 1,
    "thestreetfighter.com": 1,
    "theteebox.com": 1,
    "thewatercooler.com": 1,
    "thewebpros.co.uk": 1,
    "thewizzard.com": 1,
    "thewizzkid.com": 1,
    "thezhangs.net": 1,
    "thirdage.com": 1,
    "thisgirl.com": 1,
    "thoic.com": 1,
    "thundermail.com": 1,
    "tidni.com": 1,
    "timein.net": 1,
    "tin.it": 1,
    "tiscali.at": 1,
    "tiscali.be": 1,
    "tiscali.co.uk": 1,
    "tiscali.it": 1,
    "tiscali.lu": 1,
    "tiscali.se": 1,
    "tkcity.com": 1,
    "toolsource.com": 1,
    "topchat.com": 1,
    "topgamers.co.uk": 1,
    "topletter.com": 1,
    "topmail.com.ar": 1,
    "topsurf.com": 1,
    "topteam.bg": 1,
    "torchmail.com": 1,
    "tot.net": 1,
    "totalmusic.net": 1,
    "toughguy.net": 1,
    "tpg.com.au": 1,
    "travel.li": 1,
    "trialbytrivia.com": 1,
    "tritium.net": 1,
    "trmailbox.com": 1,
    "tropicalstorm.com": 1,
    "truckers.com": 1,
    "truckerz.com": 1,
    "truckracer.com": 1,
    "trust-me.com": 1,
    "tsamail.co.za": 1,
    "ttml.co.in": 1,
    "tunisiamail.com": 1,
    "turkey.com": 1,
    "tvcablenet.be": 1,
    "twinstarsmail.com": 1,
    "tycoonmail.com": 1,
    "typemail.com": 1,
    "u2club.com": 1,
    "uae.ac": 1,
    "uaemail.com": 1,
    "ubbi.com": 1,
    "ubbi.com.br": 1,
    "uboot.com": 1,
    "uk2k.com": 1,
    "uk2net.com": 1,
    "uk7.net": 1,
    "uk8.net": 1,
    "ukbuilder.com": 1,
    "ukcool.com": 1,
    "ukdreamcast.com": 1,
    "ukmail.org": 1,
    "ukmax.com": 1,
    "ukr.net": 1,
    "uku.co.uk": 1,
    "ultapulta.com": 1,
    "ultrapostman.com": 1,
    "ummah.org": 1,
    "umpire.com": 1,
    "unbounded.com": 1,
    "unforgettable.com": 1,
    "uni.de": 1,
    "unican.es": 1,
    "unihome.com": 1,
    "universal.pt": 1,
    "uno.ee": 1,
    "uno.it": 1,
    "unofree.it": 1,
    "unomail.com": 1,
    "uol.com.ar": 1,
    "uol.com.br": 1,
    "uol.com.co": 1,
    "uol.com.mx": 1,
    "uol.com.ve": 1,
    "uole.com": 1,
    "uole.com.ve": 1,
    "uolmail.com": 1,
    "uomail.com": 1,
    "upf.org": 1,
    "ureach.com": 1,
    "urgentmail.biz": 1,
    "usa.com": 1,
    "usa.net": 1,
    "usaaccess.net": 1,
    "usanetmail.com": 1,
    "usermail.com": 1,
    "usit.net": 1,
    "usma.net": 1,
    "usmc.net": 1,
    "uswestmail.net": 1,
    "uu.net": 1,
    "uymail.com": 1,
    "uyuyuy.com": 1,
    "v-sexi.com": 1,
    "vahoo.com": 1,
    "varbizmail.com": 1,
    "vcmail.com": 1,
    "velnet.co.uk": 1,
    "velocall.com": 1,
    "verizon.net": 1,
    "verizonmail.com": 1,
    "veryfast.biz": 1,
    "veryspeedy.net": 1,
    "videotron.ca": 1,
    "violinmakers.co.uk": 1,
    "vip.gr": 1,
    "vipmail.ru": 1,
    "virgilio.it": 1,
    "virgin.net": 1,
    "virginmedia.com": 1,
    "virtualactive.com": 1,
    "virtualmail.com": 1,
    "visitmail.com": 1,
    "visitweb.com": 1,
    "visto.com": 1,
    "visualcities.com": 1,
    "vivavelocity.com": 1,
    "vivianhsu.net": 1,
    "vjmail.com": 1,
    "vjtimail.com": 1,
    "vlmail.com": 1,
    "vnn.vn": 1,
    "voila.fr": 1,
    "volcanomail.com": 1,
    "voo.be": 1,
    "vote-democrats.com": 1,
    "vote-hillary.com": 1,
    "vote-republicans.com": 1,
    "vote4gop.org": 1,
    "votenet.com": 1,
    "vr9.com": 1,
    "w3.to": 1,
    "wahoye.com": 1,
    "wales2000.net": 1,
    "wam.co.za": 1,
    "wanadoo.co.uk": 1,
    "wanadoo.es": 1,
    "wanadoo.fr": 1,
    "warmmail.com": 1,
    "warpmail.net": 1,
    "warrior.hu": 1,
    "waumail.com": 1,
    "wbdet.com": 1,
    "wearab.net": 1,
    "web-mail.com.ar": 1,
    "web-police.com": 1,
    "web.de": 1,
    "webave.com": 1,
    "webcammail.com": 1,
    "webcity.ca": 1,
    "webdream.com": 1,
    "webinbox.com": 1,
    "webindia123.com": 1,
    "webjump.com": 1,
    "webmail.bellsouth.net": 1,
    "webmail.co.yu": 1,
    "webmail.co.za": 1,
    "webmail.hu": 1,
    "webmails.com": 1,
    "webprogramming.com": 1,
    "webstable.net": 1,
    "webstation.com": 1,
    "websurfer.co.za": 1,
    "webtopmail.com": 1,
    "weedmail.com": 1,
    "weekmail.com": 1,
    "weekonline.com": 1,
    "wehshee.com": 1,
    "welsh-lady.com": 1,
    "whale-mail.com": 1,
    "whartontx.com": 1,
    "wheelweb.com": 1,
    "whipmail.com": 1,
    "whoever.com": 1,
    "whoopymail.com": 1,
    "wickedmail.com": 1,
    "wideopenwest.com": 1,
    "wildmail.com": 1,
    "windrivers.net": 1,
    "windstream.net": 1,
    "wingnutz.com": 1,
    "winmail.com.au": 1,
    "winning.com": 1,
    "witty.com": 1,
    "wiz.cc": 1,
    "wkbwmail.com": 1,
    "woh.rr.com": 1,
    "wolf-web.com": 1,
    "wombles.com": 1,
    "wonder-net.com": 1,
    "wongfaye.com": 1,
    "wooow.it": 1,
    "workmail.com": 1,
    "worldemail.com": 1,
    "worldmailer.com": 1,
    "worldnet.att.net": 1,
    "wosaddict.com": 1,
    "wouldilie.com": 1,
    "wow.com": 1,
    "wowgirl.com": 1,
    "wowmail.com": 1,
    "wowway.com": 1,
    "wp.pl": 1,
    "wptamail.com": 1,
    "wrestlingpages.com": 1,
    "wrexham.net": 1,
    "writeme.com": 1,
    "writemeback.com": 1,
    "wrongmail.com": 1,
    "wtvhmail.com": 1,
    "wwdg.com": 1,
    "www.com": 1,
    "www2000.net": 1,
    "wx88.net": 1,
    "wxs.net": 1,
    "wyrm.supernews.com": 1,
    "x-mail.net": 1,
    "x-networks.net": 1,
    "x5g.com": 1,
    "xmastime.com": 1,
    "xmsg.com": 1,
    "xoom.com": 1,
    "xoommail.com": 1,
    "xpressmail.zzn.com": 1,
    "xsmail.com": 1,
    "xuno.com": 1,
    "xzapmail.com": 1,
    "ya.ru": 1,
    "yada-yada.com": 1,
    "yaho.com": 1,
    "yahoo.ca": 1,
    "yahoo.co.id": 1,
    "yahoo.co.in": 1,
    "yahoo.co.jp": 1,
    "yahoo.co.kr": 1,
    "yahoo.co.nz": 1,
    "yahoo.co.uk": 1,
    "yahoo.com": 1,
    "yahoo.com.ar": 1,
    "yahoo.com.au": 1,
    "yahoo.com.br": 1,
    "yahoo.com.cn": 1,
    "yahoo.com.hk": 1,
    "yahoo.com.is": 1,
    "yahoo.com.mx": 1,
    "yahoo.com.ph": 1,
    "yahoo.com.ru": 1,
    "yahoo.com.sg": 1,
    "yahoo.de": 1,
    "yahoo.dk": 1,
    "yahoo.es": 1,
    "yahoo.fr": 1,
    "yahoo.ie": 1,
    "yahoo.in": 1,
    "yahoo.it": 1,
    "yahoo.jp": 1,
    "yahoo.ru": 1,
    "yahoo.se": 1,
    "yahoofs.com": 1,
    "yalla.com": 1,
    "yalla.com.lb": 1,
    "yalook.com": 1,
    "yam.com": 1,
    "yandex.com": 1,
    "yandex.ru": 1,
    "yapost.com": 1,
    "yawmail.com": 1,
    "yclub.com": 1,
    "yebox.com": 1,
    "yehaa.com": 1,
    "yehey.com": 1,
    "yemenmail.com": 1,
    "yepmail.net": 1,
    "yesbox.net": 1,
    "ygm.com": 1,
    "yifan.net": 1,
    "ymail.com": 1,
    "ynnmail.com": 1,
    "yogotemail.com": 1,
    "yopolis.com": 1,
    "youareadork.com": 1,
    "youpy.com": 1,
    "your-house.com": 1,
    "yourinbox.com": 1,
    "yourlover.net": 1,
    "yourname.ddns.org": 1,
    "yourname.freeservers.com": 1,
    "yournightmare.com": 1,
    "yours.com": 1,
    "yourssincerely.com": 1,
    "yoursubdomain.findhere.com": 1,
    "yoursubdomain.zzn.com": 1,
    "yourteacher.net": 1,
    "yourwap.com": 1,
    "youvegotmail.net": 1,
    "yuuhuu.net": 1,
    "yyhmail.com": 1,
    "zahadum.com": 1,
    "zcities.com": 1,
    "zdnetmail.com": 1,
    "zeeks.com": 1,
    "zeepost.nl": 1,
    "zensearch.net": 1,
    "zhaowei.net": 1,
    "zionweb.org": 1,
    "zip.net": 1,
    "zipido.com": 1,
    "ziplink.net": 1,
    "ziplip.com": 1,
    "zipmail.com": 1,
    "zipmail.com.br": 1,
    "zipmax.com": 1,
    "zmail.ru": 1,
    "zoho.com": 1,
    "zonnet.nl": 1,
    "zoominternet.net": 1,
    "zubee.com": 1,
    "zuvio.com": 1,
    "zuzzurello.com": 1,
    "zwallet.com": 1,
    "zybermail.com": 1,
    "zydecofan.com": 1,
    "zzn.com": 1,
    "zzom.co.uk": 1,
    "29mayis.edu.tr": 1,
    "4cd.edu": 1,
    "a-aarhus.dk": 1,
    "aabfs.org": 1,
    "aabu.edu.jo": 1,
    "aacc.edu": 1,
    "aada.edu": 1,
    "aaidu.org": 1,
    "aalto.fi": 1,
    "aamu.edu": 1,
    "aasa.ac.jp": 1,
    "aast.edu": 1,
    "aastu.org": 1,
    "aau.ac.in": 1,
    "aau.dk": 1,
    "aau.edu.et": 1,
    "aau.edu.jo": 1,
    "aau.edu.sd": 1,
    "aaua.edu.ng": 1,
    "aauekpoma.edu.ng": 1,
    "aauj.edu": 1,
    "aauni.edu": 1,
    "abasyn.edu.pk": 1,
    "abdn.ac.uk": 1,
    "aber.ac.uk": 1,
    "aberdeen.ac.uk": 1,
    "abertay.ac.uk": 1,
    "abiapoly.edu.ng": 1,
    "ablaikhan.kz": 1,
    "abm.ac.bw": 1,
    "abo.fi": 1,
    "absu.edu.ng": 1,
    "abtech.edu": 1,
    "abu.ac.jp": 1,
    "abu.edu.ng": 1,
    "abuad.edu.ng": 1,
    "ac.ac.cy": 1,
    "academia.cl": 1,
    "academiaga.ru": 1,
    "academy.mia.by": 1,
    "academy.sumy.ua": 1,
    "academyart.edu": 1,
    "acadiau.ca": 1,
    "accimt.ac.lk": 1,
    "accrapolytechnic.edu.gh": 1,
    "acd.ac.ae": 1,
    "aceondo-ng.com": 1,
    "acg.gr": 1,
    "achievers.edu.ng": 1,
    "acibadem.edu.tr": 1,
    "acighana.org": 1,
    "ackonline.com": 1,
    "acms.edu.my": 1,
    "acmt.ac.ir": 1,
    "acofi.edu": 1,
    "acs.edu.au": 1,
    "acs350.org": 1,
    "act.edu": 1,
    "act.gotevot.edu.sa": 1,
    "acts.ac.kr": 1,
    "actx.edu": 1,
    "acu.edu": 1,
    "acu.edu.au": 1,
    "acu.edu.ng": 1,
    "ad.unc.edu": 1,
    "ada.edu.az": 1,
    "adamson.edu.ph": 1,
    "adanabtu.edu.tr": 1,
    "adau.edu.az": 1,
    "adda.edu.az": 1,
    "addu.edu.ph": 1,
    "adelaide.edu.au": 1,
    "adelekeuniversity.edu.ng": 1,
    "adelphi.edu": 1,
    "adenuniversity.edu.ye": 1,
    "adfa.oz.au": 1,
    "adiban.ac.ir": 1,
    "adiyaman.edu.tr": 1,
    "admiu.edu.az": 1,
    "admu.edu.ph": 1,
    "adnu.edu.ph": 1,
    "adpu.edu.az": 1,
    "adsu.edu.ng": 1,
    "adu.ac.ae": 1,
    "adu.edu.az": 1,
    "adu.edu.et": 1,
    "adu.edu.tr": 1,
    "adygnet.ru": 1,
    "adzu.edu.ph": 1,
    "ae.katowice.pl": 1,
    "ae.krakow.pl": 1,
    "ae.poznan.pl": 1,
    "ae.wroc.pl": 1,
    "aea.asso.fr": 1,
    "aefs.edu.al": 1,
    "aegean.gr": 1,
    "ael.ru": 1,
    "aeu.edu.kh": 1,
    "aeu.edu.my": 1,
    "afa.ac.kr": 1,
    "afeka.ac.il": 1,
    "afghanuniversity.edu.af": 1,
    "afi-ue.sn": 1,
    "afit.edu": 1,
    "africau.edu": 1,
    "afu.edu.np": 1,
    "agh.edu.pl": 1,
    "agma.astranet.ru": 1,
    "agnesscott.edu": 1,
    "agr.unideb.hu": 1,
    "agrar.uz": 1,
    "agri.edu.tr": 1,
    "agriun.almaty.kz": 1,
    "agro.roazhon.inra.fr": 1,
    "agroparistech.fr": 1,
    "agrosupdijon.fr": 1,
    "ags.edu": 1,
    "agsm.gr": 1,
    "agtu.ru": 1,
    "agu.ae": 1,
    "agu.edu.bh": 1,
    "agu.edu.tr": 1,
    "ah.dk": 1,
    "ahap.edu.tr": 1,
    "ahduni.edu.in": 1,
    "ahe.edu.pl": 1,
    "ahfad.edu.sd": 1,
    "ahgaff.edu": 1,
    "ahievran.edu.tr": 1,
    "ahliauniversity.org": 1,
    "ahlulbaitonline.com": 1,
    "ahmu.edu.cn": 1,
    "ahnu.edu.cn": 1,
    "aho.no": 1,
    "ahsdxy.ah.edu.cn": 1,
    "ahtcm.edu.cn": 1,
    "ahu.edu.cn": 1,
    "ahu.edu.jo": 1,
    "aic.edu": 1,
    "aichi-edu.ac.jp": 1,
    "aichi-fam-u.ac.jp": 1,
    "aichi-gakuin.ac.jp": 1,
    "aichi-med-u.ac.jp": 1,
    "aichi-pu.ac.jp": 1,
    "aichi-u.ac.jp": 1,
    "aii.edu": 1,
    "aiims.ac.in": 1,
    "aikoku-u.ac.jp": 1,
    "aims.edu": 1,
    "aimst.edu.my": 1,
    "aiou.edu.pk": 1,
    "aisectuniversity.ac.in": 1,
    "aistedaab.ro": 1,
    "ait.ac.th": 1,
    "ait.ie": 1,
    "aitech.ac.jp": 1,
    "aiu.ac.ke": 1,
    "aiu.edu.gm": 1,
    "aiu.edu.my": 1,
    "aiu.edu.sy": 1,
    "aiub.edu": 1,
    "aiuniv.edu": 1,
    "ajku.edu.pk": 1,
    "ajman.ac.ae": 1,
    "ajou.ac.kr": 1,
    "ajums.ac.ir": 1,
    "akad.de": 1,
    "akademiaearteve.edu.al": 1,
    "akademiapz.sk": 1,
    "akbild.ac.at": 1,
    "akdeniz.edu.tr": 1,
    "akeihou-u.ac.jp": 1,
    "akhbaracademy.edu.eg": 1,
    "akita-u.ac.jp": 1,
    "akprind.ac.id": 1,
    "aksaray.edu.tr": 1,
    "aktsu.kz": 1,
    "aku.edu": 1,
    "aku.edu.et": 1,
    "aku.edu.tr": 1,
    "aku.sk": 1,
    "akutech.edu.ng": 1,
    "al-edu.com": 1,
    "alagappauniversity.ac.in": 1,
    "alainuniversity.ac.ae": 1,
    "alamancecc.edu": 1,
    "alamo.edu": 1,
    "alanyaaku.edu.tr": 1,
    "alaqsa.edu.ps": 1,
    "alaska.edu": 1,
    "alaskapacific.edu": 1,
    "alasu.edu": 1,
    "alazhar.edu.ps": 1,
    "alba.edu.gr": 1,
    "albaath-univ.edu.sy": 1,
    "albany.edu": 1,
    "albanytech.edu": 1,
    "albemarle.edu": 1,
    "albion.edu": 1,
    "alc.edu.au": 1,
    "aldirasat.edu.pk": 1,
    "alepuniv.edu.sy": 1,
    "alex.edu.eg": 1,
    "alextech.edu": 1,
    "alfaisal.edu": 1,
    "alfred.edu": 1,
    "alfredtech.edu": 1,
    "algebra.hr": 1,
    "algonquincollege.com": 1,
    "alhikmah.edu.ng": 1,
    "alhosnu.ae": 1,
    "aliabadiau.ac.ir": 1,
    "alkhair.edu.pk": 1,
    "alldunivpio.org": 1,
    "alleg.edu": 1,
    "allegany.edu": 1,
    "allencc.edu": 1,
    "allencol.edu": 1,
    "alliant.edu": 1,
    "alma.edu": 1,
    "almaarifah.com": 1,
    "almamonuc.org": 1,
    "aloma.edu": 1,
    "alparslan.edu.tr": 1,
    "alpenacc.edu": 1,
    "alquds.edu": 1,
    "alrasheed-uc.com": 1,
    "alsadrain.org": 1,
    "altmeduniversity.com": 1,
    "altmedworld.net": 1,
    "alumnos.ui1.es": 1,
    "alverno.edu": 1,
    "alvincollege.edu": 1,
    "alyamamah.edu.sa": 1,
    "alzahra.ac.ir": 1,
    "alzaytoonah.edu.jo": 1,
    "am.katowice.pl": 1,
    "am.lodz.pl": 1,
    "am.lublin.pl": 1,
    "am.wroc.pl": 1,
    "amaiu.edu.bh": 1,
    "amasya.edu.tr": 1,
    "amb.bydgoszcz.pl": 1,
    "amb.edu.pl": 1,
    "ambassador.edu": 1,
    "ambou.edu.et": 1,
    "amc.edu.au": 1,
    "ame.ru": 1,
    "amercoastuniv.edu": 1,
    "american-college.com": 1,
    "american.edu": 1,
    "amg.gda.pl": 1,
    "amgd.eu": 1,
    "amherst.edu": 1,
    "ami.edu.pk": 1,
    "amikom.ac.id": 1,
    "amity.edu": 1,
    "aml.lv": 1,
    "amman.edu": 1,
    "ammanu.edu.jo": 1,
    "amouduniversity.org": 1,
    "amrita.edu": 1,
    "amti.hit.bg": 1,
    "amtuni.com": 1,
    "amu.ac.in": 1,
    "amu.edu.az": 1,
    "amu.edu.et": 1,
    "amu.edu.pl": 1,
    "amursu.ru": 1,
    "amuz.bydgoszcz.pl": 1,
    "amuz.gda.pl": 1,
    "amuz.krakow.pl": 1,
    "amuz.lodz.pl": 1,
    "amuz.poznan.pl": 1,
    "amuz.wroc.pl": 1,
    "amwaw.edu.pl": 1,
    "anadolu.edu.tr": 1,
    "anahuac.mx": 1,
    "anc.edu": 1,
    "ancilla.edu": 1,
    "ancollege.edu": 1,
    "andhrauniversity.info": 1,
    "andong.ac.kr": 1,
    "andrassyuni.hu": 1,
    "andrew.ac.jp": 1,
    "andrewcollege.edu": 1,
    "andrews.edu": 1,
    "anefs-edu.ro": 1,
    "angelicum.org": 1,
    "angelina.edu": 1,
    "angelo.edu": 1,
    "angkor.edu.kh": 1,
    "anglia.ac.uk": 1,
    "angrau.net": 1,
    "ankara.edu.tr": 1,
    "annamalaiuniversity.ac.in": 1,
    "annauniv.edu": 1,
    "annauniv.edu.in": 1,
    "anokaramsey.edu": 1,
    "anokatech.edu": 1,
    "anselm.edu": 1,
    "ansu.edu.ng": 1,
    "antalya.edu.tr": 1,
    "antioch.edu": 1,
    "antiochla.edu": 1,
    "antiochne.edu": 1,
    "antonianum.ofm.org": 1,
    "anu.ac.ke": 1,
    "anu.edu.au": 1,
    "anuc.edu.gh": 1,
    "aomori-u.ac.jp": 1,
    "aomoricgu.ac.jp": 1,
    "aos.sk": 1,
    "aou.edu.eg": 1,
    "aou.edu.jo": 1,
    "aou.edu.kw": 1,
    "aou.edu.om": 1,
    "aou.org.bh": 1,
    "aoyama.ac.jp": 1,
    "ap.edu.pl": 1,
    "ap.siedlce.pl": 1,
    "apiit.edu.my": 1,
    "appstate.edu": 1,
    "apsu.edu": 1,
    "apsurewa.nic.in": 1,
    "apu.ac.jp": 1,
    "apu.edu": 1,
    "apus.edu": 1,
    "aqua.sci-nnov.ru": 1,
    "aquinas-university.edu": 1,
    "aquinas.edu": 1,
    "ar.krakow.pl": 1,
    "ar.lublin.pl": 1,
    "ar.szczecin.pl": 1,
    "ar.wroc.pl": 1,
    "arabou-lb.edu.lb": 1,
    "arabou.edu.sa": 1,
    "arakmu.ac.ir": 1,
    "araku.ac.ir": 1,
    "arakut.ac.ir": 1,
    "araneta.dlsu.edu.ph": 1,
    "arapahoe.edu": 1,
    "arbor.edu": 1,
    "arc.losrios.edu": 1,
    "arcadia.edu": 1,
    "archi.ac.ma": 1,
    "ardahan.edu.tr": 1,
    "arel.edu.tr": 1,
    "arellano.edu.ph": 1,
    "aria.edu.af": 1,
    "ariel.ac.il": 1,
    "arizona.edu": 1,
    "armmed.am": 1,
    "armstrong.edu": 1,
    "arosmu.org": 1,
    "arquitecturaucv.cl": 1,
    "art.ac.ir": 1,
    "art.edu": 1,
    "art.olsztyn.pl": 1,
    "artacademy.spb.ru": 1,
    "arteiasi.ro": 1,
    "arts.bg.ac.rs": 1,
    "arts7.hu": 1,
    "artuklu.edu.tr": 1,
    "artun.ee": 1,
    "artvin.edu.tr": 1,
    "aru.ac.th": 1,
    "arums.ac.ir": 1,
    "arwauniversity.org": 1,
    "aryainstitutejpr.com": 1,
    "asa.edu": 1,
    "asahi-u.ac.jp": 1,
    "asahikawa-med.ac.jp": 1,
    "asahikawa-u.ac.jp": 1,
    "asau.am": 1,
    "asaub.edu.bd": 1,
    "asbu.edu.tr": 1,
    "ascc.edu": 1,
    "ascca.gov.az": 1,
    "ase.md": 1,
    "ase.ro": 1,
    "asfa.gr": 1,
    "asfh-berlin.de": 1,
    "ash-college.ac.il": 1,
    "ashesi.edu.gh": 1,
    "ashford.edu": 1,
    "ashitech.ac.jp": 1,
    "ashiya-u.ac.jp": 1,
    "ashland.edu": 1,
    "ashland.kctcs.edu": 1,
    "ashtoncollege.com": 1,
    "asia-u.ac.jp": 1,
    "asianust.ac.th": 1,
    "asmarya.edu.ly": 1,
    "asmi.edu.kg": 1,
    "asmu.ru": 1,
    "asnuntuck.edu": 1,
    "asoiu.edu.az": 1,
    "asp.gda.pl": 1,
    "asp.krakow.pl": 1,
    "asp.lodz.pl": 1,
    "asp.poznan.pl": 1,
    "asp.waw.pl": 1,
    "asp.wroc.pl": 1,
    "aspkat.edu.pl": 1,
    "aspu.ru": 1,
    "assamuniversity.nic.in": 1,
    "assumption.edu": 1,
    "assumptionu.ca": 1,
    "astate.edu": 1,
    "aston.ac.uk": 1,
    "astu.edu.et": 1,
    "astu.org": 1,
    "astu.secna.ru": 1,
    "asu.ac.jp": 1,
    "asu.edu": 1,
    "asu.edu.bh": 1,
    "asu.edu.et": 1,
    "asu.edu.jo": 1,
    "asu.ru": 1,
    "asub.edu": 1,
    "asue.am": 1,
    "asumh.edu": 1,
    "asun.edu": 1,
    "asurams.edu": 1,
    "at.edu.pl": 1,
    "atauni.edu.tr": 1,
    "atbu.edu.ng": 1,
    "atc.edu": 1,
    "atc2u.com": 1,
    "atgu.kz": 1,
    "athabascau.ca": 1,
    "athens.edu": 1,
    "athenstech.edu": 1,
    "ati.osu.edu": 1,
    "atilim.edu.tr": 1,
    "atishdipankaruniversity.edu.bd": 1,
    "atlantatech.edu": 1,
    "atlantic.edu": 1,
    "atlantida.edu.ar": 1,
    "atmajaya.ac.id": 1,
    "atomi.ac.jp": 1,
    "ats.dk": 1,
    "atsu.edu.ge": 1,
    "atu.ac.ir": 1,
    "atu.edu": 1,
    "au-plovdiv.bg": 1,
    "au.dk": 1,
    "au.edu": 1,
    "au.edu.af": 1,
    "au.edu.az": 1,
    "au.edu.pk": 1,
    "au.edu.tw": 1,
    "au.poznan.pl": 1,
    "aua.ac.ke": 1,
    "aua.am": 1,
    "aua.gr": 1,
    "auaf.edu.af": 1,
    "auamed.org": 1,
    "aub-bd.org": 1,
    "aub.edu.lb": 1,
    "aubg.bg": 1,
    "aubih.ba": 1,
    "auburn.edu": 1,
    "auc-edu.org": 1,
    "auc.dk": 1,
    "auc.edu": 1,
    "auca.ac.rw": 1,
    "auca.kg": 1,
    "aucegypt.edu": 1,
    "auchaiti.org": 1,
    "auchipoly.edu.ng": 1,
    "auckland.ac.nz": 1,
    "aucklanduni.ac.nz": 1,
    "aucmed.edu": 1,
    "aud.edu": 1,
    "aue-okinawa.ac.jp": 1,
    "aue.ae": 1,
    "aueb.gr": 1,
    "auf.edu.ph": 1,
    "aufe.edu.cn": 1,
    "augie.edu": 1,
    "augsburg.edu": 1,
    "augusta.edu": 1,
    "augustana.ab.ca": 1,
    "augustana.de": 1,
    "augustana.edu": 1,
    "augustatech.edu": 1,
    "auhw.ac.jp": 1,
    "aui.ma": 1,
    "auis.edu.iq": 1,
    "auk.edu.kw": 1,
    "aukonline.org": 1,
    "aul.edu": 1,
    "aul.edu.lb": 1,
    "aum.edu": 1,
    "aum.edu.kw": 1,
    "aums.ac.ir": 1,
    "aun.edu.eg": 1,
    "aun.edu.ng": 1,
    "aup.edu.ph": 1,
    "aup.edu.pk": 1,
    "aup.fr": 1,
    "aupen.edu.ph": 1,
    "aurora.edu": 1,
    "aus.edu": 1,
    "aust-abuja.org": 1,
    "aust.edu": 1,
    "aust.edu.lb": 1,
    "austincc.edu": 1,
    "austincollege.edu": 1,
    "austral.edu.ar": 1,
    "aut.ac.ir": 1,
    "aut.ac.nz": 1,
    "aut.edu": 1,
    "auth.gr": 1,
    "autonoma.edu.co": 1,
    "avc.edu": 1,
    "aventis.edu.sg": 1,
    "averett.edu": 1,
    "avicenna.hu": 1,
    "avila.edu": 1,
    "avondale.edu.au": 1,
    "avrasya.edu.tr": 1,
    "avtlg.ru": 1,
    "avu.org": 1,
    "awf.edu.pl": 1,
    "awf.gda.pl": 1,
    "awf.katowice.pl": 1,
    "awf.krakow.pl": 1,
    "awf.poznan.pl": 1,
    "awf.wroc.pl": 1,
    "aydin.edu.tr": 1,
    "ayurveduniversity.com": 1,
    "az-npu.org": 1,
    "azabu-u.ac.jp": 1,
    "azad.ac.ir": 1,
    "azhar.edu.eg": 1,
    "azmiu.edu.az": 1,
    "aztu.edu.az": 1,
    "azwestern.edu": 1,
    "ba.edu.af": 1,
    "ba.lv": 1,
    "baa.by": 1,
    "babcockuni.edu.ng": 1,
    "babson.edu": 1,
    "bac.ac.bw": 1,
    "bac.edu.cn": 1,
    "bac.edu.my": 1,
    "badakhshan.edu.af": 1,
    "baghdadcollege.edu.iq": 1,
    "baghlan.edu.af": 1,
    "bahcesehir.edu.tr": 1,
    "bahria.edu.pk": 1,
    "baika.ac.jp": 1,
    "baiko.ac.jp": 1,
    "bainbridge.edu": 1,
    "bajio.delasalle.edu.mx": 1,
    "baker.edu": 1,
    "bakersfieldcollege.edu": 1,
    "bakeru.edu": 1,
    "bakhtalruda.edu.sd": 1,
    "bakhtar.edu.af": 1,
    "bakrie.ac.id": 1,
    "balamand.edu.lb": 1,
    "balikesir.edu.tr": 1,
    "bambey.univ.sn": 1,
    "bamendauniversity.com": 1,
    "bamu.net": 1,
    "bamu.nic.in": 1,
    "banasthali.org": 1,
    "bandirma.edu.tr": 1,
    "bangor.ac.uk": 1,
    "bankurauniv.com": 1,
    "baqai.edu.pk": 1,
    "baraodemaua.br": 1,
    "barcelonagse.eu": 1,
    "bard.edu": 1,
    "barnard.edu": 1,
    "barry.edu": 1,
    "barstow.edu": 1,
    "bartin.edu.tr": 1,
    "bartonccc.edu": 1,
    "bashedu.ru": 1,
    "baskent.edu.tr": 1,
    "bastyr.edu": 1,
    "basu.ac.ir": 1,
    "basug.edu.ng": 1,
    "bates.ctc.edu": 1,
    "bates.edu": 1,
    "bath.ac.uk": 1,
    "batman.edu.tr": 1,
    "batu.edu.by": 1,
    "bau.edu.bd": 1,
    "bau.edu.jo": 1,
    "bau.edu.lb": 1,
    "bau.nic.in": 1,
    "bayamon.inter.edu": 1,
    "bayantech.edu": 1,
    "bayar.edu.tr": 1,
    "bayburt.edu.tr": 1,
    "baycollege.edu": 1,
    "baylor.edu": 1,
    "bazeuniversity.edu.ng": 1,
    "bbauindia.org": 1,
    "bbc.edu": 1,
    "bbk.ac.uk": 1,
    "bbu.ac.lk": 1,
    "bbu.edu.az": 1,
    "bbu.edu.kh": 1,
    "bc.edu": 1,
    "bc3.edu": 1,
    "bca.bw": 1,
    "bcc.cuny.edu": 1,
    "bcc.edu": 1,
    "bccc.edu": 1,
    "bcit.ca": 1,
    "bckv.edu.in": 1,
    "bcm.edu": 1,
    "bcom.ac.uk": 1,
    "bcou.ca": 1,
    "bcu.ac.uk": 1,
    "bdtf.hu": 1,
    "bdu.edu.et": 1,
    "bdu.edu.vn": 1,
    "bdu.ernet.in": 1,
    "beaufortccc.edu": 1,
    "becs.ac.in": 1,
    "beder.edu.al": 1,
    "beds.ac.uk": 1,
    "bellasartes.edu.co": 1,
    "bellevue.edu": 1,
    "bellsuniversity.org": 1,
    "belmont.edu": 1,
    "belmontcollege.edu": 1,
    "beloit.edu": 1,
    "belsut.gomel.by": 1,
    "bemidjistate.edu": 1,
    "benadiruniversity.net": 1,
    "benedictine.edu": 1,
    "bengaluruuniversity.com": 1,
    "bennington.edu": 1,
    "bentley.edu": 1,
    "beppu-u.ac.jp": 1,
    "bercol.bm": 1,
    "berea.edu": 1,
    "bergen.edu": 1,
    "berkeley.edu": 1,
    "berkeleycitycollege.edu": 1,
    "berklee.edu": 1,
    "berkshirecc.edu": 1,
    "bethanywv.edu": 1,
    "bethel.de": 1,
    "bethel.edu": 1,
    "bethelks.edu": 1,
    "bethlehem.edu": 1,
    "beu.edu.tr": 1,
    "beun.edu.tr": 1,
    "beykent.edu.tr": 1,
    "bezalel.ac.il": 1,
    "bezmialem.edu.tr": 1,
    "bfcc.edu": 1,
    "bfh.ch": 1,
    "bfsu.edu.cn": 1,
    "bfu.bg": 1,
    "bg.ac.rs": 1,
    "bgam.edu.by": 1,
    "bgctrustbd.org": 1,
    "bgsp.edu": 1,
    "bgsu.edu": 1,
    "bgu.ac.il": 1,
    "bhagwantuniversity.com": 1,
    "bham.ac.uk": 1,
    "bharathi.ernet.in": 1,
    "bharathuniv.com": 1,
    "bharatividyapeeth.edu": 1,
    "bhavuni.edu": 1,
    "bhc.edu": 1,
    "bhcc.mass.edu": 1,
    "bhms.ch": 1,
    "bhsu.edu": 1,
    "bhtafe.edu.au": 1,
    "bhu.ac.in": 1,
    "bhu.edu.cn": 1,
    "bhu.kg": 1,
    "bhub.ori.nic.in": 1,
    "bi.no": 1,
    "bible.ac.kr": 1,
    "bible.edu": 1,
    "bicol-u.edu.ph": 1,
    "bifrost.is": 1,
    "bigbend.edu": 1,
    "bigpi.biysk.ru": 1,
    "bigsandy.kctcs.edu": 1,
    "bihe.org": 1,
    "biit.edu.pk": 1,
    "bilecik.edu.tr": 1,
    "bilgi.edu.tr": 1,
    "bilkent.edu.tr": 1,
    "bims.edu.pk": 1,
    "binary.edu.my": 1,
    "binghamton.edu": 1,
    "binghamuni.edu.ng": 1,
    "bingol.edu.tr": 1,
    "binus.ac.id": 1,
    "biola.edu": 1,
    "bip.lon.ac.uk": 1,
    "bircham.edu": 1,
    "birjand.ac.ir": 1,
    "biruni.edu.tr": 1,
    "birzeit.edu": 1,
    "bishop.edu": 1,
    "bisla.sk": 1,
    "bisu.edu.cn": 1,
    "bit.edu.cn": 1,
    "biti.edu.cn": 1,
    "bitmesraranchi.org": 1,
    "bits-iserlohn.de": 1,
    "bits-pilani.ac.in": 1,
    "biu.ac.il": 1,
    "biu.edu.ng": 1,
    "biust.ac.bw": 1,
    "bjaeu.edu.cn": 1,
    "bjfu.edu.cn": 1,
    "bjmu.edu.cn": 1,
    "bjpeu.edu.cn": 1,
    "bjpu.edu.cn": 1,
    "bjtu.edu.cn": 1,
    "bju.edu": 1,
    "bjucmp.edu.cn": 1,
    "bke.hu": 1,
    "blackhawk.edu": 1,
    "blackrivertech.edu": 1,
    "bladencc.edu": 1,
    "blcu.edu.cn": 1,
    "blinn.edu": 1,
    "bloomu.edu": 1,
    "bluecc.edu": 1,
    "bluegrass.kctcs.edu": 1,
    "blueridge.edu": 1,
    "blueridgectc.edu": 1,
    "bluffton.edu": 1,
    "bmc.edu.sa": 1,
    "bmcc.cuny.edu": 1,
    "bmcc.edu": 1,
    "bme.hu": 1,
    "bmi.edu.my": 1,
    "bmstu.ru": 1,
    "bmsu.ac.ir": 1,
    "bnmu.in": 1,
    "bntu.by": 1,
    "bnu.edu.cn": 1,
    "bnu.edu.sd": 1,
    "bnue.ac.kr": 1,
    "boisestate.edu": 1,
    "bojnourdiau.ac.ir": 1,
    "boku.ac.at": 1,
    "bolton.ac.uk": 1,
    "bond.edu.au": 1,
    "boothcollege.ca": 1,
    "borealc.on.ca": 1,
    "bosasocollege.com": 1,
    "bost.edu.af": 1,
    "bothocollege.ac.bw": 1,
    "bou.edu.bd": 1,
    "boun.edu.tr": 1,
    "bournemouth.ac.uk": 1,
    "bowdoin.edu": 1,
    "bowenuniversity-edu.org": 1,
    "bowiestate.edu": 1,
    "bowlinggreen.kctcs.edu": 1,
    "bowvalleycollege.ca": 1,
    "boxhill.edu.au": 1,
    "bozok.edu.tr": 1,
    "bpc.edu.iq": 1,
    "bpc.edu.sa": 1,
    "bpcc.edu": 1,
    "bpkihs.edu": 1,
    "bpu.ac.kr": 1,
    "bpu.ac.lk": 1,
    "bpums.ac.ir": 1,
    "bput.org": 1,
    "brabu.net": 1,
    "bracuniversity.net": 1,
    "brad.ac.uk": 1,
    "bradley.edu": 1,
    "brandeis.edu": 1,
    "brandman.edu": 1,
    "brandonu.ca": 1,
    "braou.ac.in": 1,
    "brauagra.com": 1,
    "brazcubas.br": 1,
    "brcc.edu": 1,
    "brenau.edu": 1,
    "brescia.edu": 1,
    "brexgata.eu": 1,
    "briar-cliff.edu": 1,
    "bridgemont.edu": 1,
    "bridgeport.edu": 1,
    "bridgewater.edu": 1,
    "brijnet.org": 1,
    "bris.ac.uk": 1,
    "bristolcc.edu": 1,
    "brockport.edu": 1,
    "brocku.ca": 1,
    "brookdale.edu.ec": 1,
    "brookdalecc.edu": 1,
    "brookes.ac.uk": 1,
    "brookhavencollege.edu": 1,
    "broward.edu": 1,
    "brown.edu": 1,
    "broyalu.net": 1,
    "brstu.ru": 1,
    "brsu.brest.by": 1,
    "bru.mogilev.by": 1,
    "brunel.ac.uk": 1,
    "brunswickcc.edu": 1,
    "brur.ac.bd": 1,
    "bryant.edu": 1,
    "brynmawr.edu": 1,
    "bsa.edu.lv": 1,
    "bsaa.ru": 1,
    "bsauniv.ac.in": 1,
    "bsc.edu": 1,
    "bscc.edu": 1,
    "bseu.by": 1,
    "bsl-lausanne.ch": 1,
    "bsmmu.edu.bd": 1,
    "bsmrau.edu.bd": 1,
    "bsmu.by": 1,
    "bspa.unibel.by": 1,
    "bspu.ru": 1,
    "bspu.unibel.by": 1,
    "bstu.by": 1,
    "bstu.ru": 1,
    "bstu.unibel.by": 1,
    "bsu-edu.org": 1,
    "bsu.burnet.ru": 1,
    "bsu.by": 1,
    "bsu.edu": 1,
    "bsu.edu.az": 1,
    "bsu.edu.cn": 1,
    "bsu.edu.eg": 1,
    "bsu.edu.ph": 1,
    "bsu.edu.ru": 1,
    "bsuir.by": 1,
    "bsum.edu.ng": 1,
    "btc.ctc.edu": 1,
    "bth.se": 1,
    "bton.ac.uk": 1,
    "btsau.kiev.ua": 1,
    "btu.bg": 1,
    "btu.edu.ge": 1,
    "btu.edu.tr": 1,
    "btu.ge": 1,
    "bu.ac.kr": 1,
    "bu.ac.th": 1,
    "bu.edu": 1,
    "bu.edu.af": 1,
    "bu.edu.bd": 1,
    "bu.edu.eg": 1,
    "bu.edu.sa": 1,
    "buaa.edu.cn": 1,
    "buap.mx": 1,
    "bubhopal.nic.in": 1,
    "bubt.edu.bd": 1,
    "buc.edu.om": 1,
    "buck.ac.uk": 1,
    "bucknell.edu": 1,
    "bucks.ac.uk": 1,
    "bucks.edu": 1,
    "buct.edu.cn": 1,
    "budo-u.ac.jp": 1,
    "buet.ac.bd": 1,
    "buetk.edu.pk": 1,
    "buffalo.edu": 1,
    "buffalostate.edu": 1,
    "bufs.ac.kr": 1,
    "bugemauniv.ac.ug": 1,
    "buh.edu.vn": 1,
    "buid.ac.ae": 1,
    "buitms.edu.pk": 1,
    "buk.by": 1,
    "buk.edu.ng": 1,
    "bukkyo-u.ac.jp": 1,
    "bulehorauniversity.com": 1,
    "bulsu.edu.ph": 1,
    "bums.ac.ir": 1,
    "bundelkhanduniversity.org": 1,
    "bundenet.com": 1,
    "bunghatta.ac.id": 1,
    "bunka-wu.ac.jp": 1,
    "bunkyo.ac.jp": 1,
    "bunri-u.ac.jp": 1,
    "bup.edu.bd": 1,
    "bupt.edu.cn": 1,
    "buraouniversity.com": 1,
    "burdwanuniversity.ac.in": 1,
    "buse.ac.zw": 1,
    "busitema.ac.ug": 1,
    "busogauniversity.ac.ug": 1,
    "butex.edu.bd": 1,
    "butler.edu": 1,
    "butlercc.edu": 1,
    "butte.edu": 1,
    "buu.ac.th": 1,
    "bvu.edu": 1,
    "bw.edu": 1,
    "byu.edu": 1,
    "byuh.edu": 1,
    "byui.edu": 1,
    "bzu.edu.pk": 1,
    "cabrillo.edu": 1,
    "cacc.edu": 1,
    "caece.edu.ar": 1,
    "cafa.edu.cn": 1,
    "cag.edu.tr": 1,
    "cahsu.edu": 1,
    "cal.devry.ca": 1,
    "calbaptist.edu": 1,
    "calcoast.edu": 1,
    "calebuniversity.edu.ng": 1,
    "calhoun.edu": 1,
    "callutheran.edu": 1,
    "calpoly.edu": 1,
    "calsouthern.edu": 1,
    "calstate.edu": 1,
    "calstatela.edu": 1,
    "caltech.edu": 1,
    "caluniv.ac.in": 1,
    "calvin.edu": 1,
    "cam.ac.uk": 1,
    "camb.linst.ac.uk": 1,
    "camdencc.edu": 1,
    "cameron.edu": 1,
    "camosun.bc.ca": 1,
    "campbell.edu": 1,
    "campbellsville.edu": 1,
    "campus.ul.pt": 1,
    "campusleon.ugto.mx": 1,
    "canadacollege.edu": 1,
    "canberra.edu.au": 1,
    "candidomendes.br": 1,
    "canisius.edu": 1,
    "cankaya.edu.tr": 1,
    "canterbury.ac.nz": 1,
    "canterbury.ac.uk": 1,
    "canyons.edu": 1,
    "capcollege.bc.ca": 1,
    "capecod.edu": 1,
    "capella.edu": 1,
    "capellauniversity.edu": 1,
    "captechu.edu": 1,
    "cardiff.ac.uk": 1,
    "caribbean.edu": 1,
    "cariboo.bc.ca": 1,
    "caritasuni.edu.ng": 1,
    "carlalbert.edu": 1,
    "carleton.ca": 1,
    "carleton.edu": 1,
    "carlow.edu": 1,
    "carolinascollege.edu": 1,
    "carolus-magnus-university.eu": 1,
    "carrington.edu": 1,
    "carroll.edu": 1,
    "carrollcc.edu": 1,
    "carrollu.edu": 1,
    "carteret.edu": 1,
    "carthage.edu": 1,
    "casa.unimo.it": 1,
    "casagrande.edu.ec": 1,
    "cascadia.edu": 1,
    "case.edu": 1,
    "caspercollege.edu": 1,
    "castelobranco.br": 1,
    "castleton.edu": 1,
    "cataegu.ac.kr": 1,
    "cau.ac.kr": 1,
    "cau.edu.cn": 1,
    "cau.org.in": 1,
    "cauc.edu": 1,
    "cavendishza.org": 1,
    "cavern.nmsu.edu": 1,
    "cayey.upr.edu": 1,
    "cayuga-cc.edu": 1,
    "cba.edu.sa": 1,
    "cbm.iobm.edu.pk": 1,
    "cbnu.ac.kr": 1,
    "cbs.de": 1,
    "cbs.dk": 1,
    "cbu.edu": 1,
    "cbu.edu.zm": 1,
    "cbu2000.com": 1,
    "ccaa.edu": 1,
    "ccac.edu": 1,
    "ccaurora.edu": 1,
    "ccbc.ca": 1,
    "ccbc.edu": 1,
    "ccbcmd.edu": 1,
    "ccc.commnet.edu": 1,
    "ccc.edu": 1,
    "cccc.edu": 1,
    "cccd.edu": 1,
    "cccneb.edu": 1,
    "cccnj.edu": 1,
    "cccs.edu": 1,
    "cccti.edu": 1,
    "cccua.edu": 1,
    "ccd.edu": 1,
    "ccis.edu": 1,
    "ccnn.edu": 1,
    "ccnu.edu.cn": 1,
    "ccp.edu": 1,
    "ccri.edu": 1,
    "ccs.edu.sd": 1,
    "ccsf.edu": 1,
    "ccsn.edu": 1,
    "ccsnh.edu": 1,
    "ccsu.edu": 1,
    "ccsuniversity.ac.in": 1,
    "ccsuniversity.org": 1,
    "cctech.edu": 1,
    "ccu.edu": 1,
    "ccu.edu.tw": 1,
    "ccut.edu.cn": 1,
    "ccv.edu": 1,
    "cdb.edu.sv": 1,
    "cdkc.edu": 1,
    "cdu.ac.kr": 1,
    "cdu.edu.au": 1,
    "cdu.edu.cn": 1,
    "cdut.edu.cn": 1,
    "cdutcm.edu.cn": 1,
    "ceaprc.org": 1,
    "cecil.edu": 1,
    "cecos.edu.pk": 1,
    "cedarvalleycollege.edu": 1,
    "cedarville.edu": 1,
    "cema.edu.ar": 1,
    "centenary.edu": 1,
    "centennialcollege.ca": 1,
    "central.edu": 1,
    "central.edu.gh": 1,
    "central.ucv.ro": 1,
    "centralaz.edu": 1,
    "centrale-marseille.fr": 1,
    "centralgatech.edu": 1,
    "centre.edu": 1,
    "century.edu": 1,
    "ceram.edu": 1,
    "cerritos.edu": 1,
    "cerrocoso.edu": 1,
    "ces.edu.co": 1,
    "cesa.edu.co": 1,
    "cesbm.ac.in": 1,
    "cesi.fr": 1,
    "ceti.mx": 1,
    "cetys.mx": 1,
    "ceu.edu": 1,
    "ceu.edu.mx": 1,
    "ceu.edu.ph": 1,
    "ceu.es": 1,
    "ceu.hu": 1,
    "ceunix.com.mx": 1,
    "ceux.mx": 1,
    "cf.ac.uk": 1,
    "cfau.edu.cn": 1,
    "cfcc.edu": 1,
    "cfpj.com": 1,
    "cgc.maricopa.edu": 1,
    "cgcc.cc.or.us": 1,
    "cgs.edu": 1,
    "cgu.ac.jp": 1,
    "cgu.edu": 1,
    "cgu.edu.tw": 1,
    "cha.ac.kr": 1,
    "chabotcollege.edu": 1,
    "chaffey.edu": 1,
    "chalmers.se": 1,
    "champagnat.edu.mx": 1,
    "champagnat.edu.pe": 1,
    "champlain.edu": 1,
    "changwon.ac.kr": 1,
    "chapingo.mx": 1,
    "chapman.edu": 1,
    "charismauniversity.org": 1,
    "charusat.ac.in": 1,
    "chatfield.edu": 1,
    "chatham.edu": 1,
    "chattahoocheetech.edu": 1,
    "chattanoogastate.edu": 1,
    "chefs.edu": 1,
    "cheju-e.ac.kr": 1,
    "cheju.ac.kr": 1,
    "chelsea.linst.ac.uk": 1,
    "chemeketa.edu": 1,
    "chesapeake.edu": 1,
    "chester.ac.uk": 1,
    "cheyney.edu": 1,
    "chiangmai.ac.th": 1,
    "chiangraicampus.rmutl.ac.th": 1,
    "chiba-u.ac.jp": 1,
    "chikushi.ac.jp": 1,
    "chinaacademyofart.com": 1,
    "chinju-e.ac.kr": 1,
    "chinju.ac.kr": 1,
    "chna.edu.tw": 1,
    "chnu.cv.ua": 1,
    "chodang.ac.kr": 1,
    "chonbuk.ac.kr": 1,
    "chongju-e.ac.kr": 1,
    "chongju.ac.kr": 1,
    "chongshin.ac.kr": 1,
    "chonju-e.ac.kr": 1,
    "chonnam.ac.kr": 1,
    "chopin.edu.pl": 1,
    "chosun.ac.kr": 1,
    "christuniversity.in": 1,
    "chu.edu.tw": 1,
    "chubu-gu.ac.jp": 1,
    "chubu.ac.jp": 1,
    "chugye.ac.kr": 1,
    "chuhai.edu.hk": 1,
    "chujo-u.ac.jp": 1,
    "chuka.ac.ke": 1,
    "chukyo-u.ac.jp": 1,
    "chukyogakuin-u.ac.jp": 1,
    "chula.ac.th": 1,
    "chungbuk.ac.kr": 1,
    "chungju.ac.kr": 1,
    "chungnam.ac.kr": 1,
    "chungwoon.ac.kr": 1,
    "chuo-u.ac.jp": 1,
    "chuv.ch": 1,
    "chuvsu.ru": 1,
    "cic-cairo.com": 1,
    "ciefl.org": 1,
    "cife.edu.in": 1,
    "cihanuniversity.edu.iq": 1,
    "cihts.ac.in": 1,
    "ciim.ac.cy": 1,
    "ciit-atd.edu.pk": 1,
    "ciit-attock.edu.pk": 1,
    "ciit-wah.edu.pk": 1,
    "ciit.edu.pk": 1,
    "ciitlahore.edu.pk": 1,
    "cincinnatistate.edu": 1,
    "cisco.edu": 1,
    "cisisu.edu.cn": 1,
    "cit.drbit.com.ru": 1,
    "cit.ie": 1,
    "citadel.edu": 1,
    "citruscollege.edu": 1,
    "city.ac.uk": 1,
    "city.edu.my": 1,
    "cityu.bg": 1,
    "cityu.edu": 1,
    "cityu.edu.hk": 1,
    "cityu.gr": 1,
    "cityuniversity.edu.bd": 1,
    "ciu.edu.tr": 1,
    "cje.ac.kr": 1,
    "cju.ac.kr": 1,
    "cju.edu.tw": 1,
    "cku.ac.jp": 1,
    "cku.ac.kr": 1,
    "cku.edu.tw": 1,
    "clackamas.edu": 1,
    "claeh.edu.uy": 1,
    "claremontmckenna.edu": 1,
    "clarendoncollege.edu": 1,
    "claretiano.edu.br": 1,
    "clarion.edu": 1,
    "clark.edu": 1,
    "clarke.edu": 1,
    "clarkson.edu": 1,
    "clarkstate.edu": 1,
    "clarku.edu": 1,
    "clatsopcc.edu": 1,
    "clayton.edu": 1,
    "clb.ac.il": 1,
    "clemson.edu": 1,
    "clevelandcc.edu": 1,
    "clevelandstatecc.edu": 1,
    "clinch.edu": 1,
    "clinton.edu": 1,
    "cloud.edu": 1,
    "clovis.edu": 1,
    "clpccd.edu": 1,
    "cmb.ac.lk": 1,
    "cmc.edu": 1,
    "cmc.edu.tw": 1,
    "cmcc.edu": 1,
    "cmccd.edu": 1,
    "cmich.edu": 1,
    "cmjuniversity.edu.in": 1,
    "cmmccollege.edu": 1,
    "cmru.ac.th": 1,
    "cmu.ca": 1,
    "cmu.edu": 1,
    "cmu.edu.cn": 1,
    "cmu.edu.ph": 1,
    "cmvc.ac.th": 1,
    "cn.edu": 1,
    "cnam.fr": 1,
    "cnc.bc.ca": 1,
    "cncc.edu": 1,
    "cncnc.edu.cn": 1,
    "cnearc.fr": 1,
    "cnm.edu": 1,
    "cnr.edu": 1,
    "cnu.ac.kr": 1,
    "cnu.edu": 1,
    "cnu.edu.cn": 1,
    "cnuas.edu": 1,
    "cnue-e.ac.kr": 1,
    "cnue.ac.kr": 1,
    "coa.edu": 1,
    "coahomacc.edu": 1,
    "coalrafidain.edu.iq": 1,
    "coastal.edu": 1,
    "coastalalabama.edu": 1,
    "coastalbend.edu": 1,
    "coastalcarolina.edu": 1,
    "coastalpines.edu": 1,
    "coastline.edu": 1,
    "cob.edu.bs": 1,
    "cobleskill.edu": 1,
    "cocc.edu": 1,
    "cochise.edu": 1,
    "cocite.pt": 1,
    "coconino.edu": 1,
    "cod.edu": 1,
    "code.berlin": 1,
    "coe.edu": 1,
    "coeikere.edu.ng": 1,
    "coeoju.com": 1,
    "cofc.edu": 1,
    "coffeyville.edu": 1,
    "coker.edu": 1,
    "colby.edu": 1,
    "colbycc.edu": 1,
    "coleurope.eu": 1,
    "colgate.edu": 1,
    "colin.edu": 1,
    "collegeofsanmateo.edu": 1,
    "collegeofthedesert.edu": 1,
    "collegium.edu.pl": 1,
    "collin.edu": 1,
    "colman.ac.il": 1,
    "colmex.mx": 1,
    "colorado.edu": 1,
    "coloradocollege.edu": 1,
    "coloradomesa.edu": 1,
    "coloradotech.edu": 1,
    "colostate.edu": 1,
    "colsouth.edu": 1,
    "colum.edu": 1,
    "columbia.edu": 1,
    "columbia.edu.py": 1,
    "columbiabasin.edu": 1,
    "columbiacollege.ca": 1,
    "columbiasc.edu": 1,
    "columbiastate.edu": 1,
    "columbus.edu": 1,
    "columbusstate.edu": 1,
    "columbustech.edu": 1,
    "com.edu": 1,
    "compton.edu": 1,
    "comu.edu.tr": 1,
    "concordia.ab.ca": 1,
    "concordia.ca": 1,
    "conestogac.on.ca": 1,
    "conncoll.edu": 1,
    "connorsstate.edu": 1,
    "conservatoire.ru": 1,
    "conservatory.az": 1,
    "conservatory.ru": 1,
    "contracosta.edu": 1,
    "cooper.edu": 1,
    "coppin.edu": 1,
    "cord.edu": 1,
    "cornell-iowa.edu": 1,
    "cornell.edu": 1,
    "corning-cc.edu": 1,
    "cortland.edu": 1,
    "cos.edu": 1,
    "cosmiq.edu.pk": 1,
    "cotc.edu": 1,
    "coto.edu": 1,
    "cotr.bc.ca": 1,
    "cou.ac.bd": 1,
    "cou.fi": 1,
    "courtauld.ac.uk": 1,
    "covenantuniversity.edu.ng": 1,
    "coventry.ac.uk": 1,
    "cowley.edu": 1,
    "cpcc.edu": 1,
    "cpe.fr": 1,
    "cpit.ac.nz": 1,
    "cpoly.edu.gh": 1,
    "cpp.edu": 1,
    "cppsu.edu.cn": 1,
    "cptc.edu": 1,
    "cpu.ac.th": 1,
    "cpu.edu.cn": 1,
    "cpu.edu.tw": 1,
    "cpuic.edu": 1,
    "cpums.edu.cn": 1,
    "cput.ac.za": 1,
    "cqec.net.cn": 1,
    "cqgyzy.com": 1,
    "cqmu.edu.cn": 1,
    "cqnu.edu.cn": 1,
    "cqtcedu.com": 1,
    "cqu.edu.au": 1,
    "cqu.edu.cn": 1,
    "cquc.edu.cn": 1,
    "cqupt.edu.cn": 1,
    "cqust.cn": 1,
    "cqut.edu.cn": 1,
    "cqwu.net": 1,
    "craftonhills.edu": 1,
    "cranfield.ac.uk": 1,
    "cravencc.edu": 1,
    "crawforduniversity.edu.ng": 1,
    "crc.losrios.edu": 1,
    "creighton.edu": 1,
    "crescent-university.edu.ng": 1,
    "creupi.br": 1,
    "cribx1.u-bordeaux.fr": 1,
    "crk.umn.edu": 1,
    "crowder.edu": 1,
    "crsmu.com": 1,
    "crtvu.edu.cn": 1,
    "crutech.edu.ng": 1,
    "cs.ac.kr": 1,
    "cs.lpu.lv": 1,
    "csauk.ac.in": 1,
    "csbsju.edu": 1,
    "csc.edu": 1,
    "cscc.edu": 1,
    "csfu.edu.cn": 1,
    "cshl.edu": 1,
    "csi.edu": 1,
    "csm.linst.ac.uk": 1,
    "csmc.edu.tw": 1,
    "csmd.edu": 1,
    "csopp.edu": 1,
    "csp.edu": 1,
    "cspi.urc.ac.ru": 1,
    "csru.edu.cn": 1,
    "css.edu": 1,
    "cst.edu": 1,
    "cstj.qc.ca": 1,
    "csu.ac.ru": 1,
    "csu.edu.au": 1,
    "csu.edu.cn": 1,
    "csu.edu.ph": 1,
    "csub.edu": 1,
    "csubak.edu": 1,
    "csuchico.edu": 1,
    "csuci.edu": 1,
    "csudh.edu": 1,
    "csuep.edu.cn": 1,
    "csufresno.edu": 1,
    "csuglobal.edu": 1,
    "csuhayward.edu": 1,
    "csulb.edu": 1,
    "csum.edu": 1,
    "csun.edu": 1,
    "csuohio.edu": 1,
    "csus.edu": 1,
    "csusb.edu": 1,
    "csusm.edu": 1,
    "csustan.edu": 1,
    "ct.edu": 1,
    "ctbu.edu.cn": 1,
    "ctcd.edu": 1,
    "ctgu.edu.cn": 1,
    "cti.edu.sa": 1,
    "ctleuro.ac.cy": 1,
    "cts.edu": 1,
    "ctsem.edu": 1,
    "ctu.edu.vn": 1,
    "ctuonline.edu": 1,
    "cu-cdo.edu.ph": 1,
    "cu.ac.bd": 1,
    "cu.edu.eg": 1,
    "cu.edu.ge": 1,
    "cu.edu.tr": 1,
    "cua.edu": 1,
    "cuao.edu.co": 1,
    "cuauhtemoc.edu.mx": 1,
    "cubidor.com": 1,
    "cubu.edu": 1,
    "cuc.ac.jp": 1,
    "cuc.edu": 1,
    "cuc.edu.cn": 1,
    "cuc.edu.co": 1,
    "cucv.edu.gt": 1,
    "cue.ac.kr": 1,
    "cuea.edu": 1,
    "cueb.edu.cn": 1,
    "cuet.ac.bd": 1,
    "cueyatl.uam.mx": 1,
    "cufe.edu.cn": 1,
    "cug.edu.cn": 1,
    "cugb.edu.cn": 1,
    "cuhk.hk": 1,
    "cuhupr.clu.edu": 1,
    "cui.edu.co": 1,
    "cujae.edu.cu": 1,
    "cuk.ac.kr": 1,
    "cumhuriyet.edu.tr": 1,
    "cumt.edu.cn": 1,
    "cumtb.edu.cn": 1,
    "cun.edu.cn": 1,
    "cuni.cz": 1,
    "cunima.net": 1,
    "cunoc.edu.gt": 1,
    "cuny.edu": 1,
    "cup.ac.kr": 1,
    "cup.edu": 1,
    "cup.edu.kh": 1,
    "cupl.edu.cn": 1,
    "curry.edu": 1,
    "curtin.edu.au": 1,
    "curtin.edu.my": 1,
    "cus.ca": 1,
    "cus.edu.kh": 1,
    "cusat.ac.in": 1,
    "cuslm.ca": 1,
    "cust.edu.cn": 1,
    "cust.univ-bpclermont.fr": 1,
    "cut.ac.cy": 1,
    "cut.ac.za": 1,
    "cut.ac.zw": 1,
    "cut.edu.lb": 1,
    "cutb.edu.co": 1,
    "cuyamaca.edu": 1,
    "cuz.ac.zw": 1,
    "cv.edu": 1,
    "cv.unipiaget.org": 1,
    "cvcc.edu": 1,
    "cvcc.vccs.edu": 1,
    "cvru.ac.in": 1,
    "cvtc.edu": 1,
    "cvut.cz": 1,
    "cwc.edu": 1,
    "cwidaho.cc": 1,
    "cwu.edu": 1,
    "cybermed.edu.my": 1,
    "cyc.edu.cn": 1,
    "cycollege.ac.cy": 1,
    "cycu.edu.tw": 1,
    "cypresscollege.edu": 1,
    "cyryxcollege.edu.mv": 1,
    "cyut.edu.tw": 1,
    "czu.cz": 1,
    "d.umn.edu": 1,
    "da-iict.org": 1,
    "dabcc.nmsu.edu": 1,
    "dacc.edu": 1,
    "dadabhoy.edu.pk": 1,
    "daebul.ac.kr": 1,
    "daegu.ac.kr": 1,
    "daejeon.ac.kr": 1,
    "daejin.ac.kr": 1,
    "daemen.edu": 1,
    "daeshin.ac.kr": 1,
    "daffodilvarsity.edu.bd": 1,
    "dah.edu.sa": 1,
    "daido-it.ac.jp": 1,
    "daiichi-cps.ac.jp": 1,
    "daiichi-koudai.ac.jp": 1,
    "daiichi-ue.ac.jp": 1,
    "daion.ac.jp": 1,
    "daishodai.ac.jp": 1,
    "daito.ac.jp": 1,
    "dakotacollege.edu": 1,
    "dal.ca": 1,
    "dalanjuniversity.edu.sd": 1,
    "damanhour.edu.eg": 1,
    "damascusuniversity.edu.sy": 1,
    "dana.edu": 1,
    "dankook.ac.kr": 1,
    "dartmouth.edu": 1,
    "darton.edu": 1,
    "darulhuda.com": 1,
    "data.minsk.by": 1,
    "dau.edu.sa": 1,
    "dau.lv": 1,
    "dauphine.fr": 1,
    "davaodoctors.edu.ph": 1,
    "davenport.edu": 1,
    "davidson.edu": 1,
    "davidsonccc.edu": 1,
    "davietjal.org": 1,
    "daviscollege.edu": 1,
    "davuniversity.org": 1,
    "davv.ac.in": 1,
    "dawat.edu.af": 1,
    "dawson.edu": 1,
    "daystar.ac.ke": 1,
    "daytonastate.edu": 1,
    "db.dk": 1,
    "dbatechuni.org": 1,
    "dbq.edu": 1,
    "dbs.tn.nic.in": 1,
    "dbskkv.org": 1,
    "dbu.edu": 1,
    "dbu.edu.et": 1,
    "dc3.edu": 1,
    "dcad.edu": 1,
    "dcatholic.ac.kr": 1,
    "dcc.edu": 1,
    "dcc.edu.sa": 1,
    "dcc.ufmg.br": 1,
    "dcc.vccs.edu": 1,
    "dccc.edu": 1,
    "dcccd.edu": 1,
    "dceonline.net": 1,
    "dcet.edu.pk": 1,
    "dcmail.ca": 1,
    "dct.ch": 1,
    "dct.gotevot.edu.sa": 1,
    "dct.udn.vn": 1,
    "dctc.edu": 1,
    "dcu.ie": 1,
    "ddea.dk": 1,
    "ddu.ac.in": 1,
    "ddu.edu.et": 1,
    "ddu.nl": 1,
    "ddugu.edu.in": 1,
    "deakin.edu.au": 1,
    "deanza.edu": 1,
    "deccancollegepune.ac.in": 1,
    "defiance.edu": 1,
    "dehaagsehogeschool.nl": 1,
    "dehaghan.ac.ir": 1,
    "dei.ac.in": 1,
    "dei.edu.gr": 1,
    "delijanpnu.ac.ir": 1,
    "delmar.edu": 1,
    "delta.edu": 1,
    "deltacollege.edu": 1,
    "deltastate.edu": 1,
    "dendai.ac.jp": 1,
    "denison.edu": 1,
    "denmarktech.edu": 1,
    "depaul.edu": 1,
    "depauw.edu": 1,
    "derby.ac.uk": 1,
    "deu.ac.kr": 1,
    "deu.edu.tr": 1,
    "deusto.es": 1,
    "devinci.fr": 1,
    "devry.edu": 1,
    "deylaman.ac.ir": 1,
    "dfh.dk": 1,
    "dgist.ac.kr": 1,
    "dgit.gob.mx": 1,
    "dgu.ru": 1,
    "dhbw-mannheim.de": 1,
    "dhbw.de": 1,
    "dho.edu.tr": 1,
    "dhu.ac.kr": 1,
    "dhu.edu.cn": 1,
    "dhv-speyer.de": 1,
    "dhxd.edu.vn": 1,
    "dia.edu.az": 1,
    "diak.fi": 1,
    "dias.ie": 1,
    "dibru.ernet.in": 1,
    "dickinson.edu": 1,
    "dickinsonstate.edu": 1,
    "dicle.edu.tr": 1,
    "digipen.edu": 1,
    "diit.edu.ua": 1,
    "dillard.edu": 1,
    "dillauniversity.edu.et": 1,
    "dinus.ac.id": 1,
    "diploma.de": 1,
    "disfm.rnu.tn": 1,
    "dit.ac.tz": 1,
    "dit.ie": 1,
    "diu.ac.bd": 1,
    "diu.edu.bd": 1,
    "diu.net.bd": 1,
    "dju.ac.kr": 1,
    "dkdm.dk": 1,
    "dkut.ac.ke": 1,
    "dlh.dk": 1,
    "dliflc.edu": 1,
    "dlmedu.edu.cn": 1,
    "dlmu.edu.cn": 1,
    "dlsu.edu.ph": 1,
    "dlu.edu.cn": 1,
    "dlu.edu.vn": 1,
    "dlufl.edu.cn": 1,
    "dlut.edu.cn": 1,
    "dmacc.edu": 1,
    "dmcg.edu": 1,
    "dmmmsu.edu.ph": 1,
    "dmu.ac.uk": 1,
    "dmu.edu.et": 1,
    "dne.wvnet.edu": 1,
    "dnu.dp.ua": 1,
    "dnue.ac.kr": 1,
    "do-johodai.ac.jp": 1,
    "dogus.edu.tr": 1,
    "doho.ac.jp": 1,
    "dohto.ac.jp": 1,
    "dokkyo.ac.jp": 1,
    "dokkyomed.ac.jp": 1,
    "dominican.edu": 1,
    "donau-uni.ac.at": 1,
    "donga.ac.kr": 1,
    "dongau.ru": 1,
    "dongduk.ac.kr": 1,
    "dongeui.ac.kr": 1,
    "dongguk.ac.kr": 1,
    "dongguk.edu": 1,
    "dongseo.ac.kr": 1,
    "dongshinu.ac.kr": 1,
    "donmeduni.com": 1,
    "donntu.edu.ua": 1,
    "donnu.edu.ua": 1,
    "dordt.edu": 1,
    "doshisha.ac.jp": 1,
    "dote.hu": 1,
    "douglas.bc.ca": 1,
    "dowling.edu": 1,
    "dpc.edu": 1,
    "dpu.ac.th": 1,
    "dpu.dk": 1,
    "dpu.edu.tr": 1,
    "drake.edu": 1,
    "drakestate.edu": 1,
    "dravidianuniversity.ac.in": 1,
    "drew.edu": 1,
    "drexel.edu": 1,
    "drk.hu": 1,
    "drury.edu": 1,
    "dsc.dm": 1,
    "dsc.edu": 1,
    "dscc.edu": 1,
    "dshs-koeln.de": 1,
    "dslcc.edu": 1,
    "dstu.dp.ua": 1,
    "dstu.edu.ru": 1,
    "dsu.ac.kr": 1,
    "dsu.edu": 1,
    "dswe.wroc.pl": 1,
    "dtcc.edu": 1,
    "dti.sk": 1,
    "dtu.dk": 1,
    "du.ac.bd": 1,
    "du.ac.in": 1,
    "du.ac.ir": 1,
    "du.edu": 1,
    "du.edu.eg": 1,
    "du.edu.om": 1,
    "du.se": 1,
    "dubai.rit.edu": 1,
    "duc.edu.iq": 1,
    "duep.edu": 1,
    "duet.ac.bd": 1,
    "duf.hu": 1,
    "dufe.edu.cn": 1,
    "dufs.ac.kr": 1,
    "duhs.edu.pk": 1,
    "duke.edu": 1,
    "duksung.ac.kr": 1,
    "dumlupinar.edu.tr": 1,
    "dundee.ac.uk": 1,
    "dunya.edu.af": 1,
    "dupage.edu": 1,
    "duq.edu": 1,
    "dur.ac.uk": 1,
    "durhamtech.edu": 1,
    "dusit.ac.th": 1,
    "dut.ac.za": 1,
    "duth.gr": 1,
    "duzce.edu.tr": 1,
    "dvc.edu": 1,
    "dvgu.ru": 1,
    "dvgups.ru": 1,
    "dwc-legazpi.edu": 1,
    "dwc.doshisha.ac.jp": 1,
    "dwc.edu": 1,
    "dwu.ac.pg": 1,
    "dwu.edu": 1,
    "dypatiluniversity.org": 1,
    "dytc.ac.kr": 1,
    "dyu.ac.kr": 1,
    "dyu.edu.tw": 1,
    "e3i.univ-tours.fr": 1,
    "eac.edu": 1,
    "eafit.edu.co": 1,
    "ean.edu.co": 1,
    "eap.fr": 1,
    "eap.gr": 1,
    "eap.net": 1,
    "earlham.edu": 1,
    "eas.edu.pl": 1,
    "eastafricauniversity.net": 1,
    "eastcentral.edu": 1,
    "eastdelta.edu.bd": 1,
    "eastern.wvnet.edu": 1,
    "easternct.edu": 1,
    "easternflorida.edu": 1,
    "easternuni.edu.bd": 1,
    "eastfieldcollege.edu": 1,
    "eastms.edu": 1,
    "eastsomaliauniversity.com": 1,
    "eau.ac.th": 1,
    "eba-muenchen.de": 1,
    "ebc.mx": 1,
    "ebs-paris.com": 1,
    "ebs.de": 1,
    "ebs.ee": 1,
    "ebsu-edu.net": 1,
    "ec-lille.fr": 1,
    "ec-lyon.fr": 1,
    "ec-nantes.fr": 1,
    "ecam.be": 1,
    "ecam.fr": 1,
    "ecc.edu": 1,
    "eccc.edu": 1,
    "ecci.edu.co": 1,
    "ece.ac.ae": 1,
    "ece.fr": 1,
    "eciad.bc.ca": 1,
    "ecjtu.jx.cn": 1,
    "ecla.de": 1,
    "ecnu.edu.cn": 1,
    "ecok.edu": 1,
    "ecoles-idrac.com": 1,
    "ecpi.edu": 1,
    "ecr.edu.co": 1,
    "ecsc.edu.et": 1,
    "ecsu.edu": 1,
    "ecu.edu": 1,
    "ecu.edu.au": 1,
    "ecust.edu.cn": 1,
    "ed.ac.uk": 1,
    "edcc.edu": 1,
    "edgecombe.edu": 1,
    "edgehill.ac.uk": 1,
    "edgewood.edu": 1,
    "edhec.ac.ma": 1,
    "edinboro.edu": 1,
    "edisonohio.edu": 1,
    "edogawa-u.ac.jp": 1,
    "edu.edhec.com": 1,
    "edu.htl-villach.at": 1,
    "education.ivanovo.ru": 1,
    "edufr.ch": 1,
    "eelouniversity.org": 1,
    "eerie.fr": 1,
    "efau.org": 1,
    "efe.hu": 1,
    "effatcollege.edu.sa": 1,
    "efh-bochum.de": 1,
    "efh-freiburg.de": 1,
    "efh-hannover.de": 1,
    "efh-reutlingen-ludwigsburg.de": 1,
    "efhlu.de": 1,
    "efpg.inpg.fr": 1,
    "efrei.fr": 1,
    "egcc.edu": 1,
    "ege.edu.tr": 1,
    "egerton.ac.ke": 1,
    "egs.edu": 1,
    "eh-darmstadt.de": 1,
    "ehb.be": 1,
    "ehf.hu": 1,
    "ehime-u.ac.jp": 1,
    "ehl.ch": 1,
    "ehs-dresden.de": 1,
    "ehsal.be": 1,
    "ehu.es": 1,
    "ehu.eus": 1,
    "eia.edu.co": 1,
    "eicc.edu": 1,
    "eichi-u.ac.jp": 1,
    "eieonline.com": 1,
    "eiilmuniversity.ac.in": 1,
    "eit.edu.er": 1,
    "eitc.edu": 1,
    "eiu.am": 1,
    "eiu.edu": 1,
    "eivp-paris.fr": 1,
    "eiyo.ac.jp": 1,
    "eksu.edu.ng": 1,
    "ektu.kz": 1,
    "eku.edu": 1,
    "elac.edu": 1,
    "elcamino.edu": 1,
    "elcentrocollege.edu": 1,
    "elgin.edu": 1,
    "elizabethtown.kctcs.edu": 1,
    "elmahdi.edu.sd": 1,
    "elmergib.edu.ly": 1,
    "elmhurst.edu": 1,
    "elon.edu": 1,
    "elrazicollege.net": 1,
    "elshoroukacademy.edu.eg": 1,
    "elsu.ru": 1,
    "elte.hu": 1,
    "eltech.ru": 1,
    "em-lyon.com": 1,
    "ema.edu.ee": 1,
    "eman-univ.edu.ye": 1,
    "emanuel.ro": 1,
    "emc-campus.com": 1,
    "emc.maricopa.edu": 1,
    "emcc.edu": 1,
    "emerson.edu": 1,
    "emescam.br": 1,
    "emi.ac.ma": 1,
    "emi.edu.bo": 1,
    "emich.edu": 1,
    "emiratesacademy.edu": 1,
    "emmanuel.edu": 1,
    "emory.edu": 1,
    "emporia.edu": 1,
    "ems-mainz.de": 1,
    "emse.fr": 1,
    "emsfj.com": 1,
    "emu.edu": 1,
    "emu.edu.tr": 1,
    "emu.ee": 1,
    "ena.fr": 1,
    "enac.fr": 1,
    "enameknes.ac.ma": 1,
    "enap.uquebec.ca": 1,
    "enautica.pt": 1,
    "enes.unam.mx": 1,
    "engec.ru": 1,
    "english.web.ncku.edu.tw": 1,
    "enic.fr": 1,
    "enim.fr": 1,
    "enise.fr": 1,
    "enit.fr": 1,
    "enitab.fr": 1,
    "enitac.fr": 1,
    "enitiaa-nantes.fr": 1,
    "enm.meteo.fr": 1,
    "enmu.edu": 1,
    "enpc.fr": 1,
    "ens-cachan.fr": 1,
    "ens-fcl.fr": 1,
    "ens-lyon.fr": 1,
    "ens.fr": 1,
    "ens2m.fr": 1,
    "ensae.fr": 1,
    "ensai.fr": 1,
    "ensaia.u-nancy.fr": 1,
    "ensait.fr": 1,
    "ensam.inra.fr": 1,
    "ensat.fr": 1,
    "ensc-lille.fr": 1,
    "ensc-rennes.fr": 1,
    "ensccf.univ-bpclermont.fr": 1,
    "enscm.fr": 1,
    "enscmu.univ-mulhouse.fr": 1,
    "enscp.jussieu.fr": 1,
    "enscpb.u-bordeaux.fr": 1,
    "ensea.fr": 1,
    "enseeiht.fr": 1,
    "ensem.u-nancy.fr": 1,
    "enserb.u-bordeaux.fr": 1,
    "ensg.ign.fr": 1,
    "ensg.u-nancy.fr": 1,
    "ensic.u-nancy.fr": 1,
    "ensica.fr": 1,
    "ensieta.fr": 1,
    "ensitm.fr": 1,
    "ensm-ales.fr": 1,
    "ensm-douai.fr": 1,
    "ensma.fr": 1,
    "ensmp.fr": 1,
    "enspm.u-3mrs.fr": 1,
    "enst-bretagne.fr": 1,
    "enst.fr": 1,
    "ensta.fr": 1,
    "entpe.fr": 1,
    "enu.kz": 1,
    "envt.fr": 1,
    "eosc.edu": 1,
    "eou.edu": 1,
    "epcc.edu": 1,
    "epf.fr": 1,
    "epfl.ch": 1,
    "epfl.edu": 1,
    "epita.fr": 1,
    "epitech.al": 1,
    "epitech.eu": 1,
    "epitech.net": 1,
    "epm.br": 1,
    "epn.edu.ec": 1,
    "epoka.edu.al": 1,
    "erau.edu": 1,
    "erciyes.edu.tr": 1,
    "erdogan.edu.tr": 1,
    "eriicta.am": 1,
    "erzincan.edu.tr": 1,
    "erzurum.edu.tr": 1,
    "es.vccs.edu": 1,
    "esa-purpan.fr": 1,
    "esad.pt": 1,
    "esap.edu.co": 1,
    "esc-bordeaux.fr": 1,
    "esc-brest.fr": 1,
    "esc-clermont.fr": 1,
    "esc-grenoble.fr": 1,
    "esc-lille.fr": 1,
    "esc-marseille.fr": 1,
    "esc-normandie.fr": 1,
    "esc-pau.fr": 1,
    "esc-reims.edu": 1,
    "esc-rouen.fr": 1,
    "esc-toulouse.fr": 1,
    "esca.ac.ma": 1,
    "escc.edu": 1,
    "escdijon.com": 1,
    "escem.fr": 1,
    "escna.fr": 1,
    "escom.fr": 1,
    "escp.fr": 1,
    "escueladepolicia.edu.co": 1,
    "escuelaing.edu.co": 1,
    "eselondon.ac.uk": 1,
    "esenyurt.edu.tr": 1,
    "eseo.fr": 1,
    "esf.edu": 1,
    "eshte.pt": 1,
    "esiae.fr": 1,
    "esic.es": 1,
    "esiea.fr": 1,
    "esiee.fr": 1,
    "esigelec.fr": 1,
    "esim.imt-mrs.fr": 1,
    "esitpa.org": 1,
    "esm-tbilisi.ge": 1,
    "esme.fr": 1,
    "esn.ac.lk": 1,
    "espam-formationuc.org": 1,
    "espci.fr": 1,
    "espe.edu.ec": 1,
    "espoch.edu": 1,
    "espol.edu.ec": 1,
    "essca.asso.fr": 1,
    "essec.fr": 1,
    "essex.ac.uk": 1,
    "essex.edu": 1,
    "esstin.u-nancy.fr": 1,
    "esstu.ru": 1,
    "esta.ac.ma": 1,
    "estacio.br": 1,
    "estp.fr": 1,
    "esu.edu": 1,
    "esut.edu.ng": 1,
    "etf.edu": 1,
    "eth.edu": 1,
    "ethz.ch": 1,
    "etna.io": 1,
    "etown.edu": 1,
    "etsmtl.ca": 1,
    "etsu.edu": 1,
    "etu.edu.tr": 1,
    "etud.u-pem.fr": 1,
    "eu.ac.rs": 1,
    "eu.spb.ru": 1,
    "euba.sk": 1,
    "euc.ac.cy": 1,
    "euclid.int": 1,
    "eudil.fr": 1,
    "eufh.de": 1,
    "eulji.ac.kr": 1,
    "eum.ac.jp": 1,
    "eur.nl": 1,
    "eurasia.edu": 1,
    "eurazir.kz": 1,
    "europeaniu.org": 1,
    "europeanopenuniversity.com": 1,
    "europeanuniversity.pt": 1,
    "euruni.edu": 1,
    "eustatiusmed.edu": 1,
    "euv-frankfurt-o.de": 1,
    "evansville.edu": 1,
    "evc.edu": 1,
    "everest.edu": 1,
    "everettcc.edu": 1,
    "evergreen.edu": 1,
    "evfh-berlin.de": 1,
    "evfh-nuernberg.de": 1,
    "evtek.fi": 1,
    "ewc.wy.edu": 1,
    "ewha.ac.kr": 1,
    "ewu.edu": 1,
    "ewubd.edu": 1,
    "ex.ac.uk": 1,
    "fa.cvut.cz": 1,
    "fa.ru": 1,
    "faap.br": 1,
    "faculdadescuritiba.br": 1,
    "fae.edu": 1,
    "fairmontstate.edu": 1,
    "falavarjan.ac.ir": 1,
    "falmouth.ac.uk": 1,
    "famu.cz": 1,
    "famu.edu": 1,
    "fandm.edu": 1,
    "fanshawec.ca": 1,
    "fanshaweonline.ca": 1,
    "farmingdale.edu": 1,
    "faryab.edu.af": 1,
    "fashir.edu.sd": 1,
    "fatihsultan.edu.tr": 1,
    "fatima.edu.ph": 1,
    "fatimacollege.net": 1,
    "fau.edu": 1,
    "faulknerstate.edu": 1,
    "fayoum.edu.eg": 1,
    "faytechcc.edu": 1,
    "fbcusl.8k.com": 1,
    "fbsc.edu.sa": 1,
    "fbu.edu.tr": 1,
    "fc.edu": 1,
    "fcetakoka-edu.net": 1,
    "fcu.edu.tw": 1,
    "fdcnet.ac.jp": 1,
    "fdltcc.edu": 1,
    "fdu.edu": 1,
    "featiu.edu.ph": 1,
    "federation.edu.au": 1,
    "fedpoffa.edu.ng": 1,
    "feituverava.com.br": 1,
    "fern-fh.de": 1,
    "fernuni-hagen.de": 1,
    "ferpi.dem.ru": 1,
    "ferris.ac.jp": 1,
    "ferris.edu": 1,
    "festu.ru": 1,
    "feu.edu.ph": 1,
    "ffhs.ch": 1,
    "fgcu.edu": 1,
    "fh-aachen.de": 1,
    "fh-aargau.ch": 1,
    "fh-aschaffenburg.de": 1,
    "fh-augsburg.de": 1,
    "fh-bad-honnef.de": 1,
    "fh-biberach.de": 1,
    "fh-bielefeld.de": 1,
    "fh-bingen.de": 1,
    "fh-bochum.de": 1,
    "fh-brandenburg.de": 1,
    "fh-burgenland.at": 1,
    "fh-dortmund.de": 1,
    "fh-eberswalde.de": 1,
    "fh-erfurt.de": 1,
    "fh-flensburg.de": 1,
    "fh-frankfurt.de": 1,
    "fh-fresenius.de": 1,
    "fh-furtwangen.de": 1,
    "fh-gelsenkirchen.de": 1,
    "fh-giessen.de": 1,
    "fh-hagenberg.at": 1,
    "fh-hamburg.de": 1,
    "fh-hannover.de": 1,
    "fh-heidelberg.de": 1,
    "fh-heilbronn.de": 1,
    "fh-hildesheim.de": 1,
    "fh-hof.de": 1,
    "fh-htachur.ch": 1,
    "fh-htwchur.ch": 1,
    "fh-hwz.ch": 1,
    "fh-isny.de": 1,
    "fh-jena.de": 1,
    "fh-joanneum.at": 1,
    "fh-kaernten.ac.at": 1,
    "fh-karlsruhe.de": 1,
    "fh-kempten.de": 1,
    "fh-kiel.de": 1,
    "fh-kl.de": 1,
    "fh-koblenz.de": 1,
    "fh-koeln.de": 1,
    "fh-konstanz.de": 1,
    "fh-krems.ac.at": 1,
    "fh-kufstein.ac.at": 1,
    "fh-landshut.de": 1,
    "fh-lausitz.de": 1,
    "fh-lippe.de": 1,
    "fh-ludwigshafen.de": 1,
    "fh-luebeck.de": 1,
    "fh-mainz.de": 1,
    "fh-mannheim.de": 1,
    "fh-merseburg.de": 1,
    "fh-muenchen.de": 1,
    "fh-muenster.de": 1,
    "fh-nb.de": 1,
    "fh-niederrhein.de": 1,
    "fh-nordhausen.de": 1,
    "fh-nuernberg.de": 1,
    "fh-nuertingen.de": 1,
    "fh-offenburg.de": 1,
    "fh-oow.de": 1,
    "fh-osnabrueck.de": 1,
    "fh-ottersberg.de": 1,
    "fh-pforzheim.de": 1,
    "fh-potsdam.de": 1,
    "fh-regensburg.de": 1,
    "fh-reutlingen.de": 1,
    "fh-riedlingen.de": 1,
    "fh-rosenheim.de": 1,
    "fh-rottenburg.de": 1,
    "fh-sbg.ac.at": 1,
    "fh-schmalkalden.de": 1,
    "fh-schwaebischhall.de": 1,
    "fh-steyr.at": 1,
    "fh-stpoelten.ac.at": 1,
    "fh-stralsund.de": 1,
    "fh-telekom-leipzig.de": 1,
    "fh-trier.de": 1,
    "fh-vie.ac.at": 1,
    "fh-wedel.de": 1,
    "fh-weihenstephan.de": 1,
    "fh-weingarten.de": 1,
    "fh-wels.at": 1,
    "fh-westkueste.de": 1,
    "fh-wiesbaden.de": 1,
    "fh-wolfenbuettel.de": 1,
    "fh-worms.de": 1,
    "fh-wuerzburg.de": 1,
    "fh-zwickau.de": 1,
    "fhbb.ch": 1,
    "fhdw.bib.de": 1,
    "fhdw.de": 1,
    "fhkt.de": 1,
    "fhm-mittelstand.de": 1,
    "fhnon.de": 1,
    "fhnw.ch": 1,
    "fhoebb.de": 1,
    "fhs-mannheim.de": 1,
    "fhs-moritzburg.de": 1,
    "fhsg.ch": 1,
    "fhso.ch": 1,
    "fhsu.edu": 1,
    "fht-stuttgart.de": 1,
    "fhtc.edu": 1,
    "fhtw-berlin.de": 1,
    "fhv.at": 1,
    "fhvr.berlin.de": 1,
    "fhw-berlin.de": 1,
    "fhw.at": 1,
    "fhwn.ac.at": 1,
    "fhwt.de": 1,
    "fic.br": 1,
    "fielding.edu": 1,
    "filine.centro.ru": 1,
    "filmacademy.hu": 1,
    "filmowka.lodz.pl": 1,
    "fimmu.edu.cn": 1,
    "findlay.edu": 1,
    "finki.ukim.mk": 1,
    "firat.edu.tr": 1,
    "firstnationsuniversity.ca": 1,
    "fish-u.ac.jp": 1,
    "fisk.edu": 1,
    "fit.ac.jp": 1,
    "fit.edu": 1,
    "fitfd.edu.pk": 1,
    "fiu.edu": 1,
    "fjau.edu.cn": 1,
    "fjmu.edu.cn": 1,
    "fjnu.edu.cn": 1,
    "fjtcm.edu.cn": 1,
    "fju.edu.tw": 1,
    "fkcc.edu": 1,
    "flc.losrios.edu": 1,
    "flcc.edu": 1,
    "fletcher.edu": 1,
    "flinders.edu.au": 1,
    "floret.edu.pa": 1,
    "floridapoly.edu": 1,
    "fmcc.edu": 1,
    "fmmu.edu.cn": 1,
    "fmu.ac.jp": 1,
    "fnu.ac.fj": 1,
    "fom.de": 1,
    "fomicgroup.cm": 1,
    "fon.edu.mk": 1,
    "fontbonne.edu": 1,
    "fontys.edu": 1,
    "foothill.edu": 1,
    "fordham.edu": 1,
    "forest.lviv.ua": 1,
    "forsythtech.edu": 1,
    "fortlewis.edu": 1,
    "fortscott.edu": 1,
    "fosu.edu.cn": 1,
    "foundationu.com": 1,
    "foundationuniversity.com": 1,
    "fountainheadcollege.edu": 1,
    "fountainuniversity.edu.ng": 1,
    "foxcollege.edu": 1,
    "fpcc.edu": 1,
    "fpctx.edu": 1,
    "fplc.edu": 1,
    "fpms.ac.be": 1,
    "fpt.edu.vn": 1,
    "fpu.ac.jp": 1,
    "franklin.edu": 1,
    "franko.lviv.ua": 1,
    "frayluca.edu.mx": 1,
    "frc.edu": 1,
    "frederick.ac.cy": 1,
    "frederick.edu": 1,
    "fredonia.edu": 1,
    "freeuni.edu.ge": 1,
    "fresno.edu": 1,
    "fresnocitycollege.edu": 1,
    "fresnostate.edu": 1,
    "fri.icfre.gov.in": 1,
    "friends.edu": 1,
    "frontrange.edu": 1,
    "frostburg.edu": 1,
    "fsagx.ac.be": 1,
    "fsc.edu": 1,
    "fscj.edu": 1,
    "fsm.ac.fj": 1,
    "fspu.edu.cn": 1,
    "fsriau.ac.ir": 1,
    "fsu.edu": 1,
    "ftacademy.ru": 1,
    "ftmsglobal.com": 1,
    "ftu.edu.vn": 1,
    "fu-berlin.de": 1,
    "fua.br": 1,
    "fuac.edu.co": 1,
    "fucam.ac.be": 1,
    "fudan.edu.cn": 1,
    "fujijoshi.ac.jp": 1,
    "fujita-hu.ac.jp": 1,
    "fukui-med.ac.jp": 1,
    "fukui-u.ac.jp": 1,
    "fukui-ut.ac.jp": 1,
    "fukuoka-edu.ac.jp": 1,
    "fukuoka-int-u.ac.jp": 1,
    "fukuoka-pu.ac.jp": 1,
    "fukuoka-u.ac.jp": 1,
    "fukushima-u.ac.jp": 1,
    "fukuyama-u.ac.jp": 1,
    "ful.ac.be": 1,
    "fullcoll.edu": 1,
    "fuller.edu": 1,
    "fullerton.edu": 1,
    "fullsail.edu": 1,
    "fums.ac.ir": 1,
    "funandi.edu.co": 1,
    "fundepos.ac.cr": 1,
    "fundp.ac.be": 1,
    "funlam.edu.co": 1,
    "fupl.asso.fr": 1,
    "fupre.edu.ng": 1,
    "furb.rct-sc.br": 1,
    "furg.br": 1,
    "furman.edu": 1,
    "fusl.ac.be": 1,
    "futa.edu.ng": 1,
    "futminna.edu.ng": 1,
    "futo.edu.ng": 1,
    "futureuniversity.edu.eg": 1,
    "futy.edu.ng": 1,
    "fuuast.edu.pk": 1,
    "fvcc.edu": 1,
    "fvtc.edu": 1,
    "fwu.ac.jp": 1,
    "fwu.edu.pk": 1,
    "fzu.edu.cn": 1,
    "g.nsu.ru": 1,
    "gac.edu": 1,
    "gachon.ac.kr": 1,
    "gadsdenstate.edu": 1,
    "gaduniv.edu.sd": 1,
    "gakusen.ac.jp": 1,
    "gakushuin.ac.jp": 1,
    "galencollege.edu": 1,
    "galilcol.ac.il": 1,
    "galileo.edu": 1,
    "gallaudet.edu": 1,
    "gallus.pl": 1,
    "gandhara.edu.pk": 1,
    "gannon.edu": 1,
    "gantep.edu.tr": 1,
    "gapps.ntust.edu.tw": 1,
    "garrettcollege.edu": 1,
    "gaston.edu": 1,
    "gasu.ru": 1,
    "gata.edu.tr": 1,
    "gatech.edu": 1,
    "gateway.kctcs.edu": 1,
    "gatewaycc.edu": 1,
    "gau.ac.ir": 1,
    "gau.edu.tr": 1,
    "gavilan.edu": 1,
    "gazi.edu.tr": 1,
    "gbc.edu": 1,
    "gbpuat.ac.in": 1,
    "gbrownc.on.ca": 1,
    "gbs-ge.ch": 1,
    "gc.edu": 1,
    "gcal.ac.uk": 1,
    "gcc.mass.edu": 1,
    "gccaz.edu": 1,
    "gcccks.edu": 1,
    "gccnj.edu": 1,
    "gcd.ie": 1,
    "gcsu.edu": 1,
    "gcu.ac.uk": 1,
    "gcu.edu": 1,
    "gcu.edu.pk": 1,
    "gcuf.edu.pk": 1,
    "gdin.edu.cn": 1,
    "gdrtvu.edu.cn": 1,
    "gdu.edu.az": 1,
    "gdufs.edu.cn": 1,
    "gdut.edu.cn": 1,
    "gedik.edu.tr": 1,
    "geidai.ac.jp": 1,
    "gelisim.edu.tr": 1,
    "gemsvilleuniversity.com": 1,
    "genesee.edu": 1,
    "geneseo.edu": 1,
    "geneva.edu": 1,
    "georgetown.edu": 1,
    "georgian.edu": 1,
    "georgiasouthern.edu": 1,
    "germanna.edu": 1,
    "gettysburg.edu": 1,
    "geziracollege.edu.sd": 1,
    "gfc.edu": 1,
    "gfcmsu.edu": 1,
    "ggc.edu": 1,
    "ggu.ac.in": 1,
    "ggu.ac.kr": 1,
    "ggu.edu": 1,
    "ghanacu.org": 1,
    "ghc.edu": 1,
    "gidatarim.edu.tr": 1,
    "gift.edu.pk": 1,
    "gifu-keizai.ac.jp": 1,
    "gifu-kyoiku.ac.jp": 1,
    "gifu-pu.ac.jp": 1,
    "gifu-u.ac.jp": 1,
    "gijodai.ac.jp": 1,
    "giki.edu.pk": 1,
    "gimcheon.ac.kr": 1,
    "gimpa.edu.gh": 1,
    "ginue.ac.kr": 1,
    "gipe.ernet.in": 1,
    "gist.ac.kr": 1,
    "gist.edu.pk": 1,
    "gitam.edu": 1,
    "gitis.net": 1,
    "giuedu.bz": 1,
    "gjcatholic.ac.kr": 1,
    "gju.edu.jo": 1,
    "gju.ernet.in": 1,
    "gjue.ac.kr": 1,
    "gkvharidwar.org": 1,
    "gla.ac.uk": 1,
    "glam.ac.uk": 1,
    "glendale.edu": 1,
    "glenoaks.cc.mi.us": 1,
    "glion.edu": 1,
    "global-business-school.org": 1,
    "global.edu.pk": 1,
    "glos.ac.uk": 1,
    "gluk.ac.ke": 1,
    "gma.ru": 1,
    "gmc.cc.ga.us": 1,
    "gmi.edu": 1,
    "gmit.ie": 1,
    "gmu.ac.ae": 1,
    "gmu.ac.ir": 1,
    "gmu.edu": 1,
    "gnduonline.org": 1,
    "gnesin-academy.ru": 1,
    "gntc.edu": 1,
    "gntech.ac.kr": 1,
    "gnu.ac.kr": 1,
    "gnue.ac.kr": 1,
    "gocolumbia.edu": 1,
    "gogebic.edu": 1,
    "gold.ac.uk": 1,
    "goldenwestcollege.edu": 1,
    "gollisuniversity.com": 1,
    "gonzaga.edu": 1,
    "gop.edu.tr": 1,
    "gorganiau.ir": 1,
    "gorny-ins.ru": 1,
    "goshen.edu": 1,
    "gotoltc.edu": 1,
    "goucher.edu": 1,
    "goums.ac.ir": 1,
    "gouni.edu.ng": 1,
    "government.ind.in": 1,
    "govst.edu": 1,
    "gpc.edu": 1,
    "gpma.ru": 1,
    "gptc.edu": 1,
    "gpwu.ac.jp": 1,
    "grace.edu": 1,
    "graceland.edu": 1,
    "grayson.edu": 1,
    "grcc.edu": 1,
    "gre.ac.uk": 1,
    "greatbay.edu": 1,
    "green.edu.bd": 1,
    "greenheartmed.org": 1,
    "greenleaf.edu": 1,
    "greenriver.edu": 1,
    "grenoble-em.com": 1,
    "grenoble-inp.fr": 1,
    "gretsauniversity.ac.ke": 1,
    "grinnell.edu": 1,
    "grossmont.edu": 1,
    "groupe-esa.com": 1,
    "groupeiscae.ma": 1,
    "grsmu.by": 1,
    "grsu.by": 1,
    "gru.edu": 1,
    "gruni.edu.ge": 1,
    "gsa.ac.uk": 1,
    "gsau.edu.cn": 1,
    "gsau.edu.ge": 1,
    "gsba.ch": 1,
    "gsnu.ac.kr": 1,
    "gstu.gomel.by": 1,
    "gsu.edu": 1,
    "gsu.edu.ng": 1,
    "gsu.edu.tr": 1,
    "gsu.unibel.by": 1,
    "gsut.edu.cn": 1,
    "gsw.edu": 1,
    "gtc.edu": 1,
    "gtcc.edu": 1,
    "gti.spb.ru": 1,
    "gtu.ac.in": 1,
    "gtu.edu.ge": 1,
    "gtu.edu.tr": 1,
    "gtuc.edu.gh": 1,
    "gturp.spb.ru": 1,
    "gu.ac.ug": 1,
    "gu.edu.af": 1,
    "gu.edu.au": 1,
    "gu.edu.lb": 1,
    "gu.edu.pk": 1,
    "gu.nic.in": 1,
    "gu.se": 1,
    "guangztc.edu.cn": 1,
    "gubkin.ru": 1,
    "guc.co.bw": 1,
    "guc.edu.eg": 1,
    "guic.edu.pk": 1,
    "guilan.ac.ir": 1,
    "guilford.edu": 1,
    "gujaratuniversity.org.in": 1,
    "gukit.ru": 1,
    "gulbargauniversity.kar.nic.in": 1,
    "gulfcoast.edu": 1,
    "gulfuniversity.net": 1,
    "gums.ac.ir": 1,
    "gumushane.edu.tr": 1,
    "gunadarma.ac.id": 1,
    "gunma-u.ac.jp": 1,
    "guptoncollege.edu": 1,
    "gurukuluniversity.org": 1,
    "gust.edu.kw": 1,
    "guu.ru": 1,
    "gvltec.edu": 1,
    "gvsu.edu": 1,
    "gwangju.ac.kr": 1,
    "gwcc.commnet.edu": 1,
    "gwinnetttech.edu": 1,
    "gwnu.ac.kr": 1,
    "gwsh.pl": 1,
    "gwu.edu": 1,
    "gxmu.edu.cn": 1,
    "gxnu.edu.cn": 1,
    "gxtcmu.edu.cn": 1,
    "gxu.edu.cn": 1,
    "gxun.edu.cn": 1,
    "gyte.edu.tr": 1,
    "gzarts.edu.cn": 1,
    "gzhtcm.edu.cn": 1,
    "gzhu.edu.cn": 1,
    "gznu.edu.cn": 1,
    "gzsums.edu.cn": 1,
    "gzu.ac.zw": 1,
    "gzu.edu.cn": 1,
    "h-brs.de": 1,
    "h-bunkyo.ac.jp": 1,
    "h-da.de": 1,
    "ha.be": 1,
    "hacc.edu": 1,
    "hacettepe.edu.tr": 1,
    "hachinohe-u.ac.jp": 1,
    "hagerstowncc.edu": 1,
    "haifa.ac.il": 1,
    "haigazian.edu.lb": 1,
    "hainnu.edu.cn": 1,
    "hainu.edu.cn": 1,
    "hajvery.edu.pk": 1,
    "hakkari.edu.tr": 1,
    "hakodate-u.ac.jp": 1,
    "hakuoh.ac.jp": 1,
    "halic.edu.tr": 1,
    "halifaxcc.edu": 1,
    "halifaxuni.ac": 1,
    "halla.ac.kr": 1,
    "hallmarkuniversity.edu": 1,
    "hallym.ac.kr": 1,
    "hama-med.ac.jp": 1,
    "hamamatsu-u.ac.jp": 1,
    "hamdard.edu": 1,
    "hamdard.edu.pk": 1,
    "hamilton.edu": 1,
    "hamline.edu": 1,
    "hampshire.edu": 1,
    "hamptonu.edu": 1,
    "hanazono.ac.jp": 1,
    "hanbat.ac.kr": 1,
    "hancockcollege.edu": 1,
    "handong.edu": 1,
    "hangkong.ac.kr": 1,
    "hanil.ac.kr": 1,
    "hanlyo.ac.kr": 1,
    "hannam.ac.kr": 1,
    "hannan-u.ac.jp": 1,
    "hanover.edu": 1,
    "hansei.ac.kr": 1,
    "hanseo.ac.kr": 1,
    "hanseuni.de": 1,
    "hanshin.ac.kr": 1,
    "hansung.ac.kr": 1,
    "hanyang.ac.kr": 1,
    "hanze.nl": 1,
    "hanzhong.ac.kr": 1,
    "haramaya.edu.et": 1,
    "harcum.edu": 1,
    "harding.edu": 1,
    "harford.edu": 1,
    "hargeisauniversity.net": 1,
    "hariricanadian.edu.lb": 1,
    "harlingen.tstc.edu": 1,
    "harpercollege.edu": 1,
    "harran.edu.tr": 1,
    "hartford.edu": 1,
    "hartnell.edu": 1,
    "hartwick.edu": 1,
    "harvard.edu": 1,
    "haskell.edu": 1,
    "hastings.edu": 1,
    "hau.edu.ph": 1,
    "hau.edu.vn": 1,
    "hau.ernet.in": 1,
    "haverford.edu": 1,
    "hawaii.edu": 1,
    "hawaii.hawaii.edu": 1,
    "hawkeyecollege.edu": 1,
    "hawlermu.org": 1,
    "haybusak.org": 1,
    "haywood.edu": 1,
    "hazard.kctcs.edu": 1,
    "hb.se": 1,
    "hbafa.com": 1,
    "hbmeu.ac.ae": 1,
    "hbu.edu.cn": 1,
    "hcc.commnet.edu": 1,
    "hcc.edu": 1,
    "hccc.edu": 1,
    "hccfl.edu": 1,
    "hccs.edu": 1,
    "hcmuaf.edu.vn": 1,
    "hcmuarc.edu.vn": 1,
    "hcmulaw.edu.vn": 1,
    "hcmuns.edu.vn": 1,
    "hcmupeda.edu.vn": 1,
    "hcmussh.edu.vn": 1,
    "hcmut.edu.vn": 1,
    "hcmute.edu.vn": 1,
    "hcmutrans.edu.vn": 1,
    "hct.ac.ae": 1,
    "hcu-hamburg.de": 1,
    "hcu.ac.th": 1,
    "hcu.edu.tw": 1,
    "hcuge.ch": 1,
    "hdk.gu.se": 1,
    "hdm-stuttgart.de": 1,
    "hdpu.edu.cn": 1,
    "heartland.edu": 1,
    "hebau.edu.cn": 1,
    "hebeiuniteduniversity.com": 1,
    "hebmu.edu.cn": 1,
    "hebnu.edu.cn": 1,
    "hebron.edu": 1,
    "hebust.edu.cn": 1,
    "hebut.edu.cn": 1,
    "hec.ac.ma": 1,
    "hec.ca": 1,
    "hec.fr": 1,
    "hei.fr": 1,
    "heidelberg.edu": 1,
    "heisei-u.ac.jp": 1,
    "help.edu.my": 1,
    "helsinki.fi": 1,
    "helwan.edu.eg": 1,
    "hem.ac.ma": 1,
    "henannu.edu.cn": 1,
    "henau.edu.cn": 1,
    "hencc.kctcs.edu": 1,
    "hendrix.edu": 1,
    "hennepintech.edu": 1,
    "henu.edu.cn": 1,
    "hep-bejune.ch": 1,
    "hepl.ch": 1,
    "hepvs.ch": 1,
    "herkimer.edu": 1,
    "hertie-school.org": 1,
    "herts.ac.uk": 1,
    "herzen.spb.ru": 1,
    "hes-so.ch": 1,
    "hesston.edu": 1,
    "heuet.edu.cn": 1,
    "heythrop.ac.uk": 1,
    "hfb.de": 1,
    "hfcc.edu": 1,
    "hfg-gmuend.de": 1,
    "hfh.ch": 1,
    "hfp.mhn.de": 1,
    "hfph.mwn.de": 1,
    "hfu.edu.tw": 1,
    "hfut.edu.cn": 1,
    "hgkz.ch": 1,
    "hgo.se": 1,
    "hgtc.edu": 1,
    "hh.se": 1,
    "hha.dk": 1,
    "hhit.edu.cn": 1,
    "hhl.de": 1,
    "hho.edu.tr": 1,
    "hhrtu.com": 1,
    "hhs.dk": 1,
    "hhs.se": 1,
    "hhstu.edu.cn": 1,
    "hhu.edu.cn": 1,
    "hhuc.edu.cn": 1,
    "hi-tech.ac.jp": 1,
    "hi.is": 1,
    "hia.no": 1,
    "hib.no": 1,
    "hiba.edu.sy": 1,
    "hibbing.edu": 1,
    "hibfs.edu.sd": 1,
    "hibo.no": 1,
    "hiete.hu": 1,
    "hifm.no": 1,
    "hig.se": 1,
    "highland.edu": 1,
    "highlandcc.edu": 1,
    "highlands.edu": 1,
    "highline.edu": 1,
    "highpoint.edu": 1,
    "hightech.edu": 1,
    "hiiraanuniversity.info": 1,
    "hijiyama-u.ac.jp": 1,
    "hik.se": 1,
    "hikmah.edu.my": 1,
    "hil.no": 1,
    "hillagric.ernet.in": 1,
    "hillcollege.edu": 1,
    "hillsdale.edu": 1,
    "hilo.hawaii.edu": 1,
    "himeji-du.ac.jp": 1,
    "himeji-tech.ac.jp": 1,
    "himh.de": 1,
    "himolde.no": 1,
    "hindscc.edu": 1,
    "hiram.edu": 1,
    "hirogaku-u.ac.jp": 1,
    "hirojo-u.ac.jp": 1,
    "hirokoku-u.ac.jp": 1,
    "hirosaki-u.ac.jp": 1,
    "hiroshima-cu.ac.jp": 1,
    "hiroshima-pu.ac.jp": 1,
    "hiroshima-u.ac.jp": 1,
    "his.se": 1,
    "hispano.edu.mx": 1,
    "hit-u.ac.jp": 1,
    "hit.ac.jp": 1,
    "hit.ac.zw": 1,
    "hit.edu.cn": 1,
    "hitecuni.edu.pk": 1,
    "hitit.edu.tr": 1,
    "hiu.ac.jp": 1,
    "hj.se": 1,
    "hjs.uni-heidelberg.de": 1,
    "hju.ac.jp": 1,
    "hkapa.edu": 1,
    "hkbu.edu.hk": 1,
    "hkg.ac.jp": 1,
    "hkkk.fi": 1,
    "hkmu.ac.tz": 1,
    "hknu.ac.kr": 1,
    "hkr.se": 1,
    "hksyc.edu": 1,
    "hku.edu.tr": 1,
    "hku.hk": 1,
    "hku.nl": 1,
    "hlaflru.edu.cn": 1,
    "hljcu.edu.cn": 1,
    "hlju.edu.cn": 1,
    "hm.edu": 1,
    "hmc.edu": 1,
    "hmu.edu.vn": 1,
    "hnaubenin.org": 1,
    "hnbgu.ac.in": 1,
    "hneu.edu.ua": 1,
    "hnfjxy.cn": 1,
    "hnluraipur.com": 1,
    "hochschule-bonn-rhein-sieg.de": 1,
    "hocking.edu": 1,
    "hoduniv.net.ye": 1,
    "hofstra.edu": 1,
    "hokkai-k-u.ac.jp": 1,
    "hokkai-s-u.ac.jp": 1,
    "hokkyodai.ac.jp": 1,
    "hoku-iryo-u.ac.jp": 1,
    "hokudai.ac.jp": 1,
    "hokuriku-u.ac.jp": 1,
    "hokusei.ac.jp": 1,
    "hokuyakudai.ac.jp": 1,
    "holar.is": 1,
    "hollins.edu": 1,
    "holmes.edu.au": 1,
    "holmescc.edu": 1,
    "holycross.edu": 1,
    "holyspirit.edu.ph": 1,
    "honam.ac.kr": 1,
    "hongik.ac.kr": 1,
    "honolulu.hawaii.edu": 1,
    "hood.edu": 1,
    "hope.ac.uk": 1,
    "hope.edu": 1,
    "hopeafricauniversity.org": 1,
    "hopkinsville.kctcs.edu": 1,
    "hopoly.edu.gh": 1,
    "hormozgan.ac.ir": 1,
    "hosei.ac.jp": 1,
    "hoseo.ac.kr": 1,
    "hoshi.ac.jp": 1,
    "hostindia.com": 1,
    "hostos.cuny.edu": 1,
    "hotelschool.com.au": 1,
    "hotelschool.nl": 1,
    "hou.edu.vn": 1,
    "howard.edu": 1,
    "howardcc.edu": 1,
    "howardcollege.edu": 1,
    "howest.be": 1,
    "howon.ac.kr": 1,
    "hpu.edu": 1,
    "hpuniv.nic.in": 1,
    "hqgc.net": 1,
    "hqu.edu.cn": 1,
    "hr.nl": 1,
    "hrbeu.edu.cn": 1,
    "hrbmu.edu.cn": 1,
    "hrbnu.edu.cn": 1,
    "hrbucea.edu.cn": 1,
    "hrbust.edu.cn": 1,
    "hro.nl": 1,
    "hs-albsig.de": 1,
    "hs-anhalt.de": 1,
    "hs-bremen.de": 1,
    "hs-bremerhaven.de": 1,
    "hs-coburg.de": 1,
    "hs-duesseldorf.de": 1,
    "hs-esslingen.de": 1,
    "hs-fulda.de": 1,
    "hs-hannover.de": 1,
    "hs-harz.de": 1,
    "hs-magdeburg.de": 1,
    "hs-neu-ulm.de": 1,
    "hs-ulm.de": 1,
    "hs-wismar.de": 1,
    "hs-zigr.de": 1,
    "hs.ac.kr": 1,
    "hsc.colorado.edu": 1,
    "hsc.edu": 1,
    "hsc.unt.edu": 1,
    "hse.ru": 1,
    "hsleiden.nl": 1,
    "hslu.ch": 1,
    "hsr.ch": 1,
    "hstu.ac.bd": 1,
    "hsu.edu.hk": 1,
    "hsum-ac.mn": 1,
    "hsvest.is": 1,
    "hti.edu.eg": 1,
    "htl-villach.at": 1,
    "htu.se": 1,
    "htus.ac.kr": 1,
    "htw-berlin.de": 1,
    "htw-dresden.de": 1,
    "htw-saarland.de": 1,
    "htwk-leipzig.de": 1,
    "htwm.de": 1,
    "hu-berlin.de": 1,
    "hu.ac.th": 1,
    "hu.edu.af": 1,
    "hu.edu.et": 1,
    "hu.edu.jo": 1,
    "hu.edu.lb": 1,
    "hu.edu.pk": 1,
    "hu.nl": 1,
    "hua.edu.vn": 1,
    "hua.gr": 1,
    "huaf.edu.vn": 1,
    "hubu.edu.cn": 1,
    "hud.ac.uk": 1,
    "hue.ac.jp": 1,
    "hueuni.edu.vn": 1,
    "huflit.vnn.vn": 1,
    "hufs.ac.kr": 1,
    "huji.ac.il": 1,
    "hull.ac.uk": 1,
    "humanities.mn": 1,
    "humber.ca": 1,
    "humbermail.ca": 1,
    "humboldt.edu": 1,
    "humg.edu.vn": 1,
    "hums.ac.ir": 1,
    "hun.edu.tr": 1,
    "hunau.net": 1,
    "hunnu.edu.cn": 1,
    "hunter.cuny.edu": 1,
    "huntingdon.edu": 1,
    "huntington.edu": 1,
    "huntingtonjuniorcollege.edu": 1,
    "hunu.edu.cn": 1,
    "hupe.hu": 1,
    "huron.ac.uk": 1,
    "huronuc.on.ca": 1,
    "hus.edu.vn": 1,
    "hust.edu.cn": 1,
    "hust.edu.vn": 1,
    "hust.edu.ye": 1,
    "hut.edu.vn": 1,
    "hut.fi": 1,
    "hutchcc.edu": 1,
    "hva.nl": 1,
    "hvanneyri.is": 1,
    "hvcc.edu": 1,
    "hvtc.edu.vn": 1,
    "hw.ac.uk": 1,
    "hwp-hamburg.de": 1,
    "hwru.edu.vn": 1,
    "hws.edu": 1,
    "hyo-med.ac.jp": 1,
    "hyogo-dai.ac.jp": 1,
    "hyogo-u.ac.jp": 1,
    "hyrcania.ac.ir": 1,
    "hytu.ac.kr": 1,
    "hyupsung.ac.kr": 1,
    "hzau.edu.cn": 1,
    "hzs.be": 1,
    "hzu.edu.cn": 1,
    "i-med.ac.at": 1,
    "i-u.de": 1,
    "i.edu.mx": 1,
    "i4p.edu.my": 1,
    "iaa.ac.tz": 1,
    "iaau.edu.kg": 1,
    "iacademy.ph": 1,
    "iact.edu.my": 1,
    "iade.pt": 1,
    "iaf.inrs.ca": 1,
    "iaim.ro": 1,
    "iap.li": 1,
    "iari.ernet.in": 1,
    "iasbs.ac.ir": 1,
    "iaseduniv.org": 1,
    "iastate.edu": 1,
    "iate.obninsk.ru": 1,
    "iau-ahar.ac.ir": 1,
    "iau-arak.ac.ir": 1,
    "iau-boukan.ac.ir": 1,
    "iau-garmsar.ac.ir": 1,
    "iau-lahijan.ac.ir": 1,
    "iau-saveh.ac.ir": 1,
    "iau-shahrood.ac.ir": 1,
    "iau-shirvan.ac.ir": 1,
    "iau-tnb.ac.ir": 1,
    "iauardabil.ac.ir": 1,
    "iauba.ac.ir": 1,
    "iaubos.ac.ir": 1,
    "iauctb.ac.ir": 1,
    "iauh.ac.ir": 1,
    "iauk.ac.ir": 1,
    "iaukb.ir": 1,
    "iaumajlesi.ac.ir": 1,
    "iaumehriz.com": 1,
    "iaun.ac.ir": 1,
    "iauq.ac.ir": 1,
    "iauro.ac.ir": 1,
    "iausdj.ac.ir": 1,
    "iaushab.ac.ir": 1,
    "iaushiraz.ac.ir": 1,
    "iausr.ac.ir": 1,
    "iaut.ac.ir": 1,
    "iautb.ac.ir": 1,
    "iautmu.ac.ir": 1,
    "iauvaramin.ac.ir": 1,
    "iauyazd.ac.ir": 1,
    "iavalley.edu": 1,
    "iba-suk.edu.pk": 1,
    "iba.edu.pk": 1,
    "ibaisuniv.edu.bd": 1,
    "ibaraki.ac.jp": 1,
    "ibbu.edu.ng": 1,
    "ibc.ac.th": 1,
    "ibc.edu": 1,
    "ibch.ru": 1,
    "iberoamericana.edu.co": 1,
    "ibi.spb.ru": 1,
    "ibnesina.edu.af": 1,
    "ibnsina.edu.sa": 1,
    "ibnuchaldun.ac.id": 1,
    "ibp-moscow.ru": 1,
    "ibs.uz": 1,
    "ibss.eu": 1,
    "ibsu.edu.ge": 1,
    "ibu.edu.ba": 1,
    "ibu.edu.tr": 1,
    "ibub.edu.cn": 1,
    "ic.ac.uk": 1,
    "icam.fr": 1,
    "icb.edu.mn": 1,
    "icc.ac.jp": 1,
    "icc.edu": 1,
    "icci.edu.ky": 1,
    "iccms.edu": 1,
    "iccu.ac.kr": 1,
    "icda.edu.do": 1,
    "iceit.edu.co": 1,
    "icesi.edu.co": 1,
    "icfai.org": 1,
    "ichec.be": 1,
    "ici-luzern.com": 1,
    "ici.edu": 1,
    "icn-nancy.com": 1,
    "icp.fr": 1,
    "ict-toulouse.asso.fr": 1,
    "ict.edu.om": 1,
    "icthm.edu.au": 1,
    "ictp.trieste.it": 1,
    "icu-edu.org": 1,
    "icu.ac.jp": 1,
    "icu.ac.kr": 1,
    "idc.ac.il": 1,
    "ie.edu": 1,
    "iecc.edu": 1,
    "ied.edu.hk": 1,
    "ieec.cust.edu.cn": 1,
    "ieeu.udm.ru": 1,
    "iep.u-bordeaux.fr": 1,
    "iese.edu.ar": 1,
    "iet.ru": 1,
    "ieu.edu.tr": 1,
    "ifdtung.if.ua": 1,
    "ifg.com.pl": 1,
    "ifm.ac.tz": 1,
    "ifmo.ru": 1,
    "ifp.fr": 1,
    "ifslearning.ac.uk": 1,
    "igau.edu.in": 1,
    "igdir.edu.tr": 1,
    "igidr.ac.in": 1,
    "igims.org": 1,
    "ignou.ac.in": 1,
    "iha.dk": 1,
    "ihi-zittau.de": 1,
    "ihk.dk": 1,
    "ihr.sas.ac.uk": 1,
    "ihu.edu.gr": 1,
    "iic.edu.my": 1,
    "iiee.edu.pk": 1,
    "iihem.ac.ma": 1,
    "iiit-bh.ac.in": 1,
    "iiita.com": 1,
    "iiitb.ac.in": 1,
    "iiitd.ac.in": 1,
    "iiitg.ac.in": 1,
    "iiitkota.ac.in": 1,
    "iiitm.ac.in": 1,
    "iiitmk.ac.in": 1,
    "iiitvadodara.ac.in": 1,
    "iimtrichy.ac.in": 1,
    "iipsindia.org": 1,
    "iisc.ernet.in": 1,
    "iit.com.na": 1,
    "iit.edu": 1,
    "iitb.ac.in": 1,
    "iitd.ernet.in": 1,
    "iitg.ac.in": 1,
    "iitg.ernet.in": 1,
    "iitgn.ac.in": 1,
    "iith.ac.in": 1,
    "iiti.ac.in": 1,
    "iitj.ac.in": 1,
    "iitk.ac.in": 1,
    "iitkgp.ernet.in": 1,
    "iitm.ac.in": 1,
    "iitp.ac.in": 1,
    "iitr.ac.in": 1,
    "iiu.edu.my": 1,
    "iiu.edu.pk": 1,
    "iiuc.ac.bd": 1,
    "iiuedu.ie": 1,
    "ikc.edu.tr": 1,
    "ikiu.ac.ir": 1,
    "iksvv.com": 1,
    "iku.edu.tr": 1,
    "ikw.ac.kr": 1,
    "ilam.ac.ir": 1,
    "iliauni.edu.ge": 1,
    "ilidelhi.org": 1,
    "ilisagvik.edu": 1,
    "ilisimatusarfik.gl": 1,
    "illinois.edu": 1,
    "illinoisstate.edu": 1,
    "ilsacollege.edu.na": 1,
    "ilstu.edu": 1,
    "imamreza.ac.ir": 1,
    "imamu.edu.sa": 1,
    "imau.edu.cn": 1,
    "imbt.ma": 1,
    "imc-krems.ac.at": 1,
    "imd.edu.gr": 1,
    "ime.eb.mil.br": 1,
    "ime.ru": 1,
    "imese.gr": 1,
    "imi-luzern.com": 1,
    "imnu.edu.cn": 1,
    "impa.br": 1,
    "imperial.ac.uk": 1,
    "imperial.edu": 1,
    "impu.edu.cn": 1,
    "imsciences.edu.pk": 1,
    "imsu.edu.ng": 1,
    "imt-atlantique.net": 1,
    "imtlucca.it": 1,
    "imtu.edu": 1,
    "imu.edu.cn": 1,
    "imu.edu.my": 1,
    "inatek.ac.rw": 1,
    "inchon-e.ac.kr": 1,
    "inchon.ac.kr": 1,
    "indiana.edu": 1,
    "indianatech.edu": 1,
    "indianatech.net": 1,
    "indianhills.edu": 1,
    "indoamerica.edu.ec": 1,
    "indonusa.ac.id": 1,
    "indstate.edu": 1,
    "indus.edu.pk": 1,
    "indusuni.ac.in": 1,
    "indwes.edu": 1,
    "indycc.edu": 1,
    "ine.edu.kh": 1,
    "info.kma.lt": 1,
    "inha.ac.kr": 1,
    "inholland.nl": 1,
    "inje.ac.kr": 1,
    "inonu.edu.tr": 1,
    "inp-fc.fr": 1,
    "inp.pt": 1,
    "inpg.fr": 1,
    "inpl-nancy.fr": 1,
    "inpt.ac.ma": 1,
    "inrs.uquebec.ca": 1,
    "insa-lyon.fr": 1,
    "insa-rennes.fr": 1,
    "insa-rouen.fr": 1,
    "insa-tlse.fr": 1,
    "inseec.fr": 1,
    "insel.ch": 1,
    "insper.edu.br": 1,
    "instedt.edu.my": 1,
    "institutoteima.ac.pa": 1,
    "int-evry.fr": 1,
    "intec.edu.do": 1,
    "integraluniversity.ac.in": 1,
    "inter.edu": 1,
    "intercollege.ac.cy": 1,
    "internacional.edu.ec": 1,
    "international.fh-aalen.de": 1,
    "internationaluniversity-schoolofmedicine.org": 1,
    "intstudy.mai.ru": 1,
    "inu.edu.jo": 1,
    "inuaf-studia.pt": 1,
    "inun.edu.ar": 1,
    "inverhills.edu": 1,
    "ioe.ac.uk": 1,
    "iona.edu": 1,
    "iota.edu.au": 1,
    "iota.u-psud.fr": 1,
    "iowacentral.edu": 1,
    "iowalakes.edu": 1,
    "ip.kyusan-u.ac.jp": 1,
    "ipa.edu.sa": 1,
    "ipb.ac.id": 1,
    "ipb.edu.my": 1,
    "ipb.pt": 1,
    "ipbeja.pt": 1,
    "ipbl.edu.my": 1,
    "ipbmm.edu.my": 1,
    "ipc.dk": 1,
    "ipc.pt": 1,
    "ipca.pt": 1,
    "ipcb.pt": 1,
    "ipda.edu.my": 1,
    "ipdbuu.com.cn": 1,
    "ipfw.edu": 1,
    "ipg.pt": 1,
    "ipgkkb.edu.my": 1,
    "ipgkrajang.edu.my": 1,
    "ipgkti.edu.my": 1,
    "ipgmkdri.edu.my": 1,
    "ipgmksm.edu.my": 1,
    "ipgmtawau.edu.my": 1,
    "ipgperlis.edu.my": 1,
    "ipiaget.org": 1,
    "ipik.edu.my": 1,
    "ipip.edu.my": 1,
    "ipislam.edu.my": 1,
    "ipkent.edu.my": 1,
    "ipks.edu.my": 1,
    "ipl.pt": 1,
    "ipleiria.pt": 1,
    "ipm.edu.mo": 1,
    "ipn.edu.mx": 1,
    "ipp.pt": 1,
    "ippm.edu.my": 1,
    "ipportalegre.pt": 1,
    "iprm.edu.my": 1,
    "ips.pt": 1,
    "ipsa.fr": 1,
    "ipsah.edu.my": 1,
    "ipsantarem.pt": 1,
    "ipsmiri.edu.my": 1,
    "ipt.pt": 1,
    "iptaa.edu.my": 1,
    "iptb.edu.my": 1,
    "ipteknik.edu.my": 1,
    "iptho.edu.my": 1,
    "iptips.edu.my": 1,
    "ipu.ac.in": 1,
    "ipu.ac.jp": 1,
    "ipu.edu.sy": 1,
    "ipvc.pt": 1,
    "iqra.edu.pk": 1,
    "iraquniversity.net": 1,
    "ireste.fr": 1,
    "irsc.edu": 1,
    "isa.fupl.asso.fr": 1,
    "isaacnewtoncr.com": 1,
    "isab.fr": 1,
    "isae.ac.rw": 1,
    "isai.pt": 1,
    "isara.fr": 1,
    "isave.edu.pt": 1,
    "isbb.pt": 1,
    "isbm-school.com": 1,
    "isbm.org.in": 1,
    "iscet.pt": 1,
    "iscte-iul.pt": 1,
    "iscte.pt": 1,
    "isctem.ac.mz": 1,
    "isea.irk.ru": 1,
    "isea.ru": 1,
    "isen.fr": 1,
    "isenshu-u.ac.jp": 1,
    "isep.fr": 1,
    "isetr.rnu.tn": 1,
    "iseu.by": 1,
    "isfort.ac.ma": 1,
    "isg.pt": 1,
    "isg.rnu.tn": 1,
    "isical.ac.in": 1,
    "isikun.edu.tr": 1,
    "isim.univ-montp2.fr": 1,
    "isla.pt": 1,
    "islahonline.org": 1,
    "islamiccolleges.com": 1,
    "islamicuniversity.nl": 1,
    "ism-dortmund.de": 1,
    "ism.lt": 1,
    "isma.indi.ru": 1,
    "ismcm-cesti.fr": 1,
    "ismdhanbad.ac.in": 1,
    "ismm.edu.cu": 1,
    "ismpo.sk": 1,
    "ismra.fr": 1,
    "isnm.de": 1,
    "isothermal.edu": 1,
    "ispa.pt": 1,
    "ispab.pt": 1,
    "ispcmw.rimed.cu": 1,
    "ispgaya.pt": 1,
    "ispu.ac.mz": 1,
    "ispu.ru": 1,
    "isra.edu.jo": 1,
    "isra.edu.pk": 1,
    "isri.ac.mz": 1,
    "iss.nl": 1,
    "ist.ac.at": 1,
    "ist.edu.pk": 1,
    "ista.ac.id": 1,
    "istanbul.edu.tr": 1,
    "iste.edu.tr": 1,
    "istec.pt": 1,
    "istp.pt": 1,
    "istu.irk.ru": 1,
    "istu.ru": 1,
    "isu.ac.ir": 1,
    "isu.edu": 1,
    "isu.edu.ph": 1,
    "isu.edu.tw": 1,
    "isu.ru": 1,
    "isuct.ru": 1,
    "isvouga.com": 1,
    "iszu.edu.tr": 1,
    "it-chiba.ac.jp": 1,
    "it-hiroshima.ac.jp": 1,
    "ita.br": 1,
    "ita.mx": 1,
    "italo.br": 1,
    "itam.mx": 1,
    "itascacc.edu": 1,
    "itats.ac.id": 1,
    "itb.ac.id": 1,
    "itb.edu.bn": 1,
    "itba.edu.ar": 1,
    "itbmu.org.mm": 1,
    "itc.mx": 1,
    "itc.nl": 1,
    "itcarlow.ie": 1,
    "itcr.ac.cr": 1,
    "itdurango.edu.mx": 1,
    "itech.fr": 1,
    "itesm.mx": 1,
    "iteso.mx": 1,
    "ithaca.edu": 1,
    "iti.is": 1,
    "iticu.edu.tr": 1,
    "itismalta.com": 1,
    "itleon.edu.mx": 1,
    "itm.edu.co": 1,
    "itmina.edu.mx": 1,
    "itmindia.edu": 1,
    "itmo.ru": 1,
    "itmorelia.edu.mx": 1,
    "itq.edu.mx": 1,
    "its.ac.id": 1,
    "itslp.edu.mx": 1,
    "itson.mx": 1,
    "itt-tech.edu": 1,
    "itt-tech.info": 1,
    "ittihad.ac.ae": 1,
    "ittralee.ie": 1,
    "ittu.edu.tm": 1,
    "itu.dk": 1,
    "itu.edu": 1,
    "itu.edu.tr": 1,
    "iu-travnik.com": 1,
    "iu.ac.bd": 1,
    "iu.ac.ke": 1,
    "iu.edu": 1,
    "iu.edu.iq": 1,
    "iu.edu.kh": 1,
    "iu.edu.sa": 1,
    "iua.edu.ar": 1,
    "iua.edu.sd": 1,
    "iuav.unive.it": 1,
    "iub.edu": 1,
    "iub.edu.bd": 1,
    "iub.edu.pk": 1,
    "iubat.edu": 1,
    "iubnt.yar.ru": 1,
    "iubs.co.uk": 1,
    "iucn.edu.my": 1,
    "iucs.uncoma.edu.ar": 1,
    "iuctt.edu.my": 1,
    "iue.edu.co": 1,
    "iue.it": 1,
    "iufs.edu": 1,
    "iug.edu.gh": 1,
    "iugaza.edu.ps": 1,
    "iugrad.edu.kn": 1,
    "iuhw.ac.jp": 1,
    "iuil.lu": 1,
    "iuiu.ac.ug": 1,
    "iuj.ac.jp": 1,
    "iuk.ac.jp": 1,
    "iuk.ac.kr": 1,
    "iuk.kg": 1,
    "iulm.it": 1,
    "ium.edu.na": 1,
    "iums.ac.ir": 1,
    "iun.ch": 1,
    "iuna.edu.ar": 1,
    "iuo.it": 1,
    "iuoart.org": 1,
    "iuokada.edu.ng": 1,
    "iup.edu": 1,
    "iupuc.edu": 1,
    "iupui.edu": 1,
    "iur.ac.in": 1,
    "ius.edu": 1,
    "ius.edu.ba": 1,
    "iusb.edu": 1,
    "iuse.edu.es": 1,
    "iusspavia.it": 1,
    "iust.ac.ir": 1,
    "iust.edu.sy": 1,
    "iut.ac.ir": 1,
    "iutoic-dhaka.edu": 1,
    "ivanovo.ac.ru": 1,
    "ivc.edu": 1,
    "ivcc.edu": 1,
    "ivri.nic.in": 1,
    "ivytech.edu": 1,
    "iwakimu.ac.jp": 1,
    "iwate-med.ac.jp": 1,
    "iwate-pu.ac.jp": 1,
    "iwate-u.ac.jp": 1,
    "iwcc.edu": 1,
    "iwp.edu": 1,
    "iyte.edu.tr": 1,
    "izmirekonomi.edu.tr": 1,
    "iztapalapa.uam.mx": 1,
    "jabu.edu.ng": 1,
    "jacksonville-college.edu": 1,
    "jacobs-university.de": 1,
    "jadara.edu.jo": 1,
    "jadavpur.edu": 1,
    "jainuniversity.org": 1,
    "jaist.ac.jp": 1,
    "jalc.edu": 1,
    "jam.edu.jo": 1,
    "jamessprunt.edu": 1,
    "jami.ac.ir": 1,
    "jamiahamdard.edu": 1,
    "jammuvarsity.org": 1,
    "janabadra.ac.id": 1,
    "janahiau.ac.ir": 1,
    "jasu.edu.kg": 1,
    "javeriana.edu.co": 1,
    "jayabaya.ac.id": 1,
    "jazanu.edu.sa": 1,
    "jbc.edu": 1,
    "jbu.edu": 1,
    "jccc.edu": 1,
    "jccmi.edu": 1,
    "jci.edu.cn": 1,
    "jcjc.edu": 1,
    "jcsu.edu": 1,
    "jct.ac.il": 1,
    "jct.edu.sa": 1,
    "jcu.cz": 1,
    "jcu.edu.au": 1,
    "jdcc.edu": 1,
    "jeffco.edu": 1,
    "jefferson.kctcs.edu": 1,
    "jeffstateonline.com": 1,
    "jeju.ac.kr": 1,
    "jejunu.ac.kr": 1,
    "jeonju.ac.kr": 1,
    "jerashun.edu.jo": 1,
    "jesus.ac.kr": 1,
    "jewell.edu": 1,
    "jfku.edu": 1,
    "jfn.ac.lk": 1,
    "jgu.edu.ly": 1,
    "jh.edu": 1,
    "jhu.edu": 1,
    "jhuapl.edu": 1,
    "jhubc.it": 1,
    "jic.edu.sa": 1,
    "jichi.ac.jp": 1,
    "jiit.ac.in": 1,
    "jikei.ac.jp": 1,
    "jinan.edu.lb": 1,
    "jinnah.edu": 1,
    "jinnah.edu.pk": 1,
    "jissen.ac.jp": 1,
    "jiu.ac.jp": 1,
    "jiwaji.edu": 1,
    "jj.ac.kr": 1,
    "jjc.edu": 1,
    "jju.edu.et": 1,
    "jkkniu.edu.bd": 1,
    "jku.at": 1,
    "jkuat.ac.ke": 1,
    "jlau.edu.cn": 1,
    "jlu.edu.cn": 1,
    "jmi.nic.in": 1,
    "jmu.edu": 1,
    "jmu.edu.cn": 1,
    "jncasr.ac.in": 1,
    "jnkvv.nic.in": 1,
    "jntu.ac.in": 1,
    "jnu.ac.bd": 1,
    "jnu.ac.in": 1,
    "jnu.ac.kr": 1,
    "jnu.edu.cn": 1,
    "jnue.ac.kr": 1,
    "jnujaipur.ac.in": 1,
    "jobu.ac.jp": 1,
    "jodhpurnationaluniversity.com": 1,
    "joensuu.fi": 1,
    "johncabot.edu": 1,
    "johnstoncc.edu": 1,
    "jones.edu": 1,
    "joongbu.ac.kr": 1,
    "jooust.ac.ke": 1,
    "josai.ac.jp": 1,
    "joshibi.ac.jp": 1,
    "jpte.hu": 1,
    "jpv.bih.nic.in": 1,
    "jrnrvu.org": 1,
    "jscc.edu": 1,
    "jsu.edu": 1,
    "jsu.edu.cn": 1,
    "jsums.edu": 1,
    "jsust.edu.cn": 1,
    "jtcc.edu": 1,
    "jtsa.edu": 1,
    "ju.ac.ae": 1,
    "ju.edu": 1,
    "ju.edu.af": 1,
    "ju.edu.et": 1,
    "ju.edu.jo": 1,
    "ju.edu.sa": 1,
    "juba.edu.sd": 1,
    "juc.edu": 1,
    "judson.edu": 1,
    "juen.ac.jp": 1,
    "jum.ru": 1,
    "jums.ac.ir": 1,
    "juniata.edu": 1,
    "juniv.edu": 1,
    "juntan.k-junshin.ac.jp": 1,
    "juntendo.ac.jp": 1,
    "jussieu.fr": 1,
    "just.edu.jo": 1,
    "jut.edu.cn": 1,
    "jutcm.com": 1,
    "juw.edu.pk": 1,
    "jvbi.ac.in": 1,
    "jwcc.edu": 1,
    "jwu.ac.jp": 1,
    "jwu.ac.kr": 1,
    "jwu.edu": 1,
    "jxau.edu.cn": 1,
    "jxnu.edu.cn": 1,
    "jxufe.edu.cn": 1,
    "jyu.edu.cn": 1,
    "jyu.fi": 1,
    "kabarak.ac.ke": 1,
    "kabianga.ac.ke": 1,
    "kaboora.edu.af": 1,
    "kabuli.edu.af": 1,
    "kafkas.edu.tr": 1,
    "kafna.ac.kr": 1,
    "kagawa-u.ac.jp": 1,
    "kagoshima-u.ac.jp": 1,
    "kai.ru": 1,
    "kaist.ac.kr": 1,
    "kaist.edu": 1,
    "kalingauniversity.com": 1,
    "kalmsu.ru": 1,
    "kamakura-u.ac.jp": 1,
    "kamalolmolk.ac.ir": 1,
    "kamgu.ru": 1,
    "kan.edu.af": 1,
    "kanagawa-it.ac.jp": 1,
    "kanagawa-u.ac.jp": 1,
    "kanazawa-bidai.ac.jp": 1,
    "kanazawa-eco.ac.jp": 1,
    "kanazawa-gu.ac.jp": 1,
    "kanazawa-it.ac.jp": 1,
    "kanazawa-med.ac.jp": 1,
    "kanazawa-u.ac.jp": 1,
    "kanchiuniv.ac.in": 1,
    "kangnam.ac.kr": 1,
    "kangnung.ac.kr": 1,
    "kangwon.ac.kr": 1,
    "kankyo-u.ac.jp": 1,
    "kannadauniversity.org": 1,
    "kannuruniversity.ac.in": 1,
    "kanpuruniversity.org": 1,
    "kansai-gaidai-u.ac.jp": 1,
    "kansai-u.ac.jp": 1,
    "kantiana.ru": 1,
    "kanto-gakuen.ac.jp": 1,
    "kanto-gakuin.ac.jp": 1,
    "kapiolani.hawaii.edu": 1,
    "kaplan.edu": 1,
    "karabuk.edu.tr": 1,
    "karaelmas.edu.tr": 1,
    "karatay.edu.tr": 1,
    "karatekin.edu.tr": 1,
    "karatinauniversity.ac.ke": 1,
    "karch.dk": 1,
    "kardan.edu.af": 1,
    "karelia.ru": 1,
    "karlshochschule.de": 1,
    "karnatakastateopenuniversity.in": 1,
    "karpagamuniv.com": 1,
    "karts.ac.kr": 1,
    "karuniversity.com": 1,
    "karunya.edu": 1,
    "karwan.edu.af": 1,
    "kasbit.edu.pk": 1,
    "kashanu.ac.ir": 1,
    "kashmiruniversity.net": 1,
    "kaskaskia.edu": 1,
    "kassalauni.edu.sd": 1,
    "kastamonu.edu.tr": 1,
    "kasuportal.net": 1,
    "kateb.edu.af": 1,
    "kath-fh-nord.de": 1,
    "kau.ac.ir": 1,
    "kau.ac.kr": 1,
    "kau.edu": 1,
    "kau.edu.sa": 1,
    "kau.kz": 1,
    "kau.se": 1,
    "kauai.hawaii.edu": 1,
    "kaums.ac.ir": 1,
    "kaust.edu.sa": 1,
    "kawasaki-m.ac.jp": 1,
    "kaya.ac.kr": 1,
    "kazanconservatory.ru": 1,
    "kazeu.kz": 1,
    "kaznpu.kz": 1,
    "kazntu.kz": 1,
    "kaznu.kz": 1,
    "kbcc.cuny.edu": 1,
    "kbocc.org": 1,
    "kbsu.ru": 1,
    "kbtu.kz": 1,
    "kbtus.ac.kr": 1,
    "kbu.ac.jp": 1,
    "kbu.ac.th": 1,
    "kbu.edu.my": 1,
    "kca.ac.ke": 1,
    "kcc.edu": 1,
    "kckcc.edu": 1,
    "kcl.ac.uk": 1,
    "kcmc.ac.tz": 1,
    "kct.ac.in": 1,
    "kct.gotevot.edu.sa": 1,
    "kctcs.edu": 1,
    "kcu.ac.kr": 1,
    "kcua.ac.jp": 1,
    "kdcnet.ac.jp": 1,
    "kdg.be": 1,
    "kdischool.ac.kr": 1,
    "kdpu.edu.ua": 1,
    "kdu.ac.kr": 1,
    "kdu.ac.lk": 1,
    "kdu.edu.my": 1,
    "kdu.md": 1,
    "kduniv.ac.kr": 1,
    "kean.edu": 1,
    "kee.hu": 1,
    "keele.ac.uk": 1,
    "keene.edu": 1,
    "keiho-u.ac.jp": 1,
    "keimyung.ac.kr": 1,
    "keio.ac.jp": 1,
    "keisen.ac.jp": 1,
    "keiseruniversity.edu": 1,
    "keiwa-c.ac.jp": 1,
    "keller.edu": 1,
    "kellogg.edu": 1,
    "kemerburgaz.edu.tr": 1,
    "kemsu.ru": 1,
    "kemu.ac.ke": 1,
    "ken.edu.af": 1,
    "kennedy.edu.ar": 1,
    "kennesaw.edu": 1,
    "kent.edu": 1,
    "kenyon.edu": 1,
    "keralauniversity.ac.in": 1,
    "kettering.edu": 1,
    "keu.edu.af": 1,
    "kfb-berlin.de": 1,
    "kfh-freiburg.de": 1,
    "kfh-mainz.de": 1,
    "kfhnw.de": 1,
    "kfs.edu.eg": 1,
    "kfsc.edu.sa": 1,
    "kfu.edu.sa": 1,
    "kfunigraz.ac.at": 1,
    "kfupm.edu.sa": 1,
    "kg.ac.rs": 1,
    "kgmu.kcn.ru": 1,
    "kgpu.ru": 1,
    "kgre.hu": 1,
    "kgtu.runnet.ru": 1,
    "kgut.ac.ir": 1,
    "kgwu.ac.jp": 1,
    "kh-berlin.de": 1,
    "khadi.kharkov.ua": 1,
    "khai.edu": 1,
    "khas.edu.tr": 1,
    "khawarizmi.com": 1,
    "khazar.org": 1,
    "khi.ac.rw": 1,
    "khi.is": 1,
    "khio.no": 1,
    "khk.be": 1,
    "khleuven.be": 1,
    "khlim.be": 1,
    "khs-linz.ac.at": 1,
    "khsa.de": 1,
    "khspu.ru": 1,
    "khstu.ru": 1,
    "khu.ac.kr": 1,
    "khuisf.ac.ir": 1,
    "ki.se": 1,
    "kias.edu.my": 1,
    "kidu-darululum.blogspot.com": 1,
    "kie.ac.rw": 1,
    "kii.gov.by": 1,
    "kiit.edu.pk": 1,
    "kilaw.edu.kw": 1,
    "kilgore.edu": 1,
    "kilian.edu": 1,
    "kilis.edu.tr": 1,
    "kimep.kz": 1,
    "kimi.kohinoor.ac.in": 1,
    "kindai.ac.jp": 1,
    "king.edu": 1,
    "kings.edu": 1,
    "kingston.ac.uk": 1,
    "kingston.edu": 1,
    "kingsu.ab.ca": 1,
    "kinjo-u.ac.jp": 1,
    "kiperak.edu.my": 1,
    "kipsas.edu.my": 1,
    "kirklareli.edu.tr": 1,
    "kirkwood.edu": 1,
    "kirovballet.com": 1,
    "kirtland.edu": 1,
    "kish.ac.ir": 1,
    "kishwaukeecollege.edu": 1,
    "kisiiuniversity.ac.ke": 1,
    "kist.ac.rw": 1,
    "kist.edu.my": 1,
    "kit.ac.jp": 1,
    "kit.edu": 1,
    "kitab.edu.my": 1,
    "kitakyu-u.ac.jp": 1,
    "kitami-it.ac.jp": 1,
    "kitasato-u.ac.jp": 1,
    "kiu.ac.jp": 1,
    "kiu.ac.kr": 1,
    "kiu.ac.ug": 1,
    "kiu.edu.pk": 1,
    "kiu.ru": 1,
    "kiui.ac.jp": 1,
    "kkot.ac.kr": 1,
    "kku.ac.th": 1,
    "kku.edu.sa": 1,
    "kku.edu.tr": 1,
    "klamathcc.edu": 1,
    "klgtu.ru": 1,
    "kliuc.edu.my": 1,
    "klmu.edu.my": 1,
    "kln.ac.lk": 1,
    "klyuniv.ac.in": 1,
    "km.isfpnu.ac.ir": 1,
    "kma.ac.kr": 1,
    "kma.mk.ua": 1,
    "kmaritime.ac.kr": 1,
    "kmbs.edu.kw": 1,
    "kmc.edu.tw": 1,
    "kmdc.edu.pk": 1,
    "kmitl.ac.th": 1,
    "kmou.ac.kr": 1,
    "kms.ac.jp": 1,
    "kmtc.ac.ke": 1,
    "kmu.ac.ir": 1,
    "kmu.ac.jp": 1,
    "kmu.ac.kr": 1,
    "kmu.edu.af": 1,
    "kmu.edu.tr": 1,
    "kmust.edu.cn": 1,
    "kmutnb.ac.th": 1,
    "kmutt.ac.th": 1,
    "knastu.ru": 1,
    "knau.kg": 1,
    "knct.ac.jp": 1,
    "kneu.kiev.ua": 1,
    "knightsbridgeuniversity.com": 1,
    "knou.ac.kr": 1,
    "knox.edu": 1,
    "knsu.ac.kr": 1,
    "kntu.ac.ir": 1,
    "knua.ac.kr": 1,
    "knuba.edu.ua": 1,
    "knue.ac.kr": 1,
    "knupe.ac.kr": 1,
    "knust.edu.gh": 1,
    "kobe-c.ac.jp": 1,
    "kobe-cufs.ac.jp": 1,
    "kobe-du.ac.jp": 1,
    "kobe-kiu.ac.jp": 1,
    "kobe-shinwa.ac.jp": 1,
    "kobe-u.ac.jp": 1,
    "kobegakuin.ac.jp": 1,
    "kobepharma-u.ac.jp": 1,
    "koc.alaska.edu": 1,
    "kochi-ms.ac.jp": 1,
    "kochi-tech.ac.jp": 1,
    "kochi-u.ac.jp": 1,
    "kochi-wu.ac.jp": 1,
    "kodolanyi.hu": 1,
    "koforiduapoly.edu.gh": 1,
    "kogakkan-u.ac.jp": 1,
    "kogakuin.ac.jp": 1,
    "koka.ac.jp": 1,
    "kokugakuin.ac.jp": 1,
    "kokushikan.ac.jp": 1,
    "kolejshahputra.edu.my": 1,
    "kolejypc.edu.my": 1,
    "kolieh.com": 1,
    "komar.edu.iq": 1,
    "komazawa-u.ac.jp": 1,
    "konan-u.ac.jp": 1,
    "konan-wu.ac.jp": 1,
    "kongju-e.ac.kr": 1,
    "kongju.ac.kr": 1,
    "konkuk.ac.kr": 1,
    "konstfack.se": 1,
    "konya.edu.tr": 1,
    "konyang.ac.kr": 1,
    "kookmin.ac.kr": 1,
    "kordofan.edu.sd": 1,
    "korea-u.ac.jp": 1,
    "korea.ac.kr": 1,
    "koreatech.ac.kr": 1,
    "koriyama-kgc.ac.jp": 1,
    "kornu.ac.kr": 1,
    "koshien.ac.jp": 1,
    "kosin.ac.kr": 1,
    "kou.edu.tr": 1,
    "koyasan-u.ac.jp": 1,
    "koyauniversity.org": 1,
    "kpc.alaska.edu": 1,
    "kpi.kharkov.ua": 1,
    "kpi.ua": 1,
    "kpoly.edu.gh": 1,
    "kptm.edu.my": 1,
    "kpu-m.ac.jp": 1,
    "kpu.ac.jp": 1,
    "kpu.ac.kr": 1,
    "krirk.ac.th": 1,
    "krishnauniversity.ac.in": 1,
    "krok.edu.ua": 1,
    "krsu.edu.kg": 1,
    "ks.ac.kr": 1,
    "ksa.edu.pk": 1,
    "ksaba.ru": 1,
    "ksau-hs.edu.sa": 1,
    "ksdsu.edu.in": 1,
    "kse.org.ua": 1,
    "ksfei.ru": 1,
    "ksfh.de": 1,
    "kshosen.ac.jp": 1,
    "ksit.edu.tw": 1,
    "kslu.ac.in": 1,
    "ksmu.kharkov.ua": 1,
    "ksmu.kursknet.ru": 1,
    "kspu.kaluga.ru": 1,
    "kspu.ptz.ru": 1,
    "kstu.edu.ru": 1,
    "kstu.kg": 1,
    "kstu.kursk.ru": 1,
    "kstu.kz": 1,
    "kstuca.kharkov.ua": 1,
    "ksu.ac.jp": 1,
    "ksu.edu": 1,
    "ksu.edu.sa": 1,
    "ksu.edu.tr": 1,
    "ksu.edu.tw": 1,
    "ksu.edu.ua": 1,
    "ksu.kst.kz": 1,
    "ksu.kz": 1,
    "ksu.ru": 1,
    "ksucta.kg": 1,
    "ksuportal.edu.ng": 1,
    "ksusta.edu.ng": 1,
    "ksw.edu.pl": 1,
    "ktd.edu.my": 1,
    "kth-linz.ac.at": 1,
    "kth.se": 1,
    "ktkt-haiduong.edu.vn": 1,
    "ktokai-u.ac.jp": 1,
    "ktu.edu.tr": 1,
    "ktu.lt": 1,
    "kture.kharkov.ua": 1,
    "ku-eichstaett.de": 1,
    "ku.ac.ae": 1,
    "ku.ac.bd": 1,
    "ku.ac.ke": 1,
    "ku.ac.th": 1,
    "ku.ac.ug": 1,
    "ku.dk": 1,
    "ku.edu": 1,
    "ku.edu.af": 1,
    "ku.edu.bh": 1,
    "ku.edu.np": 1,
    "ku.edu.sa": 1,
    "ku.edu.tr": 1,
    "ku.lt": 1,
    "ku.sk": 1,
    "kuas.edu.tw": 1,
    "kubagro.ru": 1,
    "kubrussel.ac.be": 1,
    "kubstu.ru": 1,
    "kubsu.ru": 1,
    "kud.ac.in": 1,
    "kudqi.net.my": 1,
    "kuet.ac.bd": 1,
    "kufos.ac.in": 1,
    "kufs.ac.jp": 1,
    "kug.ac.at": 1,
    "kuim.edu.my": 1,
    "kuin.edu.my": 1,
    "kuins.ac.jp": 1,
    "kuis.ac.jp": 1,
    "kuis.edu.my": 1,
    "kuk.edu.ng": 1,
    "kukinfo.com": 1,
    "kul.lublin.pl": 1,
    "kulak.ac.be": 1,
    "kuleuven.ac.be": 1,
    "kumagaku.ac.jp": 1,
    "kumamoto-u.ac.jp": 1,
    "kumaununiversity.org": 1,
    "kumc.edu": 1,
    "kumoh.ac.kr": 1,
    "kums.ac.ir": 1,
    "kumsa.net": 1,
    "kunitachi.ac.jp": 1,
    "kuniv.edu.kw": 1,
    "kunsan.ac.kr": 1,
    "kunstakademie-duesseldorf.de": 1,
    "kunstakademiet.dk": 1,
    "kure-u.ac.jp": 1,
    "kursk-uni.ru": 1,
    "kurume-it.ac.jp": 1,
    "kurume-u.ac.jp": 1,
    "kusa.ac.jp": 1,
    "kushiro-pu.ac.jp": 1,
    "kust.edu.pk": 1,
    "kustar.ac.ae": 1,
    "kustwudil.edu.ng": 1,
    "kusw.ac.jp": 1,
    "kutztown.edu": 1,
    "kuva.fi": 1,
    "kuvempu.ac.in": 1,
    "kuwarangal.com": 1,
    "kuzstu.ac.ru": 1,
    "kvcc.edu": 1,
    "kvcc.me.edu": 1,
    "kvctc.edu": 1,
    "kvl.dk": 1,
    "kw.ac.kr": 1,
    "kwandong.ac.kr": 1,
    "kwangju-e.ac.kr": 1,
    "kwangju.ac.kr": 1,
    "kwangshin.ac.kr": 1,
    "kwangwoon.ac.kr": 1,
    "kwansei.ac.jp": 1,
    "kwantlen.bc.ca": 1,
    "kwarapoly.edu.ng": 1,
    "kwararafauniversity.edu.ng": 1,
    "kwassui.ac.jp": 1,
    "kwasu.edu.ng": 1,
    "kwc-u.ac.jp": 1,
    "kwu.ac.kr": 1,
    "kwu.edu": 1,
    "kwuc.ac.jp": 1,
    "kwust.ac.ke": 1,
    "kyokyo-u.ac.jp": 1,
    "kyonggi.ac.kr": 1,
    "kyongju.ac.kr": 1,
    "kyorin-u.ac.jp": 1,
    "kyoritsu-ph.ac.jp": 1,
    "kyoritsu-wu.ac.jp": 1,
    "kyoto-art.ac.jp": 1,
    "kyoto-phu.ac.jp": 1,
    "kyoto-seika.ac.jp": 1,
    "kyoto-su.ac.jp": 1,
    "kyoto-u.ac.jp": 1,
    "kyoto-wu.ac.jp": 1,
    "kyotogakuen-u.ac.jp": 1,
    "kyu-dent.ac.jp": 1,
    "kyu.ac.ug": 1,
    "kyukyo-u.ac.jp": 1,
    "kyunghee.ac.kr": 1,
    "kyungil.ac.kr": 1,
    "kyungnam.ac.kr": 1,
    "kyungpook.ac.kr": 1,
    "kyungsung.ac.kr": 1,
    "kyungwon.ac.kr": 1,
    "kyushu-id.ac.jp": 1,
    "kyushu-ns.ac.jp": 1,
    "kyushu-u.ac.jp": 1,
    "kyutech.ac.jp": 1,
    "kzoo.edu": 1,
    "labette.edu": 1,
    "laccd.edu": 1,
    "lacitycollege.edu": 1,
    "lackawanna.edu": 1,
    "lacollege.edu": 1,
    "ladelta.edu": 1,
    "ladhs.org": 1,
    "lafayette.edu": 1,
    "lagcc.cuny.edu": 1,
    "lagh-univ.dz": 1,
    "lagrange.edu": 1,
    "lahc.edu": 1,
    "laikipia.ac.ke": 1,
    "lakeareatech.edu": 1,
    "lakeheadu.ca": 1,
    "lakeland.cc.il.us": 1,
    "lakelandcc.edu": 1,
    "lakemichigancollege.edu": 1,
    "lama.lv": 1,
    "lamar.edu": 1,
    "lamarcc.edu": 1,
    "lamarpa.edu": 1,
    "lambtoncollege.ca": 1,
    "lamission.edu": 1,
    "lamk.fi": 1,
    "lamolina.edu.pe": 1,
    "lamp.ac.uk": 1,
    "lampangvc.ac.th": 1,
    "lancs.ac.uk": 1,
    "lander.edu": 1,
    "lanecc.edu": 1,
    "laney.edu": 1,
    "langara.bc.ca": 1,
    "langara.ca": 1,
    "langston.edu": 1,
    "laniertech.edu": 1,
    "lansbridge.com": 1,
    "laredo.edu": 1,
    "lasalle.edu": 1,
    "lasalle.edu.co": 1,
    "lasalleuniversities.net": 1,
    "lasc.edu": 1,
    "lasell.edu": 1,
    "lasierra.edu": 1,
    "laspositascollege.edu": 1,
    "laspotech.net": 1,
    "lassencollege.edu": 1,
    "lasunigeria.org": 1,
    "latech.edu": 1,
    "latrobe.edu.au": 1,
    "lattc.edu": 1,
    "lau.edu.lb": 1,
    "laurea.fi": 1,
    "laurentian.ca": 1,
    "lauruscollege.edu": 1,
    "lautech.edu.ng": 1,
    "lavc.edu": 1,
    "laverne.edu": 1,
    "laverne.edu.gr": 1,
    "lawrence.edu": 1,
    "lazarski.pl": 1,
    "lbcc.edu": 1,
    "lbhc.edu": 1,
    "lboro.ac.uk": 1,
    "lbs.lon.ac.uk": 1,
    "lbu.edu.np": 1,
    "lbwcc.edu": 1,
    "lc.edu": 1,
    "lcat.ac.th": 1,
    "lcc.edu": 1,
    "lcc.lt": 1,
    "lccc.edu": 1,
    "lccc.wy.edu": 1,
    "lcct.ac.th": 1,
    "lclark.edu": 1,
    "lco.edu": 1,
    "lcsc.edu": 1,
    "lcst.ac": 1,
    "lctu.edu.cn": 1,
    "lcu.edu.ng": 1,
    "lcwu.edu.pk": 1,
    "ldceahd.org": 1,
    "ldcu.edu.ph": 1,
    "ldsbc.edu": 1,
    "le.ac.uk": 1,
    "lee.edu": 1,
    "leeds.ac.uk": 1,
    "leeward.hawaii.edu": 1,
    "lef.upn.mx": 1,
    "lefke.edu.tr": 1,
    "lehigh.edu": 1,
    "leidenuniv.nl": 1,
    "lemoyne.edu": 1,
    "lenoircc.edu": 1,
    "leon.uia.mx": 1,
    "lesley.edu": 1,
    "lesroches.edu": 1,
    "letran.edu": 1,
    "letu.edu": 1,
    "lewisu.edu": 1,
    "lfc.edu": 1,
    "lfcc.edu": 1,
    "lfze.hu": 1,
    "lgpu.lg.ua": 1,
    "lgu.ac.uk": 1,
    "lhi.is": 1,
    "lhs.se": 1,
    "lhu.edu.tw": 1,
    "lhup.edu": 1,
    "lib.klte.hu": 1,
    "liberty.edu": 1,
    "libopenuniv-edu.org": 1,
    "liccsalsl.org": 1,
    "lidapoly.com": 1,
    "limkokwing.edu.my": 1,
    "limt.co.uk": 1,
    "limu.edu.ly": 1,
    "lincoln.ac.nz": 1,
    "lincoln.ac.uk": 1,
    "lincoln.edu": 1,
    "lindenwood.edu": 1,
    "linfield.edu": 1,
    "linnbenton.edu": 1,
    "linnstate.edu": 1,
    "linton.edu.my": 1,
    "lipscomb.edu": 1,
    "lit.edu": 1,
    "littlehoop.edu": 1,
    "littlepriest.edu": 1,
    "liu.edu.lb": 1,
    "liu.se": 1,
    "liuc.it": 1,
    "liunet.edu": 1,
    "liv.ac.uk": 1,
    "lixin.edu.cn": 1,
    "ljmu.ac.uk": 1,
    "lka.edu.lv": 1,
    "lka.lt": 1,
    "lkka.lt": 1,
    "llcc.edu": 1,
    "lltc.edu": 1,
    "llu.edu": 1,
    "llu.lv": 1,
    "lma.lv": 1,
    "lmta.lt": 1,
    "lmu.ac.uk": 1,
    "lmu.de": 1,
    "lmu.edu": 1,
    "lmu.edu.ng": 1,
    "lmuza.lv": 1,
    "ln.edu.hk": 1,
    "lnipe.edu": 1,
    "lnmu.bih.nic.in": 1,
    "lnnu.edu.cn": 1,
    "lntu.edu.cn": 1,
    "lnu.edu.cn": 1,
    "lnu.edu.ua": 1,
    "lnu.evis.net.ph": 1,
    "lockhaven.edu": 1,
    "lon.ac.uk": 1,
    "londonmet.ac.uk": 1,
    "lonestar.edu": 1,
    "longwood.edu": 1,
    "lorainccc.edu": 1,
    "loras.edu": 1,
    "losmedanos.edu": 1,
    "losrios.edu": 1,
    "louisburg.edu": 1,
    "louisiana.edu": 1,
    "louisville.edu": 1,
    "lowercolumbia.edu": 1,
    "loyola.edu": 1,
    "lp.edu.ua": 1,
    "lpru.ac.th": 1,
    "lpu.edu.ph": 1,
    "lpu.in": 1,
    "lr.edu": 1,
    "lrc.edu": 1,
    "lrcc.edu": 1,
    "lrguas.ch": 1,
    "lrsc.edu": 1,
    "lsb.ie": 1,
    "lsbf.org.uk": 1,
    "lsc.edu": 1,
    "lsco.edu": 1,
    "lse.ac.uk": 1,
    "lshtm.ac.uk": 1,
    "lsmu.com": 1,
    "lspa.lanet.lv": 1,
    "lssu.edu": 1,
    "lsu-visca.edu.ph": 1,
    "lsu.ac.zw": 1,
    "lsu.edu": 1,
    "lsu.edu.az": 1,
    "lsua.edu": 1,
    "lsue.edu": 1,
    "ltc.edu.tw": 1,
    "ltcc.edu": 1,
    "ltu.bg": 1,
    "ltu.edu": 1,
    "lu.ac.ir": 1,
    "lu.lv": 1,
    "lu.se": 1,
    "luc.edu": 1,
    "lucknowuniv.org": 1,
    "luiss.it": 1,
    "lumei.edu.cn": 1,
    "lumhs.edu.pk": 1,
    "lums.ac.ir": 1,
    "lums.edu.pk": 1,
    "lumsa.it": 1,
    "luna.edu": 1,
    "lunn.sci-nnov.ru": 1,
    "lus.ac.bd": 1,
    "lut.fi": 1,
    "luth.se": 1,
    "luther.edu": 1,
    "luthersem.edu": 1,
    "luz.ve": 1,
    "luzerne.edu": 1,
    "lva.lt": 1,
    "lvc.edu": 1,
    "lycoming.edu": 1,
    "lynchburg.edu": 1,
    "lyndonstate.edu": 1,
    "lynn.edu": 1,
    "lyon.edu": 1,
    "lzmc.edu.cn": 1,
    "lzu.edu.cn": 1,
    "lzua.lt": 1,
    "ma.odessa.ua": 1,
    "maakhiruniversity.net": 1,
    "macalester.edu": 1,
    "macc.edu": 1,
    "maccormac.edu": 1,
    "macewan.ca": 1,
    "macfast.org": 1,
    "machung.ac.id": 1,
    "mackenzie.br": 1,
    "macomb.edu": 1,
    "madenatalelem.com": 1,
    "madi.ru": 1,
    "madisoncollege.edu": 1,
    "madisonville.kctcs.edu": 1,
    "madonnauniversity.edu.ng": 1,
    "magadhuniversity.org": 1,
    "mah.se": 1,
    "mahendradatta.org": 1,
    "mahidol.ac.th": 1,
    "mahsa.edu.my": 1,
    "mahshahriau.ac.ir": 1,
    "mail.xhu.edu.cn": 1,
    "maimonides.edu.ar": 1,
    "maine.edu": 1,
    "majancollege.edu.om": 1,
    "mak.ac.ug": 1,
    "mala.bc.ca": 1,
    "malayeru.ac.ir": 1,
    "malekanpnu.ac.ir": 1,
    "malone.edu": 1,
    "maltepe.edu.tr": 1,
    "mamasaniiau.ac.ir": 1,
    "man.ac.uk": 1,
    "man.radom.pl": 1,
    "manarat.ac.bd": 1,
    "manas.kg": 1,
    "manc.edu": 1,
    "manchester.ac.uk": 1,
    "mandela.ac.za": 1,
    "mandhu.com": 1,
    "mangaloreuniversity.ac.in": 1,
    "manhattan.edu": 1,
    "manhattantech.edu": 1,
    "manipal.edu": 1,
    "manipur.nic.in": 1,
    "manit.ac.in": 1,
    "manoa.hawaii.edu": 1,
    "manor.edu": 1,
    "mans.edu.eg": 1,
    "mansfield.edu": 1,
    "manuu.ac.in": 1,
    "maranatha.edu": 1,
    "marcusoldham.vic.edu.au": 1,
    "margu.mari.ru": 1,
    "marianna-u.ac.jp": 1,
    "maricopa.edu": 1,
    "marietta.edu": 1,
    "marin.edu": 1,
    "marionmilitary.edu": 1,
    "marist.edu": 1,
    "marlboro.edu": 1,
    "marmara.edu.tr": 1,
    "marquette.edu": 1,
    "marshall.edu": 1,
    "marshall.tstc.edu": 1,
    "marstu.mari.ru": 1,
    "martincc.edu": 1,
    "maryam.edu.af": 1,
    "marymount.edu": 1,
    "maryville.edu": 1,
    "marywood.edu": 1,
    "masdar.ac.ae": 1,
    "maseno.ac.ke": 1,
    "massasoit.edu": 1,
    "massasoit.mass.edu": 1,
    "massbay.edu": 1,
    "massey.ac.nz": 1,
    "masu.ru": 1,
    "matc.edu": 1,
    "matci.ac.ma": 1,
    "matnu.edu.lb": 1,
    "matsu.alaska.edu": 1,
    "matsuyama-u.ac.jp": 1,
    "mau.ac.ir": 1,
    "maua.br": 1,
    "may.ie": 1,
    "maybod.ac.ir": 1,
    "mayland.edu": 1,
    "maysville.kctcs.edu": 1,
    "mazums.ac.ir": 1,
    "mbc.edu": 1,
    "mbl.edu": 1,
    "mbs.ac.uk": 1,
    "mbstu.ac.bd": 1,
    "mbu.ac.th": 1,
    "mc.edu": 1,
    "mc3.edu": 1,
    "mcad.edu": 1,
    "mcc.commnet.edu": 1,
    "mcc.edu": 1,
    "mccc.edu": 1,
    "mccd.edu": 1,
    "mcckc.edu": 1,
    "mccneb.edu": 1,
    "mccnh.edu": 1,
    "mcdaniel.edu": 1,
    "mcdowelltech.edu": 1,
    "mcg.edu": 1,
    "mcgill.ca": 1,
    "mch.mii.lt": 1,
    "mchenry.edu": 1,
    "mci.edu": 1,
    "mclennan.edu": 1,
    "mcm.edu": 1,
    "mcmaster.ca": 1,
    "mcneese.edu": 1,
    "mcpherson.edu": 1,
    "mcst.edu.sa": 1,
    "mctc.edu": 1,
    "mcu.ac.in": 1,
    "mcu.ac.kr": 1,
    "mcu.ac.th": 1,
    "mcu.edu.ph": 1,
    "mcu.edu.tw": 1,
    "mcw.edu": 1,
    "mdh.se": 1,
    "mdis.uz": 1,
    "mdp.edu.ar": 1,
    "mdsuajmer.ac.in": 1,
    "mdu.ac.jp": 1,
    "mdu.edu.az": 1,
    "mdurohtak.com": 1,
    "mdw.ac.at": 1,
    "mdx.ac.uk": 1,
    "mecc.edu": 1,
    "mechnik.spb.ru": 1,
    "med.ic.ac.uk": 1,
    "med.sgu.ru": 1,
    "medeniyet.edu.tr": 1,
    "medilam.hbi.ir": 1,
    "medin.nsc.ru": 1,
    "medipol.edu.tr": 1,
    "mediu.edu.my": 1,
    "medsab.ac.ir": 1,
    "meduni-graz.at": 1,
    "meduniv.lviv.ua": 1,
    "meduniver.gomel.by": 1,
    "meduniversity-plovdiv.bg": 1,
    "meduniwien.at": 1,
    "mef.edu.tr": 1,
    "megatrend-edu.net": 1,
    "megatrend.edu.rs": 1,
    "mehmetakif.edu.tr": 1,
    "meiji-u.ac.jp": 1,
    "meiji.ac.jp": 1,
    "meijigakuin.ac.jp": 1,
    "meijo-u.ac.jp": 1,
    "meikai.ac.jp": 1,
    "meio-u.ac.jp": 1,
    "meisei-u.ac.jp": 1,
    "mejiro.ac.jp": 1,
    "mekong.edu.kh": 1,
    "members.rotfl.com": 1,
    "memphis.edu": 1,
    "mendelu.cz": 1,
    "mendocino.edu": 1,
    "menofia.edu.eg": 1,
    "mercer.edu": 1,
    "mercubuana.ac.id": 1,
    "mercy.edu": 1,
    "mercyhurst.edu": 1,
    "mercymavericks.edu": 1,
    "meredith.edu": 1,
    "meridiancc.edu": 1,
    "merkur-fh.org": 1,
    "merritt.edu": 1,
    "mersin.edu.tr": 1,
    "merz-akademie.de": 1,
    "mesabirange.edu": 1,
    "mesacc.edu": 1,
    "mesalands.edu": 1,
    "mesi.ru": 1,
    "messiah.edu": 1,
    "metro-hs.ac.jp": 1,
    "metro-u.ac.jp": 1,
    "metropolitan.edu.rs": 1,
    "metrostate.edu": 1,
    "metrouni.edu.bd": 1,
    "metu.edu.tr": 1,
    "meu.edu.jo": 1,
    "mfh-iserlohn.de": 1,
    "mfu.ac.th": 1,
    "mga.edu": 1,
    "mgavm.ru": 1,
    "mgccc.edu": 1,
    "mgimo.ru": 1,
    "mgkvp.ac.in": 1,
    "mgpu.gomel.by": 1,
    "mgri-rggru.ru": 1,
    "mgsu.norna.ru": 1,
    "mgsubikaner.ac.in": 1,
    "mgu.ac.in": 1,
    "mgu.ac.jp": 1,
    "mgu.bg": 1,
    "mgul.ac.ru": 1,
    "mh-hannover.de": 1,
    "mh-trossingen.de": 1,
    "mhcc.edu": 1,
    "miami.edu": 1,
    "miamioh.edu": 1,
    "middlebury.edu": 1,
    "middlesex.mass.edu": 1,
    "middlesexcc.edu": 1,
    "midlandstech.edu": 1,
    "midmich.edu": 1,
    "midsouthcc.edu": 1,
    "mie-chukyo-u.ac.jp": 1,
    "mie-u.ac.jp": 1,
    "miet.ru": 1,
    "mif.hu": 1,
    "miigaik.ru": 1,
    "miit.ru": 1,
    "miit.unikl.edu.my": 1,
    "mil.lv": 1,
    "milescc.edu": 1,
    "millersville.edu": 1,
    "milligan.edu": 1,
    "millikin.edu": 1,
    "millsaps.edu": 1,
    "mimasaka.ac.jp": 1,
    "mineralarea.edu": 1,
    "mines-ales.fr": 1,
    "mines-ales.org": 1,
    "mines.edu": 1,
    "mines.u-nancy.fr": 1,
    "minia.edu.eg": 1,
    "minneapolis.edu": 1,
    "minnesota.edu": 1,
    "minotstateu.edu": 1,
    "miom.org": 1,
    "mipt.ru": 1,
    "miracosta.edu": 1,
    "mirbis.ru": 1,
    "mirea.ru": 1,
    "miryang.ac.kr": 1,
    "misis.ru": 1,
    "missioncollege.edu": 1,
    "missouri.edu": 1,
    "missouristate.edu": 1,
    "mist.ac.bd": 1,
    "mit.edu": 1,
    "mitchellcc.edu": 1,
    "mitchelltech.edu": 1,
    "mitethiopia.edu.et": 1,
    "mitindia.edu": 1,
    "miu.ac.ir": 1,
    "miu.by": 1,
    "miu.edu.pk": 1,
    "miu.ru": 1,
    "miuegypt.edu.eg": 1,
    "miun.se": 1,
    "miyakyo-u.ac.jp": 1,
    "miyasankei-u.ac.jp": 1,
    "miyazaki-med.ac.jp": 1,
    "miyazaki-mu.ac.jp": 1,
    "miyazaki-u.ac.jp": 1,
    "mjc.edu": 1,
    "mjpru.ac.in": 1,
    "mju.ac.kr": 1,
    "mju.ac.th": 1,
    "mku.ac.ke": 1,
    "mku.edu.tr": 1,
    "mkuhyd.com": 1,
    "mkv2.mah.nic.in": 1,
    "ml.refer.org": 1,
    "mlqu.edu.ph": 1,
    "mlsu.ac.in": 1,
    "mma.ru": 1,
    "mmarau.ac.ke": 1,
    "mmibordeaux.com": 1,
    "mmm.edu": 1,
    "mmsu.edu.ph": 1,
    "mmu.ac.ke": 1,
    "mmu.ac.kr": 1,
    "mmu.ac.tz": 1,
    "mmu.ac.ug": 1,
    "mmu.ac.uk": 1,
    "mmu.edu.my": 1,
    "mmust.ac.ke": 1,
    "mnit.ac.in": 1,
    "mnma.ac.tz": 1,
    "mnnit.ac.in": 1,
    "mnstate.edu": 1,
    "mnsu.edu": 1,
    "mnu.edu.mv": 1,
    "mnwest.edu": 1,
    "modares.ac.ir": 1,
    "modern-academy.edu.eg": 1,
    "moestopo.ac.id": 1,
    "mofidu.ac.ir": 1,
    "mogadishuuniversity.com": 1,
    "mohave.edu": 1,
    "mohawkcollege.ca": 1,
    "mokpo.ac.kr": 1,
    "mokwon.ac.kr": 1,
    "molloy.edu": 1,
    "monash.edu": 1,
    "monash.edu.au": 1,
    "monash.edu.my": 1,
    "monmouth.edu": 1,
    "monmouthcollege.edu": 1,
    "monroecc.edu": 1,
    "monroeccc.edu": 1,
    "monroecollege.edu": 1,
    "montaigne.u-bordeaux.fr": 1,
    "montana.edu": 1,
    "montcalm.edu": 1,
    "montclair.edu": 1,
    "monterey.edu": 1,
    "montesquieu.u-bordeaux.fr": 1,
    "montgomery.edu": 1,
    "montgomerycollege.edu": 1,
    "montreat.edu": 1,
    "moorelanduniversity.com": 1,
    "moorparkcollege.edu": 1,
    "morainepark.edu": 1,
    "morainevalley.edu": 1,
    "moravian.edu": 1,
    "moreheadstate.edu": 1,
    "morgan.edu": 1,
    "morgancc.edu": 1,
    "morioka-u.ac.jp": 1,
    "morton.edu": 1,
    "mosconsv.ru": 1,
    "most.gov.mm": 1,
    "motolinia.com.mx": 1,
    "mouau.edu.ng": 1,
    "moultrietech.edu": 1,
    "mountsaintvincent.edu": 1,
    "moz.ac.at": 1,
    "mpbou.org": 1,
    "mpc.edu": 1,
    "mpcc.edu": 1,
    "mpei.ac.ru": 1,
    "mpkv.mah.nic.in": 1,
    "mpu-prague.cz": 1,
    "mpu.ac.jp": 1,
    "mq.edu.au": 1,
    "mrs.umn.edu": 1,
    "mrsu.ru": 1,
    "mrt.ac.lk": 1,
    "mru.ac.ug": 1,
    "mruni.eu": 1,
    "msa.ac.za": 1,
    "msa.eun.eg": 1,
    "msaab.ru": 1,
    "msbcollege.edu": 1,
    "mscc.edu": 1,
    "mscfs.edu": 1,
    "mscok.edu": 1,
    "msdelta.edu": 1,
    "mseuf.edu.ph": 1,
    "msgsu.edu.tr": 1,
    "mshdiau.ac.ir": 1,
    "msiu.ru": 1,
    "msj.edu": 1,
    "msjc.edu": 1,
    "mslu.by": 1,
    "msmary.edu": 1,
    "msmc.edu": 1,
    "msoe.edu": 1,
    "mssc.edu": 1,
    "mssm.edu": 1,
    "msstate.edu": 1,
    "mst.edu": 1,
    "msta.ac.ru": 1,
    "mstc.edu": 1,
    "mstu.edu.ru": 1,
    "mstuca.ru": 1,
    "msu.ac.th": 1,
    "msu.ac.zw": 1,
    "msu.edu": 1,
    "msu.edu.my": 1,
    "msu.edu.tr": 1,
    "msu.mogilev.by": 1,
    "msu.ru": 1,
    "msua.edu.mn": 1,
    "msuac.edu.mn": 1,
    "msubaroda.ac.in": 1,
    "msubillings.edu": 1,
    "msuc.edu.ru": 1,
    "msudenver.edu": 1,
    "msue.edu.mn": 1,
    "msuee.ru": 1,
    "msuie.ru": 1,
    "msuiit.edu.ph": 1,
    "msumain.edu.ph": 1,
    "msun.edu": 1,
    "msvu.ca": 1,
    "mta.ca": 1,
    "mta.ro": 1,
    "mtc.edu": 1,
    "mtc.edu.eg": 1,
    "mtech.edu": 1,
    "mtholyoke.edu": 1,
    "mti.edu.eg": 1,
    "mtroyal.ca": 1,
    "mtsac.edu": 1,
    "mtsu.edu": 1,
    "mtu.ac.kr": 1,
    "mtu.edu": 1,
    "mtu.edu.et": 1,
    "mtuci.ru": 1,
    "mu-luebeck.de": 1,
    "mu-pleven.bg": 1,
    "mu-sofia.bg": 1,
    "mu-varna.bg": 1,
    "mu.ac.in": 1,
    "mu.ac.ke": 1,
    "mu.ac.zm": 1,
    "mu.edu.et": 1,
    "mu.edu.sa": 1,
    "mu.edu.tr": 1,
    "mu.fapenet.org": 1,
    "mubabol.ac.ir": 1,
    "muc.edu": 1,
    "muc.edu.iq": 1,
    "muccobs.ac.tz": 1,
    "muchs.ac.tz": 1,
    "muctr.edu.ru": 1,
    "muet.edu.pk": 1,
    "muh.ru": 1,
    "mui.ac.ir": 1,
    "muic.mahidol.ac.th": 1,
    "muk.ac.ir": 1,
    "mukogawa-u.ac.jp": 1,
    "mul.edu.pk": 1,
    "mum.edu": 1,
    "mums.ac.ir": 1,
    "mundragon.edu": 1,
    "muni.cz": 1,
    "muni.es": 1,
    "muq.ac.ir": 1,
    "murdoch.edu.au": 1,
    "murni.edu.my": 1,
    "muroran-it.ac.jp": 1,
    "mursuky.edu": 1,
    "musabi.ac.jp": 1,
    "musashi-tech.ac.jp": 1,
    "musashi.ac.jp": 1,
    "musashino-music.ac.jp": 1,
    "musashino-wu.ac.jp": 1,
    "musc.edu": 1,
    "muscatcollege.edu.om": 1,
    "musicacademy.edu.az": 1,
    "musik-kons.dk": 1,
    "muskegoncc.edu": 1,
    "muskingum.edu": 1,
    "must.ac.ke": 1,
    "must.ac.ug": 1,
    "must.edu.eg": 1,
    "must.edu.mn": 1,
    "must.edu.my": 1,
    "must.edu.sy": 1,
    "mut.ac.th": 1,
    "mut.ac.za": 1,
    "mut.edu.lb": 1,
    "mutah.edu.jo": 1,
    "muthesius.de": 1,
    "muw.edu": 1,
    "mvc.edu": 1,
    "mvc.edu.ph": 1,
    "mvcc.edu": 1,
    "mvsu.edu": 1,
    "mwc.edu": 1,
    "mwcc.edu": 1,
    "mwsc.edu": 1,
    "mwsu.edu": 1,
    "mwu.edu.et": 1,
    "mxcc.commnet.edu": 1,
    "my-pharm.ac.jp": 1,
    "my.ipleiria.pt": 1,
    "mybrcc.edu": 1,
    "mylambton.ca": 1,
    "mylaurier.ca": 1,
    "mylcp.net": 1,
    "myongji.ac.kr": 1,
    "myscc.ca": 1,
    "myseneca.ca": 1,
    "myu.ac.jp": 1,
    "mzumbe.ac.tz": 1,
    "mzuni.ac.mw": 1,
    "n-fukushi.ac.jp": 1,
    "n-nov.mednet.com": 1,
    "na.edu": 1,
    "naa.edu.az": 1,
    "naba.it": 1,
    "nacc.edu": 1,
    "nagano.ac.jp": 1,
    "nagaokaut.ac.jp": 1,
    "nagarjunauniversity.ac.in": 1,
    "nagasaki-u.ac.jp": 1,
    "nagasakipu.ac.jp": 1,
    "nagauniv.org.in": 1,
    "nagoya-cu.ac.jp": 1,
    "nagoya-ku.ac.jp": 1,
    "nagoya-u.ac.jp": 1,
    "nagoya-wu.ac.jp": 1,
    "nagpur-university.com": 1,
    "nahrainuniv.edu.iq": 1,
    "nait.ca": 1,
    "najafabad-uast.ac.ir": 1,
    "najah.edu": 1,
    "nakamura-u.ac.jp": 1,
    "nalandaopenuniversity.info": 1,
    "nambu.ac.kr": 1,
    "nan.rmutl.ac.th": 1,
    "nancy.archi.fr": 1,
    "nankyudai.ac.jp": 1,
    "nanzan-u.ac.jp": 1,
    "napavalley.edu": 1,
    "napier.ac.uk": 1,
    "nara-edu.ac.jp": 1,
    "nara-su.ac.jp": 1,
    "nara-u.ac.jp": 1,
    "nara-wu.ac.jp": 1,
    "naramed-u.ac.jp": 1,
    "narauc.ac.jp": 1,
    "narotama.ac.id": 1,
    "naruto-u.ac.jp": 1,
    "nashcc.edu": 1,
    "nashuacc.edu": 1,
    "natfiz.bg": 1,
    "nation.ac.th": 1,
    "nationalmuseumindia.org": 1,
    "nau.edu": 1,
    "nau.edu.ua": 1,
    "nauss.edu.sa": 1,
    "nauu.kiev.ua": 1,
    "navarrocollege.edu": 1,
    "navy.ac.kr": 1,
    "nawrozuniversity.com": 1,
    "nayanova.edu": 1,
    "naz.edu": 1,
    "nbu.ac.in": 1,
    "nbu.ac.jp": 1,
    "nbu.bg": 1,
    "nbu.edu.cn": 1,
    "nbu.edu.sa": 1,
    "nbut.edu.cn": 1,
    "nc.edu.sd": 1,
    "nca.edu.pk": 1,
    "ncat.edu": 1,
    "ncbc.edu": 1,
    "ncc.commnet.edu": 1,
    "ncc.edu": 1,
    "nccc.edu": 1,
    "nccu.edu": 1,
    "nccu.edu.tw": 1,
    "ncepubj.edu.cn": 1,
    "ncf.edu": 1,
    "nchu.edu.tw": 1,
    "nchulc.edu.tw": 1,
    "ncirl.ie": 1,
    "ncktc.edu": 1,
    "ncl.ac.uk": 1,
    "ncmich.edu": 1,
    "ncmissouri.edu": 1,
    "ncnu.edu.tw": 1,
    "ncpes.edu.tw": 1,
    "ncstatecollege.edu": 1,
    "ncstu.ru": 1,
    "ncsu.edu": 1,
    "ncta.unl.edu": 1,
    "nctc.edu": 1,
    "nctu.edu.tw": 1,
    "ncu.edu.cn": 1,
    "ncu.edu.jm": 1,
    "ncu.edu.tw": 1,
    "ncue.edu.tw": 1,
    "ncuindia.edu": 1,
    "ncut.edu.cn": 1,
    "ncwc.edu": 1,
    "ncyu.edu.tw": 1,
    "nd.edu": 1,
    "nd.edu.au": 1,
    "nda.edu.ng": 1,
    "ndejjeuniversity.ac.ug": 1,
    "ndhu.edu.tw": 1,
    "ndmc.ac.jp": 1,
    "ndmu.edu.ph": 1,
    "ndpi.uz": 1,
    "ndri.nic.in": 1,
    "ndscs.edu": 1,
    "ndsu.ac.jp": 1,
    "ndsu.edu": 1,
    "ndu.ac.jp": 1,
    "ndu.edu": 1,
    "ndu.edu.az": 1,
    "ndu.edu.lb": 1,
    "ndu.edu.ng": 1,
    "ndu.fapenet.org": 1,
    "nduat.nic.in": 1,
    "ndus.edu": 1,
    "neau.edu.cn": 1,
    "nebuta.ac.jp": 1,
    "necc.edu": 1,
    "necc.mass.edu": 1,
    "neduet.edu.pk": 1,
    "neelain.edu.sd": 1,
    "nefu.edu.cn": 1,
    "nehu.ac.in": 1,
    "neic.nsk.su": 1,
    "neijtc.edu.cn": 1,
    "neit.edu": 1,
    "nemcc.edu": 1,
    "nenu.edu.cn": 1,
    "neo.edu": 1,
    "neosho.edu": 1,
    "nes.ru": 1,
    "netc.edu": 1,
    "netcomsa.com": 1,
    "network.rca.ac.uk": 1,
    "neu.edu": 1,
    "neu.edu.cn": 1,
    "neu.edu.ph": 1,
    "neu.edu.tr": 1,
    "neu.edu.vn": 1,
    "neub.edu.bd": 1,
    "neumann.edu": 1,
    "neuq.edu.cn": 1,
    "nevada.edu": 1,
    "nevsehir.edu.tr": 1,
    "newasia.bj.edu.cn": 1,
    "newberry.edu": 1,
    "newcastle.edu.au": 1,
    "newcollege.edu": 1,
    "neweracollege.ac.bw": 1,
    "newhaven.edu": 1,
    "newpaltz.edu": 1,
    "newport.ac.uk": 1,
    "newports.edu.pk": 1,
    "newriver.edu": 1,
    "newtonpaiva.br": 1,
    "newworld.ac": 1,
    "nfcc.edu": 1,
    "nfu.edu.tw": 1,
    "ngasu.sci-nnov.ru": 1,
    "ngha.med.sa": 1,
    "ngu.ac.in": 1,
    "ngu.ac.jp": 1,
    "nha-bg.org": 1,
    "nhc.edu": 1,
    "nhcc.edu": 1,
    "nhctc.edu.tw": 1,
    "nhh.no": 1,
    "nhltc.edu.tw": 1,
    "nhti.edu": 1,
    "nhtv.nl": 1,
    "nhu.edu.tw": 1,
    "nhv.se": 1,
    "ni.ac.rs": 1,
    "nia.edu.tw": 1,
    "niab.org.pk": 1,
    "niacc.edu": 1,
    "niagara.edu": 1,
    "niagaracc.suny.edu": 1,
    "nias.ac.jp": 1,
    "nibm.lk": 1,
    "nibs.ac.ke": 1,
    "nic.bc.ca": 1,
    "nic.edu": 1,
    "nicc.edu": 1,
    "nicholls.edu": 1,
    "nicoletcollege.edu": 1,
    "nida.ac.th": 1,
    "nifs-k.ac.jp": 1,
    "nih.no": 1,
    "nihon-u.ac.jp": 1,
    "niigata-pharm.ac.jp": 1,
    "niigata-u.ac.jp": 1,
    "niigataum.ac.jp": 1,
    "nilai.edu.my": 1,
    "nilc.spb.ru": 1,
    "nileu.edu.eg": 1,
    "nilevalley.edu.sd": 1,
    "nimhans.kar.nic.in": 1,
    "nims.ap.nic.in": 1,
    "nims.net.in": 1,
    "nipissingu.ca": 1,
    "nirmauni.ac.in": 1,
    "nisantasi.edu.tr": 1,
    "nishitech.ac.jp": 1,
    "nishogakusha-u.ac.jp": 1,
    "nisikyu-u.ac.jp": 1,
    "nit.ac.ir": 1,
    "nit.ac.jp": 1,
    "nita.ac.in": 1,
    "nitandhra.ac.in": 1,
    "nitap.in": 1,
    "nitc.ac.in": 1,
    "nitdelhi.ac.in": 1,
    "nitdgp.ac.in": 1,
    "nitech.ac.jp": 1,
    "nitgoa.ac.in": 1,
    "nith.ac.in": 1,
    "nith.no": 1,
    "nitie.edu": 1,
    "nitj.ac.in": 1,
    "nitjsr.ac.in": 1,
    "nitk.ac.in": 1,
    "nitkkr.net": 1,
    "nitm.ac.in": 1,
    "nitmanipur.ac.in": 1,
    "nitmz.ac.in": 1,
    "nitnagaland.ac.in": 1,
    "nitp.ac.in": 1,
    "nitpy.ac.in": 1,
    "nitrkl.ac.in": 1,
    "nitrr.ac.in": 1,
    "nits.ac.in": 1,
    "nitsikkim.ac.in": 1,
    "nitsri.net": 1,
    "nitt.edu": 1,
    "nittai.ac.jp": 1,
    "nituk.ac.in": 1,
    "nitw.ernet.in": 1,
    "niu.edu": 1,
    "niu.edu.tw": 1,
    "niu.org.uk": 1,
    "niuitmo.ru": 1,
    "nivadhana.ac.th": 1,
    "njau.edu.cn": 1,
    "njc.edu": 1,
    "njcu.edu": 1,
    "njfu.edu.cn": 1,
    "njim.edu.cn": 1,
    "njit.edu": 1,
    "njmu.edu.cn": 1,
    "njnu.edu.cn": 1,
    "njtu.edu.cn": 1,
    "nju.edu.cn": 1,
    "njuct.edu.cn": 1,
    "njue.edu.cn": 1,
    "njupt.edu.cn": 1,
    "njust.edu.cn": 1,
    "njutcm.edu.cn": 1,
    "njuts.cn": 1,
    "nkfu.edu.tw": 1,
    "nknu.edu.tw": 1,
    "nkrriwf.pl": 1,
    "nku.edu": 1,
    "nku.edu.tr": 1,
    "nku.nankai.edu.cn": 1,
    "nkumbauniversity.ac.ug": 1,
    "nkzu.kz": 1,
    "nl.edu": 1,
    "nla.no": 1,
    "nlc.bc.ca": 1,
    "nlh.no": 1,
    "nls.ac.in": 1,
    "nlu.edu": 1,
    "nma.bg": 1,
    "nmaa.edu.af": 1,
    "nmcc.edu": 1,
    "nmetau.edu.ua": 1,
    "nmh.no": 1,
    "nmhu.edu": 1,
    "nmims.edu": 1,
    "nmjc.edu": 1,
    "nmmi.edu": 1,
    "nmmu.ac.za": 1,
    "nms.ac.jp": 1,
    "nmsu.edu": 1,
    "nmsua.edu": 1,
    "nmt.edu": 1,
    "nmu.ac.in": 1,
    "nmu.edu": 1,
    "nmu.edu.ua": 1,
    "nmu.org.ua": 1,
    "nnc.edu": 1,
    "nntu.sci-nnov.ru": 1,
    "nny.edu.tr": 1,
    "noc.edu": 1,
    "nodai.ac.jp": 1,
    "nommensen.org": 1,
    "nooruse.ee": 1,
    "nordakademie.de": 1,
    "normandale.edu": 1,
    "northampton.ac.uk": 1,
    "northampton.edu": 1,
    "northark.edu": 1,
    "northeast.edu": 1,
    "northeastern.edu": 1,
    "northeaststate.edu": 1,
    "northern.edu": 1,
    "northgatech.edu": 1,
    "northlakecollege.edu": 1,
    "northland.edu": 1,
    "northlandcollege.edu": 1,
    "northshore.edu": 1,
    "northsouth.edu": 1,
    "northwestcollege.edu": 1,
    "northwestern.edu": 1,
    "northwesterncollege.edu": 1,
    "northwestms.edu": 1,
    "northweststate.edu": 1,
    "norton.edu.kh": 1,
    "norwich.edu": 1,
    "nosu.ru": 1,
    "notredame.ac.jp": 1,
    "nottingham.ac.uk": 1,
    "nottingham.edu.cn": 1,
    "nottingham.edu.my": 1,
    "nou.edu.ng": 1,
    "nou.edu.tw": 1,
    "nova.edu": 1,
    "novenauniversity.edu.ng": 1,
    "novsu.ac.ru": 1,
    "np.ac.rs": 1,
    "np.edu": 1,
    "npc.edu": 1,
    "npcc.edu": 1,
    "npcts.edu": 1,
    "nps.edu": 1,
    "npttc.edu.tw": 1,
    "npu.edu.ua": 1,
    "npust.edu.tw": 1,
    "nr.edu": 1,
    "nrao.edu": 1,
    "ns2.uni-ak.ac.at": 1,
    "nsa.bg": 1,
    "nsac.ns.ca": 1,
    "nsau.edu.ru": 1,
    "nsbm.lk": 1,
    "nscad.ns.ca": 1,
    "nscc.edu": 1,
    "nsit.ac.in": 1,
    "nsmc.edu.cn": 1,
    "nsmu.ru": 1,
    "nstu.edu.bd": 1,
    "nstu.ru": 1,
    "nsu.ac.jp": 1,
    "nsu.ac.kr": 1,
    "nsu.edu": 1,
    "nsu.edu.np": 1,
    "nsu.ru": 1,
    "nsuk.edu.ng": 1,
    "nsula.edu": 1,
    "nsuok.edu": 1,
    "nsysu.edu.tw": 1,
    "nt.gov.au": 1,
    "ntb.ch": 1,
    "ntc.edu": 1,
    "ntca.edu.tw": 1,
    "ntcc.edu": 1,
    "ntcmn.edu": 1,
    "ntcn.edu.tw": 1,
    "ntcpe.edu.tw": 1,
    "ntctc.edu.tw": 1,
    "nthu.edu.tw": 1,
    "ntntc.edu.tw": 1,
    "ntnu.edu.ng": 1,
    "ntnu.edu.tw": 1,
    "ntnu.no": 1,
    "ntou.edu.tw": 1,
    "ntptc.edu.tw": 1,
    "ntpu.edu.tw": 1,
    "ntruhs.ap.nic.in": 1,
    "ntti.ac.ke": 1,
    "ntttc.edu.tw": 1,
    "ntu.ac.jp": 1,
    "ntu.ac.uk": 1,
    "ntu.edu": 1,
    "ntu.edu.sg": 1,
    "ntu.edu.tw": 1,
    "ntu.kar.net": 1,
    "ntua.gr": 1,
    "ntust.edu.tw": 1,
    "ntut.edu.tw": 1,
    "nu-online.com": 1,
    "nu.ac.th": 1,
    "nu.edu": 1,
    "nu.edu.af": 1,
    "nu.edu.bd": 1,
    "nu.edu.ph": 1,
    "nu.edu.pk": 1,
    "nu.edu.sa": 1,
    "nua.ac.jp": 1,
    "nuaa.edu.cn": 1,
    "nub.ac.bd": 1,
    "nucba.ac.jp": 1,
    "nuch.ac.kr": 1,
    "nudt.edu.cn": 1,
    "nufs.nakanishi.ac.jp": 1,
    "nugaaluniversity.com": 1,
    "nui.ie": 1,
    "nuis.ac.jp": 1,
    "nuist.edu.cn": 1,
    "nuk.edu.tw": 1,
    "nul.ls": 1,
    "nulaoag.com": 1,
    "num.edu.kh": 1,
    "num.edu.mn": 1,
    "numed.ncl.ac.uk": 1,
    "numl.edu.pk": 1,
    "nunez.edu": 1,
    "nuol.edu.la": 1,
    "nur.ac.rw": 1,
    "nur.edu": 1,
    "nus.edu": 1,
    "nus.edu.sg": 1,
    "nus.edu.ws": 1,
    "nust.ac.zw": 1,
    "nust.edu.pk": 1,
    "nuu.edu.tw": 1,
    "nuu.uz": 1,
    "nuv.ac.in": 1,
    "nv.edu": 1,
    "nvau.ac.jp": 1,
    "nvcc.edu": 1,
    "nvit.bc.ca": 1,
    "nwacc.edu": 1,
    "nwau.edu.cn": 1,
    "nwcc.commnet.edu": 1,
    "nwciowa.edu": 1,
    "nwfpuet.edu.pk": 1,
    "nwfsc.edu": 1,
    "nwicc.edu": 1,
    "nwktc.edu": 1,
    "nwmissouri.edu": 1,
    "nwnu.edu.cn": 1,
    "nwpi.ru": 1,
    "nwpu.edu.cn": 1,
    "nwscc.edu": 1,
    "nwtc.edu": 1,
    "nwu.ac.za": 1,
    "nwu.edu.cn": 1,
    "nxmc.edu.cn": 1,
    "nxu.edu.cn": 1,
    "nyenrode.nl": 1,
    "nyit.edu": 1,
    "nyit.edu.bh": 1,
    "nyit.edu.jo": 1,
    "nyme.hu": 1,
    "nyu.edu": 1,
    "nyuad.nyu.edu": 1,
    "nyuniversity.net": 1,
    "o6u.edu.eg": 1,
    "oakland.edu": 1,
    "oaklandcc.edu": 1,
    "oakton.edu": 1,
    "oakwood.edu": 1,
    "oamk.fi": 1,
    "oau.edu.sd": 1,
    "oauife.edu.ng": 1,
    "oberlin.edu": 1,
    "obihiro.ac.jp": 1,
    "obirin.ac.jp": 1,
    "obonguniversity.net": 1,
    "oc.edu": 1,
    "ocad.ca": 1,
    "occc.edu": 1,
    "ocean.edu": 1,
    "ocha.ac.jp": 1,
    "octech.edu": 1,
    "odc.edu": 1,
    "odessa.edu": 1,
    "odu.edu": 1,
    "odu.edu.tr": 1,
    "oduduwauniversity.edu.ng": 1,
    "ogasa.odessa.ua": 1,
    "ogeecheetech.edu": 1,
    "ogi.edu": 1,
    "ogu.edu.tr": 1,
    "ohio.edu": 1,
    "ohkagakuen-u.ac.jp": 1,
    "ohlone.edu": 1,
    "ohsu.edu": 1,
    "ohtani-w.ac.jp": 1,
    "ohu-u.ac.jp": 1,
    "ohu.edu.tr": 1,
    "oit.ac.jp": 1,
    "oit.edu": 1,
    "oita-med.ac.jp": 1,
    "oita-nhs.ac.jp": 1,
    "oita-u.ac.jp": 1,
    "oiu.edu.sd": 1,
    "oiu.oiu.ac.jp": 1,
    "oiuw.oiu.ac.jp": 1,
    "oka-pu.ac.jp": 1,
    "okan.edu.tr": 1,
    "okanagan.bc.ca": 1,
    "okayama-u.ac.jp": 1,
    "okbu.edu": 1,
    "okcu.edu": 1,
    "okigei.ac.jp": 1,
    "okinawa-u.ac.jp": 1,
    "okiu.ac.jp": 1,
    "okstate.edu": 1,
    "olemiss.edu": 1,
    "olivet.edu": 1,
    "ollusa.edu": 1,
    "olmeca.edu.mx": 1,
    "olympia.edu.my": 1,
    "omancollege.edu.om": 1,
    "omgau.ru": 1,
    "omgtu.ru": 1,
    "omgups.ru": 1,
    "oml.pt": 1,
    "omsk-osma.ru": 1,
    "omsk.edu": 1,
    "omu.edu.ly": 1,
    "omu.edu.tr": 1,
    "ontariotechu.ca": 1,
    "ontariotechu.net": 1,
    "onu.edu": 1,
    "onu.edu.ua": 1,
    "oouagoiwoye.edu.ng": 1,
    "op.org": 1,
    "open.ac.uk": 1,
    "openpolytechnic.ac.nz": 1,
    "openu.ac.il": 1,
    "opu.odessa.ua": 1,
    "oradeauniversity.co": 1,
    "oradeauniversity.com": 1,
    "orangecoastcollege.edu": 1,
    "oregonstate.edu": 1,
    "orkhon.edu.mn": 1,
    "ort.edu.uy": 1,
    "oru.edu": 1,
    "oru.se": 1,
    "orun.ru": 1,
    "osaft.odessa.ua": 1,
    "osaka-cu.ac.jp": 1,
    "osaka-dent.ac.jp": 1,
    "osaka-gaidai.ac.jp": 1,
    "osaka-geidai.ac.jp": 1,
    "osaka-gu.ac.jp": 1,
    "osaka-kyoiku.ac.jp": 1,
    "osaka-med.ac.jp": 1,
    "osaka-sandai.ac.jp": 1,
    "osaka-shoin.ac.jp": 1,
    "osaka-u.ac.jp": 1,
    "osaka-ue.ac.jp": 1,
    "osaka-wu.ac.jp": 1,
    "osakac.ac.jp": 1,
    "osakafu-u.ac.jp": 1,
    "oshmed.com": 1,
    "osmania.ac.in": 1,
    "osmaniye.edu.tr": 1,
    "osmu.odessa.ua": 1,
    "osu.ac.jp": 1,
    "osu.cz": 1,
    "osu.edu": 1,
    "osu.ru": 1,
    "osustech.edu.ng": 1,
    "oswego.edu": 1,
    "otago.ac.nz": 1,
    "otani.ac.jp": 1,
    "otaru-uc.ac.jp": 1,
    "otc.edu": 1,
    "oteima.ac.pa": 1,
    "otemae.ac.jp": 1,
    "otemon.ac.jp": 1,
    "otsuma.ac.jp": 1,
    "otterbein.edu": 1,
    "ou.ac.lk": 1,
    "ou.dk": 1,
    "ou.edu": 1,
    "ou.edu.vn": 1,
    "ou.nl": 1,
    "ouc.ac.cy": 1,
    "ouc.edu.cn": 1,
    "ouhk.edu.hk": 1,
    "ouhs.ac.jp": 1,
    "ouk.edu.tw": 1,
    "oulu.fi": 1,
    "oum.edu.my": 1,
    "oups.ac.jp": 1,
    "ous.ac.jp": 1,
    "ous.edu.sd": 1,
    "out.ac.tz": 1,
    "ovidunivconstanta-edu.org": 1,
    "owens.edu": 1,
    "owensboro.kctcs.edu": 1,
    "owu.edu": 1,
    "ox.ac.uk": 1,
    "oxford.ac.uk": 1,
    "oxnardcollege.edu": 1,
    "oxy.edu": 1,
    "oyu.edu.az": 1,
    "ozarka.edu": 1,
    "ozarks.edu": 1,
    "ozyegin.edu.tr": 1,
    "p.lodz.pl": 1,
    "pa.edu.az": 1,
    "pac.by": 1,
    "pace.edu": 1,
    "pacific.edu": 1,
    "pacificu.edu": 1,
    "pacuc.edu.gh": 1,
    "pacuniversity.ac.ke": 1,
    "paderborn.de": 1,
    "padmavatiwomen-univ.org": 1,
    "pafkiet.edu.pk": 1,
    "paichai.ac.kr": 1,
    "paisley.ac.uk": 1,
    "pakaims.edu": 1,
    "pakaims.edu.pk": 1,
    "pakistanhomoeopathy.com": 1,
    "palermo.edu.ar": 1,
    "palmbeachstate.edu": 1,
    "palomar.edu": 1,
    "paloverde.edu": 1,
    "pam.szczecin.pl": 1,
    "pamir.edu.af": 1,
    "pamlicocc.edu": 1,
    "pamukkale.edu.tr": 1,
    "panam.edu": 1,
    "panasia.org.sg": 1,
    "pancabudi.ac.id": 1,
    "panola.edu": 1,
    "panteion.gr": 1,
    "paramadina.ac.id": 1,
    "paris.ensam.fr": 1,
    "paris4.sorbonne.fr": 1,
    "parisjc.edu": 1,
    "park.edu": 1,
    "parkland.edu": 1,
    "paruluniversity.ac.in": 1,
    "parwan.edu.af": 1,
    "pasadena.edu": 1,
    "pasim.ac.id": 1,
    "patrickhenry.edu": 1,
    "pau.ac.pg": 1,
    "pau.edu": 1,
    "pau.edu.ng": 1,
    "pauluniversity.edu.ng": 1,
    "payap.ac.th": 1,
    "pb.bialystok.pl": 1,
    "pbac.edu": 1,
    "pcc.edu": 1,
    "pccc.edu": 1,
    "pcci.edu": 1,
    "pccu.edu.tw": 1,
    "pccua.edu": 1,
    "pcdp.edu.sa": 1,
    "pcom.edu": 1,
    "pct.edu": 1,
    "pcu.ac.kr": 1,
    "pcu.edu.ph": 1,
    "pcz.czest.pl": 1,
    "pdc.edu": 1,
    "pdkv.ac.in": 1,
    "pdn.ac.lk": 1,
    "pdpu.ac.in": 1,
    "pdx.edu": 1,
    "peace.edu": 1,
    "pec.ac.in": 1,
    "pedago.pt": 1,
    "pedagogica.edu.co": 1,
    "pedu.edu.pk": 1,
    "peizheng.com.cn": 1,
    "pembroke.edu": 1,
    "pennhighlands.edu": 1,
    "pensacolastate.edu": 1,
    "pepperdine.edu": 1,
    "peralta.edu": 1,
    "perbanas.ac.id": 1,
    "perbanas.id": 1,
    "perdanauniversity.edu.my": 1,
    "perpetualdalta.edu.ph": 1,
    "peru.edu": 1,
    "pes.edu": 1,
    "petra.ac.id": 1,
    "pfh-goettingen.de": 1,
    "pfu.edu.ru": 1,
    "pg.gda.pl": 1,
    "pgcc.edu": 1,
    "pgia.ac.lk": 1,
    "pgimer.nic.in": 1,
    "pglu.ru": 1,
    "pgu.ac.ir": 1,
    "ph-erfurt.de": 1,
    "ph-freiburg.de": 1,
    "ph-gmuend.de": 1,
    "ph-gr.ch": 1,
    "ph-heidelberg.de": 1,
    "ph-karlsruhe.de": 1,
    "ph-ludwigsburg.de": 1,
    "ph-weingarten.de": 1,
    "pharmi.uz": 1,
    "phbern.ch": 1,
    "phcc.edu": 1,
    "philadelphia.edu.jo": 1,
    "philau.edu": 1,
    "phillips.edu": 1,
    "philtheol-augustin.de": 1,
    "phlu.ch": 1,
    "phoenix.edu": 1,
    "phoenixcollege.edu": 1,
    "phsc.edu": 1,
    "phsg.ch": 1,
    "phsz.ch": 1,
    "phtg.ch": 1,
    "phw.info": 1,
    "phystech.edu": 1,
    "phzg.ch": 1,
    "phzh.ch": 1,
    "pi.ac.ae": 1,
    "piau.ac.ir": 1,
    "picollege.ca": 1,
    "pics.edu.pk": 1,
    "pidc.edu.my": 1,
    "pieas.edu.pk": 1,
    "piedmontcc.edu": 1,
    "pierce.ctc.edu": 1,
    "piercecollege.edu": 1,
    "pierpont.edu": 1,
    "pima.edu": 1,
    "pimsat-khi.edu.pk": 1,
    "pine.edu.my": 1,
    "pinetech.edu": 1,
    "pio.urbe.it": 1,
    "pirireis.edu.tr": 1,
    "pit.edu": 1,
    "pitt.edu": 1,
    "pittcc.edu": 1,
    "pittstate.edu": 1,
    "pitzer.edu": 1,
    "piu.ac.ke": 1,
    "piup.edu.my": 1,
    "pjwstk.edu.pl": 1,
    "pk.edu.pl": 1,
    "pkb.edu.my": 1,
    "pkksabah.edu.my": 1,
    "pkkt.edu.my": 1,
    "pknu.ac.kr": 1,
    "pku.edu.cn": 1,
    "planwel.edu": 1,
    "platt.edu": 1,
    "plattsburgh.edu": 1,
    "plm.edu.ph": 1,
    "plu.edu": 1,
    "plymouth.ac.uk": 1,
    "plymouth.edu": 1,
    "pma.ph": 1,
    "pmbs.ac.id": 1,
    "pmm.edu.my": 1,
    "pmu.edu.sa": 1,
    "pnc.edu": 1,
    "pnj.ac.id": 1,
    "pnl.ac.id": 1,
    "pnt.edu.vn": 1,
    "pntu.edu.ua": 1,
    "pnu.ac.ir": 1,
    "pnum.ac.ir": 1,
    "pnumanila.com.ph": 1,
    "pnut.ac.ir": 1,
    "pnw.edu": 1,
    "pnzgu.ru": 1,
    "po.opole.pl": 1,
    "pointpark.edu": 1,
    "pol.lublin.pl": 1,
    "polak.edu.lv": 1,
    "polban.ac.id": 1,
    "poliba.it": 1,
    "police.ac.kr": 1,
    "poligran.edu.co": 1,
    "poligto.edu.mx": 1,
    "polijb.edu.my": 1,
    "poliku.edu.my": 1,
    "polimas.edu.my": 1,
    "polimelaka.edu.my": 1,
    "polimi.it": 1,
    "polimuadzam.edu.my": 1,
    "polines.ac.id": 1,
    "polinpdg.ac.id": 1,
    "polipd.edu.my": 1,
    "polisas.edu.my": 1,
    "politecjic.edu.co": 1,
    "polito.it": 1,
    "polito.uz": 1,
    "polk.edu": 1,
    "polnep.ac.id": 1,
    "polsl.gliwice.pl": 1,
    "poltek-malang.ac.id": 1,
    "poltekpos.ac.id": 1,
    "poltesa.ac.id": 1,
    "poly.edu": 1,
    "polyibadan.edu.ng": 1,
    "polymtl.ca": 1,
    "polytech-lille.fr": 1,
    "polytech-marseille.fr": 1,
    "polytechnic-kabul.org": 1,
    "polytechnic.edu.na": 1,
    "polytechnique.edu": 1,
    "polytechnique.fr": 1,
    "polyu.edu.hk": 1,
    "polyunwana.net": 1,
    "pomona.edu": 1,
    "pomorsu.ru": 1,
    "pondiuni.org": 1,
    "poole.ac.jp": 1,
    "pop-to.rnp.br": 1,
    "popakademie.de": 1,
    "port.ac.uk": 1,
    "portervillecollege.edu": 1,
    "postech.ac.kr": 1,
    "postech.edu": 1,
    "pote.hu": 1,
    "potsdam.edu": 1,
    "ppcc.edu": 1,
    "ppke.hu": 1,
    "ppu.edu": 1,
    "pr.ac.rs": 1,
    "praguecollege.cz": 1,
    "prairiestate.edu": 1,
    "pratt.edu": 1,
    "prattcc.edu": 1,
    "prcc.edu": 1,
    "prempeh-college.com": 1,
    "presby.edu": 1,
    "presbyuniversity.edu.gh": 1,
    "prescott.edu": 1,
    "presidency.edu.bd": 1,
    "prestonpak.edu.pk": 1,
    "princeton.edu": 1,
    "principia.edu": 1,
    "privatfh-da.de": 1,
    "privrednaakademija.edu.rs": 1,
    "providence.edu": 1,
    "prz.rzeszow.pl": 1,
    "psa.edu.my": 1,
    "psas.edu.my": 1,
    "pscabha.edu.sa": 1,
    "psfa.ru": 1,
    "psgtech.edu": 1,
    "psis.edu.my": 1,
    "psma.ru": 1,
    "psmza.edu.my": 1,
    "psp.edu.my": 1,
    "pspu.ac.ru": 1,
    "pstcc.edu": 1,
    "pstu.ac.bd": 1,
    "pstu.ac.ru": 1,
    "psu-online.edu.ph": 1,
    "psu.ac.th": 1,
    "psu.by": 1,
    "psu.edu": 1,
    "psu.edu.ph": 1,
    "psu.edu.sa": 1,
    "psu.kz": 1,
    "psu.ru": 1,
    "psut.edu.jo": 1,
    "psy.lv": 1,
    "ptc.edu": 1,
    "ptcdb.edu.ps": 1,
    "pte.hu": 1,
    "ptetjnvu.org": 1,
    "pth-bb.de": 1,
    "pth-muenster.de": 1,
    "pthv.de": 1,
    "pti.edu": 1,
    "ptit.edu.vn": 1,
    "ptpl.edu.my": 1,
    "ptsb.edu.my": 1,
    "ptss.edu.my": 1,
    "ptu.ac.in": 1,
    "ptu.ac.kr": 1,
    "ptu.ac.th": 1,
    "ptuk.edu.ps": 1,
    "ptuniv.ac.kr": 1,
    "pu-kumamoto.ac.jp": 1,
    "pu-toyama.ac.jp": 1,
    "pu.ac.ke": 1,
    "pu.edu.af": 1,
    "pu.edu.np": 1,
    "pu.edu.pk": 1,
    "pu.edu.tw": 1,
    "pu.if.ua": 1,
    "pu.kielce.pl": 1,
    "pua.edu.eg": 1,
    "pub.ac.bd": 1,
    "pub.ro": 1,
    "puc-rio.br": 1,
    "puc.ac.bd": 1,
    "puc.edu": 1,
    "puc.edu.kh": 1,
    "puccamp.br": 1,
    "puce.edu.ec": 1,
    "puchd.ac.in": 1,
    "pucit.edu.pk": 1,
    "pucminas.br": 1,
    "pucmm.edu.do": 1,
    "pucp.edu.pe": 1,
    "pucpr.br": 1,
    "pucpr.edu": 1,
    "pucrs.br": 1,
    "pucsp.br": 1,
    "puea.ac.ke": 1,
    "pueblocc.edu": 1,
    "pufs.ac.kr": 1,
    "pugc.edu.pk": 1,
    "pul.it": 1,
    "pulaskitech.edu": 1,
    "puls.edu.pl": 1,
    "punjabiuniversity.ac.in": 1,
    "puntlandstateuniversity.com": 1,
    "puo.edu.my": 1,
    "puonline.bih.nic.in": 1,
    "pup.edu.ph": 1,
    "pupr.edu": 1,
    "purbuniv.edu.np": 1,
    "purdue.edu": 1,
    "purduecal.edu": 1,
    "pusan-e.ac.kr": 1,
    "pusan.ac.kr": 1,
    "pusavarsity.org.in": 1,
    "pusc.it": 1,
    "pusku.edu.ua": 1,
    "pust.ac.bd": 1,
    "pust.net": 1,
    "pust.urbe.it": 1,
    "put.ac.ir": 1,
    "put.poznan.pl": 1,
    "puterabatam.ac.id": 1,
    "puts.ac.kr": 1,
    "puv.fi": 1,
    "pv-ma.bg": 1,
    "pvamu.edu": 1,
    "pvc.maricopa.edu": 1,
    "pvcc.edu": 1,
    "pw.edu.pl": 1,
    "pwc.ac.kr": 1,
    "pwit.ac.ir": 1,
    "pwr.wroc.pl": 1,
    "pwsc.alaska.edu": 1,
    "pwst.krakow.pl": 1,
    "pwsz.eu": 1,
    "pwsz.pila.pl": 1,
    "pwu.com": 1,
    "pwu.edu": 1,
    "pz.zgora.pl": 1,
    "pzhu.edu.cn": 1,
    "qadissuni.edu.iq": 1,
    "qatar.northwestern.edu": 1,
    "qau.edu.pk": 1,
    "qc.edu.sa": 1,
    "qcc.cuny.edu": 1,
    "qcc.edu": 1,
    "qdnet.pl": 1,
    "qdpi.uz": 1,
    "qdu.edu.cn": 1,
    "qfnu.edu.cn": 1,
    "qhnu.edu.cn": 1,
    "qhrtvu.edu.cn": 1,
    "qhu.edu.cn": 1,
    "qiau.ac.ir": 1,
    "qmul.ac.uk": 1,
    "qmw.ac.uk": 1,
    "qom-iau.ac.ir": 1,
    "qom.ac.ir": 1,
    "qou.edu": 1,
    "qu.edu.az": 1,
    "qu.edu.qa": 1,
    "qu.edu.sa": 1,
    "qub.ac.uk": 1,
    "queensu.ca": 1,
    "queensuniversity.edu.bd": 1,
    "questu.ca": 1,
    "quincy.edu": 1,
    "quincycollege.edu": 1,
    "quinnipiac.edu": 1,
    "qums.ac.ir": 1,
    "quran-unv.edu.sd": 1,
    "qurtuba.edu.pk": 1,
    "qust.edu.cn": 1,
    "qut.ac.ir": 1,
    "qut.edu.au": 1,
    "qvcc.edu": 1,
    "qzu.edu.cn": 1,
    "rabindrabharatiuniversity.net": 1,
    "racc.edu": 1,
    "radford.edu": 1,
    "raffles-university.edu.my": 1,
    "raghebisf.ac.ir": 1,
    "rah.ru": 1,
    "rakmhsu.com": 1,
    "rakuno.ac.jp": 1,
    "ram.ac.uk": 1,
    "ramapo.edu": 1,
    "ramk.fi": 1,
    "ranchiuniversity.org.in": 1,
    "randolph.edu": 1,
    "rangercollege.edu": 1,
    "rappahannock.edu": 1,
    "raritanval.edu": 1,
    "rau.am": 1,
    "rau.lv": 1,
    "rau.ro": 1,
    "raubikaner.org": 1,
    "rauheshaus.de": 1,
    "razi.ac.ir": 1,
    "rbc.edu": 1,
    "rbni.technion.ac.il": 1,
    "rca.ac.uk": 1,
    "rcc.edu": 1,
    "rcc.mass.edu": 1,
    "rccc.edu": 1,
    "rccd.edu": 1,
    "rcm.ac.uk": 1,
    "rcm.upr.edu": 1,
    "rcpi.ie": 1,
    "rcsi-mub.com": 1,
    "rcsi.ie": 1,
    "rct.edu.sa": 1,
    "rctc.edu": 1,
    "rcu.ac.zw": 1,
    "rdg.ac.uk": 1,
    "rdunijbpin.org": 1,
    "rea.ru": 1,
    "rectorat-uh2c.ac.ma": 1,
    "redcross.ac.jp": 1,
    "redeemer.ca": 1,
    "redlandscc.edu": 1,
    "reduaeh.mx": 1,
    "reduaz.mx": 1,
    "reduc.edu.cu": 1,
    "redwoods.edu": 1,
    "reed.edu": 1,
    "reedleycollege.edu": 1,
    "regent-college.edu": 1,
    "regent.edu": 1,
    "regentghana.net": 1,
    "regis.edu": 1,
    "reitaku-u.ac.jp": 1,
    "reynolds.edu": 1,
    "rfh-koeln.de": 1,
    "rfhsm.ac.uk": 1,
    "rgata.yaroslavl.ru": 1,
    "rgtu.net": 1,
    "rgu.ac.in": 1,
    "rgu.ac.uk": 1,
    "rh.ac.uk": 1,
    "rhbnc.ac.uk": 1,
    "rhodes.edu": 1,
    "rhodesstate.edu": 1,
    "riarauniversity.ac.ke": 1,
    "riau.ac.ir": 1,
    "ribat.edu.sd": 1,
    "ric.edu": 1,
    "rice.edu": 1,
    "richland.edu": 1,
    "richlandcollege.edu": 1,
    "richmond.ac.uk": 1,
    "richmondcc.edu": 1,
    "rider.edu": 1,
    "ridgewater.edu": 1,
    "rihs.edu.af": 1,
    "rikkyo.ac.jp": 1,
    "rio.maricopa.edu": 1,
    "riohondo.edu": 1,
    "riphah.edu.pk": 1,
    "ripon.edu": 1,
    "ris.ac.jp": 1,
    "rit.edu": 1,
    "riths.ac.in": 1,
    "ritsumei.ac.jp": 1,
    "riv.edu": 1,
    "riverland.edu": 1,
    "rivervalley.edu": 1,
    "riviera.fr": 1,
    "riyadh.edu.sa": 1,
    "rjt.ac.lk": 1,
    "rku.ac.jp": 1,
    "rlc.edu": 1,
    "rma.ac.be": 1,
    "rmc.ca": 1,
    "rmc.edu": 1,
    "rmcc.edu": 1,
    "rmit.edu.au": 1,
    "rmit.edu.vn": 1,
    "rmlau.ac.in": 1,
    "rmu.edu": 1,
    "rmutp.ac.th": 1,
    "rmwc.edu": 1,
    "rnu.edu.ng": 1,
    "roac.nl": 1,
    "roanestate.edu": 1,
    "roanoke.edu": 1,
    "roanokechowan.edu": 1,
    "robertmorris.edu": 1,
    "robeson.edu": 1,
    "rochester.edu": 1,
    "rockefeller.edu": 1,
    "rockford.edu": 1,
    "rockhurst.edu": 1,
    "rockinghamcc.edu": 1,
    "rockvalleycollege.edu": 1,
    "rocky.edu": 1,
    "roehampton.ac.uk": 1,
    "roguecc.edu": 1,
    "rollins.edu": 1,
    "roosevelt.edu": 1,
    "rosary.edu": 1,
    "rose-hulman.edu": 1,
    "rose.edu": 1,
    "rossu.edu": 1,
    "roswell.enmu.edu": 1,
    "rowan.edu": 1,
    "royalholloway.ac.uk": 1,
    "royalroads.ca": 1,
    "rpcc.edu": 1,
    "rpi.edu": 1,
    "rpiva.lv": 1,
    "rrcc.edu": 1,
    "rrcc.mnscu.edu": 1,
    "rshu.ru": 1,
    "rsm.nl": 1,
    "rsmu.da.ru": 1,
    "rsmu.ru": 1,
    "rsu.ac.th": 1,
    "rsu.edu": 1,
    "rsu.edu.sd": 1,
    "rsu.ru": 1,
    "rsuh.ru": 1,
    "rsuniversity.com": 1,
    "rsute.ru": 1,
    "rtc.edu": 1,
    "rtu.ac.in": 1,
    "rtu.edu.ph": 1,
    "rtu.lv": 1,
    "ru.ac.bd": 1,
    "ru.ac.th": 1,
    "ru.ac.za": 1,
    "ru.acad.bg": 1,
    "ru.is": 1,
    "ru.lv": 1,
    "ru.nl": 1,
    "rua.edu.kh": 1,
    "rub.edu.bt": 1,
    "ruc.dk": 1,
    "ruc.edu.cn": 1,
    "ruet.ac.bd": 1,
    "rufa.edu.kh": 1,
    "rug.ac.be": 1,
    "rug.edu.sa": 1,
    "rug.nl": 1,
    "ruh.ac.lk": 1,
    "ruhr-uni-bochum.de": 1,
    "rule.edu.kh": 1,
    "rumeli.edu.tr": 1,
    "rumi.ac.ma": 1,
    "rums.ac.ir": 1,
    "run.edu.ng": 1,
    "rupp.edu.kh": 1,
    "ruraluniversity-chitrakoot.org": 1,
    "rusangu-university.edu.zm": 1,
    "rusoil.net": 1,
    "rutgers.edu": 1,
    "rwth-aachen.de": 1,
    "rwu.edu": 1,
    "ryerson.ca": 1,
    "ryukoku.ac.jp": 1,
    "saadcollege.com": 1,
    "sab.ac.lk": 1,
    "saba.edu.ge": 1,
    "sabanciuniv.edu": 1,
    "sabanciuniv.edu.tr": 1,
    "sabauni.net": 1,
    "sabi.eu.com": 1,
    "sac.edu": 1,
    "sacramento.mticollege.edu": 1,
    "sacredheart.edu": 1,
    "sacrocuore.org": 1,
    "sadat.edu.af": 1,
    "sadatacademy.edu.eg": 1,
    "saddleback.edu": 1,
    "sadjad.ac.ir": 1,
    "sadra.ac.ir": 1,
    "saga-med.ac.jp": 1,
    "saga-u.ac.jp": 1,
    "sagami-wu.ac.jp": 1,
    "sagaruniversity.nic.in": 1,
    "sagchip.edu": 1,
    "sage.edu": 1,
    "sagrado.edu": 1,
    "sagu.edu": 1,
    "saic.edu": 1,
    "saintjoe.edu": 1,
    "saintleo.edu": 1,
    "saintmarys.edu": 1,
    "saintpaul.edu": 1,
    "sait.ca": 1,
    "saitama-med.ac.jp": 1,
    "saitama-u.ac.jp": 1,
    "saitm.edu.lk": 1,
    "saito.edu.my": 1,
    "saiu.ac.ug": 1,
    "sakhgu.sakhalin.ru": 1,
    "sakushin-u.ac.jp": 1,
    "salam.edu.af": 1,
    "salemcc.edu": 1,
    "salemuniversity.edu.ng": 1,
    "salford.ac.uk": 1,
    "salisbury.edu": 1,
    "salleurl.edu": 1,
    "salu.edu.pk": 1,
    "salvador.edu.ar": 1,
    "sambalpuruniversitypgc.in": 1,
    "samchok.ac.kr": 1,
    "samdu.uz": 1,
    "samford.edu": 1,
    "samiit.ru": 1,
    "samk.fi": 1,
    "sampsoncc.edu": 1,
    "samsmu.ru": 1,
    "sanaaguniversity.com": 1,
    "sanbeda.edu.ph": 1,
    "sandau.edu.cn": 1,
    "sandburg.edu": 1,
    "sandhills.edu": 1,
    "sandiego.edu": 1,
    "sangha.ac.kr": 1,
    "sangji.ac.kr": 1,
    "sangmyung.ac.kr": 1,
    "sangu.ge": 1,
    "sanjuanbautista.edu": 1,
    "sanjuancollege.edu": 1,
    "sanko.edu.tr": 1,
    "sanmartin.edu.co": 1,
    "sanno.ac.jp": 1,
    "sans.edu": 1,
    "sanskrit.nic.in": 1,
    "santarosa.edu": 1,
    "sanxiau.edu.cn": 1,
    "saojudas.br": 1,
    "sapanet.ru": 1,
    "sapc.edu": 1,
    "sapmed.ac.jp": 1,
    "sapporo-u.ac.jp": 1,
    "sarjanawiyata.ac.id": 1,
    "sas-sd.net": 1,
    "sas.ac.uk": 1,
    "saskweb.com": 1,
    "sastra.edu": 1,
    "sathyabamauniv.ac.in": 1,
    "sau.ac.bd": 1,
    "sau.ac.th": 1,
    "sau.edu": 1,
    "sau.edu.pk": 1,
    "sau.edu.tr": 1,
    "sau.sumy.ua": 1,
    "sauder.ubc.ca": 1,
    "saurashtrauniversity.edu": 1,
    "saut.ac.tz": 1,
    "sautech.edu": 1,
    "savannahtech.edu": 1,
    "saxion.edu": 1,
    "sbc.edu": 1,
    "sbcc.edu": 1,
    "sbg.ac.at": 1,
    "sbmu.ac.ir": 1,
    "sbs.edu": 1,
    "sbs.edu.cn": 1,
    "sbu.ac.ir": 1,
    "sbu.ac.uk": 1,
    "sbu.edu": 1,
    "sbu.edu.tr": 1,
    "sbuniv.edu": 1,
    "sc.edu": 1,
    "sc4.edu": 1,
    "scad.edu": 1,
    "scar.utoronto.ca": 1,
    "scau.edu.cn": 1,
    "scbaghdad.edu.iq": 1,
    "scc.edu.tw": 1,
    "scc.losrios.edu": 1,
    "scc.spokane.edu": 1,
    "sccc.edu": 1,
    "scciowa.edu": 1,
    "sccnc.edu": 1,
    "sccollege.edu": 1,
    "sccsc.edu": 1,
    "sccu.edu.cn": 1,
    "sce.ac.il": 1,
    "sce.ac.in": 1,
    "sch.ac.kr": 1,
    "schillerlondon.ac.uk": 1,
    "schillermadrid.edu": 1,
    "schillerparis.com": 1,
    "schillerstrasbourg.com": 1,
    "schoolcraft.edu": 1,
    "sciences-po.fr": 1,
    "sckans.edu": 1,
    "sclondon.ac": 1,
    "scnu.ac.kr": 1,
    "scnu.edu.cn": 1,
    "scott.ac.ke": 1,
    "scottsdalecc.edu": 1,
    "scp.fi": 1,
    "scranton.edu": 1,
    "scripps.edu": 1,
    "sct.edu": 1,
    "sctcc.edu": 1,
    "sctech.edu": 1,
    "sctimst.ker.nic.in": 1,
    "scu.ac.ir": 1,
    "scu.ac.kr": 1,
    "scu.edu": 1,
    "scu.edu.au": 1,
    "scu.edu.cn": 1,
    "scu.edu.tw": 1,
    "scut.edu.cn": 1,
    "sdada.edu.cn": 1,
    "sdau.edu.cn": 1,
    "sdau.edu.in": 1,
    "sdcc.edu": 1,
    "sdcity.edu": 1,
    "sdi.ac.ir": 1,
    "sdie.edu.cn": 1,
    "sdju.edu.cn": 1,
    "sdmesa.edu": 1,
    "sdmiramar.edu": 1,
    "sdmu.edu.cn": 1,
    "sdnu.edu.cn": 1,
    "sdsmt.edu": 1,
    "sdstate.edu": 1,
    "sdsu.edu": 1,
    "sdu.dk": 1,
    "sdu.edu.az": 1,
    "sdu.edu.cn": 1,
    "sdu.edu.kz": 1,
    "sdu.edu.tr": 1,
    "sdust.edu.cn": 1,
    "sdut.edu.cn": 1,
    "sdutcm.edu.cn": 1,
    "seark.edu": 1,
    "seas.upenn.edu": 1,
    "seattleantioch.edu": 1,
    "seattlecentral.edu": 1,
    "seattlecolleges.edu": 1,
    "seattleu.edu": 1,
    "sebhau.edu.ly": 1,
    "sec.ac.bd": 1,
    "secon.edu": 1,
    "secupv.org": 1,
    "seeu.edu.mk": 1,
    "segi.edu.my": 1,
    "sehan.ac.kr": 1,
    "sehir.edu.tr": 1,
    "seian.ac.jp": 1,
    "seigakuin-univ.ac.jp": 1,
    "seijo.ac.jp": 1,
    "seikei.ac.jp": 1,
    "seinan-gu.ac.jp": 1,
    "seisen-u.ac.jp": 1,
    "seiwa-u.ac.jp": 1,
    "sejong.ac.kr": 1,
    "sek.edu": 1,
    "seku.ac.ke": 1,
    "sekuco.org": 1,
    "selcuk.edu.tr": 1,
    "selk.de": 1,
    "selkirk.bc.ca": 1,
    "selu.edu": 1,
    "selyeuni.sk": 1,
    "sem-ums.ac.ir": 1,
    "semgu.kz": 1,
    "semnan.ac.ir": 1,
    "semnaniau.ac.ir": 1,
    "semo.edu": 1,
    "semyung.ac.kr": 1,
    "sendaidaigaku.jp": 1,
    "senecacollege.ca": 1,
    "senshu-u.ac.jp": 1,
    "senzoku.ac.jp": 1,
    "seokyeong.ac.kr": 1,
    "seonam.ac.kr": 1,
    "seoul-e.ac.kr": 1,
    "seoultech.ac.kr": 1,
    "seowon.ac.kr": 1,
    "ses.ac.ir": 1,
    "setsunan.ac.jp": 1,
    "setur.fo": 1,
    "seu.ac.bd": 1,
    "seu.ac.lk": 1,
    "seu.edu.cn": 1,
    "seua.am": 1,
    "sevntu.com.ua": 1,
    "sevs.sk": 1,
    "sewanee.edu": 1,
    "sfa.ba": 1,
    "sfasu.edu": 1,
    "sfb.ac.rw": 1,
    "sfcc.edu": 1,
    "sfccmo.edu": 1,
    "sfcpa.edu": 1,
    "sfsu.edu": 1,
    "sfu.ca": 1,
    "sg-u.ac.jp": 1,
    "sg.inter.edu": 1,
    "sgap.ru": 1,
    "sgau.ru": 1,
    "sggw.waw.pl": 1,
    "sgh.waw.pl": 1,
    "sghms.ac.uk": 1,
    "sgma.info": 1,
    "sgma.kz": 1,
    "sgpgi.ac.in": 1,
    "sgu.ac.id": 1,
    "sgu.ac.jp": 1,
    "sgu.ac.kr": 1,
    "sgu.edu": 1,
    "sgu.edu.cn": 1,
    "sgu.edu.vn": 1,
    "sgu.ernet.in": 1,
    "sgu.ru": 1,
    "sguc.ac.jp": 1,
    "sh-sipopolytechnic.com": 1,
    "sh.se": 1,
    "shahed.ac.ir": 1,
    "shahroodut.ac.ir": 1,
    "shahryariau.ac.ir": 1,
    "shakaijigyo.ac.jp": 1,
    "shams.edu.eg": 1,
    "shanghai_edu.customs.gov.cn": 1,
    "shannoncollege.com": 1,
    "sharif.ac.ir": 1,
    "sharjah.ac.ae": 1,
    "shastacollege.edu": 1,
    "shawnee.edu": 1,
    "shawneecc.edu": 1,
    "shbu.ac.ir": 1,
    "shc.edu": 1,
    "shef.ac.uk": 1,
    "sheltonstate.edu": 1,
    "shenkar.ac.il": 1,
    "sheridan.edu": 1,
    "sheridancollege.ca": 1,
    "shfu.edu.cn": 1,
    "shh.fi": 1,
    "shibaura-it.ac.jp": 1,
    "shift.edu.cn": 1,
    "shiga-med.ac.jp": 1,
    "shiga-u.ac.jp": 1,
    "shikoku-u.ac.jp": 1,
    "shimane-med.ac.jp": 1,
    "shimane-u.ac.jp": 1,
    "shimonoseki-cu.ac.jp": 1,
    "shinawatra.ac.th": 1,
    "shinhan.ac.kr": 1,
    "shinshu-u.ac.jp": 1,
    "ship.edu": 1,
    "shirayuri.ac.jp": 1,
    "shirazu.ac.ir": 1,
    "shisu.edu.cn": 1,
    "shitennoji.ac.jp": 1,
    "shizuoka.ac.jp": 1,
    "shmtu.edu.cn": 1,
    "shmu.ac.ir": 1,
    "shmu.edu.cn": 1,
    "shobhituniversity.ac.in": 1,
    "shodai.ac.jp": 1,
    "shoin.ac.jp": 1,
    "shokei-gakuen.ac.jp": 1,
    "shomal.ac.ir": 1,
    "shonan-it.ac.jp": 1,
    "shoreline.edu": 1,
    "shorter.edu": 1,
    "shotoku.ac.jp": 1,
    "shouhua.net.cn": 1,
    "showa-u.ac.jp": 1,
    "shoyaku.ac.jp": 1,
    "shridharuniversity.ac.in": 1,
    "shsmu.edu.cn": 1,
    "shspu.edu.cn": 1,
    "shsu.edu": 1,
    "shtdu.edu.cn": 1,
    "shtu.edu.cn": 1,
    "shtvu.edu.cn": 1,
    "shu-bg.net": 1,
    "shu.ac.uk": 1,
    "shu.edu": 1,
    "shu.edu.cn": 1,
    "shu.edu.tw": 1,
    "shu.smolensk.su": 1,
    "shuchiin.ac.jp": 1,
    "shudo-u.ac.jp": 1,
    "shufe.edu.cn": 1,
    "shujitsu.ac.jp": 1,
    "shukutoku.ac.jp": 1,
    "shumei-u.ac.jp": 1,
    "shutcm.edu.cn": 1,
    "shzu.edu.cn": 1,
    "siam.edu": 1,
    "siba.fi": 1,
    "sibiu.ro": 1,
    "sibsiu.kemerovo.su": 1,
    "sic.edu": 1,
    "sicau.edu.cn": 1,
    "sicnu.edu.cn": 1,
    "sierracollege.edu": 1,
    "siewerth-akademie.de": 1,
    "sifc.edu": 1,
    "sigu7.jussieu.fr": 1,
    "siirt.edu.tr": 1,
    "sil.edu.pe": 1,
    "silla.ac.kr": 1,
    "sim.edu.sg": 1,
    "simhapuriuniv.ac.in": 1,
    "simmons.edu": 1,
    "simons-rock.edu": 1,
    "simpson.edu": 1,
    "simt.edu.la": 1,
    "sinclair.edu": 1,
    "singidunum.edu.rs": 1,
    "sinnaruniv.edu.sd": 1,
    "sinop.edu.tr": 1,
    "sinus.ac.id": 1,
    "sipi.edu": 1,
    "sirnak.edu.tr": 1,
    "sisekaitse.ee": 1,
    "siskiyous.edu": 1,
    "sissa.it": 1,
    "sisu.edu.cn": 1,
    "sit.ac.jp": 1,
    "siu-heidelberg.de": 1,
    "siu.ac.jp": 1,
    "siu.edu": 1,
    "siu.edu.bd": 1,
    "siu.edu.in": 1,
    "siue.edu": 1,
    "siust.edu.sy": 1,
    "sjc.edu": 1,
    "sjca.edu": 1,
    "sjcc.edu": 1,
    "sjcme.edu": 1,
    "sjcsf.edu": 1,
    "sjdlc.com": 1,
    "sjp.ac.lk": 1,
    "sjrstate.edu": 1,
    "sjs.ac.kr": 1,
    "sjsm.org": 1,
    "sjsmit.edu.tw": 1,
    "sjsu.edu": 1,
    "sjsv.nic.in": 1,
    "sjtu.edu.cn": 1,
    "sju.edu": 1,
    "sjvc.edu": 1,
    "sjzu.edu.cn": 1,
    "ska.khio.no": 1,
    "skagit.edu": 1,
    "skc.edu": 1,
    "skhu.ac.kr": 1,
    "skidmore.edu": 1,
    "skku.ac.kr": 1,
    "skku.edu": 1,
    "skmu.edu.in": 1,
    "sku.ac.ir": 1,
    "skuastkashmir.ac.in": 1,
    "skums.ac.ir": 1,
    "skuniv.ac.kr": 1,
    "skuniv.ap.nic.in": 1,
    "skylinecollege.edu": 1,
    "skylineuniversity.com": 1,
    "sl.psu.edu": 1,
    "slam.katowice.pl": 1,
    "slbsrsv.ac.in": 1,
    "slc-sflu.edu.ph": 1,
    "slc.edu": 1,
    "slcc.edu": 1,
    "slcn.ac.jp": 1,
    "sliate.net": 1,
    "sliit.lk": 1,
    "slu.cz": 1,
    "slu.edu": 1,
    "slu.edu.ph": 1,
    "slu.se": 1,
    "smarcos.br": 1,
    "smc.edu": 1,
    "smcc.edu": 1,
    "smccd.edu": 1,
    "smccme.edu": 1,
    "smcks.edu": 1,
    "smcm.edu": 1,
    "smcsc.edu": 1,
    "smcvt.edu": 1,
    "smith.edu": 1,
    "smkfomra.net": 1,
    "smmu.edu.cn": 1,
    "smolny-un.spb.ru": 1,
    "smsu.edu": 1,
    "smtu.ru": 1,
    "smu.ac.kr": 1,
    "smu.ac.uk": 1,
    "smu.ac.za": 1,
    "smu.ca": 1,
    "smu.edu": 1,
    "smu.edu.in": 1,
    "smu.edu.ph": 1,
    "smu.edu.sg": 1,
    "smumn.edu": 1,
    "sndt.edu": 1,
    "snead.edu": 1,
    "snhu.edu": 1,
    "snnu.edu.cn": 1,
    "sns.it": 1,
    "snspa.ro": 1,
    "snu.ac.kr": 1,
    "snu.edu": 1,
    "snu.edu.ua": 1,
    "snue.ac.kr": 1,
    "snut.ac.kr": 1,
    "soai.ac.jp": 1,
    "soas.ac.uk": 1,
    "soauniversity.ac.in": 1,
    "socc.edu": 1,
    "sogang.ac.kr": 1,
    "sohag-univ.edu.eg": 1,
    "soharuni.edu.om": 1,
    "soka.ac.jp": 1,
    "soken.ac.jp": 1,
    "solacc.edu": 1,
    "solano.edu": 1,
    "solent.ac.uk": 1,
    "solusi.ac.zw": 1,
    "somaiya.edu": 1,
    "somerset.kctcs.edu": 1,
    "somtech.org": 1,
    "songwon.ac.kr": 1,
    "sonoda-u.ac.jp": 1,
    "sonoma.edu": 1,
    "sookmyung.ac.kr": 1,
    "soongsil.ac.kr": 1,
    "sophia.ac.jp": 1,
    "soran.edu.iq": 1,
    "sorbon.fr": 1,
    "sorbonne.ae": 1,
    "sote.hu": 1,
    "sothebysinstitutelondon.com": 1,
    "soton.ac.uk": 1,
    "sou.edu": 1,
    "southalabama.edu": 1,
    "southark.edu": 1,
    "southasianuniversity.org": 1,
    "southcentral.edu": 1,
    "southeast.edu": 1,
    "southeast.kctcs.edu": 1,
    "southeasterntech.edu": 1,
    "southeastmissourihospitalcollege.edu": 1,
    "southeastmn.edu": 1,
    "southeasttech.edu": 1,
    "southern.edu": 1,
    "southern.edu.bd": 1,
    "southernct.edu": 1,
    "southernwv.edu": 1,
    "southgatech.edu": 1,
    "southmountaincc.edu": 1,
    "southplainscollege.edu": 1,
    "southside.edu": 1,
    "southwest.tn.edu": 1,
    "southwestern.edu": 1,
    "southwesterncc.edu": 1,
    "southwestgatech.edu": 1,
    "sowela.edu": 1,
    "sowmesaraiau.ac.ir": 1,
    "sp.senac.br": 1,
    "spa.ac.in": 1,
    "spartanmed.org": 1,
    "spbau.ru": 1,
    "spbgasu.ru": 1,
    "spbgau.spb.ru": 1,
    "spbguki.ru": 1,
    "spbiir.ru": 1,
    "spbstu.ru": 1,
    "spbtei.ru": 1,
    "spbu.ru": 1,
    "spbuwc.ru": 1,
    "spcc.edu": 1,
    "spcollege.edu": 1,
    "spcpa.ru": 1,
    "spiruharet.ro": 1,
    "spmi.edu.ru": 1,
    "spnu.ac.ir": 1,
    "spokanefalls.edu": 1,
    "spscc.ctc.edu": 1,
    "spsmma.com": 1,
    "spu.ac.jp": 1,
    "spu.ac.ke": 1,
    "spu.ac.th": 1,
    "spu.ac.za": 1,
    "spu.ba": 1,
    "spu.edu": 1,
    "spu.edu.ph": 1,
    "spuniv.org": 1,
    "spuvvn.edu": 1,
    "squ.edu.om": 1,
    "squareit.ac.in": 1,
    "srbiau.ac.ir": 1,
    "src.edu": 1,
    "srh-berlin.de": 1,
    "srisathyasai.org.in": 1,
    "srkdc.org": 1,
    "srmuniv.ac.in": 1,
    "srtmun.org": 1,
    "srttu.edu": 1,
    "sru.edu": 1,
    "sru.edu.kh": 1,
    "ssaa.ru": 1,
    "ssaba.smr.ru": 1,
    "ssau.ru": 1,
    "ssc.edu": 1,
    "sscc.edu": 1,
    "sscok.edu": 1,
    "sse.gr": 1,
    "ssea.runnet.ru": 1,
    "ssees.ac.uk": 1,
    "sseriga.edu.lv": 1,
    "sseu.ru": 1,
    "ssgmce.org": 1,
    "ssms.edu.pk": 1,
    "ssmu.ru": 1,
    "sssup.it": 1,
    "ssttu.samara.ru": 1,
    "sstu-edu.ru": 1,
    "sstu.samara.ru": 1,
    "ssu.ac.ir": 1,
    "ssu.ac.jp": 1,
    "ssu.ac.kr": 1,
    "ssu.edu.ng": 1,
    "ssu.edu.ph": 1,
    "ssu.komi.com": 1,
    "ssu.samara.ru": 1,
    "ssuet.edu.pk": 1,
    "ssus.ac.in": 1,
    "ssvv.up.nic.in": 1,
    "st-and.ac.uk": 1,
    "st-andrews.ac.uk": 1,
    "st-georgen.uni-frankfurt.de": 1,
    "st-patricks.ac.uk": 1,
    "staffs.ac.uk": 1,
    "stamford.edu": 1,
    "stamforduniversity.edu.bd": 1,
    "stan.ac.id": 1,
    "stanford.edu": 1,
    "stankin.ru": 1,
    "stanly.edu": 1,
    "starkstate.edu": 1,
    "stavsu.ru": 1,
    "stcc.edu": 1,
    "stcecilia.br": 1,
    "stchas.edu": 1,
    "stcl.edu": 1,
    "stclairc.on.ca": 1,
    "stclairconnect.ca": 1,
    "stclements.edu.nu": 1,
    "stcloudstate.edu": 1,
    "stedwards.edu": 1,
    "stenden.com": 1,
    "stephens.edu": 1,
    "stetson.edu": 1,
    "stevens.edu": 1,
    "stevenscollege.edu": 1,
    "stevenson.edu": 1,
    "stfrancis.edu": 1,
    "stfx.ca": 1,
    "stir.ac.uk": 1,
    "stjohn.ac.th": 1,
    "stjohns.edu": 1,
    "stjosephtanzania.com": 1,
    "stkate.edu": 1,
    "stlawu.edu": 1,
    "stlcop.edu": 1,
    "stmartin.edu": 1,
    "stmarys-ca.edu": 1,
    "stmarys.ca": 1,
    "stmatthews.edu": 1,
    "stmu.org": 1,
    "stockholm-fu.com": 1,
    "stockton.edu": 1,
    "stolaf.edu": 1,
    "stonechild.edu": 1,
    "stonybrook.edu": 1,
    "stonybrookmedicine.edu": 1,
    "stou.ac.th": 1,
    "stptrisakti.ac.id": 1,
    "stratford.edu": 1,
    "strath.ac.uk": 1,
    "strathmore.edu": 1,
    "strayer.edu": 1,
    "strose.edu": 1,
    "stthom.edu": 1,
    "stthomas.edu": 1,
    "stthomasu.ca": 1,
    "sttu.ac.ir": 1,
    "stu.ac.kr": 1,
    "stu.edu": 1,
    "stu.edu.cn": 1,
    "stu.gcu.edu.cn": 1,
    "stu.lipetsk.ru": 1,
    "stu.ru": 1,
    "stu.xhu.edu.cn": 1,
    "stuba.sk": 1,
    "stud.hs-hannover.de": 1,
    "student.42.fr": 1,
    "student.42.us.org": 1,
    "student.aau.dk": 1,
    "student.gsa.ac.uk": 1,
    "student.hs-anhalt.de": 1,
    "student.lamk.fi": 1,
    "student.laurea.fi": 1,
    "student.lboro.ac.uk": 1,
    "student.lut.fi": 1,
    "student.murdoch.edu.au": 1,
    "student.scad.edu": 1,
    "student.tudelft.nl": 1,
    "student.uml.edu": 1,
    "student.uts.edu.au": 1,
    "students.finki.ukim.mk": 1,
    "stut.edu.tw": 1,
    "stvincent.edu": 1,
    "stw.de": 1,
    "su.ac.th": 1,
    "su.digitaluniversity.ac": 1,
    "su.edu": 1,
    "su.edu.eg": 1,
    "su.edu.et": 1,
    "su.edu.ly": 1,
    "su.edu.ph": 1,
    "su.edu.sa": 1,
    "su.edu.ye": 1,
    "su.lt": 1,
    "su.se": 1,
    "suagm.edu": 1,
    "suai.ru": 1,
    "suanet.ac.tz": 1,
    "subr.edu": 1,
    "suc.edu.om": 1,
    "suda.edu.cn": 1,
    "sues.edu.cn": 1,
    "suez.edu.eg": 1,
    "suffolk.edu": 1,
    "sugino.ac.jp": 1,
    "sugiyama-u.ac.jp": 1,
    "suh-edu.com": 1,
    "suit.edu.pk": 1,
    "sullivan.edu": 1,
    "sulross.edu": 1,
    "suma.kobe-wu.ac.jp": 1,
    "sumdu.edu.ua": 1,
    "summitunivofla.edu": 1,
    "sums.ac.ir": 1,
    "sun.ac.jp": 1,
    "sun.ac.za": 1,
    "sunchon.ac.kr": 1,
    "sunderland.ac.uk": 1,
    "sungkyul.ac.kr": 1,
    "sungshin.ac.kr": 1,
    "sunmoon.ac.kr": 1,
    "sunway.edu.my": 1,
    "sunycentral.edu": 1,
    "sunycgcc.edu": 1,
    "sunydutchess.edu": 1,
    "sunyit.edu": 1,
    "sunyjcc.edu": 1,
    "sunyjefferson.edu": 1,
    "sunymaritime.edu": 1,
    "sunyocc.edu": 1,
    "sunyorange.edu": 1,
    "sunyrockland.edu": 1,
    "sunysccc.edu": 1,
    "sunysullivan.edu": 1,
    "sunywcc.edu": 1,
    "supaero.fr": 1,
    "supbiotech.fr": 1,
    "supco-amiens.fr": 1,
    "supco-montpellier.fr": 1,
    "supelec.fr": 1,
    "superior.edu.pk": 1,
    "supsi.ch": 1,
    "suptelecom.net.ma": 1,
    "surgu.wsnet.ru": 1,
    "surrey.ac.uk": 1,
    "surry.edu": 1,
    "surugadai.ac.jp": 1,
    "suscc.edu": 1,
    "susla.edu": 1,
    "susqu.edu": 1,
    "sussex.ac.uk": 1,
    "sussex.edu": 1,
    "sust.edu": 1,
    "sustc.edu.cn": 1,
    "sustech.edu": 1,
    "sut.ac.ir": 1,
    "sut.ac.jp": 1,
    "sut.ac.th": 1,
    "sut.ru": 1,
    "sutd.ru": 1,
    "sutech.ac.ir": 1,
    "suu.edu": 1,
    "suwon.ac.kr": 1,
    "suwoncatholic.ac.kr": 1,
    "suzuka-iu.ac.jp": 1,
    "suzuka-u.ac.jp": 1,
    "svbpuctm.org": 1,
    "svcc.edu": 1,
    "sve-mo.ba": 1,
    "svimstpt.ap.nic.in": 1,
    "svnit.ac.in": 1,
    "svsu.edu": 1,
    "svu.edu.eg": 1,
    "svuni.ap.nic.in": 1,
    "svuonline.org": 1,
    "sw.edu": 1,
    "swac.edu": 1,
    "swan.ac.uk": 1,
    "swarthmore.edu": 1,
    "swau.edu.cn": 1,
    "swc.tc": 1,
    "swccd.edu": 1,
    "swcciowa.edu": 1,
    "swfc.edu.cn": 1,
    "swic.edu": 1,
    "swin.edu.au": 1,
    "swinburne.edu.my": 1,
    "swissmc.ch": 1,
    "swissu.org": 1,
    "swjtu.edu.cn": 1,
    "swmed.edu": 1,
    "swmich.edu": 1,
    "swnu.edu.cn": 1,
    "swps.edu.pl": 1,
    "swpu.edu.cn": 1,
    "swri.edu": 1,
    "swsm.cn": 1,
    "swt.edu": 1,
    "swtc.edu": 1,
    "swtjc.net": 1,
    "swu.ac.jp": 1,
    "swu.ac.kr": 1,
    "swu.ac.th": 1,
    "swu.bg": 1,
    "swu.edu.ph": 1,
    "swufe.edu.cn": 1,
    "swun.edu.cn": 1,
    "swupl.edu.cn": 1,
    "swust.edu.cn": 1,
    "swuyc.edu.cn": 1,
    "sx.ac.uk": 1,
    "sxau.edu.cn": 1,
    "sxu.edu": 1,
    "sxu.edu.cn": 1,
    "sydney.edu.au": 1,
    "syict.edu.cn": 1,
    "synergy.ru": 1,
    "synergy.university": 1,
    "syphu.edu.cn": 1,
    "sypu.edu.cn": 1,
    "syr.edu": 1,
    "sytu.edu.cn": 1,
    "syu.ac.kr": 1,
    "syu.edu.cn": 1,
    "szabist.edu.pk": 1,
    "sze.hu": 1,
    "szie.hu": 1,
    "szu.edu.af": 1,
    "szu.edu.cn": 1,
    "szu.sk": 1,
    "t-komazawa.ac.jp": 1,
    "t-kougei.ac.jp": 1,
    "tabari.ac.ir": 1,
    "tabor.edu": 1,
    "tabriziau.ac.ir": 1,
    "tabrizu.ac.ir": 1,
    "tachibana-u.ac.jp": 1,
    "tacomacc.edu": 1,
    "taegu-e.ac.kr": 1,
    "taegu.ac.kr": 1,
    "taejon.ac.kr": 1,
    "taeshin.ac.kr": 1,
    "taftcollege.edu": 1,
    "taftu.edu": 1,
    "taibahu.edu.sa": 1,
    "tais.ac.jp": 1,
    "taizun.net": 1,
    "taj.edu.my": 1,
    "tajagroun.tj": 1,
    "takachiho.ac.jp": 1,
    "takamatsu-u.ac.jp": 1,
    "takara-univ.ac.jp": 1,
    "takushoku-u.ac.jp": 1,
    "tamabi.ac.jp": 1,
    "tamagawa.ac.jp": 1,
    "tamiluniversity.ac.in": 1,
    "tamiu.edu": 1,
    "tamu.edu": 1,
    "tamuc.edu": 1,
    "tamucc.edu": 1,
    "tamuk.edu": 1,
    "tane.edu.ua": 1,
    "tansianuniversity.edu.ng": 1,
    "tanta.edu.eg": 1,
    "tanuvas.com": 1,
    "taoistcollege.org.sg": 1,
    "tarc.edu.my": 1,
    "tarleton.edu": 1,
    "tart.spb.ru": 1,
    "tashgiv.uz": 1,
    "tasued.edu.ng": 1,
    "tau.ac.il": 1,
    "tau.ac.kr": 1,
    "tau.edu.tr": 1,
    "tauedu.org": 1,
    "tayi.uz": 1,
    "taylors.edu.my": 1,
    "tayloru.edu": 1,
    "taynguyenuni.edu.vn": 1,
    "tbcc.cc.or.us": 1,
    "tbgu.ac.jp": 1,
    "tbzmed.ac.ir": 1,
    "tc3.edu": 1,
    "tcc.edu": 1,
    "tcc.fl.edu": 1,
    "tccd.edu": 1,
    "tcd.ie": 1,
    "tce.edu": 1,
    "tcicollege.edu": 1,
    "tcl.edu": 1,
    "tcm.ac.uk": 1,
    "tcnj.edu": 1,
    "tct.ac.ir": 1,
    "tctc.edu": 1,
    "tcu.edu": 1,
    "tcu.edu.tw": 1,
    "tcue.ac.jp": 1,
    "tdc.ac.jp": 1,
    "tdiu.uz": 1,
    "tdtu.uz": 1,
    "teak.fi": 1,
    "tecbc.mx": 1,
    "technet.com.br": 1,
    "technikum-wien.at": 1,
    "technion.ac.il": 1,
    "tedu.edu.tr": 1,
    "tees.ac.uk": 1,
    "teh-lavasan.pnu.ac.ir": 1,
    "teiath.gr": 1,
    "teiep.gr": 1,
    "teihal.gr": 1,
    "teiher.gr": 1,
    "teikal.gr": 1,
    "teikav.edu.gr": 1,
    "teikoz.gr": 1,
    "teikyo-u.ac.jp": 1,
    "teilam.gr": 1,
    "teilar.gr": 1,
    "teimes.gr": 1,
    "teipat.gr": 1,
    "teipir.gr": 1,
    "teiser.gr": 1,
    "teithe.gr": 1,
    "teiwest.gr": 1,
    "telkomuniversity.ac.id": 1,
    "teluguuniversity.ac.in": 1,
    "teluq.uquebec.ca": 1,
    "temple.edu": 1,
    "templejc.edu": 1,
    "tenri-u.ac.jp": 1,
    "teologi.dk": 1,
    "tepeyac.edu.mx": 1,
    "termnet.co.jp": 1,
    "terra.edu": 1,
    "tesc.edu": 1,
    "tesu.edu": 1,
    "teu.ac.jp": 1,
    "texarkanacollege.edu": 1,
    "tezu.ernet.in": 1,
    "tezuka-gu.ac.jp": 1,
    "tezukayama-u.ac.jp": 1,
    "tfh-berlin.de": 1,
    "tfh-bochum.de": 1,
    "tfh-wildau.de": 1,
    "tfi.uz": 1,
    "tfu.ac.jp": 1,
    "tgnu.tarena.tj": 1,
    "tgpi.ttn.ru": 1,
    "tgsha.ru": 1,
    "th-brandenburg.de": 1,
    "th-deg.de": 1,
    "theatrins-yar.ru": 1,
    "thenewcollege.org": 1,
    "thenicc.edu": 1,
    "theonest.edu.lb": 1,
    "thh-friedensau.de": 1,
    "thi.de": 1,
    "thierryschool.org": 1,
    "thiqaruni.org": 1,
    "thk.edu.tr": 1,
    "thmu.edu.tw": 1,
    "thomas.edu": 1,
    "thomasmore.edu": 1,
    "thu.edu.tw": 1,
    "thums.ac.ir": 1,
    "thunderbird.edu": 1,
    "thuniv.net": 1,
    "tiaa.edu.ge": 1,
    "tiau.ac.ir": 1,
    "ties.com.mx": 1,
    "tiet.ac.in": 1,
    "tietgen.dk": 1,
    "tiffin.edu": 1,
    "tiffinprague.cz": 1,
    "tiho-hannover.de": 1,
    "tiim.uz": 1,
    "tijmu.edu.cn": 1,
    "tilburguniversity.nl": 1,
    "timacad.ru": 1,
    "timis.ac.jp": 1,
    "tip.edu.pk": 1,
    "tishreen.edu.sy": 1,
    "tiss.edu": 1,
    "tit.ac.kr": 1,
    "titech.ac.jp": 1,
    "tiu.ac.jp": 1,
    "tiu.tj": 1,
    "tiu.uz": 1,
    "tjarts.edu.cn": 1,
    "tjcu.edu.cn": 1,
    "tjmu.edu.cn": 1,
    "tjnu.edu.cn": 1,
    "tjpu.edu.cn": 1,
    "tjrtvu.edu.cn": 1,
    "tju.edu": 1,
    "tju.edu.cn": 1,
    "tjufe.edu.cn": 1,
    "tjut.edu.cn": 1,
    "tkbf.hu": 1,
    "tktk.ee": 1,
    "tku.ac.jp": 1,
    "tku.edu.tw": 1,
    "tltsu.ru": 1,
    "tlu.ee": 1,
    "tma.uz": 1,
    "tmbu.org": 1,
    "tmc.edu.tw": 1,
    "tmcc.edu": 1,
    "tmd.ac.jp": 1,
    "tmit.ac.jp": 1,
    "tmmu.edu.cn": 1,
    "tmtc.edu.tw": 1,
    "tmu.ac.ir": 1,
    "tmv.edu.in": 1,
    "tnca.edu.tw": 1,
    "tncc.edu": 1,
    "tndalu.org": 1,
    "tnmeyah.net": 1,
    "tnmmu.ac.in": 1,
    "tnstate.edu": 1,
    "tntech.edu": 1,
    "tnu.crimea.ua": 1,
    "tnuni.sk": 1,
    "tnuniv.ac.in": 1,
    "tnut.ac.kr": 1,
    "tocc.edu": 1,
    "toho-music.ac.jp": 1,
    "toho-u.ac.jp": 1,
    "tohoku-gakuin.ac.jp": 1,
    "tohoku-pharm.ac.jp": 1,
    "tohoku.ac.jp": 1,
    "tohomusic.ac.jp": 1,
    "tohtech.ac.jp": 1,
    "tohwa-u.ac.jp": 1,
    "toin.ac.jp": 1,
    "tojo.ac.jp": 1,
    "tokai.ac.jp": 1,
    "tokaigakuen-u.ac.jp": 1,
    "tokaijoshi-u.ac.jp": 1,
    "tokiwa.ac.jp": 1,
    "tokoha-u.ac.jp": 1,
    "tokushima-u.ac.jp": 1,
    "tokuyama-u.ac.jp": 1,
    "tokyo-kasei.ac.jp": 1,
    "tokyo-med.ac.jp": 1,
    "tokyo-ondai.ac.jp": 1,
    "tokyo-u-fish.ac.jp": 1,
    "toledo.br": 1,
    "tongji.edu.cn": 1,
    "tonichi-kokusai-u.ac.jp": 1,
    "toros.edu.tr": 1,
    "torrens.edu.au": 1,
    "tosho-u.ac.jp": 1,
    "tottori-u.ac.jp": 1,
    "toua-u.ac.jp": 1,
    "tourism.edu.az": 1,
    "touro.edu": 1,
    "touro.ru": 1,
    "towson.edu": 1,
    "toyaku.ac.jp": 1,
    "toyama-mpu.ac.jp": 1,
    "toyama-u.ac.jp": 1,
    "toyo.ac.jp": 1,
    "toyoeiwa.ac.jp": 1,
    "toyogakuen-u.ac.jp": 1,
    "toyota-ti.ac.jp": 1,
    "tpec.edu.tw": 1,
    "tpmcollege.edu.my": 1,
    "tpoly.edu.gh": 1,
    "tpu.fi": 1,
    "tpu.ru": 1,
    "trakya.edu.tr": 1,
    "transy.edu": 1,
    "trcc.commnet.edu": 1,
    "trcc.edu": 1,
    "trenholmstate.edu": 1,
    "trenton.edu": 1,
    "trentu.ca": 1,
    "tri-c.edu": 1,
    "tribhuvan-university.edu.np": 1,
    "tricountycc.edu": 1,
    "trident.edu": 1,
    "tridenttech.edu": 1,
    "trincoll.edu": 1,
    "trine.edu": 1,
    "trinidadstate.edu": 1,
    "trinity-cm.ac.uk": 1,
    "trinity.edu": 1,
    "trinity.edu.gh": 1,
    "trinity.utoronto.ca": 1,
    "trinitybiblecollege.edu": 1,
    "trinitydc.edu": 1,
    "tripurauniv.in": 1,
    "trisakti.ac.id": 1,
    "triton.edu": 1,
    "troy.edu": 1,
    "tru.ca": 1,
    "truman.edu": 1,
    "truni.sk": 1,
    "tshmc.org": 1,
    "tsi.lv": 1,
    "tsinghua.edu.cn": 1,
    "tsma.ru": 1,
    "tsmu.edu": 1,
    "tsogu.ru": 1,
    "tspu.edu.ru": 1,
    "tstu.ru": 1,
    "tstu.tver.ru": 1,
    "tsu.ac.th": 1,
    "tsu.edu": 1,
    "tsu.edu.ge": 1,
    "tsu.ru": 1,
    "tsu.tmn.ru": 1,
    "tsu.tula.ru": 1,
    "tsuab.ru": 1,
    "tsuda.ac.jp": 1,
    "tsufl.edu": 1,
    "tsukuba.ac.jp": 1,
    "tsuniversity.edu.ng": 1,
    "tsure.ru": 1,
    "tsuru.ac.jp": 1,
    "tsurumi-u.ac.jp": 1,
    "ttc.ryazan.ru": 1,
    "ttit.edu.tw": 1,
    "ttmc.edu.cn": 1,
    "ttu.edu": 1,
    "ttu.edu.jo": 1,
    "ttu.edu.tw": 1,
    "ttu.ee": 1,
    "ttuhsc.edu": 1,
    "tu-berlin.de": 1,
    "tu-bryansk.ru": 1,
    "tu-bs.de": 1,
    "tu-chel.ac.ru": 1,
    "tu-chemnitz.de": 1,
    "tu-clausthal.de": 1,
    "tu-cottbus.de": 1,
    "tu-darmstadt.de": 1,
    "tu-dortmund.de": 1,
    "tu-dresden.de": 1,
    "tu-freiberg.de": 1,
    "tu-ilmenau.de": 1,
    "tu-sofia.bg": 1,
    "tu-varna.acad.bg": 1,
    "tu.ac.th": 1,
    "tu.edu.af": 1,
    "tu.edu.iq": 1,
    "tu.edu.sa": 1,
    "tu.edu.te.ua": 1,
    "tu.kielce.pl": 1,
    "tu.koszalin.pl": 1,
    "tua.edu.au": 1,
    "tuad.ac.jp": 1,
    "tuaf.edu.vn": 1,
    "tuat.ac.jp": 1,
    "tuc.gr": 1,
    "tucsonu.edu": 1,
    "tudelft.nl": 1,
    "tue.nl": 1,
    "tuf.edu.pk": 1,
    "tufs.ac.jp": 1,
    "tufts.edu": 1,
    "tugab.bg": 1,
    "tugraz.at": 1,
    "tuhh.de": 1,
    "tui.edu": 1,
    "tuiasi.ro": 1,
    "tuins.ac.jp": 1,
    "tuis.ac.jp": 1,
    "tuit.uz": 1,
    "tuj.ac.jp": 1,
    "tuke.sk": 1,
    "tukenya.ac.ke": 1,
    "tukkk.fi": 1,
    "tulane.edu": 1,
    "tulsacc.edu": 1,
    "tum.ac.ke": 1,
    "tum.de": 1,
    "tum.edu": 1,
    "tumaini.ac.tz": 1,
    "tumkuruniversity.ac.in": 1,
    "tums.ac.ir": 1,
    "tunceli.edu.tr": 1,
    "tuniv.szczecin.pl": 1,
    "tunxis.edu": 1,
    "tup.edu.ph": 1,
    "tup.km.ua": 1,
    "turathun.com": 1,
    "turkistan.kz": 1,
    "tusculum.edu": 1,
    "tuskegee.edu": 1,
    "tusol.org": 1,
    "tusom.org": 1,
    "tusur.ru": 1,
    "tut.ac.jp": 1,
    "tut.ac.za": 1,
    "tut.fi": 1,
    "tuvsu.ru": 1,
    "tuwien.ac.at": 1,
    "tuzvo.sk": 1,
    "tvcc.cc": 1,
    "tvcc.edu": 1,
    "tvu.ac.uk": 1,
    "tvuni.in": 1,
    "tvz.hr": 1,
    "twcpe.ac.jp": 1,
    "twcu.ac.jp": 1,
    "twmu.ac.jp": 1,
    "twu.ca": 1,
    "twu.edu": 1,
    "txstate.edu": 1,
    "tyszkiewicz.edu.pl": 1,
    "tyut.edu.cn": 1,
    "tzc.edu.cn": 1,
    "u-3mrs.fr": 1,
    "u-air.ac.jp": 1,
    "u-aizu.ac.jp": 1,
    "u-bordeaux2.fr": 1,
    "u-bunkyo.ac.jp": 1,
    "u-cergy.fr": 1,
    "u-clermont1.fr": 1,
    "u-gakugei.ac.jp": 1,
    "u-grenoble3.fr": 1,
    "u-keiai.ac.jp": 1,
    "u-paris10.fr": 1,
    "u-paris2.fr": 1,
    "u-pem.fr": 1,
    "u-picardie.fr": 1,
    "u-psud.fr": 1,
    "u-ryukyu.ac.jp": 1,
    "u-sacred-heart.ac.jp": 1,
    "u-shizuoka-ken.ac.jp": 1,
    "u-szeged.hu": 1,
    "u-tokai.ac.jp": 1,
    "u-tokyo.ac.jp": 1,
    "u1.ac.kr": 1,
    "u7nc.uvt.rnu.tn": 1,
    "ua.ac.be": 1,
    "ua.edu": 1,
    "ua.edu.ph": 1,
    "ua.es": 1,
    "ua.pt": 1,
    "uaa.alaska.edu": 1,
    "uaa.edu.py": 1,
    "uaa.mx": 1,
    "uaaan.mx": 1,
    "uaar.edu.pk": 1,
    "uab.edu": 1,
    "uab.edu.bo": 1,
    "uab.es": 1,
    "uab.ro": 1,
    "uabc.mx": 1,
    "uabcs.mx": 1,
    "uabjb.edu.bo": 1,
    "uabjo.mx": 1,
    "uabobo.ci": 1,
    "uac.bj": 1,
    "uac.edu.co": 1,
    "uac.pt": 1,
    "uaca.ac.cr": 1,
    "uacam.mx": 1,
    "uaccb.edu": 1,
    "uacch.edu": 1,
    "uaccm.edu": 1,
    "uacg.bg": 1,
    "uach.cl": 1,
    "uach.mx": 1,
    "uacj.mx": 1,
    "uacm.edu.mx": 1,
    "uaconcagua.cl": 1,
    "uad.ac.id": 1,
    "uad.edu.mx": 1,
    "uade.edu.ar": 1,
    "uadec.mx": 1,
    "uader.edu.ar": 1,
    "uady.mx": 1,
    "uae.ac.ma": 1,
    "uae.edu.sv": 1,
    "uaed.edu.mx": 1,
    "uaem.mx": 1,
    "uaemex.mx": 1,
    "uaeu.ac.ae": 1,
    "uaf.edu": 1,
    "uaf.edu.pk": 1,
    "uaf.mx": 1,
    "uafam.edu.do": 1,
    "uafs.edu": 1,
    "uag.mx": 1,
    "uagraria.edu.ec": 1,
    "uagrm.edu.bo": 1,
    "uagro.mx": 1,
    "uah.edu": 1,
    "uah.es": 1,
    "uahb.sn": 1,
    "uahurtado.cl": 1,
    "uai.cl": 1,
    "uaic.ro": 1,
    "uajms.edu.bo": 1,
    "uajy.ac.id": 1,
    "uakron.edu": 1,
    "ual.mx": 1,
    "ualberta.ca": 1,
    "ualg.pt": 1,
    "ualm.es": 1,
    "ualr.edu": 1,
    "uam.edu.co": 1,
    "uam.edu.ng": 1,
    "uam.edu.ni": 1,
    "uam.es": 1,
    "uam.mx": 1,
    "uam.refer.ne": 1,
    "uamerica.edu.co": 1,
    "uamericana.edu.py": 1,
    "uamericas.cl": 1,
    "uamont.edu": 1,
    "uams.be": 1,
    "uams.edu": 1,
    "uamsa.net": 1,
    "uan.ao": 1,
    "uan.mx": 1,
    "uanarino.edu.co": 1,
    "uancv.edu.pe": 1,
    "uandes.cl": 1,
    "uandina.edu.pe": 1,
    "uane.edu.mx": 1,
    "uanl.mx": 1,
    "uantof.cl": 1,
    "uap-bd.edu": 1,
    "uap.edu.pe": 1,
    "uap.edu.ph": 1,
    "uap.edu.py": 1,
    "uapa.edu.do": 1,
    "uapa.ru": 1,
    "uapar.edu": 1,
    "uapnet.edu.bo": 1,
    "uaq.mx": 1,
    "uark.edu": 1,
    "uartdcluj.ro": 1,
    "uas.alaska.edu": 1,
    "uas.cl": 1,
    "uas.mx": 1,
    "uasb.edu.bo": 1,
    "uasb.edu.ec": 1,
    "uasbng.kar.nic.in": 1,
    "uasd.edu.do": 1,
    "uasd.net": 1,
    "uaslp.mx": 1,
    "uasm.md": 1,
    "uasnet.mx": 1,
    "uast.ac.ir": 1,
    "uasys.edu": 1,
    "uat.edu": 1,
    "uat.edu.al": 1,
    "uat.mx": 1,
    "uat.ro": 1,
    "uatf.edu.bo": 1,
    "uatla.pt": 1,
    "uatx.mx": 1,
    "uav.ro": 1,
    "uax.es": 1,
    "uazuay.edu.ec": 1,
    "ub.ac.id": 1,
    "ub.bw": 1,
    "ub.edu.ar": 1,
    "ub.edu.bi": 1,
    "ub.edu.bz": 1,
    "ub.edu.ph": 1,
    "ub.edu.pl": 1,
    "ub.es": 1,
    "ub.ro": 1,
    "uba.ar": 1,
    "uba.edu.ve": 1,
    "ubac.edu.mx": 1,
    "ubaguio.edu": 1,
    "ubalt.edu": 1,
    "ubaya.ac.id": 1,
    "ubbcluj.ro": 1,
    "ubc.ca": 1,
    "ubd.edu.bn": 1,
    "ubfc.fr": 1,
    "ubhara.ac.id": 1,
    "ubharajaya.ac.id": 1,
    "ubi.edu": 1,
    "ubi.pt": 1,
    "ubiobio.cl": 1,
    "ubishops.ca": 1,
    "ubm.ac.id": 1,
    "ubm.ro": 1,
    "ubohiggins.cl": 1,
    "ubolivariana.cl": 1,
    "ubouake.ci": 1,
    "ubp.edu.ar": 1,
    "ubritanica.cl": 1,
    "ubt.edu.al": 1,
    "ubu.ac.th": 1,
    "ubu.es": 1,
    "ubuea.cm": 1,
    "ubv.edu.ve": 1,
    "uc-bcf.edu.ph": 1,
    "uc.cl": 1,
    "uc.edu": 1,
    "uc.edu.kh": 1,
    "uc.edu.py": 1,
    "uc.edu.ve": 1,
    "uc.pt": 1,
    "uc.rnu.tn": 1,
    "uc3m.es": 1,
    "uca.ac.cr": 1,
    "uca.edu": 1,
    "uca.edu.ar": 1,
    "uca.edu.ni": 1,
    "uca.edu.sv": 1,
    "uca.es": 1,
    "ucaat.com": 1,
    "ucaazo.edu.ec": 1,
    "ucab.edu.ve": 1,
    "ucacue.edu.ec": 1,
    "ucad.edu.sv": 1,
    "ucad.sn": 1,
    "ucaldas.edu.co": 1,
    "ucalgary.ca": 1,
    "ucalp.edu.ar": 1,
    "ucam.ac.ma": 1,
    "ucam.edu": 1,
    "ucan.edu": 1,
    "ucapanama.org": 1,
    "ucas.edu.ps": 1,
    "ucasal.net": 1,
    "ucat.edu.ve": 1,
    "ucateci.edu.do": 1,
    "ucatolica.ac.cr": 1,
    "ucatolica.edu.co": 1,
    "ucatolicamz.edu.co": 1,
    "ucauca.edu.co": 1,
    "ucavila.es": 1,
    "ucb.br": 1,
    "ucb.edu.bh": 1,
    "ucb.edu.bo": 1,
    "ucb.edu.pr": 1,
    "ucbc.org": 1,
    "ucbcba.edu.bo": 1,
    "ucbscz.edu.bo": 1,
    "ucbtja.edu.bo": 1,
    "ucbukavu.ac.cd": 1,
    "ucc.edu": 1,
    "ucc.edu.co": 1,
    "ucc.edu.gh": 1,
    "ucc.edu.ni": 1,
    "ucc.ie": 1,
    "uccaribe.edu": 1,
    "uccb.ns.ca": 1,
    "uccm.md": 1,
    "uccor.edu.ar": 1,
    "uccr.edu": 1,
    "uccs.edu": 1,
    "uccuyo.edu.ar": 1,
    "ucd.ac.ma": 1,
    "ucd.ie": 1,
    "ucdavis.edu": 1,
    "ucdenver.edu": 1,
    "uce.edu.do": 1,
    "ucel.edu.ar": 1,
    "ucem.edu.mx": 1,
    "ucem.edu.ni": 1,
    "ucentral.cl": 1,
    "ucentral.edu.co": 1,
    "ucentral.edu.ec": 1,
    "ucervantes.cl": 1,
    "uces.edu.ar": 1,
    "uceva.edu.co": 1,
    "ucf.edu": 1,
    "ucf.edu.cu": 1,
    "ucfv.bc.ca": 1,
    "ucg.br": 1,
    "ucg.cg.ac.yu": 1,
    "ucg.gr": 1,
    "ucg.ie": 1,
    "uch.edu.ar": 1,
    "uch.edu.pe": 1,
    "uchaswv.edu": 1,
    "uchceu.es": 1,
    "uchicago.edu": 1,
    "uchile.cl": 1,
    "uci.ac.cr": 1,
    "uci.edu": 1,
    "ucine.edu.ar": 1,
    "ucinf.cl": 1,
    "ucj.edu.sa": 1,
    "uck.ac.rw": 1,
    "ucl.ac.be": 1,
    "ucl.ac.uk": 1,
    "ucla.edu": 1,
    "ucla.edu.ve": 1,
    "uclah.edu.mx": 1,
    "uclan.ac.uk": 1,
    "uclm.es": 1,
    "uclv.edu.cu": 1,
    "ucm.ac.mz": 1,
    "ucm.cl": 1,
    "ucm.es": 1,
    "ucm.sk": 1,
    "ucmerced.edu": 1,
    "ucmo.edu": 1,
    "ucn.cl": 1,
    "ucn.edu.co": 1,
    "ucna.info": 1,
    "ucne.edu.do": 1,
    "ucnh.org": 1,
    "uco.edu": 1,
    "uco.edu.co": 1,
    "uco.es": 1,
    "uco.fr": 1,
    "ucol.mx": 1,
    "ucom.edu.py": 1,
    "ucongres.edu.ar": 1,
    "uconn.edu": 1,
    "ucp.br": 1,
    "ucp.edu.ar": 1,
    "ucp.edu.pk": 1,
    "ucp.pt": 1,
    "ucpel.tche.br": 1,
    "ucpr.edu.co": 1,
    "ucr.ac.cr": 1,
    "ucr.edu": 1,
    "ucs.ac.uk": 1,
    "ucs.mun.ca": 1,
    "ucs.tche.br": 1,
    "ucsa.edu.py": 1,
    "ucsal.br": 1,
    "ucsb.edu": 1,
    "ucsc.cl": 1,
    "ucsc.edu": 1,
    "ucsd.edu": 1,
    "ucsd.edu.do": 1,
    "ucse.edu.ar": 1,
    "ucsf.edu": 1,
    "ucsf.edu.ar": 1,
    "ucsg.edu.ec": 1,
    "ucsh.cl": 1,
    "ucsi.edu.my": 1,
    "ucsm.edu.pe": 1,
    "ucsur.edu.pe": 1,
    "ucsy.edu.mm": 1,
    "uct.ac.za": 1,
    "uct.edu.ec": 1,
    "uct.edu.vn": 1,
    "uctem.cl": 1,
    "ucti.edu.my": 1,
    "uctm.edu": 1,
    "ucu.ac.ug": 1,
    "ucu.edu.ar": 1,
    "ucu.edu.uy": 1,
    "ucuenca.edu.ec": 1,
    "ucv.cl": 1,
    "ucv.edu.pe": 1,
    "ucv.edu.ph": 1,
    "ucv.es": 1,
    "ucv.ve": 1,
    "ucy.ac.cy": 1,
    "ucyt.edu.ni": 1,
    "ud.ac.ae": 1,
    "ud.edu.sa": 1,
    "ud.edu.vn": 1,
    "uda.ac.id": 1,
    "uda.ad": 1,
    "uda.cl": 1,
    "uda.edu.ar": 1,
    "udabol.edu.bo": 1,
    "udallas.edu": 1,
    "udayton.edu": 1,
    "udb.sn": 1,
    "udc.edu": 1,
    "udc.es": 1,
    "udca.edu.co": 1,
    "udch.edu.pe": 1,
    "ude.edu.uy": 1,
    "udea.edu.co": 1,
    "udec.cl": 1,
    "udec.edu.mx": 1,
    "udeci.edu.mx": 1,
    "udeh.edu.mx": 1,
    "udel.edu": 1,
    "udelas.ac.pa": 1,
    "udelmar.cl": 1,
    "udelosandes.edu.bo": 1,
    "udem.edu.co": 1,
    "udem.edu.mx": 1,
    "udem.edu.ni": 1,
    "udemm.edu.ar": 1,
    "udenar.edu.co": 1,
    "udep.edu.pe": 1,
    "udes.edu.co": 1,
    "udesa.edu.ar": 1,
    "udesanmiguel.edu.mx": 1,
    "udesarrollo.cl": 1,
    "udesc.br": 1,
    "udesmontagnes.org": 1,
    "udg.co.cu": 1,
    "udg.es": 1,
    "udg.mx": 1,
    "udh.edu.pe": 1,
    "udi.edu": 1,
    "udistrital.edu.co": 1,
    "udl.edu.pe": 1,
    "udl.es": 1,
    "udla.mx": 1,
    "udlap.mx": 1,
    "udm.edu.my": 1,
    "udmercy.edu": 1,
    "udo.edu.ve": 1,
    "udo.mx": 1,
    "udom.ac.tz": 1,
    "udoym.edu.do": 1,
    "udp.cl": 1,
    "uds.edu.gh": 1,
    "udsm.ac.tz": 1,
    "udusok.edu.ng": 1,
    "udv.edu.mx": 1,
    "ue-varna.bg": 1,
    "ue.edu.ph": 1,
    "ue.edu.pk": 1,
    "uea.ac.uk": 1,
    "uea.edu.sn": 1,
    "ueab.ac.ke": 1,
    "ueb.isfun.net": 1,
    "uec.ac.jp": 1,
    "uece.br": 1,
    "uees.edu.ec": 1,
    "uees.edu.sv": 1,
    "uef.ru": 1,
    "uefs.br": 1,
    "ueh.edu.ht": 1,
    "ueh.edu.vn": 1,
    "uel.ac.uk": 1,
    "uel.br": 1,
    "uem.br": 1,
    "uem.es": 1,
    "uem.mz": 1,
    "uem.ro": 1,
    "uema.br": 1,
    "uenf.br": 1,
    "uenogakuen.ac.jp": 1,
    "uep.educ.ph": 1,
    "uepb.edu.br": 1,
    "uepg.br": 1,
    "uerj.br": 1,
    "uerm.edu.ph": 1,
    "uern.br": 1,
    "ues.edu.sv": 1,
    "uesb.br": 1,
    "uesc.br": 1,
    "uesiglo21.edu.ar": 1,
    "uespi.br": 1,
    "uestc.edu.cn": 1,
    "uet.edu": 1,
    "uettaxila.edu.pk": 1,
    "uevora.pt": 1,
    "uew.edu.gh": 1,
    "uexternado.edu.co": 1,
    "ufabc.edu.br": 1,
    "ufac.br": 1,
    "ufal.br": 1,
    "ufar.am": 1,
    "ufasta.edu.ar": 1,
    "ufba.br": 1,
    "ufc.br": 1,
    "ufcg.edu.br": 1,
    "ufe.edu.eg": 1,
    "ufes.br": 1,
    "uff.br": 1,
    "ufg.br": 1,
    "ufg.edu.sv": 1,
    "ufgd.edu.br": 1,
    "ufh.ac.za": 1,
    "ufhec.edu.do": 1,
    "ufidelitas.ac.cr": 1,
    "ufinis.cl": 1,
    "ufjf.br": 1,
    "ufl.edu": 1,
    "ufla.br": 1,
    "uflo.edu.ar": 1,
    "ufm.edu.gt": 1,
    "ufm.edu.mx": 1,
    "ufma.br": 1,
    "ufmg.br": 1,
    "ufms.br": 1,
    "ufmt.br": 1,
    "ufop.br": 1,
    "ufp.nc": 1,
    "ufp.pt": 1,
    "ufpa.br": 1,
    "ufpb.br": 1,
    "ufpe.br": 1,
    "ufpel.tche.br": 1,
    "ufpi.br": 1,
    "ufpr.br": 1,
    "ufps.edu.co": 1,
    "ufram.edu.mx": 1,
    "ufrgs.br": 1,
    "ufrj.br": 1,
    "ufrn.br": 1,
    "ufro.cl": 1,
    "ufrpe.br": 1,
    "ufrrj.br": 1,
    "ufs.ac.za": 1,
    "ufs.br": 1,
    "ufsc.br": 1,
    "ufscar.br": 1,
    "ufsia.ac.be": 1,
    "ufsm.br": 1,
    "uft-plovdiv.bg": 1,
    "uft.edu.ve": 1,
    "ufu.br": 1,
    "ufuk.edu.tr": 1,
    "ufv.br": 1,
    "ufv.es": 1,
    "ug.edu.ec": 1,
    "ug.edu.gh": 1,
    "uga.edu": 1,
    "ugaf.rnu.tn": 1,
    "ugal.ro": 1,
    "uganc.org": 1,
    "ugatu.ac.ru": 1,
    "ugb.edu.sv": 1,
    "ugb.sn": 1,
    "ugd.edu.mk": 1,
    "ugf.br": 1,
    "ugf.edu": 1,
    "ugm.ac.id": 1,
    "ugm.cl": 1,
    "ugma.edu.ve": 1,
    "ugr.es": 1,
    "ugrancolombia.edu.co": 1,
    "ugrasu.ru": 1,
    "ugs.ed.ao": 1,
    "ugsha.ru": 1,
    "ugto.mx": 1,
    "uh.cu": 1,
    "uh.edu": 1,
    "uh1.ac.ma": 1,
    "uh2m.ac.ma": 1,
    "uhasselt.be": 1,
    "uhb.fr": 1,
    "uhd.edu": 1,
    "uhd.edu.iq": 1,
    "uheeyc.edu.cn": 1,
    "uhispam.edu.ni": 1,
    "uhispanoamericana.ac.cr": 1,
    "uho.edu.cu": 1,
    "uhp-nancy.fr": 1,
    "uhs.ac.kr": 1,
    "uhsa.ag": 1,
    "uhu.es": 1,
    "ui.ac.id": 1,
    "ui.ac.ir": 1,
    "ui.edu.ng": 1,
    "ui.phinma.edu.ph": 1,
    "ui1.es": 1,
    "uia.ac.cr": 1,
    "uia.es": 1,
    "uia.mx": 1,
    "uiah.fi": 1,
    "uib.es": 1,
    "uib.kz": 1,
    "uib.no": 1,
    "uibe.edu.cn": 1,
    "uibk.ac.at": 1,
    "uic.edu": 1,
    "uic.edu.mx": 1,
    "uic.es": 1,
    "uic.globe.com.ph": 1,
    "uidaho.edu": 1,
    "uigv.edu.pe": 1,
    "uii.ac.id": 1,
    "uii.sever.ru": 1,
    "uika-bogor.ac.id": 1,
    "uileon.edu.mx": 1,
    "uiliria.org": 1,
    "uimp.es": 1,
    "uindy.edu": 1,
    "uindy.edu.gr": 1,
    "uinjkt.ac.id": 1,
    "uinternacional.pt": 1,
    "uio.no": 1,
    "uion.edu.gr": 1,
    "uiowa.edu": 1,
    "uir.ac.id": 1,
    "uis.edu": 1,
    "uis.edu.co": 1,
    "uis.no": 1,
    "uisek.cl": 1,
    "uisrael.ec": 1,
    "uist.edu.mk": 1,
    "uisu.ac.id": 1,
    "uit.no": 1,
    "uitec.ac.jp": 1,
    "uitm.edu.my": 1,
    "uits.edu.bd": 1,
    "uiu.ac.bd": 1,
    "uiu.edu": 1,
    "uiuc.edu": 1,
    "uiw.edu": 1,
    "uiwtx.edu": 1,
    "uj.ac.za": 1,
    "uj.edu": 1,
    "uj.edu.pl": 1,
    "uj.rnu.tn": 1,
    "ujaen.es": 1,
    "ujap.edu.ve": 1,
    "ujat.mx": 1,
    "ujcv.edu.hn": 1,
    "ujed.mx": 1,
    "ujep.cz": 1,
    "ujf-grenoble.fr": 1,
    "uji.es": 1,
    "ujmd.edu.sv": 1,
    "ujmv.edu": 1,
    "ujn.edu.cn": 1,
    "ujnk.org": 1,
    "ujsierra.mx": 1,
    "ujso.cl": 1,
    "uk.ac.ir": 1,
    "ukc.ac.uk": 1,
    "ukdw.ac.id": 1,
    "ukf.sk": 1,
    "ukh.ac": 1,
    "uki.ac.id": 1,
    "ukim.edu.mk": 1,
    "ukim.mk": 1,
    "ukings.ns.ca": 1,
    "ukit-tomohon.org": 1,
    "uklo.edu.mk": 1,
    "ukm.my": 1,
    "ukma.kiev.ua": 1,
    "ukrfa.kharkov.ua": 1,
    "ukrida.ac.id": 1,
    "uksw.edu": 1,
    "uksw.edu.pl": 1,
    "uktech.ac.in": 1,
    "uku.fi": 1,
    "uky.edu": 1,
    "ukzn.ac.za": 1,
    "ul.ac.za": 1,
    "ul.edu.lb": 1,
    "ul.ie": 1,
    "ul.pt": 1,
    "ula.edu.mx": 1,
    "ula.ve": 1,
    "ulaanbaatar.edu.mn": 1,
    "ulab.edu.bd": 1,
    "ulacit.ac.cr": 1,
    "ulacit.ac.pa": 1,
    "uladech.edu.pe": 1,
    "ulagos.cl": 1,
    "ulaicavr.com": 1,
    "ulam.edu.ni": 1,
    "ulangola.net": 1,
    "ulapland.fi": 1,
    "ulare.cl": 1,
    "ulasalle.ac.cr": 1,
    "ulat.ac.pa": 1,
    "ulatina.ac.cr": 1,
    "ulaval.ca": 1,
    "ulb.ac.be": 1,
    "ulbra.br": 1,
    "ulbsibiu.ro": 1,
    "ulbu.bi": 1,
    "uleam.edu.ec": 1,
    "uleth.ca": 1,
    "ulg.ac.be": 1,
    "ulicori.ac.cr": 1,
    "ulim.md": 1,
    "ulima.edu.pe": 1,
    "ulivingstonia.com": 1,
    "ulk.ac.rw": 1,
    "ull.es": 1,
    "ulm.edu": 1,
    "uloyola.es": 1,
    "ulpgc.es": 1,
    "ulsa.edu.mx": 1,
    "ulsab.edu.mx": 1,
    "ulsac.edu.mx": 1,
    "ulsan.ac.kr": 1,
    "ulsop.ac.uk": 1,
    "ulspu.ru": 1,
    "ulst.ac.uk": 1,
    "ulstu.ru": 1,
    "ulsu.ru": 1,
    "ult.ens.tn": 1,
    "uludag.edu.tr": 1,
    "ulusiada.pt": 1,
    "ulusofona.pt": 1,
    "um-rdc.org": 1,
    "um.ac.id": 1,
    "um.ac.ir": 1,
    "um.edu.ar": 1,
    "um.edu.mt": 1,
    "um.edu.my": 1,
    "um.edu.uy": 1,
    "um.es": 1,
    "um.rnu.tn": 1,
    "um.si": 1,
    "um1ygn.edu.mm": 1,
    "um5a.ac.ma": 1,
    "um5s.ac.ma": 1,
    "uma.ac.in": 1,
    "uma.ac.ir": 1,
    "uma.co.ao": 1,
    "uma.edu.py": 1,
    "uma.edu.sv": 1,
    "uma.es": 1,
    "uma.pt": 1,
    "uma.rnu.tn": 1,
    "umac.mo": 1,
    "umad.edu.mx": 1,
    "umag.cl": 1,
    "umaine.edu": 1,
    "uman.edu.mx": 1,
    "umanitoba.ca": 1,
    "umanizales.edu.co": 1,
    "umar.mx": 1,
    "umariana.edu.co": 1,
    "umaritima.cl": 1,
    "umaryland.edu": 1,
    "umass.edu": 1,
    "umassd.edu": 1,
    "umayor.cl": 1,
    "umaza.edu.ar": 1,
    "umb.edu": 1,
    "umb.edu.co": 1,
    "umb.edu.pe": 1,
    "umb.no": 1,
    "umb.sk": 1,
    "umbb.dz": 1,
    "umbc.edu": 1,
    "umc.br": 1,
    "umc.edu": 1,
    "umc.edu.dz": 1,
    "umca.net": 1,
    "umcc.cu": 1,
    "umce.cl": 1,
    "umcollege.com": 1,
    "umcs.lublin.pl": 1,
    "umd.edu": 1,
    "umdearborn.edu": 1,
    "umds.ac.jp": 1,
    "umds.ac.uk": 1,
    "ume.cl": 1,
    "umes.edu": 1,
    "umf.maine.edu": 1,
    "umfcluj.ro": 1,
    "umfiasi.ro": 1,
    "umfk.maine.edu": 1,
    "umflint.edu": 1,
    "umft.ro": 1,
    "umftgm.ro": 1,
    "umg.edu.gt": 1,
    "umh.ac.be": 1,
    "umh.es": 1,
    "umhelena.edu": 1,
    "umi-mdn.edu": 1,
    "umi.ac.id": 1,
    "umi.edu.mx": 1,
    "umi.edu.pk": 1,
    "umich.edu": 1,
    "umich.mx": 1,
    "umindanao.edu.ph": 1,
    "uminho.pt": 1,
    "umit.at": 1,
    "umj.ac.id": 1,
    "umk.ac.id": 1,
    "umk.edu.my": 1,
    "umkc.edu": 1,
    "uml.edu": 1,
    "umla.edu.mx": 1,
    "umm.ac.id": 1,
    "umm.edu.mx": 1,
    "umm.maine.edu": 1,
    "ummg.edu.mm": 1,
    "ummgl.ac.id": 1,
    "ummto.dz": 1,
    "umn.edu": 1,
    "umne.edu.mx": 1,
    "umng.edu.co": 1,
    "umoar.edu.sv": 1,
    "umoderna.pt": 1,
    "umoncton.ca": 1,
    "umontemorelos.edu.mx": 1,
    "umontreal.ca": 1,
    "ump.ac.za": 1,
    "ump.edu.my": 1,
    "umpi.maine.edu": 1,
    "umpqua.edu": 1,
    "umr.edu": 1,
    "ums.ac.id": 1,
    "ums.edu.my": 1,
    "umsa.edu.ar": 1,
    "umsa.edu.mx": 1,
    "umsanet.edu.bo": 1,
    "umsha.ac.ir": 1,
    "umsl.edu": 1,
    "umss.edu.bo": 1,
    "umst-edu.com": 1,
    "umsu.ac.id": 1,
    "umsu.ac.ir": 1,
    "umt.edu": 1,
    "umt.edu.my": 1,
    "umt.edu.pk": 1,
    "umtech.edu.my": 1,
    "umu.ac.ug": 1,
    "umu.se": 1,
    "umuc.edu": 1,
    "umutarapolytech.ac.rw": 1,
    "umw.edu": 1,
    "umy.ac.id": 1,
    "umyu.edu.ng": 1,
    "umz.ac.ir": 1,
    "un.edu.mx": 1,
    "un.mx": 1,
    "una.ac.cr": 1,
    "una.an": 1,
    "una.edu.ni": 1,
    "una.edu.ve": 1,
    "una.py": 1,
    "unaab.edu.ng": 1,
    "unab.cl": 1,
    "unab.edu.co": 1,
    "unab.edu.sv": 1,
    "unac.edu.co": 1,
    "unac.edu.pe": 1,
    "unacar.mx": 1,
    "unach.edu.ec": 1,
    "unach.mx": 1,
    "unachi.ac.pa": 1,
    "unachile.cl": 1,
    "unad.edu.co": 1,
    "unad.edu.do": 1,
    "unadeca.ac.cr": 1,
    "unadp.ac.pa": 1,
    "unaerp.br": 1,
    "unah.edu.hn": 1,
    "unai.edu": 1,
    "unair.ac.id": 1,
    "unak.is": 1,
    "unal.edu.co": 1,
    "unam.ac.cr": 1,
    "unam.edu.ar": 1,
    "unam.mx": 1,
    "unam.na": 1,
    "unama.br": 1,
    "unan.edu.ni": 1,
    "unand.ac.id": 1,
    "unap.cl": 1,
    "unap.edu.pe": 1,
    "unapec.edu.do": 1,
    "unapiquitos.edu.pe": 1,
    "unarte.ro": 1,
    "unas.ac.id": 1,
    "unas.edu.pe": 1,
    "unasa.edu.sv": 1,
    "unasam.edu.pe": 1,
    "unat.ens.tn": 1,
    "unatc.ro": 1,
    "unaula.edu.co": 1,
    "unav.es": 1,
    "unavarra.es": 1,
    "unb.br": 1,
    "unb.ca": 1,
    "unbc.ca": 1,
    "unbeg.edu.sd": 1,
    "unbi.ba": 1,
    "unbosque.edu.co": 1,
    "unbsj.ca": 1,
    "unc.edu": 1,
    "unc.edu.ar": 1,
    "unc.edu.pe": 1,
    "unc.edu.ph": 1,
    "unca.edu": 1,
    "unca.edu.ar": 1,
    "uncc.edu": 1,
    "uncen.ac.id": 1,
    "uncfsu.edu": 1,
    "uncg.edu": 1,
    "unco.edu": 1,
    "uncoma.edu.ar": 1,
    "uncp.edu.pe": 1,
    "uncu.edu.ar": 1,
    "uncw.edu": 1,
    "und.edu": 1,
    "undac.edu.pe": 1,
    "undana.ac.id": 1,
    "undh.org": 1,
    "undip.ac.id": 1,
    "une.edu": 1,
    "une.edu.au": 1,
    "une.edu.mx": 1,
    "une.edu.pe": 1,
    "une.edu.py": 1,
    "une.edu.ve": 1,
    "uneb.br": 1,
    "unec.edu.az": 1,
    "uned.ac.cr": 1,
    "uned.es": 1,
    "unefa.edu.do": 1,
    "unefa.edu.ve": 1,
    "unefm.edu.ve": 1,
    "uneg.edu.ve": 1,
    "unej.ac.id": 1,
    "unellez.edu.ve": 1,
    "unem.edu": 1,
    "unep.edu.ph": 1,
    "uneph.org": 1,
    "uner.edu.ar": 1,
    "unerg.edu.ve": 1,
    "unermb.edu.ve": 1,
    "unes.edu.mx": 1,
    "unesa.ac.id": 1,
    "unesc.rct-sc.br": 1,
    "unesco-ihe.org": 1,
    "unesp.br": 1,
    "unesr.edu.ve": 1,
    "unesur.edu.ve": 1,
    "unet.edu.ve": 1,
    "unev-rd.edu.do": 1,
    "unex.es": 1,
    "unexpo.edu.ve": 1,
    "unf.edu": 1,
    "unf.edu.ar": 1,
    "unfa.cl": 1,
    "unfv.edu.pe": 1,
    "ung.ac.id": 1,
    "ung.br": 1,
    "ung.edu": 1,
    "ung.si": 1,
    "unge.gq": 1,
    "ungs.edu.ar": 1,
    "unh.edu": 1,
    "unhalu.ac.id": 1,
    "unhamzah.ac.id": 1,
    "unhas.ac.id": 1,
    "unheval.edu.pe": 1,
    "uni-agro.grodno.by": 1,
    "uni-augsburg.de": 1,
    "uni-bamberg.de": 1,
    "uni-bayreuth.de": 1,
    "uni-bielefeld.de": 1,
    "uni-bonn.de": 1,
    "uni-bremen.de": 1,
    "uni-dubna.ru": 1,
    "uni-duesseldorf.de": 1,
    "uni-duisburg-essen.de": 1,
    "uni-erfurt.de": 1,
    "uni-erlangen.de": 1,
    "uni-flensburg.de": 1,
    "uni-frankfurt.de": 1,
    "uni-freiburg.de": 1,
    "uni-giessen.de": 1,
    "uni-goettingen.de": 1,
    "uni-greifswald.de": 1,
    "uni-halle.de": 1,
    "uni-hamburg.de": 1,
    "uni-hannover.de": 1,
    "uni-heidelberg.de": 1,
    "uni-hildesheim.de": 1,
    "uni-hohenheim.de": 1,
    "uni-jena.de": 1,
    "uni-kassel.de": 1,
    "uni-kiel.de": 1,
    "uni-kl.de": 1,
    "uni-klu.ac.at": 1,
    "uni-koblenz-landau.de": 1,
    "uni-koeln.de": 1,
    "uni-konstanz.de": 1,
    "uni-leipzig.de": 1,
    "uni-lj.si": 1,
    "uni-lueneburg.de": 1,
    "uni-magdeburg.de": 1,
    "uni-mainz.de": 1,
    "uni-mannheim.de": 1,
    "uni-marburg.de": 1,
    "uni-miskolc.hu": 1,
    "uni-muenchen.de": 1,
    "uni-muenster.de": 1,
    "uni-mysore.ac.in": 1,
    "uni-oldenburg.de": 1,
    "uni-osnabrueck.de": 1,
    "uni-paderborn.de": 1,
    "uni-pannon.hu": 1,
    "uni-passau.de": 1,
    "uni-plovdiv.bg": 1,
    "uni-polsdam.de": 1,
    "uni-potsdam.de": 1,
    "uni-pr.edu": 1,
    "uni-prizren.com": 1,
    "uni-regensburg.de": 1,
    "uni-rostock.de": 1,
    "uni-saarland.de": 1,
    "uni-siegen.de": 1,
    "uni-sofia.bg": 1,
    "uni-stuttgart.de": 1,
    "uni-svishtov.bg": 1,
    "uni-sz.bg": 1,
    "uni-trier.de": 1,
    "uni-tuebingen.de": 1,
    "uni-ulm.de": 1,
    "uni-vechta.de": 1,
    "uni-vologda.ac.ru": 1,
    "uni-vt.bg": 1,
    "uni-weimar.de": 1,
    "uni-wh.de": 1,
    "uni-wuerzburg.de": 1,
    "uni-wuppertal.de": 1,
    "uni.edu": 1,
    "uni.edu.ni": 1,
    "uni.edu.pe": 1,
    "uni.li": 1,
    "uni.lodz.pl": 1,
    "uni.lu": 1,
    "uni.opole.pl": 1,
    "uni.pt": 1,
    "uni.sydney.edu.au": 1,
    "uni.torun.pl": 1,
    "uni.udm.ru": 1,
    "uni.wroc.pl": 1,
    "unia.ao": 1,
    "uniaam.uia.es": 1,
    "uniacc.cl": 1,
    "uniactiva.com": 1,
    "uniag.sk": 1,
    "uniamazonia.edu.co": 1,
    "unian.it": 1,
    "uniandes.edu.co": 1,
    "uniara.com.br": 1,
    "uniara.uia.es": 1,
    "uniatlantico.edu.co": 1,
    "unib.ac.id": 1,
    "unib.br": 1,
    "uniba.it": 1,
    "uniba.sk": 1,
    "uniban.br": 1,
    "uniband.org": 1,
    "unibas.ch": 1,
    "unibas.it": 1,
    "unibda.net": 1,
    "unibe.ac.cr": 1,
    "unibe.ch": 1,
    "unibe.edu.do": 1,
    "uniben.edu": 1,
    "unibg.it": 1,
    "unibl.org": 1,
    "unibo.edu.ar": 1,
    "unibo.it": 1,
    "unibocconi.it": 1,
    "unibosco.br": 1,
    "uniboyaca.edu.co": 1,
    "unibrasil.com.br": 1,
    "unibs.it": 1,
    "unibuc.ro": 1,
    "unibuja.edu.ng": 1,
    "unibw-hamburg.de": 1,
    "unibw-muenchen.de": 1,
    "unibz.it": 1,
    "unic.ac.cy": 1,
    "unica.cu": 1,
    "unica.edu.do": 1,
    "unica.edu.mx": 1,
    "unica.edu.ni": 1,
    "unica.edu.pe": 1,
    "unica.edu.ve": 1,
    "unica.it": 1,
    "unicach.edu.mx": 1,
    "unicaen.fr": 1,
    "unicah.edu": 1,
    "unical.ac.in": 1,
    "unical.edu.ng": 1,
    "unical.it": 1,
    "unicam.it": 1,
    "unicamp.br": 1,
    "unicampus.it": 1,
    "unicap.br": 1,
    "unicaribe.edu.do": 1,
    "unicartagena.edu.co": 1,
    "unicas.it": 1,
    "unicastelo.br": 1,
    "unicatt.it": 1,
    "unice.fr": 1,
    "unicen.edu.ar": 1,
    "unicen.edu.bo": 1,
    "unicesar.edu.co": 1,
    "unich.it": 1,
    "unicid.br": 1,
    "unicit.cl": 1,
    "unicit.edu.ni": 1,
    "unico.edu.sv": 1,
    "unicordoba.edu.co": 1,
    "unicruz.tche.br": 1,
    "unicsul.br": 1,
    "unict.it": 1,
    "unida.edu.py": 1,
    "unidavi.rct-sc.br": 1,
    "unideb.hu": 1,
    "unidu.hr": 1,
    "uniedpa.com": 1,
    "uniel.edu.al": 1,
    "uniese.it": 1,
    "unifacs.br": 1,
    "unifap.br": 1,
    "unife.edu.pe": 1,
    "unife.it": 1,
    "unifenas.br": 1,
    "unifeso.edu.br": 1,
    "unifg.it": 1,
    "unifi.it": 1,
    "unifiji.ac.fj": 1,
    "unifor.br": 1,
    "unifr.ch": 1,
    "unifran.br": 1,
    "unifranz.edu.bo": 1,
    "unig.br": 1,
    "unige.ch": 1,
    "unige.it": 1,
    "unigoa.ac.in": 1,
    "unigoro.ac.id": 1,
    "unigranrio.br": 1,
    "unigre.it": 1,
    "unigre.urbe.it": 1,
    "uniguajira.edu.co": 1,
    "unijos.edu.ng": 1,
    "unijui.tche.br": 1,
    "unik-kediri.ac.id": 1,
    "unika.ac.id": 1,
    "unikal.ac.id": 1,
    "unikin.cd": 1,
    "unikino.mx": 1,
    "unikis.ac.cd": 1,
    "unikl.edu.my": 1,
    "unikom.ac.id": 1,
    "unikuljis.edu.bo": 1,
    "unil.ch": 1,
    "unila.ac.id": 1,
    "unilag.edu.ng": 1,
    "unilak.ac.id": 1,
    "unile.it": 1,
    "unileoben.ac.at": 1,
    "unileon.es": 1,
    "unilib.neva.ru": 1,
    "unilibre.edu.co": 1,
    "unilim.fr": 1,
    "unilink.it": 1,
    "unillanos.edu.co": 1,
    "unilorin.edu.ng": 1,
    "unilu.ac.cd": 1,
    "unilu.ch": 1,
    "uniludes.ch": 1,
    "unilurio.ac.mz": 1,
    "unilus.ac.zm": 1,
    "unima.ac.id": 1,
    "unima.mw": 1,
    "unimaas.nl": 1,
    "unimagdalena.edu.co": 1,
    "unimaid.edu.ng": 1,
    "unimap.edu.my": 1,
    "unimar.br": 1,
    "unimas.my": 1,
    "unimayab.edu.mx": 1,
    "unimc.it": 1,
    "unime.it": 1,
    "unimed.ac.id": 1,
    "unimelb.edu.au": 1,
    "unimep.br": 1,
    "unimes.com.br": 1,
    "unimet.edu.ve": 1,
    "unimetro.edu.co": 1,
    "unimetro.edu.hn": 1,
    "unimetroangola.com": 1,
    "unimex.edu.mx": 1,
    "unimi.it": 1,
    "unimib.it": 1,
    "unimkar.edu.ng": 1,
    "unimol.it": 1,
    "unimonte.br": 1,
    "unimontes.br": 1,
    "unimoron.edu.ar": 1,
    "unin.hr": 1,
    "unina.it": 1,
    "unina2.it": 1,
    "uninav.it": 1,
    "unincca.edu.co": 1,
    "unine.ch": 1,
    "uninorte.edu.co": 1,
    "uninorte.edu.py": 1,
    "uninova.sk": 1,
    "uninp.edu.rs": 1,
    "uninsubria.it": 1,
    "uninus.ac.id": 1,
    "unioeste.br": 1,
    "union.edu": 1,
    "unios.hr": 1,
    "uniosun.edu.ng": 1,
    "uniovi.es": 1,
    "unip-objetivo.br": 1,
    "unipa.it": 1,
    "unipamplona.edu.co": 1,
    "unipavaresia.edu.al": 1,
    "unipaz.edu.co": 1,
    "unipd.it": 1,
    "unipdu.ac.id": 1,
    "unipe.br": 1,
    "unipg.it": 1,
    "unipi.gr": 1,
    "unipi.it": 1,
    "unipiloto.edu.co": 1,
    "unipli.com.br": 1,
    "unipo.sk": 1,
    "uniport.edu.ng": 1,
    "unipr.it": 1,
    "unipu.hr": 1,
    "unipune.ernet.in": 1,
    "unipv.it": 1,
    "uniq.edu": 1,
    "uniquindio.edu.co": 1,
    "unir.br": 1,
    "unira-pmk.net": 1,
    "uniraj.org": 1,
    "unirazak.edu.my": 1,
    "unirc.it": 1,
    "uniremhos.edu.do": 1,
    "uniri.hr": 1,
    "unirio.br": 1,
    "unirioja.es": 1,
    "uniroma1.it": 1,
    "uniroma2.eu": 1,
    "uniroma3.it": 1,
    "unirsm.sm": 1,
    "unis.edu.gt": 1,
    "unis.sn": 1,
    "unisa.ac.za": 1,
    "unisa.br": 1,
    "unisa.edu.au": 1,
    "unisa.it": 1,
    "unisabana.edu.co": 1,
    "unisal.it": 1,
    "unisannio.it": 1,
    "unisantos.com.br": 1,
    "unisba.ac.id": 1,
    "unisc.br": 1,
    "unisel.edu.my": 1,
    "unisey.ac.sc": 1,
    "unisg.ch": 1,
    "unisg.it": 1,
    "unishabunia.org": 1,
    "unishivaji.ac.in": 1,
    "unishk.edu.al": 1,
    "unisi.it": 1,
    "unisilvaner.info": 1,
    "unisimonbolivar.edu.co": 1,
    "unisinos.br": 1,
    "unisinucartagena.edu.co": 1,
    "unisma.ac.id": 1,
    "unismuh.ac.id": 1,
    "unisob.na.it": 1,
    "unispital.ch": 1,
    "unisri.ac.id": 1,
    "uniss.it": 1,
    "unissa.edu.bn": 1,
    "unissula.ac.id": 1,
    "unist.ac.kr": 1,
    "unist.hr": 1,
    "unistangerang.ac.id": 1,
    "unistrapg.it": 1,
    "unistrasi.it": 1,
    "unisucre.edu.co": 1,
    "unisul.br": 1,
    "uniswa.sz": 1,
    "unisza.edu.my": 1,
    "unit.br": 1,
    "unita.edu.ec": 1,
    "unitar.edu.my": 1,
    "unitau.br": 1,
    "unitbv.ro": 1,
    "unite.edu.mk": 1,
    "unite.it": 1,
    "unitec.edu": 1,
    "unitec.edu.ve": 1,
    "unitec.mx": 1,
    "unitech.ac.pg": 1,
    "uniten.edu.my": 1,
    "unitir.edu.al": 1,
    "unitn.it": 1,
    "unito.it": 1,
    "unitomo.ac.id": 1,
    "unitru.edu.pe": 1,
    "units.it": 1,
    "unitus.it": 1,
    "uniube.br": 1,
    "uniud.it": 1,
    "uniurb.it": 1,
    "uniuyo.edu.ng": 1,
    "univ-ab.pt": 1,
    "univ-ag.fr": 1,
    "univ-alger.dz": 1,
    "univ-alger3.dz": 1,
    "univ-angers.fr": 1,
    "univ-annaba.dz": 1,
    "univ-antananarivo.mg": 1,
    "univ-antsiranana.mg": 1,
    "univ-artois.fr": 1,
    "univ-avignon.fr": 1,
    "univ-bangui.net": 1,
    "univ-batna.dz": 1,
    "univ-bejaia.dz": 1,
    "univ-biskra.dz": 1,
    "univ-blida.dz": 1,
    "univ-bpclermont.fr": 1,
    "univ-brest.fr": 1,
    "univ-catholyon.fr": 1,
    "univ-chlef.dz": 1,
    "univ-cocody.ci": 1,
    "univ-corse.fr": 1,
    "univ-douala.com": 1,
    "univ-dschang.org": 1,
    "univ-emir.dz": 1,
    "univ-evry.fr": 1,
    "univ-fianar.mg": 1,
    "univ-grenoble-alpes.fr": 1,
    "univ-guelma.dz": 1,
    "univ-ibntofail.ac.ma": 1,
    "univ-inpt.fr": 1,
    "univ-jijel.dz": 1,
    "univ-k.rnu.tn": 1,
    "univ-kag.org": 1,
    "univ-lehavre.fr": 1,
    "univ-lemans.fr": 1,
    "univ-lille1.fr": 1,
    "univ-lille2.fr": 1,
    "univ-lille3.fr": 1,
    "univ-littoral.fr": 1,
    "univ-lome.tg": 1,
    "univ-lorraine.fr": 1,
    "univ-lr.fr": 1,
    "univ-lyon1.fr": 1,
    "univ-lyon2.fr": 1,
    "univ-lyon3.fr": 1,
    "univ-mahajanga.mg": 1,
    "univ-metz.fr": 1,
    "univ-mlv.fr": 1,
    "univ-mngb.net": 1,
    "univ-montp1.fr": 1,
    "univ-montp2.fr": 1,
    "univ-montp3.fr": 1,
    "univ-mosta.dz": 1,
    "univ-msila.dz": 1,
    "univ-mulhouse.fr": 1,
    "univ-nancy2.fr": 1,
    "univ-nantes.fr": 1,
    "univ-ndere.cm": 1,
    "univ-ndjamena.org": 1,
    "univ-nkc.mr": 1,
    "univ-oeb.dz": 1,
    "univ-oran.dz": 1,
    "univ-orleans.fr": 1,
    "univ-ouaga.bf": 1,
    "univ-ouargla.dz": 1,
    "univ-oujda.ac.ma": 1,
    "univ-ovidius.ro": 1,
    "univ-paris1.fr": 1,
    "univ-paris12.fr": 1,
    "univ-paris13.fr": 1,
    "univ-paris3.fr": 1,
    "univ-paris5.fr": 1,
    "univ-paris8.fr": 1,
    "univ-pau.fr": 1,
    "univ-perp.fr": 1,
    "univ-poitiers.fr": 1,
    "univ-reims.fr": 1,
    "univ-rennes1.fr": 1,
    "univ-reunion.fr": 1,
    "univ-rouen.fr": 1,
    "univ-saida.dz": 1,
    "univ-sante.edu.kh": 1,
    "univ-savoie.fr": 1,
    "univ-sba.dz": 1,
    "univ-setif.dz": 1,
    "univ-skikda.dz": 1,
    "univ-st-etienne.fr": 1,
    "univ-tebessa.dz": 1,
    "univ-thies.sn": 1,
    "univ-tiaret.dz": 1,
    "univ-tlemcen.dz": 1,
    "univ-tln.fr": 1,
    "univ-tlse1.fr": 1,
    "univ-tlse2.fr": 1,
    "univ-toamasina.mg": 1,
    "univ-toliara.mg": 1,
    "univ-toulouse.fr": 1,
    "univ-tours.fr": 1,
    "univ-ubs.fr": 1,
    "univ-usto.dz": 1,
    "univ-valenciennes.fr": 1,
    "univ-zig.sn": 1,
    "univ.edu.dj": 1,
    "univ.gda.pl": 1,
    "univ.kiev.ua": 1,
    "univ.rzeszow.pl": 1,
    "univ.szczecin.pl": 1,
    "univ.uzhgorod.ua": 1,
    "univa.mx": 1,
    "univagro-iasi.ro": 1,
    "unival.edu.ni": 1,
    "univale.br": 1,
    "univali.rct-sc.br": 1,
    "univalle.edu": 1,
    "univalle.edu.co": 1,
    "univap.br": 1,
    "univaq.it": 1,
    "univas.edu.mx": 1,
    "univasf.edu.br": 1,
    "univcb.ro": 1,
    "univchapultepec.edu.mx": 1,
    "univd.edu.ua": 1,
    "unive.it": 1,
    "univen.ac.za": 1,
    "univer.kharkov.ua": 1,
    "univer.omsk.su": 1,
    "univermed-cdgm.ro": 1,
    "universidad-monteavila.edu.ve": 1,
    "universidad-policial.edu.ar": 1,
    "universidad.edu.uy": 1,
    "universidadarcis.cl": 1,
    "universidadatlantico.org": 1,
    "universidadbrauliocarrillo.com": 1,
    "universidadcentral.com": 1,
    "universidaddeleon.edu.mx": 1,
    "universidade-autonoma.pt": 1,
    "universidadlaconcordia.edu.mx": 1,
    "universidadmotolinia.edu.mx": 1,
    "universidadnotarial.edu.ar": 1,
    "universidadpedagogica.com": 1,
    "universidadsalesiana.edu.mx": 1,
    "universidadsanjosecr.com": 1,
    "universitas-trilogi.ac.id": 1,
    "universitateamaritima.ro": 1,
    "universite-yde2.org": 1,
    "universitekongo.org": 1,
    "university.kg": 1,
    "university.kherson.ua": 1,
    "university.tversu.ru": 1,
    "universitycanadawest.ca": 1,
    "universityliberia.org": 1,
    "universityofbohol.com": 1,
    "universityofcebu.edu.ph": 1,
    "universityofsomalia.net": 1,
    "universo.br": 1,
    "universum-ks.org": 1,
    "univet.hu": 1,
    "univgb.rnu.tn": 1,
    "univie.ac.at": 1,
    "univillarica.mx": 1,
    "univlora.edu.al": 1,
    "univman.edu.ph": 1,
    "univmed.fr": 1,
    "univo.edu.sv": 1,
    "univpancasila.ac.id": 1,
    "univr.it": 1,
    "univsul.org": 1,
    "uniwest.ac.za": 1,
    "uniyar.ac.ru": 1,
    "uniza.sk": 1,
    "unizambeze.ac.mz": 1,
    "unizar.es": 1,
    "unizd.hr": 1,
    "unizg.hr": 1,
    "unizh.ch": 1,
    "unizik.edu.ng": 1,
    "unizulu.ac.za": 1,
    "unizwa.edu.om": 1,
    "unj.ac.id": 1,
    "unja.ac.id": 1,
    "unjani.ac.id": 1,
    "unjbg.edu.pe": 1,
    "unjfsc.edu.pe": 1,
    "unju.edu.ar": 1,
    "unk.edu": 1,
    "unkhair.ac.id": 1,
    "unklab.ac.id": 1,
    "unkorce.edu.al": 1,
    "unkris.ac.id": 1,
    "unl.ac.uk": 1,
    "unl.edu": 1,
    "unl.edu.ar": 1,
    "unl.edu.ec": 1,
    "unl.pt": 1,
    "unla.edu.ar": 1,
    "unla.edu.mx": 1,
    "unlam.ac.id": 1,
    "unlam.edu.ar": 1,
    "unlar.edu.ar": 1,
    "unlp.edu.ar": 1,
    "unlpam.edu.ar": 1,
    "unlu.edu.ar": 1,
    "unlv.edu": 1,
    "unlz.edu.ar": 1,
    "unm.ac.id": 1,
    "unm.edu": 1,
    "unmas.org": 1,
    "unmb.ro": 1,
    "unmer-madiun.ac.id": 1,
    "unmer.ac.id": 1,
    "unmo.ba": 1,
    "unmsm.edu.pe": 1,
    "unmuhjember.ac.id": 1,
    "unmuhmataram.com": 1,
    "unmul.ac.id": 1,
    "unn.ac.ru": 1,
    "unn.ac.uk": 1,
    "unn.edu.ng": 1,
    "unne.edu.ar": 1,
    "unnes.ac.id": 1,
    "unnet.es": 1,
    "unnoba.edu.ar": 1,
    "uno-r.edu.ph": 1,
    "uno.edu": 1,
    "uno.mx": 1,
    "unoesc.edu.br": 1,
    "unoeste.br": 1,
    "unom.ac.in": 1,
    "unomaha.edu": 1,
    "unp.ac.id": 1,
    "unp.br": 1,
    "unp.edu.ar": 1,
    "unp.edu.pe": 1,
    "unp.edu.ph": 1,
    "unpa.edu.ar": 1,
    "unpad.ac.id": 1,
    "unpak.ac.id": 1,
    "unpar.ac.id": 1,
    "unpas.ac.id": 1,
    "unpatti.ac.id": 1,
    "unphu.edu.do": 1,
    "unprg.edu.pe": 1,
    "unq.edu.ar": 1,
    "unr.ac.id": 1,
    "unr.edu": 1,
    "unr.edu.ar": 1,
    "unram.ac.id": 1,
    "unrc.edu.ar": 1,
    "unri.ac.id": 1,
    "uns.ac.id": 1,
    "uns.ac.rs": 1,
    "uns.edu.ar": 1,
    "uns.edu.pe": 1,
    "unsa.ba": 1,
    "unsa.edu.ar": 1,
    "unsa.edu.pe": 1,
    "unsaac.edu.pe": 1,
    "unsada.ac.id": 1,
    "unsam.edu.ar": 1,
    "unsch.edu.pe": 1,
    "unse.edu.ar": 1,
    "unsil.ac.id": 1,
    "unsj.edu.ar": 1,
    "unsl.edu.ar": 1,
    "unslp.edu.bo": 1,
    "unsm.edu.pe": 1,
    "unsoed.ac.id": 1,
    "unsrat.ac.id": 1,
    "unsri.ac.id": 1,
    "unssa.edu.sv": 1,
    "unssa.rs.ba": 1,
    "unsta.edu.ar": 1,
    "unsw.edu.au": 1,
    "unswagati-crb.ac.id": 1,
    "unsxx.edu.bo": 1,
    "unsyiah.ac.id": 1,
    "unt.edu": 1,
    "unt.edu.ar": 1,
    "untad.ac.id": 1,
    "untag-banyuwangi.ac.id": 1,
    "untag-jkt.org": 1,
    "untag-smd.ac.id": 1,
    "untag.ac.id": 1,
    "untagcirebon.info": 1,
    "untagsmg.ac.id": 1,
    "untan.ac.id": 1,
    "untar.ac.id": 1,
    "unthsc.edu": 1,
    "untirta.ac.id": 1,
    "untref.edu.ar": 1,
    "untumbes.edu.pe": 1,
    "untz.ba": 1,
    "unu.edu": 1,
    "unu.edu.pe": 1,
    "unu.edu.sd": 1,
    "unud.ac.id": 1,
    "unum.edu.mx": 1,
    "unva.cz": 1,
    "unvi.edu.ba": 1,
    "unw.edu.pk": 1,
    "unwe.acad.bg": 1,
    "unwiku.ac.id": 1,
    "uny.ac.id": 1,
    "unyp.cz": 1,
    "unyt.edu.al": 1,
    "unza.zm": 1,
    "unze.ba": 1,
    "uo.edu.cu": 1,
    "uoa.gr": 1,
    "uoalmuthana.edu.iq": 1,
    "uoanbar.edu.iq": 1,
    "uob.edu.bh": 1,
    "uob.edu.ly": 1,
    "uob.edu.pk": 1,
    "uob.ga": 1,
    "uobabylon.edu.iq": 1,
    "uobaghdad.edu.iq": 1,
    "uobasrah.edu.iq": 1,
    "uoc.edu": 1,
    "uoc.es": 1,
    "uoc.gr": 1,
    "uod.ac": 1,
    "uod.edu.do": 1,
    "uoda.edu.bd": 1,
    "uodiyala.edu.iq": 1,
    "uoe.edu.pk": 1,
    "uoeh-u.ac.jp": 1,
    "uoeld.ac.ke": 1,
    "uofd.edu.sd": 1,
    "uofg.edu.sd": 1,
    "uofk.edu": 1,
    "uog.ac.pg": 1,
    "uog.edu": 1,
    "uog.edu.et": 1,
    "uog.edu.gy": 1,
    "uog.edu.pk": 1,
    "uogj.edu.al": 1,
    "uoguelph.ca": 1,
    "uoh.edu.sa": 1,
    "uohyd.ernet.in": 1,
    "uoi.gr": 1,
    "uoit.ca": 1,
    "uojazeera.com": 1,
    "uok.ac.in": 1,
    "uok.ac.ir": 1,
    "uok.edu.pk": 1,
    "uok.edu.sy": 1,
    "uokerbala.edu.iq": 1,
    "uokirkuk.edu.iq": 1,
    "uokufa.edu.iq": 1,
    "uol.edu.pk": 1,
    "uom.ac.mu": 1,
    "uom.edu.mx": 1,
    "uom.edu.pk": 1,
    "uom.gr": 1,
    "uomisan.edu.iq": 1,
    "uomosul.edu.iq": 1,
    "uomustansiriyah.edu.iq": 1,
    "uonbi.ac.ke": 1,
    "uop.edu": 1,
    "uop.edu.jo": 1,
    "uop.gr": 1,
    "uopeople.edu": 1,
    "uor.edu": 1,
    "uor.org": 1,
    "uoradea.ro": 1,
    "uoregon.edu": 1,
    "uos.ac.kr": 1,
    "uos.edu.pk": 1,
    "uosa.uar.net": 1,
    "uot.edu.ly": 1,
    "uotechnology.edu.iq": 1,
    "uottawa.ca": 1,
    "uou.ac.in": 1,
    "uou.edu.ps": 1,
    "uovs.ac.za": 1,
    "uow.edu.au": 1,
    "uowasit.edu.iq": 1,
    "uowdubai.ac.ae": 1,
    "uowm.gr": 1,
    "uoz.ac.ir": 1,
    "up.ac.mz": 1,
    "up.ac.pa": 1,
    "up.ac.za": 1,
    "up.edu": 1,
    "up.edu.pe": 1,
    "up.edu.ps": 1,
    "up.mx": 1,
    "up.pt": 1,
    "up.univ-mrs.fr": 1,
    "up45.ac.id": 1,
    "upa.cl": 1,
    "upa.ro": 1,
    "upacifico.cl": 1,
    "upacifico.edu.ec": 1,
    "upaep.mx": 1,
    "upal.edu": 1,
    "upan.edu.sv": 1,
    "upana.edu.gt": 1,
    "upang.edu.ph": 1,
    "upao.edu.pe": 1,
    "upatras.gr": 1,
    "upb.edu": 1,
    "upb.edu.co": 1,
    "upb.edu.ph": 1,
    "upc-rdc.cd": 1,
    "upc.edu": 1,
    "upc.edu.pe": 1,
    "upce.cz": 1,
    "upch.edu.pe": 1,
    "upci.edu.pe": 1,
    "upco.es": 1,
    "upct.es": 1,
    "upd.edu.ph": 1,
    "upds.edu.bo": 1,
    "upe.br": 1,
    "upe.edu.py": 1,
    "upeace.org": 1,
    "upei.ca": 1,
    "upel.edu.ve": 1,
    "upenn.edu": 1,
    "upes.edu.sv": 1,
    "upesh.edu": 1,
    "upet.ro": 1,
    "upeu.edu.pe": 1,
    "upf.edu": 1,
    "upf.es": 1,
    "upf.pf": 1,
    "upf.tche.br": 1,
    "upg-ploiesti.ro": 1,
    "uph.edu": 1,
    "uphighschoolcebu.edu.ph": 1,
    "uphr.edu.ph": 1,
    "upi.edu": 1,
    "upiig.ipn.mx": 1,
    "upis.br": 1,
    "upit.ro": 1,
    "upj.pitt.edu": 1,
    "upjs.sk": 1,
    "upla.edu.pe": 1,
    "uplb.edu.ph": 1,
    "upm.edu.my": 1,
    "upm.edu.ph": 1,
    "upm.es": 1,
    "upm.moldnet.md": 1,
    "upm.ro": 1,
    "upmc.com": 1,
    "upmc.edu": 1,
    "upmin.edu.ph": 1,
    "upn.mx": 1,
    "upnfm.edu.hn": 1,
    "upng.ac.pg": 1,
    "upnjatim.ac.id": 1,
    "upnorte.edu.pe": 1,
    "upo.es": 1,
    "upol.cz": 1,
    "upoli.edu.ni": 1,
    "uponic.edu.ni": 1,
    "uportu.pt": 1,
    "upou.org": 1,
    "upr-ponce.upr.edu": 1,
    "upr.ac.id": 1,
    "upr.clu.edu": 1,
    "upr.edu": 1,
    "upr.edu.cu": 1,
    "upr.si": 1,
    "upra.edu": 1,
    "upra.org": 1,
    "uprag.edu": 1,
    "uprb.edu": 1,
    "uprc.edu": 1,
    "uprm.edu": 1,
    "uprrp.edu": 1,
    "uprutuado.edu": 1,
    "ups-tlse.fr": 1,
    "ups.edu": 1,
    "ups.edu.ec": 1,
    "ups.urbe.it": 1,
    "upsa.edu.bo": 1,
    "upsa.es": 1,
    "upsb.edu.pe": 1,
    "upsi.edu.my": 1,
    "upsjb.edu.pe": 1,
    "upstegal.ac.id": 1,
    "upt.al": 1,
    "upt.edu.pe": 1,
    "upt.pitt.edu": 1,
    "uptc.edu.co": 1,
    "uptu.ac.in": 1,
    "upv.edu.ph": 1,
    "upv.es": 1,
    "uq.edu.au": 1,
    "uqac.ca": 1,
    "uqam.ca": 1,
    "uqar.uquebec.ca": 1,
    "uqat.uquebec.ca": 1,
    "uqo.ca": 1,
    "uqroo.mx": 1,
    "uqtr.uquebec.ca": 1,
    "uqu.edu.sa": 1,
    "uquebec.ca": 1,
    "ur.mx": 1,
    "uraccan.edu.ni": 1,
    "urbancollege.edu": 1,
    "urbaniana.edu": 1,
    "urbe.edu": 1,
    "urc.ac.ru": 1,
    "urc.edu.ph": 1,
    "urca.br": 1,
    "urcamp.tche.br": 1,
    "uregina.ca": 1,
    "urfu.ru": 1,
    "uri.br": 1,
    "uri.edu": 1,
    "urich.edu": 1,
    "urjc.es": 1,
    "url.edu.gt": 1,
    "url.es": 1,
    "urmh.edu.mx": 1,
    "urmia.ac.ir": 1,
    "urosario.edu.co": 1,
    "urp.edu.pe": 1,
    "urse.edu.mx": 1,
    "ursinus.edu": 1,
    "uru.edu": 1,
    "urural.edu.gt": 1,
    "urv.es": 1,
    "us.edu.pl": 1,
    "us.es": 1,
    "usa.edu.ph": 1,
    "usa.edu.pk": 1,
    "usaaa.ru": 1,
    "usab-tm.ro": 1,
    "usab.ro": 1,
    "usac.edu.gt": 1,
    "usac.edu.mx": 1,
    "usaca.edu.co": 1,
    "usach.cl": 1,
    "usafa.af.mil": 1,
    "usafa.edu": 1,
    "usaim.edu": 1,
    "usak.edu.tr": 1,
    "usal.es": 1,
    "usalesiana.edu.bo": 1,
    "usam.ac.cr": 1,
    "usam.edu.sv": 1,
    "usam.md": 1,
    "usamvcluj.ro": 1,
    "usanandres.cl": 1,
    "usanpedro.edu.pe": 1,
    "usao.edu": 1,
    "usap.edu": 1,
    "usart.ru": 1,
    "usask.ca": 1,
    "usat.edu.pe": 1,
    "usat.ms": 1,
    "usb.ac.ir": 1,
    "usb.edu.co": 1,
    "usb.edu.mx": 1,
    "usb.md": 1,
    "usb.ve": 1,
    "usbmed.edu.co": 1,
    "usc.ac.ir": 1,
    "usc.br": 1,
    "usc.edu": 1,
    "usc.edu.au": 1,
    "usc.edu.cn": 1,
    "usc.edu.ph": 1,
    "usc.edu.tt": 1,
    "usc.es": 1,
    "usca.edu": 1,
    "uscga.edu": 1,
    "uscon.ru": 1,
    "usd.ac.id": 1,
    "usd.edu": 1,
    "usek.edu.lb": 1,
    "usenghor-francophonie.org": 1,
    "usep.edu.ph": 1,
    "userena.cl": 1,
    "usergioarboleda.edu.co": 1,
    "usf.br": 1,
    "usf.com.mx": 1,
    "usf.edu": 1,
    "usfca.edu": 1,
    "usfea.ru": 1,
    "usfq.edu.ec": 1,
    "usfx.edu.bo": 1,
    "usfx.info": 1,
    "ush.sd": 1,
    "usherb.ca": 1,
    "ushs.u-strasbg.fr": 1,
    "usi.ac.id": 1,
    "usi.ch": 1,
    "usi.edu": 1,
    "usin.edu.sv": 1,
    "usindh.edu.pk": 1,
    "usiu.ac.ke": 1,
    "usiu.edu": 1,
    "usj.edu.lb": 1,
    "usj.edu.mo": 1,
    "usjc.uwaterloo.ca": 1,
    "usjr.edu.ph": 1,
    "uskudar.edu.tr": 1,
    "usl.edu": 1,
    "usla.ru": 1,
    "usls.edu": 1,
    "usm.ac.id": 1,
    "usm.edu": 1,
    "usm.edu.ec": 1,
    "usm.edu.ph": 1,
    "usm.maine.edu": 1,
    "usm.md": 1,
    "usm.my": 1,
    "usm.trompo.com": 1,
    "usma.ac.pa": 1,
    "usma.edu": 1,
    "usmba.ac.ma": 1,
    "usmf.md": 1,
    "usmga.ru": 1,
    "usmma.edu": 1,
    "usmp.edu.pe": 1,
    "usmtu.edu.ua": 1,
    "usna.edu": 1,
    "usoms.poznan.pl": 1,
    "uson.mx": 1,
    "usonsonate.edu.sv": 1,
    "usouixfalls.edu": 1,
    "usp.ac.fj": 1,
    "usp.ac.jp": 1,
    "usp.br": 1,
    "usp.edu.pe": 1,
    "usp.ph": 1,
    "usps.edu.hn": 1,
    "uspsantapaula.com": 1,
    "usq.edu.au": 1,
    "uss.cl": 1,
    "uss.edu.pe": 1,
    "uss.rnu.tn": 1,
    "usst.edu.cn": 1,
    "ust.ac.kr": 1,
    "ust.cl": 1,
    "ust.edu": 1,
    "ust.edu.ng": 1,
    "ust.edu.ph": 1,
    "ust.edu.sd": 1,
    "ust.hk": 1,
    "ust.md": 1,
    "usta.edu.co": 1,
    "ustanne.ednet.ns.ca": 1,
    "ustb.edu.cn": 1,
    "ustb.edu.pk": 1,
    "ustboniface.mb.ca": 1,
    "ustc.ac.bd": 1,
    "ustc.edu.cn": 1,
    "usthb.dz": 1,
    "ustmb.ac.ir": 1,
    "ustpaul.ca": 1,
    "usu.ac.id": 1,
    "usu.br": 1,
    "usu.edu": 1,
    "usu.ru": 1,
    "usudbury.com": 1,
    "usue.ru": 1,
    "usuft.kiev.ua": 1,
    "usuhs.mil": 1,
    "usurcolombia.com": 1,
    "usv.ro": 1,
    "uswr.ac.ir": 1,
    "ut.ac.id": 1,
    "ut.ac.ir": 1,
    "ut.edu": 1,
    "ut.edu.co": 1,
    "ut.edu.sa": 1,
    "ut.ee": 1,
    "ut.pr": 1,
    "uta.cl": 1,
    "uta.edu": 1,
    "uta.edu.ec": 1,
    "uta.fi": 1,
    "utad-petel-edu.org": 1,
    "utad.pt": 1,
    "utadeo.edu.co": 1,
    "utah.edu": 1,
    "utalca.cl": 1,
    "utanga.co.ao": 1,
    "utar.edu.my": 1,
    "utas.edu.au": 1,
    "utb.cz": 1,
    "utb.edu": 1,
    "utb.edu.ec": 1,
    "utbm.fr": 1,
    "utc.edu": 1,
    "utc.edu.ec": 1,
    "utc.fr": 1,
    "utcb.ro": 1,
    "utcc.ac.th": 1,
    "utch.edu.co": 1,
    "utcluj.ro": 1,
    "utd.edu": 1,
    "utdallas.edu": 1,
    "utdt.edu": 1,
    "ute.edu.do": 1,
    "ute.edu.ec": 1,
    "utea.edu.pe": 1,
    "utec.edu.sv": 1,
    "utech.edu.jm": 1,
    "utelvt.edu.ec": 1,
    "utem.cl": 1,
    "utem.edu.my": 1,
    "utep.edu": 1,
    "uteq.edu.ec": 1,
    "utesa.edu": 1,
    "utesur.edu.do": 1,
    "utexas.edu": 1,
    "utfpr.edu.br": 1,
    "utfsm.cl": 1,
    "utg.edu.gm": 1,
    "utgjiu.ro": 1,
    "uth.gr": 1,
    "uth.hn": 1,
    "uthm.edu.my": 1,
    "utibet.edu.cn": 1,
    "utica.edu": 1,
    "utk.edu": 1,
    "utkaluniv.org": 1,
    "utl.pt": 1,
    "utla.edu.sv": 1,
    "utm.ac.id": 1,
    "utm.ac.mu": 1,
    "utm.edu": 1,
    "utm.edu.ec": 1,
    "utm.md": 1,
    "utm.mx": 1,
    "utm.my": 1,
    "utm.rnu.tn": 1,
    "utm.ro": 1,
    "utm.utoronto.ca": 1,
    "utmachala.edu.ec": 1,
    "utmb.edu": 1,
    "utn.edu.ar": 1,
    "utn.edu.ec": 1,
    "utneza.edu.mx": 1,
    "uto.edu.bo": 1,
    "utoledo.edu": 1,
    "utoronto.ca": 1,
    "utp.ac.id": 1,
    "utp.ac.pa": 1,
    "utp.edu.co": 1,
    "utp.edu.my": 1,
    "utp.edu.pe": 1,
    "utp.edu.pl": 1,
    "utpb.edu": 1,
    "utpl.edu.ec": 1,
    "utpp.edu.kh": 1,
    "utrgv.edu": 1,
    "uts.edu.au": 1,
    "utsa.edu": 1,
    "utsam.edu.ec": 1,
    "utsouthwestern.edu": 1,
    "utsunomiya-u.ac.jp": 1,
    "utt.edu.tt": 1,
    "utt.fr": 1,
    "utt.ro": 1,
    "uttyler.edu": 1,
    "utu.fi": 1,
    "utulsa.edu": 1,
    "utunis.rnu.tn": 1,
    "utur.ac.cr": 1,
    "utwente.nl": 1,
    "uu.ac.kr": 1,
    "uu.edu": 1,
    "uu.nl": 1,
    "uu.se": 1,
    "uuc.edu.et": 1,
    "uum.edu.my": 1,
    "uut.ac.ir": 1,
    "uv.cl": 1,
    "uv.edu.ph": 1,
    "uv.es": 1,
    "uv.mx": 1,
    "uva.br": 1,
    "uva.es": 1,
    "uvanet.br": 1,
    "uvas.edu.pk": 1,
    "uvauga.ru": 1,
    "uvb.edu.mx": 1,
    "uveritas.ac.cr": 1,
    "uvg.edu.gt": 1,
    "uvg1.net": 1,
    "uvh.nl": 1,
    "uvi.edu": 1,
    "uvic.ca": 1,
    "uvic.es": 1,
    "uvigo.es": 1,
    "uvipro.cl": 1,
    "uvm.cl": 1,
    "uvm.edu": 1,
    "uvm.edu.ve": 1,
    "uvm.sk": 1,
    "uvmnet.edu": 1,
    "uvs.edu": 1,
    "uvsc.edu": 1,
    "uvsq.fr": 1,
    "uvt.edu.mx": 1,
    "uvt.rnu.tn": 1,
    "uvt.ro": 1,
    "uvu.edu": 1,
    "uvu.edu.cn": 1,
    "uvvg.ro": 1,
    "uw.edu": 1,
    "uw.edu.pk": 1,
    "uw.edu.pl": 1,
    "uwa.edu.au": 1,
    "uwasa.fi": 1,
    "uwaterloo.ca": 1,
    "uwc.ac.za": 1,
    "uwc.edu": 1,
    "uwcm.ac.uk": 1,
    "uwe.ac.uk": 1,
    "uwec.edu": 1,
    "uwed.uz": 1,
    "uwf.edu": 1,
    "uwgb.edu": 1,
    "uwi.tt": 1,
    "uwic.ac.uk": 1,
    "uwichill.edu.bb": 1,
    "uwiener.edu.pe": 1,
    "uwimona.edu.jm": 1,
    "uwindsor.ca": 1,
    "uwinnipeg.ca": 1,
    "uwlax.edu": 1,
    "uwm.edu": 1,
    "uwm.edu.pl": 1,
    "uwo.ca": 1,
    "uwosh.edu": 1,
    "uwp.edu": 1,
    "uwplatt.edu": 1,
    "uwrf.edu": 1,
    "uws.edu.au": 1,
    "uwsa.edu": 1,
    "uwsp.edu": 1,
    "uwstout.edu": 1,
    "uwsuper.edu": 1,
    "uwu.ac.lk": 1,
    "uww.edu": 1,
    "uwyo.edu": 1,
    "uxac.edu.mx": 1,
    "uy1.uninet.cm": 1,
    "uz.ac.zw": 1,
    "uz.rnu.tn": 1,
    "uzh.ch": 1,
    "uzimauniversity.ac.ke": 1,
    "uzswlu.uz": 1,
    "va.lv": 1,
    "valahia.ro": 1,
    "valdosta.edu": 1,
    "valenciacollege.edu": 1,
    "valleycollege.edu": 1,
    "valpo.edu": 1,
    "vancouver.wsu.edu": 1,
    "vanderbilt.edu": 1,
    "vaneduc.edu.ar": 1,
    "vaniercollege.qc.ca": 1,
    "vassar.edu": 1,
    "vbspu.ac.in": 1,
    "vbu.co.in": 1,
    "vcc.ca": 1,
    "vcc.edu": 1,
    "vccs.edu": 1,
    "vcsu.nodak.edu": 1,
    "vcu.edu": 1,
    "vdu.edu.ua": 1,
    "vdu.lt": 1,
    "venturacollege.edu": 1,
    "ver.ucc.mx": 1,
    "veritas.edu.ng": 1,
    "vern.hr": 1,
    "vernoncollege.edu": 1,
    "vesalius.edu": 1,
    "vet-alfort.fr": 1,
    "vet-lyon.fr": 1,
    "vet-nantes.fr": 1,
    "veths.no": 1,
    "vfmac.edu": 1,
    "vfrta.ru": 1,
    "vfu.bg": 1,
    "vfu.cz": 1,
    "vgafk.ru": 1,
    "vgasa.ru": 1,
    "vgcc.edu": 1,
    "vgmu.vitebsk.by": 1,
    "vgta.vrn.ru": 1,
    "vgtu.lt": 1,
    "vgu.edu.vn": 1,
    "vhcc.edu": 1,
    "vic.edu": 1,
    "victoria-uni.ch": 1,
    "victoriacollege.edu": 1,
    "vicu.utoronto.ca": 1,
    "vidyasagar.ac.in": 1,
    "vieup.ru": 1,
    "vignanuniversity.org": 1,
    "vikramuniversity.org": 1,
    "villanova.edu": 1,
    "villanueva.edu": 1,
    "vimaru.edu.vn": 1,
    "vinayakamissions.com": 1,
    "virginia.edu": 1,
    "virginiawestern.edu": 1,
    "visva-bharati.ac.in": 1,
    "vit.ac.in": 1,
    "viu.edu.pa": 1,
    "vjc.edu": 1,
    "vkgu.kz": 1,
    "vksu-ara.org": 1,
    "vlekho.be": 1,
    "vlerick.be": 1,
    "vlsu.ru": 1,
    "vmi.edu": 1,
    "vmou.ac.in": 1,
    "vmuf.edu.ph": 1,
    "vnitnagpur.ac.in": 1,
    "vnmu.vn.ua": 1,
    "vnu.edu.vn": 1,
    "vnuhcm.edu.vn": 1,
    "voenmeh.ru": 1,
    "volstate.edu": 1,
    "volsu.ru": 1,
    "vorstu.ac.ru": 1,
    "vpa.ac.lk": 1,
    "vpu.lt": 1,
    "vru.ac.ir": 1,
    "vsau.ru": 1,
    "vsavm.com": 1,
    "vsb.cz": 1,
    "vscht.cz": 1,
    "vsci.cz": 1,
    "vse.cz": 1,
    "vsgaki.burnet.ru": 1,
    "vsgtu.eastsib.ru": 1,
    "vslib.cz": 1,
    "vsm.sk": 1,
    "vsma.info": 1,
    "vsmu.sk": 1,
    "vsp.cz": 1,
    "vspu.ac.ru": 1,
    "vspu.kirov.ru": 1,
    "vspu.ru": 1,
    "vssladkovicovo.sk": 1,
    "vssut.ac.in": 1,
    "vssvalzbety.sk": 1,
    "vstu.ru": 1,
    "vstu.vinnica.ua": 1,
    "vstu.vitebsk.by": 1,
    "vsu.by": 1,
    "vsu.edu": 1,
    "vsu.ru": 1,
    "vsvu.sk": 1,
    "vt.edu": 1,
    "vtc.edu": 1,
    "vtu.ac.in": 1,
    "vu-wien.ac.at": 1,
    "vu.ac.th": 1,
    "vu.edu.au": 1,
    "vu.edu.pk": 1,
    "vu.lt": 1,
    "vu.nl": 1,
    "vub.ac.be": 1,
    "vumk.eu": 1,
    "vut.ac.za": 1,
    "vutbr.cz": 1,
    "vuw.ac.nz": 1,
    "vvc.edu": 1,
    "vvsu.ru": 1,
    "vvu.edu.gh": 1,
    "vwc.edu": 1,
    "vxu.se": 1,
    "wabash.edu": 1,
    "waco.tstc.edu": 1,
    "wageningenuniversity.nl": 1,
    "wagner.edu": 1,
    "wahmedicalcollege.edu.pk": 1,
    "waikato.ac.nz": 1,
    "wakayama-med.ac.jp": 1,
    "wakayama-u.ac.jp": 1,
    "wakehealth.edu": 1,
    "waketech.edu": 1,
    "wakf.org": 1,
    "wakhok.ac.jp": 1,
    "wako.ac.jp": 1,
    "waldenu.edu": 1,
    "wales.ac.uk": 1,
    "wallace.edu": 1,
    "wallacestate.edu": 1,
    "wallawalla.edu": 1,
    "walshcollege.edu": 1,
    "warnborough.edu": 1,
    "warren-wilson.edu": 1,
    "warren.edu": 1,
    "wartburg.edu": 1,
    "warwick.ac.uk": 1,
    "waseda.ac.jp": 1,
    "washcoll.edu": 1,
    "washington.edu": 1,
    "washjeff.edu": 1,
    "watc.edu": 1,
    "waubonsee.edu": 1,
    "wayne.edu": 1,
    "wayne.uakron.edu": 1,
    "waynecc.edu": 1,
    "waynesburg.edu": 1,
    "wayo.ac.jp": 1,
    "wbu.edu": 1,
    "wbuafs.nic.in": 1,
    "wbut.net": 1,
    "wc.edu": 1,
    "wcc.vccs.edu": 1,
    "wcc.yccd.edu": 1,
    "wccc.edu": 1,
    "wccc.me.edu": 1,
    "wcccd.edu": 1,
    "wccnet.edu": 1,
    "wccs.edu": 1,
    "wcjc.edu": 1,
    "wcslc.edu": 1,
    "wcsu.edu": 1,
    "wctc.edu": 1,
    "wcu.edu": 1,
    "wcums.edu.cn": 1,
    "wcupa.edu": 1,
    "wdsdjxy.com": 1,
    "wdt.edu": 1,
    "wdu.edu.ng": 1,
    "web.prover.com.br": 1,
    "weber.edu": 1,
    "webs.satlink.com": 1,
    "webster.ac.at": 1,
    "webster.ac.th": 1,
    "webster.ch": 1,
    "webster.edu": 1,
    "weizmann.ac.il": 1,
    "wellesley.edu": 1,
    "wells.edu": 1,
    "wellspringuniversity.edu.ng": 1,
    "wenk.be": 1,
    "wesley.edu": 1,
    "wesleyan.edu": 1,
    "wesleyan.edu.ph": 1,
    "westal.edu": 1,
    "westcoastuniversity-edu.com": 1,
    "westcoastuniversity.bz": 1,
    "westcoastuniversity.edu": 1,
    "western.edu": 1,
    "western.edu.kh": 1,
    "westerntc.edu": 1,
    "westfield.mass.edu": 1,
    "westga.edu": 1,
    "westgatech.edu": 1,
    "westhill.edu.mx": 1,
    "westhillscollege.com": 1,
    "westkentucky.kctcs.edu": 1,
    "westliberty.edu": 1,
    "westminster-mo.edu": 1,
    "westminster.ac.uk": 1,
    "westminster.edu": 1,
    "westminster.edu.my": 1,
    "westmont.edu": 1,
    "westshore.edu": 1,
    "westtexas.tstc.edu": 1,
    "westvalley.edu": 1,
    "wetcc.edu": 1,
    "wfu.edu": 1,
    "wgalil.ac.il": 1,
    "wgu.edu": 1,
    "whapu.edu.cn": 1,
    "whatcom.ctc.edu": 1,
    "wheaton.edu": 1,
    "wheatonma.edu": 1,
    "whitman.edu": 1,
    "whittier.edu": 1,
    "whitworth.edu": 1,
    "whtu.edu.cn": 1,
    "whu-koblenz.de": 1,
    "whu.edu.cn": 1,
    "whut.edu.cn": 1,
    "wichita.edu": 1,
    "widener.edu": 1,
    "widyagama.ac.id": 1,
    "widyakarya.ac.id": 1,
    "widyatama.ac.id": 1,
    "wijayakusumasby.ac.id": 1,
    "wilberforce.edu": 1,
    "wilkes.edu": 1,
    "wilkescc.edu": 1,
    "willamette.edu": 1,
    "williamgilbert.co.uk": 1,
    "williams.edu": 1,
    "willistonstate.edu": 1,
    "wilmington.edu": 1,
    "wilmu.edu": 1,
    "wilsoncc.edu": 1,
    "wiltech.edu": 1,
    "wima.ac.id": 1,
    "wimbledon.ac.uk": 1,
    "windesheim.nl": 1,
    "windsor.edu": 1,
    "windward.hawaii.edu": 1,
    "winona.edu": 1,
    "winthrop.edu": 1,
    "wiregrass.edu": 1,
    "wisc.edu": 1,
    "wise.edu.jo": 1,
    "wisnuwardhana.ac.id": 1,
    "wit.edu": 1,
    "wit.ie": 1,
    "witc.edu": 1,
    "witcc.edu": 1,
    "wits.ac.za": 1,
    "wittenberg.edu": 1,
    "wittenborg.eu": 1,
    "wiu.edu": 1,
    "wiu.edu.sy": 1,
    "wiut.uz": 1,
    "wjc.edu": 1,
    "wkau.kz": 1,
    "wku.ac.kr": 1,
    "wku.edu": 1,
    "wku.edu.et": 1,
    "wlac.edu": 1,
    "wlc.edu": 1,
    "wlodkowic.pl": 1,
    "wlsc.wvnet.edu": 1,
    "wlu.ca": 1,
    "wlu.edu": 1,
    "wlv.ac.uk": 1,
    "wm.edu": 1,
    "wma.edu": 1,
    "wmc.edu": 1,
    "wmcc.edu": 1,
    "wmich.edu": 1,
    "wmitchell.edu": 1,
    "wmpenn.edu": 1,
    "wmsu.edu.ph": 1,
    "wmu.se": 1,
    "wmwoods.edu": 1,
    "wncc.edu": 1,
    "wne.edu": 1,
    "wnec.edu": 1,
    "wnmu.edu": 1,
    "wofford.edu": 1,
    "wonkwang.ac.kr": 1,
    "woodbury.edu": 1,
    "wooster.edu": 1,
    "woosuk.ac.kr": 1,
    "worc.ac.uk": 1,
    "worwic.edu": 1,
    "wosc.edu": 1,
    "wou.edu.my": 1,
    "wp.missouristate.edu": 1,
    "wpcc.edu": 1,
    "wpi.edu": 1,
    "wpu.edu.sy": 1,
    "wpunj.edu": 1,
    "wright.edu": 1,
    "ws.edu": 1,
    "wsb-nlu.edu.pl": 1,
    "wsb.poznan.pl": 1,
    "wsb.toi.tarnow.pl": 1,
    "wscc.edu": 1,
    "wsfiz.edu.pl": 1,
    "wsh.edu.pl": 1,
    "wship.edu.pl": 1,
    "wsinf.edu.pl": 1,
    "wsisiz.edu.pl": 1,
    "wsiz.rzeszow.pl": 1,
    "wsm.gdynia.pl": 1,
    "wsm.szczecin.pl": 1,
    "wsm.whu.edu.cn": 1,
    "wsms.edu.pl": 1,
    "wsp.bydgoszcz.pl": 1,
    "wsp.czest.pl": 1,
    "wsp.krakow.pl": 1,
    "wsp.slupsk.pl": 1,
    "wsp.zgora.pl": 1,
    "wspiz.edu.pl": 1,
    "wsps.waw.pl": 1,
    "wsptwpwaw.edu.pl": 1,
    "wsu.ac.kr": 1,
    "wsu.ac.za": 1,
    "wsu.edu": 1,
    "wsu.edu.et": 1,
    "wsub.waw.pl": 1,
    "wsz-pou.edu.pl": 1,
    "wsz.pl": 1,
    "wszib.krakow.pl": 1,
    "wszim.edu.pl": 1,
    "wtamu.edu": 1,
    "wtc.edu": 1,
    "wts.edu": 1,
    "wtusm.edu.cn": 1,
    "wu-wien.ac.at": 1,
    "wu.ac.at": 1,
    "wu.ac.th": 1,
    "wu.edu.az": 1,
    "wu.edu.et": 1,
    "wua.ac.zw": 1,
    "wuacc.edu": 1,
    "wub.edu": 1,
    "wuhee.edu.cn": 1,
    "wuni.edu.et": 1,
    "wustl.edu": 1,
    "wustoportal.edu.ng": 1,
    "wvc.edu": 1,
    "wvncc.edu": 1,
    "wvsu.edu.ph": 1,
    "wvu.edu": 1,
    "wvwc.edu": 1,
    "wwcc.edu": 1,
    "wwcc.wy.edu": 1,
    "wwu.de": 1,
    "wwu.edu": 1,
    "www-azc.uam.mx": 1,
    "www-ecpm.u-strasbg.fr": 1,
    "www-engees.u-strasbg.fr": 1,
    "www-ensais.u-strasbg.fr": 1,
    "www-ensps.u-strasbg.fr": 1,
    "www-ulp.u-strasbg.fr": 1,
    "www-urs.u-strasbg.fr": 1,
    "www.ccm.edu": 1,
    "www.clcillinois.edu": 1,
    "www.clcmn.edu": 1,
    "www.cuesta.edu": 1,
    "www.eacc.edu": 1,
    "www.fdtc.edu": 1,
    "www.ojc.edu": 1,
    "www.sunyacc.edu": 1,
    "www.sunybroome.edu": 1,
    "www.sunyulster.edu": 1,
    "www.tjc.edu": 1,
    "www.yewon.ac.kr": 1,
    "www.yongin.ac.kr": 1,
    "www.youngsan.ac.kr": 1,
    "www.ysu.ac.kr": 1,
    "www2.mozcom.com": 1,
    "www3.sunysuffolk.edu": 1,
    "wxuli.edu.cn": 1,
    "wyb.ac.lk": 1,
    "wyu.edu.cn": 1,
    "wzmu.net": 1,
    "wzu.edu.cn": 1,
    "xafa.edu.cn": 1,
    "xahu.edu.cn": 1,
    "xauat.edu.cn": 1,
    "xaut.edu.cn": 1,
    "xavier.edu": 1,
    "xhcom.edu.cn": 1,
    "xhu.edu.cn": 1,
    "xidian.edu.cn": 1,
    "xiju.edu.cn": 1,
    "xisu.edu.cn": 1,
    "xjau.edu.cn": 1,
    "xjnu.edu.cn": 1,
    "xjtlu.edu.cn": 1,
    "xjtu.edu.cn": 1,
    "xju.edu.cn": 1,
    "xjufe.edu.cn": 1,
    "xmu.edu.cn": 1,
    "xtnu.edu.cn": 1,
    "xtu.edu.cn": 1,
    "xu.edu.ph": 1,
    "xula.edu": 1,
    "xz.edu.rs": 1,
    "xza.cn": 1,
    "xzmy.edu.cn": 1,
    "xznu.edu.cn": 1,
    "yabatech.edu.ng": 1,
    "yacambu.edu.ve": 1,
    "yai.ac.id": 1,
    "yale-nus.edu.sg": 1,
    "yale.edu": 1,
    "yalova.edu.tr": 1,
    "yama.sut.ac.jp": 1,
    "yamagata-u.ac.jp": 1,
    "yamaguchi-pu.ac.jp": 1,
    "yamaguchi-u.ac.jp": 1,
    "yamanashi-med.ac.jp": 1,
    "yamanashi.ac.jp": 1,
    "yangtzeu.edu.cn": 1,
    "yarsi.ac.id": 1,
    "yasar.edu.tr": 1,
    "yasuda-u.ac.jp": 1,
    "yau.edu.cn": 1,
    "yazduni.ac.ir": 1,
    "ybu.edu.cn": 1,
    "ybu.edu.tr": 1,
    "ybust.edu.cn": 1,
    "yc.edu": 1,
    "yc.yccd.edu": 1,
    "yccc.edu": 1,
    "ycmou.com": 1,
    "ycp.edu": 1,
    "yds.edu.vn": 1,
    "yeditepe.edu.tr": 1,
    "yeniyuzyil.edu.tr": 1,
    "yeungnam.ac.kr": 1,
    "ygu.ac.jp": 1,
    "yhc.edu": 1,
    "yic.edu.sa": 1,
    "yildiz.edu.tr": 1,
    "yizhuan.com": 1,
    "ym.edu.tw": 1,
    "yma.ac.ru": 1,
    "ynau.edu.cn": 1,
    "ynnu.edu.cn": 1,
    "ynu.ac.jp": 1,
    "ynu.edu.cn": 1,
    "yokkaichi-u.ac.jp": 1,
    "yokohama-cu.ac.jp": 1,
    "yonsei.ac.kr": 1,
    "york.ac.uk": 1,
    "yorktech.edu": 1,
    "yorku.ca": 1,
    "yosemite.edu": 1,
    "yosu.ac.kr": 1,
    "ypu.edu.sy": 1,
    "ysmu.am": 1,
    "ysparmaruniversity.org": 1,
    "yspu.yar.ru": 1,
    "ystu.yar.ru": 1,
    "ysu.am": 1,
    "ysu.edu": 1,
    "ysu.edu.cn": 1,
    "ysu.ru": 1,
    "ytet.edu.cn": 1,
    "yti.edu": 1,
    "yti.edu.sa": 1,
    "ytnc.edu.cn": 1,
    "ytu.edu.cn": 1,
    "yu.ac.ir": 1,
    "yu.edu": 1,
    "yu.edu.jo": 1,
    "yuc.edu.sa": 1,
    "yukoncollege.yk.ca": 1,
    "yuksekihtisasuniversitesi.edu.tr": 1,
    "yums.ac.ir": 1,
    "yuniv.net": 1,
    "yuntech.edu.tw": 1,
    "yvc.ac.il": 1,
    "yvcc.edu": 1,
    "yyu.edu.tr": 1,
    "yznu.cn": 1,
    "yzu.edu.cn": 1,
    "yzu.edu.tw": 1,
    "zamanuniversity.edu.kh": 1,
    "zamorano.edu": 1,
    "zanestate.edu": 1,
    "zaou.ac.zm": 1,
    "zawiya.edu.pk": 1,
    "zcu.cz": 1,
    "zdmu.ac.ir": 1,
    "zdsoft.com.cn": 1,
    "zegu.ac.zw": 1,
    "zetechcollege.com": 1,
    "zgfxy.cn": 1,
    "zhaw.ch": 1,
    "zhdk.ch": 1,
    "zhezu.kz": 1,
    "zhgu.kz": 1,
    "zhnut.edu.cn": 1,
    "zhwin.ch": 1,
    "zjfc.edu.cn": 1,
    "zjgsu.edu.cn": 1,
    "zjnu.edu.cn": 1,
    "zjou.edu.cn": 1,
    "zju.edu.cn": 1,
    "zjut.edu.cn": 1,
    "zntu.edu.ua": 1,
    "znu.ac.ir": 1,
    "znu.edu.ua": 1,
    "znuel.net": 1,
    "znufe.edu.cn": 1,
    "zokei.ac.jp": 1,
    "zou.ac.zw": 1,
    "zpsb.szczecin.pl": 1,
    "zpu.edu.jo": 1,
    "zsb.scfai.edu.cn": 1,
    "zsem.hr": 1,
    "zstu.edu.cn": 1,
    "zsu.edu.cn": 1,
    "zu.ac.ae": 1,
    "zu.edu.eg": 1,
    "zu.edu.ly": 1,
    "zu.edu.pk": 1,
    "zums.ac.ir": 1,
    "zut.edu.pl": 1,
    "zuyd.nl": 1,
    "zzgc.edu.cn": 1,
    "zzut.edu.cn": 1
};

const HighLeadScore = 70;

module.exports = {
    PersonEmailDomains,
    ShouldResearchCountries,
    GoodPersonalEmails,
    DoNotResearchEmails,
    DoNotResearchCountries,
    LeadTableName,
    StudentEmailDomains,
    StudentAndThrowawayDomains,
    HighLeadScore
};
